var _regeneratorRuntime = require("/vercel/path0/react/react-app-custom-v3-react-17/groupchannel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

/**
 * Copyright (c) 2016 SendBird DBA (Smile Family, Inc.)
 * SendBird Call JavaScript SDK v1.9.3 production
 */
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).SendBirdCall = t();
}(this, function () {
  "use strict";

  var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

  function t(e, t) {
    return e(t = {
      exports: {}
    }, t.exports), t.exports;
  }

  function u(e) {
    try {
      return !!e();
    } catch (e) {
      return !0;
    }
  }

  function i(e, t) {
    return {
      enumerable: !(1 & e),
      configurable: !(2 & e),
      writable: !(4 & e),
      value: t
    };
  }

  function r(e) {
    return c.call(e).slice(8, -1);
  }

  function l(e) {
    if (null == e) throw TypeError("Can't call method on " + e);
    return e;
  }

  function d(e) {
    return E(l(e));
  }

  function h(e) {
    return "object" == typeof e ? null !== e : "function" == typeof e;
  }

  function f(e, t) {
    if (!h(e)) return e;
    var n, r;
    if (t && "function" == typeof (n = e.toString) && !h(r = n.call(e))) return r;
    if ("function" == typeof (n = e.valueOf) && !h(r = n.call(e))) return r;
    if (!t && "function" == typeof (n = e.toString) && !h(r = n.call(e))) return r;
    throw TypeError("Can't convert object to primitive value");
  }

  function y(e, t) {
    return k.call(e, t);
  }

  function n(e) {
    return C ? R.createElement(e) : {};
  }

  function w(e) {
    if (!h(e)) throw TypeError(String(e) + " is not an object");
    return e;
  }

  function _(t, n) {
    try {
      O(p, t, n);
    } catch (e) {
      p[t] = n;
    }

    return n;
  }

  var a = function a(e) {
    return e && e.Math == Math && e;
  },
      p = a("object" == typeof globalThis && globalThis) || a("object" == typeof window && window) || a("object" == typeof self && self) || a("object" == typeof e && e) || function () {
    return this;
  }() || Function("return this")(),
      v = !u(function () {
    return 7 != Object.defineProperty({}, 1, {
      get: function get() {
        return 7;
      }
    })[1];
  }),
      o = {}.propertyIsEnumerable,
      s = Object.getOwnPropertyDescriptor,
      m = {
    f: s && !o.call({
      1: 2
    }, 1) ? function (e) {
      e = s(this, e);
      return !!e && e.enumerable;
    } : o
  },
      c = {}.toString,
      g = "".split,
      E = u(function () {
    return !Object("z").propertyIsEnumerable(0);
  }) ? function (e) {
    return "String" == r(e) ? g.call(e, "") : Object(e);
  } : Object,
      k = {}.hasOwnProperty,
      R = p.document,
      C = h(R) && h(R.createElement),
      I = !v && !u(function () {
    return 7 != Object.defineProperty(n("div"), "a", {
      get: function get() {
        return 7;
      }
    }).a;
  }),
      A = Object.getOwnPropertyDescriptor,
      T = {
    f: v ? A : function (e, t) {
      if (e = d(e), t = f(t, !0), I) try {
        return A(e, t);
      } catch (e) {}
      if (y(e, t)) return i(!m.f.call(e, t), e[t]);
    }
  },
      S = Object.defineProperty,
      b = {
    f: v ? S : function (e, t, n) {
      if (w(e), t = f(t, !0), w(n), I) try {
        return S(e, t, n);
      } catch (e) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
      return "value" in n && (e[t] = n.value), e;
    }
  },
      O = v ? function (e, t, n) {
    return b.f(e, t, i(1, n));
  } : function (e, t, n) {
    return e[t] = n, e;
  },
      D = "__core-js_shared__",
      N = p[D] || _(D, {}),
      L = Function.toString;

  "function" != typeof N.inspectSource && (N.inspectSource = function (e) {
    return L.call(e);
  });

  function x(e) {
    return "Symbol(" + String(void 0 === e ? "" : e) + ")_" + (++K + Y).toString(36);
  }

  var P,
      M,
      U,
      V,
      F,
      G,
      B,
      j,
      q = N.inspectSource,
      H = p.WeakMap,
      z = "function" == typeof H && /native code/.test(q(H)),
      W = t(function (e) {
    (e.exports = function (e, t) {
      return N[e] || (N[e] = void 0 !== t ? t : {});
    })("versions", []).push({
      version: "3.8.1",
      mode: "global",
      copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
    });
  }),
      K = 0,
      Y = Math.random(),
      Z = W("keys"),
      Q = function Q(e) {
    return Z[e] || (Z[e] = x(e));
  },
      X = {},
      $ = p.WeakMap;

  B = z ? (P = N.state || (N.state = new $()), M = P.get, U = P.has, V = P.set, F = function F(e, t) {
    return t.facade = e, V.call(P, e, t), t;
  }, G = function G(e) {
    return M.call(P, e) || {};
  }, function (e) {
    return U.call(P, e);
  }) : (j = Q("state"), X[j] = !0, F = function F(e, t) {
    return t.facade = e, O(e, j, t), t;
  }, G = function G(e) {
    return y(e, j) ? e[j] : {};
  }, function (e) {
    return y(e, j);
  });

  function J(e) {
    return "function" == typeof e ? e : void 0;
  }

  function ee(e, t) {
    return arguments.length < 2 ? J(_e[e]) || J(p[e]) : _e[e] && _e[e][t] || p[e] && p[e][t];
  }

  function te(e) {
    return isNaN(e = +e) ? 0 : (0 < e ? ve : pe)(e);
  }

  function ne(e) {
    return 0 < e ? ye(te(e), 9007199254740991) : 0;
  }

  function re(e, t) {
    return (e = te(e)) < 0 ? me(e + t, 0) : ge(e, t);
  }

  function ie(e, t) {
    var n,
        r = d(e),
        i = 0,
        a = [];

    for (n in r) {
      !y(X, n) && y(r, n) && a.push(n);
    }

    for (; t.length > i;) {
      y(r, n = t[i++]) && (~Ee(a, n) || a.push(n));
    }

    return a;
  }

  function ae(e, t) {
    var n,
        r,
        i,
        a = e.target,
        o = e.global,
        s = e.stat,
        c = o ? p : s ? p[a] || _(a, {}) : (p[a] || {}).prototype;
    if (c) for (n in t) {
      if (r = t[n], i = e.noTargetGet ? (i = Ne(c, n)) && i.value : c[n], !De(o ? n : a + (s ? "." : "#") + n, e.forced) && void 0 !== i) {
        if (typeof r == typeof i) continue;
        !function (e, t) {
          for (var n = we(t), r = b.f, i = T.f, a = 0; a < n.length; a++) {
            var o = n[a];
            y(e, o) || r(e, o, i(t, o));
          }
        }(r, i);
      }

      (e.sham || i && i.sham) && O(r, "sham", !0), fe(c, n, r, e);
    }
  }

  function oe(e) {
    if ("function" != typeof e) throw TypeError(String(e) + " is not a function");
    return e;
  }

  function se(r, i, e) {
    if (oe(r), void 0 === i) return r;

    switch (e) {
      case 0:
        return function () {
          return r.call(i);
        };

      case 1:
        return function (e) {
          return r.call(i, e);
        };

      case 2:
        return function (e, t) {
          return r.call(i, e, t);
        };

      case 3:
        return function (e, t, n) {
          return r.call(i, e, t, n);
        };
    }

    return function () {
      return r.apply(i, arguments);
    };
  }

  function ce(e) {
    return Object(l(e));
  }

  function ue(e) {
    return y(Pe, e) || (xe && y(Me, e) ? Pe[e] = Me[e] : Pe[e] = Ue("Symbol." + e)), Pe[e];
  }

  function le(e, t) {
    var n;
    return Le(e) && ("function" == typeof (n = e.constructor) && (n === Array || Le(n.prototype)) || h(n) && null === (n = n[Ve])) && (n = void 0), new (void 0 === n ? Array : n)(0 === t ? 0 : t);
  }

  function de(e) {
    throw e;
  }

  var he = {
    set: F,
    get: G,
    has: B,
    enforce: function enforce(e) {
      return B(e) ? G(e) : F(e, {});
    },
    getterFor: function getterFor(n) {
      return function (e) {
        var t;
        if (!h(e) || (t = G(e)).type !== n) throw TypeError("Incompatible receiver, " + n + " required");
        return t;
      };
    }
  },
      fe = t(function (e) {
    var t = he.get,
        s = he.enforce,
        c = String(String).split("String");
    (e.exports = function (e, t, n, r) {
      var i = !!r && !!r.unsafe,
          a = !!r && !!r.enumerable,
          o = !!r && !!r.noTargetGet;
      "function" == typeof n && ("string" != typeof t || y(n, "name") || O(n, "name", t), (r = s(n)).source || (r.source = c.join("string" == typeof t ? t : ""))), e !== p ? (i ? !o && e[t] && (a = !0) : delete e[t], a ? e[t] = n : O(e, t, n)) : a ? e[t] = n : _(t, n);
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && t(this).source || q(this);
    });
  }),
      _e = p,
      pe = Math.ceil,
      ve = Math.floor,
      ye = Math.min,
      me = Math.max,
      ge = Math.min,
      a = function a(s) {
    return function (e, t, n) {
      var r,
          i = d(e),
          a = ne(i.length),
          o = re(n, a);

      if (s && t != t) {
        for (; o < a;) {
          if ((r = i[o++]) != r) return !0;
        }
      } else for (; o < a; o++) {
        if ((s || o in i) && i[o] === t) return s || o || 0;
      }

      return !s && -1;
    };
  },
      e = {
    includes: a(!0),
    indexOf: a(!1)
  },
      Ee = e.indexOf,
      ke = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"],
      Re = ke.concat("length", "prototype"),
      Ce = {
    f: Object.getOwnPropertyNames || function (e) {
      return ie(e, Re);
    }
  },
      Ie = {
    f: Object.getOwnPropertySymbols
  },
      we = ee("Reflect", "ownKeys") || function (e) {
    var t = Ce.f(w(e)),
        n = Ie.f;
    return n ? t.concat(n(e)) : t;
  },
      Ae = /#|\.prototype\./,
      o = function o(e, t) {
    e = Se[Te(e)];
    return e == Oe || e != be && ("function" == typeof t ? u(t) : !!t);
  },
      Te = o.normalize = function (e) {
    return String(e).replace(Ae, ".").toLowerCase();
  },
      Se = o.data = {},
      be = o.NATIVE = "N",
      Oe = o.POLYFILL = "P",
      De = o,
      Ne = T.f,
      Le = Array.isArray || function (e) {
    return "Array" == r(e);
  },
      xe = !!Object.getOwnPropertySymbols && !u(function () {
    return !String(Symbol());
  }),
      D = xe && !Symbol.sham && "symbol" == typeof Symbol.iterator,
      Pe = W("wks"),
      Me = p.Symbol,
      Ue = D ? Me : Me && Me.withoutSetter || x,
      Ve = ue("species"),
      Fe = [].push,
      H = function H(h) {
    var f = 1 == h,
        _ = 2 == h,
        p = 3 == h,
        v = 4 == h,
        y = 6 == h,
        m = 7 == h,
        g = 5 == h || y;

    return function (e, t, n, r) {
      for (var i, a, o = ce(e), s = E(o), c = se(t, n, 3), u = ne(s.length), l = 0, r = r || le, d = f ? r(e, u) : _ || m ? r(e, 0) : void 0; l < u; l++) {
        if ((g || l in s) && (a = c(i = s[l], l, o), h)) if (f) d[l] = a;else if (a) switch (h) {
          case 3:
            return !0;

          case 5:
            return i;

          case 6:
            return l;

          case 2:
            Fe.call(d, i);
        } else switch (h) {
          case 4:
            return !1;

          case 7:
            Fe.call(d, i);
        }
      }

      return y ? -1 : p || v ? v : d;
    };
  },
      z = {
    forEach: H(0),
    map: H(1),
    filter: H(2),
    some: H(3),
    every: H(4),
    find: H(5),
    findIndex: H(6),
    filterOut: H(7)
  },
      $ = function $(e, t) {
    var n = [][e];
    return !!n && u(function () {
      n.call(null, t || function () {
        throw 1;
      }, 1);
    });
  },
      Ge = Object.defineProperty,
      Be = {},
      a = function a(e, t) {
    if (y(Be, e)) return Be[e];
    var n = [][e],
        r = !!y(t = t || {}, "ACCESSORS") && t.ACCESSORS,
        i = y(t, 0) ? t[0] : de,
        a = y(t, 1) ? t[1] : void 0;
    return Be[e] = !!n && !u(function () {
      if (r && !v) return 1;
      var e = {
        length: -1
      };
      r ? Ge(e, 1, {
        enumerable: !0,
        get: de
      }) : e[1] = 1, n.call(e, i, a);
    });
  },
      je = z.forEach,
      o = $("forEach"),
      W = a("forEach"),
      qe = o && W ? [].forEach : function (e) {
    return je(this, e, 1 < arguments.length ? arguments[1] : void 0);
  };

  ae({
    target: "Array",
    proto: !0,
    forced: [].forEach != qe
  }, {
    forEach: qe
  });

  function He() {}

  function ze(e) {
    return "<script>" + e + "</" + Xe + ">";
  }

  var We,
      Ke = Object.keys || function (e) {
    return ie(e, ke);
  },
      Ye = v ? Object.defineProperties : function (e, t) {
    w(e);

    for (var n, r = Ke(t), i = r.length, a = 0; a < i;) {
      b.f(e, n = r[a++], t[n]);
    }

    return e;
  },
      Ze = ee("document", "documentElement"),
      Qe = "prototype",
      Xe = "script",
      $e = Q("IE_PROTO"),
      _Je = function Je() {
    try {
      We = document.domain && new ActiveXObject("htmlfile");
    } catch (e) {}

    var e;
    _Je = We ? function (e) {
      e.write(ze("")), e.close();
      var t = e.parentWindow.Object;
      return e = null, t;
    }(We) : ((e = n("iframe")).style.display = "none", Ze.appendChild(e), e.src = String("javascript:"), (e = e.contentWindow.document).open(), e.write(ze("document.F=Object")), e.close(), e.F);

    for (var t = ke.length; t--;) {
      delete _Je[Qe][ke[t]];
    }

    return _Je();
  };

  X[$e] = !0;

  var et = Object.create || function (e, t) {
    var n;
    return null !== e ? (He[Qe] = w(e), n = new He(), He[Qe] = null, n[$e] = e) : n = _Je(), void 0 === t ? n : Ye(n, t);
  },
      tt = ue("unscopables"),
      nt = Array.prototype;

  null == nt[tt] && b.f(nt, tt, {
    configurable: !0,
    value: et(null)
  });

  var D = function D(e) {
    nt[tt][e] = !0;
  },
      rt = {},
      H = !u(function () {
    function e() {}

    return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
  }),
      it = Q("IE_PROTO"),
      at = Object.prototype,
      ot = H ? Object.getPrototypeOf : function (e) {
    return e = ce(e), y(e, it) ? e[it] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? at : null;
  },
      o = ue("iterator"),
      W = !1;

  [].keys && ("next" in (Pt = [].keys()) ? (vn = ot(ot(Pt))) !== Object.prototype && (yn = vn) : W = !0), null == yn && (yn = {}), y(yn, o) || O(yn, o, function () {
    return this;
  });

  function st(e, t, n) {
    e && !y(e = n ? e : e.prototype, ft) && ht(e, ft, {
      configurable: !0,
      value: t
    });
  }

  function ct() {
    return this;
  }

  function ut(e, t, n) {
    return t += " Iterator", e.prototype = et(_t, {
      next: i(1, n)
    }), st(e, t, !1), rt[t] = ct, e;
  }

  function lt() {
    return this;
  }

  function dt(e, t, n, r, i, a, o) {
    function s(e) {
      if (e === i && _) return _;
      if (!yt && e in h) return h[e];

      switch (e) {
        case "keys":
        case gt:
        case Et:
          return function () {
            return new n(this, e);
          };
      }

      return function () {
        return new n(this);
      };
    }

    ut(n, t, r);

    var c,
        u,
        l = t + " Iterator",
        d = !1,
        h = e.prototype,
        f = h[mt] || h["@@iterator"] || i && h[i],
        _ = !yt && f || s(i);

    if ((r = "Array" == t && h.entries || f) && (e = ot(r.call(new e())), vt !== Object.prototype && e.next && (ot(e) !== vt && (pt ? pt(e, vt) : "function" != typeof e[mt] && O(e, mt, lt)), st(e, l, !0))), i == gt && f && f.name !== gt && (d = !0, _ = function _() {
      return f.call(this);
    }), h[mt] !== _ && O(h, mt, _), rt[t] = _, i) if (c = {
      values: s(gt),
      keys: a ? _ : s("keys"),
      entries: s(Et)
    }, o) for (u in c) {
      !yt && !d && u in h || fe(h, u, c[u]);
    } else ae({
      target: t,
      proto: !0,
      forced: yt || d
    }, c);
    return c;
  }

  var Q = {
    IteratorPrototype: yn,
    BUGGY_SAFARI_ITERATORS: W
  },
      ht = b.f,
      ft = ue("toStringTag"),
      _t = Q.IteratorPrototype,
      pt = Object.setPrototypeOf || ("__proto__" in {} ? function () {
    var n,
        r = !1,
        e = {};

    try {
      (n = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(e, []), r = e instanceof Array;
    } catch (e) {}

    return function (e, t) {
      return w(e), function (e) {
        if (!h(e) && null !== e) throw TypeError("Can't set " + String(e) + " as a prototype");
      }(t), r ? n.call(e, t) : e.__proto__ = t, e;
    };
  }() : void 0),
      vt = Q.IteratorPrototype,
      yt = Q.BUGGY_SAFARI_ITERATORS,
      mt = ue("iterator"),
      gt = "values",
      Et = "entries",
      kt = "Array Iterator",
      Rt = he.set,
      Ct = he.getterFor(kt),
      It = dt(Array, "Array", function (e, t) {
    Rt(this, {
      type: kt,
      target: d(e),
      index: 0,
      kind: t
    });
  }, function () {
    var e = Ct(this),
        t = e.target,
        n = e.kind,
        r = e.index++;
    return !t || r >= t.length ? {
      value: e.target = void 0,
      done: !0
    } : "keys" == n ? {
      value: r,
      done: !1
    } : "values" == n ? {
      value: t[r],
      done: !1
    } : {
      value: [r, t[r]],
      done: !1
    };
  }, "values");
  rt.Arguments = rt.Array, D("keys"), D("values"), D("entries");

  function wt(e) {
    return void 0 !== e && (rt.Array === e || bt[St] === e);
  }

  var At = !u(function () {
    return Object.isExtensible(Object.preventExtensions({}));
  }),
      Tt = t(function (e) {
    function n(e) {
      t(e, r, {
        value: {
          objectID: "O" + ++i,
          weakData: {}
        }
      });
    }

    var t = b.f,
        r = x("meta"),
        i = 0,
        a = Object.isExtensible || function () {
      return !0;
    },
        o = e.exports = {
      REQUIRED: !1,
      fastKey: function fastKey(e, t) {
        if (!h(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;

        if (!y(e, r)) {
          if (!a(e)) return "F";
          if (!t) return "E";
          n(e);
        }

        return e[r].objectID;
      },
      getWeakData: function getWeakData(e, t) {
        if (!y(e, r)) {
          if (!a(e)) return !0;
          if (!t) return !1;
          n(e);
        }

        return e[r].weakData;
      },
      onFreeze: function onFreeze(e) {
        return At && o.REQUIRED && a(e) && !y(e, r) && n(e), e;
      }
    };

    X[r] = !0;
  }),
      St = (Tt.REQUIRED, Tt.fastKey, Tt.getWeakData, Tt.onFreeze, ue("iterator")),
      bt = Array.prototype,
      H = {};
  H[ue("toStringTag")] = "z";

  function Ot(e) {
    if (null != e) return e[Ft] || e["@@iterator"] || rt[Vt(e)];
  }

  function Dt(e) {
    var t = e.return;
    return void 0 !== t && w(t.call(e)).value;
  }

  function Nt(e, t) {
    this.stopped = e, this.result = t;
  }

  function Lt(e, t, n) {
    function r(e) {
      return a && Dt(a), new Nt(!0, e);
    }

    function i(e) {
      return h ? (w(e), _ ? p(e[0], e[1], r) : p(e[0], e[1])) : _ ? p(e, r) : p(e);
    }

    var a,
        o,
        s,
        c,
        u,
        l,
        d = n && n.that,
        h = !(!n || !n.AS_ENTRIES),
        f = !(!n || !n.IS_ITERATOR),
        _ = !(!n || !n.INTERRUPTED),
        p = se(t, d, 1 + h + _);

    if (f) a = e;else {
      if ("function" != typeof (f = Ot(e))) throw TypeError("Target is not iterable");

      if (wt(f)) {
        for (o = 0, s = ne(e.length); o < s; o++) {
          if ((c = i(e[o])) && c instanceof Nt) return c;
        }

        return new Nt(!1);
      }

      a = f.call(e);
    }

    for (u = a.next; !(l = u.call(a)).done;) {
      try {
        c = i(l.value);
      } catch (e) {
        throw Dt(a), e;
      }

      if ("object" == typeof c && c && c instanceof Nt) return c;
    }

    return new Nt(!1);
  }

  function xt(e, t, n) {
    if (!(e instanceof t)) throw TypeError("Incorrect " + (n ? n + " " : "") + "invocation");
    return e;
  }

  var Pt = "[object z]" === String(H),
      Mt = ue("toStringTag"),
      Ut = "Arguments" == r(function () {
    return arguments;
  }()),
      Vt = Pt ? r : function (e) {
    var t;
    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (e = function (e, t) {
      try {
        return e[t];
      } catch (e) {}
    }(t = Object(e), Mt)) ? e : Ut ? r(t) : "Object" == (e = r(t)) && "function" == typeof t.callee ? "Arguments" : e;
  },
      Ft = ue("iterator"),
      Gt = ue("iterator"),
      Bt = !1;

  try {
    var jt = 0,
        qt = {
      next: function next() {
        return {
          done: !!jt++
        };
      },
      return: function _return() {
        Bt = !0;
      }
    };
    qt[Gt] = function () {
      return this;
    }, Array.from(qt, function () {
      throw 2;
    });
  } catch (e) {}

  function Ht(e, t) {
    if (!t && !Bt) return !1;
    var n = !1;

    try {
      var r = {};
      r[Gt] = function () {
        return {
          next: function next() {
            return {
              done: n = !0
            };
          }
        };
      }, e(r);
    } catch (e) {}

    return n;
  }

  function zt(e, t, n) {
    var r, i;
    return pt && "function" == typeof (r = t.constructor) && r !== n && h(i = r.prototype) && i !== n.prototype && pt(e, i), e;
  }

  function Wt(e, t, n) {
    for (var r in t) {
      fe(e, r, t[r], n);
    }

    return e;
  }

  function Kt(e) {
    var t = ee(e),
        e = b.f;
    v && t && !t[ln] && e(t, ln, {
      configurable: !0,
      get: function get() {
        return this;
      }
    });
  }

  var Yt,
      Zt,
      Qt,
      Xt,
      $t,
      Jt,
      en,
      tn,
      nn,
      rn,
      an,
      on,
      sn,
      cn,
      un,
      ln = ue("species"),
      dn = b.f,
      hn = Tt.fastKey,
      fn = he.set,
      _n = he.getterFor;
  Zt = function Zt(e) {
    return function () {
      return e(this, arguments.length ? arguments[0] : void 0);
    };
  }, Qt = {
    getConstructor: function getConstructor(e, n, r, i) {
      function a(e, t, n) {
        var r,
            i = s(e),
            a = c(e, t);
        return a ? a.value = n : (i.last = a = {
          index: r = hn(t, !0),
          key: t,
          value: n,
          previous: n = i.last,
          next: void 0,
          removed: !1
        }, i.first || (i.first = a), n && (n.next = a), v ? i.size++ : e.size++, "F" !== r && (i.index[r] = a)), e;
      }

      var o = e(function (e, t) {
        xt(e, o, n), fn(e, {
          type: n,
          index: et(null),
          first: void 0,
          last: void 0,
          size: 0
        }), v || (e.size = 0), null != t && Lt(t, e[i], {
          that: e,
          AS_ENTRIES: r
        });
      }),
          s = _n(n),
          c = function c(e, t) {
        var n,
            r = s(e),
            e = hn(t);
        if ("F" !== e) return r.index[e];

        for (n = r.first; n; n = n.next) {
          if (n.key == t) return n;
        }
      };

      return Wt(o.prototype, {
        clear: function clear() {
          for (var e = s(this), t = e.index, n = e.first; n;) {
            n.removed = !0, n.previous && (n.previous = n.previous.next = void 0), delete t[n.index], n = n.next;
          }

          e.first = e.last = void 0, v ? e.size = 0 : this.size = 0;
        },
        delete: function _delete(e) {
          var t,
              n = s(this),
              r = c(this, e);
          return r && (t = r.next, e = r.previous, delete n.index[r.index], r.removed = !0, e && (e.next = t), t && (t.previous = e), n.first == r && (n.first = t), n.last == r && (n.last = e), v ? n.size-- : this.size--), !!r;
        },
        forEach: function forEach(e) {
          for (var t, n = s(this), r = se(e, 1 < arguments.length ? arguments[1] : void 0, 3); t = t ? t.next : n.first;) {
            for (r(t.value, t.key, this); t && t.removed;) {
              t = t.previous;
            }
          }
        },
        has: function has(e) {
          return !!c(this, e);
        }
      }), Wt(o.prototype, r ? {
        get: function get(e) {
          e = c(this, e);
          return e && e.value;
        },
        set: function set(e, t) {
          return a(this, 0 === e ? 0 : e, t);
        }
      } : {
        add: function add(e) {
          return a(this, e = 0 === e ? 0 : e, e);
        }
      }), v && dn(o.prototype, "size", {
        get: function get() {
          return s(this).size;
        }
      }), o;
    },
    setStrong: function setStrong(e, t, n) {
      var r = t + " Iterator",
          i = _n(t),
          a = _n(r);

      dt(e, t, function (e, t) {
        fn(this, {
          type: r,
          target: e,
          state: i(e),
          kind: t,
          last: void 0
        });
      }, function () {
        for (var e = a(this), t = e.kind, n = e.last; n && n.removed;) {
          n = n.previous;
        }

        return e.target && (e.last = n = n ? n.next : e.state.first) ? "keys" == t ? {
          value: n.key,
          done: !1
        } : "values" == t ? {
          value: n.value,
          done: !1
        } : {
          value: [n.key, n.value],
          done: !1
        } : {
          value: e.target = void 0,
          done: !0
        };
      }, n ? "entries" : "values", !n, !0), Kt(t);
    }
  }, nn = -1 !== (Yt = "Map").indexOf("Map"), rn = -1 !== Yt.indexOf("Weak"), an = nn ? "set" : "add", on = p[Yt], sn = on && on.prototype, un = {}, De(Yt, "function" != typeof (cn = on) || !(rn || sn.forEach && !u(function () {
    new on().entries().next();
  }))) ? (cn = Qt.getConstructor(Zt, Yt, nn, an), Tt.REQUIRED = !0) : De(Yt, !0) && ($t = (Xt = new cn())[an](rn ? {} : -0, 1) != Xt, Jt = u(function () {
    Xt.has(1);
  }), en = Ht(function (e) {
    new on(e);
  }), tn = !rn && u(function () {
    for (var e = new on(), t = 5; t--;) {
      e[an](t, t);
    }

    return !e.has(-0);
  }), en || (((cn = Zt(function (e, t) {
    xt(e, cn, Yt);
    e = zt(new on(), e, cn);
    return null != t && Lt(t, e[an], {
      that: e,
      AS_ENTRIES: nn
    }), e;
  })).prototype = sn).constructor = cn), (Jt || tn) && (pn("delete"), pn("has"), nn && pn("get")), (tn || $t) && pn(an), rn && sn.clear && delete sn.clear), un[Yt] = cn, ae({
    global: !0,
    forced: cn != on
  }, un), st(cn, Yt), rn || Qt.setStrong(cn, Yt, nn);

  function pn(e) {
    var n = sn[e];
    fe(sn, e, "add" == e ? function (e) {
      return n.call(this, 0 === e ? 0 : e), this;
    } : "delete" == e ? function (e) {
      return !(rn && !h(e)) && n.call(this, 0 === e ? 0 : e);
    } : "get" == e ? function (e) {
      return rn && !h(e) ? void 0 : n.call(this, 0 === e ? 0 : e);
    } : "has" == e ? function (e) {
      return !(rn && !h(e)) && n.call(this, 0 === e ? 0 : e);
    } : function (e, t) {
      return n.call(this, 0 === e ? 0 : e, t), this;
    });
  }

  var vn = Pt ? {}.toString : function () {
    return "[object " + Vt(this) + "]";
  };
  Pt || fe(Object.prototype, "toString", vn, {
    unsafe: !0
  });

  var o = function o(a) {
    return function (e, t) {
      var n,
          r = String(l(e)),
          i = te(t),
          e = r.length;
      return i < 0 || e <= i ? a ? "" : void 0 : (t = r.charCodeAt(i)) < 55296 || 56319 < t || i + 1 === e || (n = r.charCodeAt(i + 1)) < 56320 || 57343 < n ? a ? r.charAt(i) : t : a ? r.slice(i, i + 2) : n - 56320 + (t - 55296 << 10) + 65536;
    };
  },
      yn = {
    codeAt: o(!1),
    charAt: o(!0)
  },
      mn = yn.charAt,
      gn = "String Iterator",
      En = he.set,
      kn = he.getterFor(gn);

  dt(String, "String", function (e) {
    En(this, {
      type: gn,
      string: String(e),
      index: 0
    });
  }, function () {
    var e = kn(this),
        t = e.string,
        n = e.index;
    return n >= t.length ? {
      value: void 0,
      done: !0
    } : (n = mn(t, n), e.index += n.length, {
      value: n,
      done: !1
    });
  });
  var Rn,
      Cn = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  };

  for (Rn in Cn) {
    var In = p[Rn],
        wn = In && In.prototype;
    if (wn && wn.forEach !== qe) try {
      O(wn, "forEach", qe);
    } catch (e) {
      wn.forEach = qe;
    }
  }

  var An,
      Tn,
      Sn = ue("iterator"),
      bn = ue("toStringTag"),
      On = It.values;

  for (An in Cn) {
    var Dn = p[An],
        Nn = Dn && Dn.prototype;

    if (Nn) {
      if (Nn[Sn] !== On) try {
        O(Nn, Sn, On);
      } catch (e) {
        Nn[Sn] = On;
      }
      if (Nn[bn] || O(Nn, bn, An), Cn[An]) for (var Ln in It) {
        if (Nn[Ln] !== It[Ln]) try {
          O(Nn, Ln, It[Ln]);
        } catch (e) {
          Nn[Ln] = It[Ln];
        }
      }
    }
  }

  function xn(e) {
    return (xn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function Pn(e, t, n, r, i, a, o) {
    try {
      var s = e[a](o),
          c = s.value;
    } catch (e) {
      return void n(e);
    }

    s.done ? t(c) : Promise.resolve(c).then(r, i);
  }

  function Mn(s) {
    return function () {
      var e = this,
          o = arguments;
      return new Promise(function (t, n) {
        var r = s.apply(e, o);

        function i(e) {
          Pn(r, t, n, i, a, "next", e);
        }

        function a(e) {
          Pn(r, t, n, i, a, "throw", e);
        }

        i(void 0);
      });
    };
  }

  function Un(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function Vn(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function Fn(e, t, n) {
    return t && Vn(e.prototype, t), n && Vn(e, n), e;
  }

  function Gn(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function Bn(t, e) {
    var n,
        r = Object.keys(t);
    return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n)), r;
  }

  function jn(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? Bn(Object(n), !0).forEach(function (e) {
        Gn(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Bn(Object(n)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }

    return t;
  }

  function qn(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && zn(e, t);
  }

  function Hn(e) {
    return (Hn = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function zn(e, t) {
    return (zn = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function Wn() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }

  function Kn(e, t, n) {
    return (Kn = Wn() ? Reflect.construct : function (e, t, n) {
      var r = [null];
      r.push.apply(r, t);
      r = new (Function.bind.apply(e, r))();
      return n && zn(r, n.prototype), r;
    }).apply(null, arguments);
  }

  function Yn(e) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return (Yn = function Yn(e) {
      if (null === e || (t = e, -1 === Function.toString.call(t).indexOf("[native code]"))) return e;
      var t;
      if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

      if (void 0 !== r) {
        if (r.has(e)) return r.get(e);
        r.set(e, n);
      }

      function n() {
        return Kn(e, arguments, Hn(this).constructor);
      }

      return n.prototype = Object.create(e.prototype, {
        constructor: {
          value: n,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), zn(n, e);
    })(e);
  }

  function Zn(e, t) {
    if (null == e) return {};

    var n,
        r = function (e, t) {
      if (null == e) return {};

      for (var n, r = {}, i = Object.keys(e), a = 0; a < i.length; a++) {
        n = i[a], 0 <= t.indexOf(n) || (r[n] = e[n]);
      }

      return r;
    }(e, t);

    if (Object.getOwnPropertySymbols) for (var i = Object.getOwnPropertySymbols(e), a = 0; a < i.length; a++) {
      n = i[a], 0 <= t.indexOf(n) || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }

  function Qn(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function Xn(n) {
    var r = Wn();
    return function () {
      var e,
          t = Hn(n);
      return e = r ? (e = Hn(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments), t = this, !(e = e) || "object" != typeof e && "function" != typeof e ? Qn(t) : e;
    };
  }

  function $n(e, t, n) {
    return ($n = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
      e = function (e, t) {
        for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Hn(e));) {
          ;
        }

        return e;
      }(e, t);

      if (e) {
        t = Object.getOwnPropertyDescriptor(e, t);
        return t.get ? t.get.call(n) : t.value;
      }
    })(e, t, n || e);
  }

  function Jn(e, t) {
    return tr(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          i = !1,
          a = void 0;

      try {
        for (var o, s = e[Symbol.iterator](); !(r = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        i = !0, a = e;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (i) throw a;
        }
      }

      return n;
    }(e, t) || rr(e, t) || ar();
  }

  function er(e) {
    return function (e) {
      if (Array.isArray(e)) return ir(e);
    }(e) || nr(e) || rr(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function tr(e) {
    if (Array.isArray(e)) return e;
  }

  function nr(e) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
  }

  function rr(e, t) {
    if (e) {
      if ("string" == typeof e) return ir(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ir(e, t) : void 0;
    }
  }

  function ir(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function ar() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function or(e, t) {
    var _n2;

    if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
      if (Array.isArray(e) || (_n2 = rr(e)) || t && e && "number" == typeof e.length) {
        _n2 && (e = _n2);

        var r = 0,
            t = function t() {};

        return {
          s: t,
          n: function n() {
            return r >= e.length ? {
              done: !0
            } : {
              done: !1,
              value: e[r++]
            };
          },
          e: function e(_e2) {
            throw _e2;
          },
          f: t
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var i,
        a = !0,
        o = !1;
    return {
      s: function s() {
        _n2 = e[Symbol.iterator]();
      },
      n: function n() {
        var e = _n2.next();

        return a = e.done, e;
      },
      e: function e(_e3) {
        o = !0, i = _e3;
      },
      f: function f() {
        try {
          a || null == _n2.return || _n2.return();
        } finally {
          if (o) throw i;
        }
      }
    };
  }

  function sr(e) {
    e = function (e, t) {
      if ("object" != typeof e || null === e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 === n) return ("string" === t ? String : Number)(e);
      if ("object" != typeof (t = n.call(e, t || "default"))) return t;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }(e, "string");

    return "symbol" == typeof e ? e : String(e);
  }

  function cr(e, t, n, r) {
    var i = ur();
    if (r) for (var a = 0; a < r.length; a++) {
      i = r[a](i);
    }
    var n = t(function (e) {
      i.initializeInstanceElements(e, o.elements);
    }, n),
        o = i.decorateClass(function (e) {
      for (var t, n = [], r = function r(e) {
        return "method" === e.kind && e.key === a.key && e.placement === a.placement;
      }, i = 0; i < e.length; i++) {
        var a = e[i];
        if ("method" === a.kind && (t = n.find(r))) {
          if (hr(a.descriptor) || hr(t.descriptor)) {
            if (dr(a) || dr(t)) throw new ReferenceError("Duplicated methods (" + a.key + ") can't be decorated.");
            t.descriptor = a.descriptor;
          } else {
            if (dr(a)) {
              if (dr(t)) throw new ReferenceError("Decorators can't be placed on different accessors with for the same property (" + a.key + ").");
              t.decorators = a.decorators;
            }

            !function (e, t) {
              void 0 !== e.descriptor.get ? t.descriptor.get = e.descriptor.get : t.descriptor.set = e.descriptor.set;
            }(a, t);
          }
        } else n.push(a);
      }

      return n;
    }(n.d.map(lr)), e);
    return i.initializeClassElements(n.F, o.elements), i.runClassFinishers(n.F, o.finishers);
  }

  function ur() {
    ur = function ur() {
      return e;
    };

    var e = {
      elementsDefinitionOrder: [["method"], ["field"]],
      initializeInstanceElements: function initializeInstanceElements(n, e) {
        ["method", "field"].forEach(function (t) {
          e.forEach(function (e) {
            e.kind === t && "own" === e.placement && this.defineClassElement(n, e);
          }, this);
        }, this);
      },
      initializeClassElements: function initializeClassElements(r, e) {
        var i = r.prototype;
        ["method", "field"].forEach(function (n) {
          e.forEach(function (e) {
            var t = e.placement;
            e.kind !== n || "static" !== t && "prototype" !== t || (t = "static" === t ? r : i, this.defineClassElement(t, e));
          }, this);
        }, this);
      },
      defineClassElement: function defineClassElement(e, t) {
        var n,
            r = t.descriptor;
        "field" === t.kind && (n = t.initializer, r = {
          enumerable: r.enumerable,
          writable: r.writable,
          configurable: r.configurable,
          value: void 0 === n ? void 0 : n.call(e)
        }), Object.defineProperty(e, t.key, r);
      },
      decorateClass: function decorateClass(e, t) {
        var n = [],
            r = [],
            i = {
          static: [],
          prototype: [],
          own: []
        };
        if (e.forEach(function (e) {
          this.addElementPlacement(e, i);
        }, this), e.forEach(function (e) {
          if (!dr(e)) return n.push(e);
          e = this.decorateElement(e, i);
          n.push(e.element), n.push.apply(n, e.extras), r.push.apply(r, e.finishers);
        }, this), !t) return {
          elements: n,
          finishers: r
        };
        t = this.decorateConstructor(n, t);
        return r.push.apply(r, t.finishers), t.finishers = r, t;
      },
      addElementPlacement: function addElementPlacement(e, t, n) {
        t = t[e.placement];
        if (!n && -1 !== t.indexOf(e.key)) throw new TypeError("Duplicated element (" + e.key + ")");
        t.push(e.key);
      },
      decorateElement: function decorateElement(e, t) {
        for (var n = [], r = [], i = e.decorators, a = i.length - 1; 0 <= a; a--) {
          var o = t[e.placement];
          o.splice(o.indexOf(e.key), 1);
          o = this.fromElementDescriptor(e), o = this.toElementFinisherExtras((0, i[a])(o) || o);
          e = o.element, this.addElementPlacement(e, t), o.finisher && r.push(o.finisher);
          var s = o.extras;

          if (s) {
            for (var c = 0; c < s.length; c++) {
              this.addElementPlacement(s[c], t);
            }

            n.push.apply(n, s);
          }
        }

        return {
          element: e,
          finishers: r,
          extras: n
        };
      },
      decorateConstructor: function decorateConstructor(e, t) {
        for (var n = [], r = t.length - 1; 0 <= r; r--) {
          var i = this.fromClassDescriptor(e),
              i = this.toClassDescriptor((0, t[r])(i) || i);

          if (void 0 !== i.finisher && n.push(i.finisher), void 0 !== i.elements) {
            e = i.elements;

            for (var a = 0; a < e.length - 1; a++) {
              for (var o = a + 1; o < e.length; o++) {
                if (e[a].key === e[o].key && e[a].placement === e[o].placement) throw new TypeError("Duplicated element (" + e[a].key + ")");
              }
            }
          }
        }

        return {
          elements: e,
          finishers: n
        };
      },
      fromElementDescriptor: function fromElementDescriptor(e) {
        var t = {
          kind: e.kind,
          key: e.key,
          placement: e.placement,
          descriptor: e.descriptor
        };
        return Object.defineProperty(t, Symbol.toStringTag, {
          value: "Descriptor",
          configurable: !0
        }), "field" === e.kind && (t.initializer = e.initializer), t;
      },
      toElementDescriptors: function toElementDescriptors(e) {
        if (void 0 !== e) return (tr(e = e) || nr(e) || rr(e) || ar()).map(function (e) {
          var t = this.toElementDescriptor(e);
          return this.disallowProperty(e, "finisher", "An element descriptor"), this.disallowProperty(e, "extras", "An element descriptor"), t;
        }, this);
      },
      toElementDescriptor: function toElementDescriptor(e) {
        var t = String(e.kind);
        if ("method" !== t && "field" !== t) throw new TypeError('An element descriptor\'s .kind property must be either "method" or "field", but a decorator created an element descriptor with .kind "' + t + '"');
        var n = sr(e.key),
            r = String(e.placement);
        if ("static" !== r && "prototype" !== r && "own" !== r) throw new TypeError('An element descriptor\'s .placement property must be one of "static", "prototype" or "own", but a decorator created an element descriptor with .placement "' + r + '"');
        var i = e.descriptor;
        this.disallowProperty(e, "elements", "An element descriptor");
        r = {
          kind: t,
          key: n,
          placement: r,
          descriptor: Object.assign({}, i)
        };
        return "field" !== t ? this.disallowProperty(e, "initializer", "A method descriptor") : (this.disallowProperty(i, "get", "The property descriptor of a field descriptor"), this.disallowProperty(i, "set", "The property descriptor of a field descriptor"), this.disallowProperty(i, "value", "The property descriptor of a field descriptor"), r.initializer = e.initializer), r;
      },
      toElementFinisherExtras: function toElementFinisherExtras(e) {
        return {
          element: this.toElementDescriptor(e),
          finisher: fr(e, "finisher"),
          extras: this.toElementDescriptors(e.extras)
        };
      },
      fromClassDescriptor: function fromClassDescriptor(e) {
        e = {
          kind: "class",
          elements: e.map(this.fromElementDescriptor, this)
        };
        return Object.defineProperty(e, Symbol.toStringTag, {
          value: "Descriptor",
          configurable: !0
        }), e;
      },
      toClassDescriptor: function toClassDescriptor(e) {
        var t = String(e.kind);
        if ("class" !== t) throw new TypeError('A class descriptor\'s .kind property must be "class", but a decorator created a class descriptor with .kind "' + t + '"');
        this.disallowProperty(e, "key", "A class descriptor"), this.disallowProperty(e, "placement", "A class descriptor"), this.disallowProperty(e, "descriptor", "A class descriptor"), this.disallowProperty(e, "initializer", "A class descriptor"), this.disallowProperty(e, "extras", "A class descriptor");
        t = fr(e, "finisher");
        return {
          elements: this.toElementDescriptors(e.elements),
          finisher: t
        };
      },
      runClassFinishers: function runClassFinishers(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = (0, t[n])(e);

          if (void 0 !== r) {
            if ("function" != typeof r) throw new TypeError("Finishers must return a constructor.");
            e = r;
          }
        }

        return e;
      },
      disallowProperty: function disallowProperty(e, t, n) {
        if (void 0 !== e[t]) throw new TypeError(n + " can't have a ." + t + " property.");
      }
    };
    return e;
  }

  function lr(e) {
    var t = sr(e.key);
    "method" === e.kind ? n = {
      value: e.value,
      writable: !0,
      configurable: !0,
      enumerable: !1
    } : "get" === e.kind ? n = {
      get: e.value,
      configurable: !0,
      enumerable: !1
    } : "set" === e.kind ? n = {
      set: e.value,
      configurable: !0,
      enumerable: !1
    } : "field" === e.kind && (n = {
      configurable: !0,
      writable: !0,
      enumerable: !0
    });
    var n = {
      kind: "field" === e.kind ? "field" : "method",
      key: t,
      placement: e.static ? "static" : "field" === e.kind ? "own" : "prototype",
      descriptor: n
    };
    return e.decorators && (n.decorators = e.decorators), "field" === e.kind && (n.initializer = e.value), n;
  }

  function dr(e) {
    return e.decorators && e.decorators.length;
  }

  function hr(e) {
    return void 0 !== e && (void 0 !== e.value || void 0 !== e.writable);
  }

  function fr(e, t) {
    e = e[t];
    if (void 0 !== e && "function" != typeof e) throw new TypeError("Expected '" + t + "' to be a function");
    return e;
  }

  (W = Tn = Tn || {})[W.DIAL_CANCELED = 1800100] = "DIAL_CANCELED", W[W.MY_USER_ID_NOT_ALLOWED = 1800101] = "MY_USER_ID_NOT_ALLOWED", W[W.ERR_REQUEST_FAILED = 1800200] = "ERR_REQUEST_FAILED", W[W.ERR_WEBSOCKET_CONNECTION_NOT_OPENED = 1800201] = "ERR_WEBSOCKET_CONNECTION_NOT_OPENED", W[W.ERR_WEBSOCKET_CONNECTION_FAILED = 1800202] = "ERR_WEBSOCKET_CONNECTION_FAILED", W[W.ERR_NO_RESPONSE_DUE_TO_TIMEOUT = 1800203] = "ERR_NO_RESPONSE_DUE_TO_TIMEOUT", W[W.ERR_REQUEST_FAILED_DUE_TO_WEBSOCKET_CONNECTION_LOST = 1800204] = "ERR_REQUEST_FAILED_DUE_TO_WEBSOCKET_CONNECTION_LOST", W[W.ERR_WRONG_RESPONSE = 1800205] = "ERR_WRONG_RESPONSE", W[W.ERR_QUERY_IN_PROGRESS = 1800206] = "ERR_QUERY_IN_PROGRESS", W[W.INTERNAL_SERVER_ERROR = 1800207] = "INTERNAL_SERVER_ERROR", W[W.ERR_MALFORMED_DATA = 1800208] = "ERR_MALFORMED_DATA", W[W.ERR_PARTICIPANT_ALREADY_IN_ROOM = 1800700] = "ERR_PARTICIPANT_ALREADY_IN_ROOM", W[W.ERR_ENTERING_ROOM_STILL_IN_PROGRESS = 1800701] = "ERR_ENTERING_ROOM_STILL_IN_PROGRESS", W[W.ERR_PARTICIPANT_NOT_IN_ROOM = 1800702] = "ERR_PARTICIPANT_NOT_IN_ROOM", W[W.ERR_EXITING_ROOM_STILL_IN_PROGRESS = 1800703] = "ERR_EXITING_ROOM_STILL_IN_PROGRESS", W[W.ERR_FAILED_TO_ESTABLISH_CONNECTION_TO_SEND_STREAM = 1800704] = "ERR_FAILED_TO_ESTABLISH_CONNECTION_TO_SEND_STREAM", W[W.ERR_FAILED_TO_ESTABLISH_CONNECTION_TO_RECEIVE_STREAM = 1800705] = "ERR_FAILED_TO_ESTABLISH_CONNECTION_TO_RECEIVE_STREAM", W[W.ERR_LOCAL_PARTICIPANT_LOST_CONNECTION = 1800706] = "ERR_LOCAL_PARTICIPANT_LOST_CONNECTION", W[W.INVALID_PARAMETER_VALUE = 1800300] = "INVALID_PARAMETER_VALUE", W[W.INVALID_PARAMETER_TYPE = 1800301] = "INVALID_PARAMETER_TYPE", W[W.INSTANCE_NOT_INITIALIZED = 1800302] = "INSTANCE_NOT_INITIALIZED", W[W.USER_NOT_AUTHENTICATED = 1800303] = "USER_NOT_AUTHENTICATED", W[W.CAMERA_ALREADY_SWITCHING = 1800400] = "CAMERA_ALREADY_SWITCHING", W[W.ERR_CAMERA_SWITCH = 1800401] = "ERR_CAMERA_SWITCH", W[W.ERR_CHANGING_AUDIO_DEVICE = 1800402] = "ERR_CHANGING_AUDIO_DEVICE", W[W.ERR_CAPTURE_NOT_ALLOWED_ON_AUDIO_CALL = 1800600] = "ERR_CAPTURE_NOT_ALLOWED_ON_AUDIO_CALL", W[W.ERR_VIDEO_VIEW_NOT_READY = 1800601] = "ERR_VIDEO_VIEW_NOT_READY", W[W.ERR_VIDEO_CALL_NOT_CONNECTED_YET = 1800602] = "ERR_VIDEO_CALL_NOT_CONNECTED_YET", W[W.ERR_FAILED_TO_GET_IMAGE_FROM_VIDEO_STREAM = 1800603] = "ERR_FAILED_TO_GET_IMAGE_FROM_VIDEO_STREAM", W[W.ERR_SERVER_INTERNAL_ERROR = 1400999] = "ERR_SERVER_INTERNAL_ERROR", W[W.ERR_INVALID_CALL_STATUS = 1400101] = "ERR_INVALID_CALL_STATUS", W[W.ERR_CALL_DOES_NOT_EXIST = 1400102] = "ERR_CALL_DOES_NOT_EXIST", W[W.ERR_CALLEE_DOES_NOT_EXIST = 1400103] = "ERR_CALLEE_DOES_NOT_EXIST", W[W.ERR_DIAL_MYSELF = 1400104] = "ERR_DIAL_MYSELF", W[W.ERR_NO_PERMISSION = 1400105] = "ERR_NO_PERMISSION", W[W.ERR_CALLEE_NEVER_AUTHENTICATE = 1400106] = "ERR_CALLEE_NEVER_AUTHENTICATE", W[W.ERR_ROOM_MAX_PARTICIPANTS = 1400120] = "ERR_ROOM_MAX_PARTICIPANTS", W[W.ERR_INVALID_ROOM_PARTICIPANT = 1400121] = "ERR_INVALID_ROOM_PARTICIPANT", W[W.ERR_CLIENT_ALREADY_ENTERED = 1400122] = "ERR_CLIENT_ALREADY_ENTERED", W[W.ERR_SEND_ENDPOINT_CANNOT_ATTACH = 1400123] = "ERR_SEND_ENDPOINT_CANNOT_ATTACH", W[W.ERR_PARTICIPANT_ALREADY_HAS_SEND_ENDPOINT = 1400124] = "ERR_PARTICIPANT_ALREADY_HAS_SEND_ENDPOINT", W[W.ERR_ROOM_DELETED = 1400126] = "ERR_ROOM_DELETED", W[W.ERR_CALL_NOT_CONNECTED_YET = 1800610] = "ERR_CALL_NOT_CONNECTED_YET", W[W.ERR_WRONG_RECORDING_TYPE_FOR_AUDIO_CALL = 1800611] = "ERR_WRONG_RECORDING_TYPE_FOR_AUDIO_CALL", W[W.ERR_RECORDING_ALREADY_IN_PROGRESS = 1800612] = "ERR_RECORDING_ALREADY_IN_PROGRESS", W[W.ERR_FAILED_TO_OPEN_FILE = 1800613] = "ERR_FAILED_TO_OPEN_FILE", W[W.ERR_FAILED_TO_START_RECORDING = 1800614] = "ERR_FAILED_TO_START_RECORDING", W[W.ERR_FAILED_TO_STOP_RECORDING = 1800615] = "ERR_FAILED_TO_STOP_RECORDING", W[W.ERR_NOT_SUPPORTED_BROWSER_FOR_RECORDING = 1800616] = "ERR_NOT_SUPPORTED_BROWSER_FOR_RECORDING", W[W.ERR_INVALID_RECORDING_TYPE = 1800617] = "ERR_INVALID_RECORDING_TYPE", W[W.ERR_NOT_SUPPORTED_OS_VERSION_FOR_RECORDING = 1800618] = "ERR_NOT_SUPPORTED_OS_VERSION_FOR_RECORDING", W[W.ERR_SCREEN_SHARE_RESTRICTED_FROM_AUDIO_CALL = 1800620] = "ERR_SCREEN_SHARE_RESTRICTED_FROM_AUDIO_CALL", W[W.ERR_SCREEN_SHARE_REQUEST_BEFORE_CALL_IS_CONNECTED = 1800621] = "ERR_SCREEN_SHARE_REQUEST_BEFORE_CALL_IS_CONNECTED", W[W.ERR_SCREEN_SHARE_ALREADY_IN_PROGRESS = 1800622] = "ERR_SCREEN_SHARE_ALREADY_IN_PROGRESS", W[W.ERR_NO_SCREEN_SHARE_EXISTS = 1800623] = "ERR_NO_SCREEN_SHARE_EXISTS", W[W.ERR_NOT_SUPPORTED_BROWSER_FOR_SCREEN_SHARE = 1800625] = "ERR_NOT_SUPPORTED_BROWSER_FOR_SCREEN_SHARE", W[W.ERR_SCREEN_SHARE_FAILED_DUE_TO_UNKNOWN_REASON = 1800626] = "ERR_SCREEN_SHARE_FAILED_DUE_TO_UNKNOWN_REASON", W[W.ERR_NOT_SUPPORTED_APP_STATE_FOR_SCREEN_SHARE = 1800627] = "ERR_NOT_SUPPORTED_APP_STATE_FOR_SCREEN_SHARE", W[W.ERR_PERMISSION_DENIED_FOR_SCREEN_SHARE = 1800628] = "ERR_PERMISSION_DENIED_FOR_SCREEN_SHARE", W[W.ERR_SELECTED_CONTENT_NOT_EXIST = 1800629] = "ERR_SELECTED_CONTENT_NOT_EXIST", W[W.ERR_SELECTED_CONTENT_INACCESSIBLE = 1800630] = "ERR_SELECTED_CONTENT_INACCESSIBLE", W[W.ERR_MEDIA_STREAM_NOT_ALLOWED_ON_HOLD = 1800631] = "ERR_MEDIA_STREAM_NOT_ALLOWED_ON_HOLD", W[W.ERR_CALL_ALREADY_ON_HOLD = 1800801] = "ERR_CALL_ALREADY_ON_HOLD", W[W.ERR_ACTIVE_CALL_IN_PROGRESS = 1800802] = "ERR_ACTIVE_CALL_IN_PROGRESS", W[W.ERR_ANOTHER_CALL_IN_PROGRESS = 1800803] = "ERR_ANOTHER_CALL_IN_PROGRESS";

  function _r(e, t, n) {
    (t = f(t)) in e ? b.f(e, t, i(0, n)) : e[t] = n;
  }

  var pr = function () {
    function e() {
      Un(this, e);
    }

    return Fn(e, null, [{
      key: "getErrorMessage",
      value: function value(e) {
        var t = (1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}).invalidParameter,
            n = void 0 === t ? "" : t;

        switch (e) {
          case Tn.DIAL_CANCELED:
            return "Call canceled before receiving a callback.";

          case Tn.MY_USER_ID_NOT_ALLOWED:
            return "The caller can't dial their own user ID.";

          case Tn.ERR_REQUEST_FAILED:
            return "The http request failed.";

          case Tn.ERR_WEBSOCKET_CONNECTION_NOT_OPENED:
            return "Websocket connection not established.";

          case Tn.ERR_WEBSOCKET_CONNECTION_FAILED:
            return "Websocket connection failed.";

          case Tn.ERR_NO_RESPONSE_DUE_TO_TIMEOUT:
            return "The request failed to receive a response due to timeout.";

          case Tn.ERR_REQUEST_FAILED_DUE_TO_WEBSOCKET_CONNECTION_LOST:
            return "The request failed because the websocket connection is lost.";

          case Tn.ERR_WRONG_RESPONSE:
            return "The response contains an unexpected object type of data.";

          case Tn.ERR_QUERY_IN_PROGRESS:
            return "The previous query is still in progress.";

          case Tn.INTERNAL_SERVER_ERROR:
            return "An internal server error has occurred.";

          case Tn.ERR_MALFORMED_DATA:
            return "The data format of the response is invalid.";

          case Tn.INVALID_PARAMETER_VALUE:
            return "".concat(n, " is an invalid or empty value.");

          case Tn.INVALID_PARAMETER_TYPE:
            return "The data type of ".concat(n, " is invalid.");

          case Tn.INSTANCE_NOT_INITIALIZED:
            return "SendBirdCall instance not initialized.";

          case Tn.USER_NOT_AUTHENTICATED:
            return "The user is not authenticated.";

          case Tn.CAMERA_ALREADY_SWITCHING:
            return "Camera is already switching.";

          case Tn.ERR_CAMERA_SWITCH:
            return "A camera switch error has occurred.";

          case Tn.ERR_CHANGING_AUDIO_DEVICE:
            return "An error occurred while changing audio device.";

          case Tn.ERR_CAPTURE_NOT_ALLOWED_ON_AUDIO_CALL:
            return "Capturing a video view isn't allowed while on an audio call.";

          case Tn.ERR_VIDEO_VIEW_NOT_READY:
            return "A video view isn't ready to be captured.";

          case Tn.ERR_VIDEO_CALL_NOT_CONNECTED_YET:
            return "A video call isn't connected yet therefore can't capture a video view.";

          case Tn.ERR_FAILED_TO_GET_IMAGE_FROM_VIDEO_STREAM:
            return "An error occurred while getting an image form the video stream.";

          case Tn.ERR_ROOM_MAX_PARTICIPANTS:
            return "The room has reached max participants.";

          case Tn.ERR_INVALID_ROOM_PARTICIPANT:
            return "The room participant argument is not valid.";

          case Tn.ERR_CLIENT_ALREADY_ENTERED:
            return "The given client is already entered.";

          case Tn.ERR_SEND_ENDPOINT_CANNOT_ATTACH:
            return "The send endpoint failed to attach.";

          case Tn.ERR_PARTICIPANT_ALREADY_HAS_SEND_ENDPOINT:
            return "The given participant already has send endpoint.";

          case Tn.ERR_CALL_NOT_CONNECTED_YET:
            return "A call isn’t connected yet therefore can’t start media recording.";

          case Tn.ERR_WRONG_RECORDING_TYPE_FOR_AUDIO_CALL:
            return "A wrong recording type is selected in an audio call.";

          case Tn.ERR_RECORDING_ALREADY_IN_PROGRESS:
            return "An ongoing recording session is already in progress.";

          case Tn.ERR_FAILED_TO_OPEN_FILE:
            return "Couldn't open a recording file due to an error.";

          case Tn.ERR_FAILED_TO_START_RECORDING:
            return "Couldn't start a recording session due to an error.";

          case Tn.ERR_FAILED_TO_STOP_RECORDING:
            return "Coudln't stop a recording session due to an error.";

          case Tn.ERR_NOT_SUPPORTED_BROWSER_FOR_RECORDING:
            return "The browser doesn't support media recording.";

          case Tn.ERR_INVALID_RECORDING_TYPE:
            return "Invalid recording type is selected.";

          case Tn.ERR_NOT_SUPPORTED_OS_VERSION_FOR_RECORDING:
            return "The operating system version doesn't support media recording.";

          case Tn.ERR_SCREEN_SHARE_RESTRICTED_FROM_AUDIO_CALL:
            return "Screen share is restricted from audio calls.";

          case Tn.ERR_SCREEN_SHARE_REQUEST_BEFORE_CALL_IS_CONNECTED:
            return "A call isn't connected yet, but the request for screen share has been made.";

          case Tn.ERR_SCREEN_SHARE_ALREADY_IN_PROGRESS:
            return "The user is trying to share the screen while the previous request is still in progress.";

          case Tn.ERR_MEDIA_STREAM_NOT_ALLOWED_ON_HOLD:
            return "Screen sharing or any other actions that need media streaming as well as capturing screen aren't allowed while a call is on hold.";

          case Tn.ERR_NOT_SUPPORTED_BROWSER_FOR_SCREEN_SHARE:
            return "The browser doesn't support screen share.";

          case Tn.ERR_SCREEN_SHARE_FAILED_DUE_TO_UNKNOWN_REASON:
            return "Screen share failed due to unknown reason.";

          case Tn.ERR_NOT_SUPPORTED_APP_STATE_FOR_SCREEN_SHARE:
            return "The application state isn't supported for screen share.";

          case Tn.ERR_PERMISSION_DENIED_FOR_SCREEN_SHARE:
            return "An access permission denied for screen share.";

          case Tn.ERR_SELECTED_CONTENT_NOT_EXIST:
            return "The selected content for screen share doesn't exist.";

          case Tn.ERR_SELECTED_CONTENT_INACCESSIBLE:
            return "The selected content for screen share is inaccessible by the system.";

          case Tn.ERR_PARTICIPANT_ALREADY_IN_ROOM:
            return "The participant is trying to enter the same room they're already in.";

          case Tn.ERR_ENTERING_ROOM_STILL_IN_PROGRESS:
            return "The participant is trying to enter the room while the previous request is still in progress.";

          case Tn.ERR_PARTICIPANT_NOT_IN_ROOM:
            return "The participant is not in the room and the request can't be processed.";

          case Tn.ERR_EXITING_ROOM_STILL_IN_PROGRESS:
            return "The participant is trying to exit the same room.";

          case Tn.ERR_FAILED_TO_ESTABLISH_CONNECTION_TO_SEND_STREAM:
            return "Couldn't establish a connection to send media streaming.";

          case Tn.ERR_FAILED_TO_ESTABLISH_CONNECTION_TO_RECEIVE_STREAM:
            return "Couldn't establish a connection to receive media streaming.";

          case Tn.ERR_LOCAL_PARTICIPANT_LOST_CONNECTION:
            return "The local participant exited the room due to lost connection.";

          case Tn.ERR_CALL_ALREADY_ON_HOLD:
            return "The call is already on hold.";

          case Tn.ERR_ACTIVE_CALL_IN_PROGRESS:
            return "The active call is in progress. Cannot remove the active call from a hold because the call is not on hold.";

          case Tn.ERR_ANOTHER_CALL_IN_PROGRESS:
            return "The active call is in progress. Cannot remove a hold from another call while there is an active call.";

          default:
            return "";
        }
      }
    }]), e;
  }(),
      Q = ee("navigator", "userAgent") || "",
      H = p.process,
      Pt = H && H.versions,
      vn = Pt && Pt.v8;

  vn ? Ar = (Cr = vn.split("."))[0] + Cr[1] : Q && (!(Cr = Q.match(/Edge\/(\d+)/)) || 74 <= Cr[1]) && (Cr = Q.match(/Chrome\/(\d+)/)) && (Ar = Cr[1]);

  var vr = Ar && +Ar,
      yr = ue("species"),
      o = function o(t) {
    return 51 <= vr || !u(function () {
      var e = [];
      return (e.constructor = {})[yr] = function () {
        return {
          foo: 1
        };
      }, 1 !== e[t](Boolean).foo;
    });
  },
      mr = ue("isConcatSpreadable"),
      gr = 9007199254740991,
      Er = "Maximum allowed index exceeded",
      W = 51 <= vr || !u(function () {
    var e = [];
    return e[mr] = !1, e.concat()[0] !== e;
  }),
      H = o("concat");

  ae({
    target: "Array",
    proto: !0,
    forced: !W || !H
  }, {
    concat: function concat(e) {
      for (var t, n, r, i = ce(this), a = le(i, 0), o = 0, s = -1, c = arguments.length; s < c; s++) {
        if (function (e) {
          if (!h(e)) return !1;
          var t = e[mr];
          return void 0 !== t ? !!t : Le(e);
        }(r = -1 === s ? i : arguments[s])) {
          if (n = ne(r.length), gr < o + n) throw TypeError(Er);

          for (t = 0; t < n; t++, o++) {
            t in r && _r(a, o, r[t]);
          }
        } else {
          if (gr <= o) throw TypeError(Er);

          _r(a, o++, r);
        }
      }

      return a.length = o, a;
    }
  });
  var kr = z.map,
      Pt = o("map"),
      vn = a("map");
  ae({
    target: "Array",
    proto: !0,
    forced: !Pt || !vn
  }, {
    map: function map(e) {
      return kr(this, e, 1 < arguments.length ? arguments[1] : void 0);
    }
  });

  function Rr() {
    var e = w(this),
        t = "";
    return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.sticky && (t += "y"), t;
  }

  var Cr = "toString",
      Ir = RegExp.prototype,
      wr = Ir[Cr],
      Ar = u(function () {
    return "/a/b" != wr.call({
      source: "a",
      flags: "b"
    });
  }),
      W = wr.name != Cr;
  (Ar || W) && fe(RegExp.prototype, Cr, function () {
    var e = w(this),
        t = String(e.source),
        n = e.flags;
    return "/" + t + "/" + String(void 0 === n && e instanceof RegExp && !("flags" in Ir) ? Rr.call(e) : n);
  }, {
    unsafe: !0
  });

  var Tr,
      Sr = "".repeat || function (e) {
    var t = String(l(this)),
        n = "",
        r = te(e);
    if (r < 0 || r == 1 / 0) throw RangeError("Wrong number of repetitions");

    for (; 0 < r; (r >>>= 1) && (t += t)) {
      1 & r && (n += t);
    }

    return n;
  },
      br = Math.ceil,
      H = function H(i) {
    return function (e, t, n) {
      var r = String(l(e)),
          e = r.length,
          n = void 0 === n ? " " : String(n),
          t = ne(t);
      return t <= e || "" == n ? r : (e = t - e, (n = Sr.call(n, br(e / n.length))).length > e && (n = n.slice(0, e)), i ? r + n : n + r);
    };
  },
      Pt = {
    start: H(!1),
    end: H(!0)
  },
      vn = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(Q),
      Or = Pt.start;

  ae({
    target: "String",
    proto: !0,
    forced: vn
  }, {
    padStart: function padStart(e) {
      return Or(this, e, 1 < arguments.length ? arguments[1] : void 0);
    }
  }), (Ar = Tr = Tr || {}).VERBOSE = "VERBOSE", Ar.DEBUG = "DEBUG", Ar.INFO = "INFO", Ar.WARNING = "WARNING", Ar.ERROR = "ERROR", Ar.NONE = "NONE";
  var Dr = {
    VERBOSE: {
      level: -1,
      name: Tr.VERBOSE,
      public: !1
    },
    DEBUG: {
      level: 1,
      name: Tr.DEBUG,
      public: !1
    },
    INFO: {
      level: 2,
      name: Tr.INFO,
      public: !0
    },
    WARNING: {
      level: 3,
      name: Tr.WARNING,
      public: !0
    },
    ERROR: {
      level: 4,
      name: Tr.ERROR,
      public: !0
    },
    NONE: {
      level: 100,
      name: Tr.NONE,
      public: !0
    }
  },
      Nr = z.some,
      W = $("some"),
      Cr = a("some");
  ae({
    target: "Array",
    proto: !0,
    forced: !W || !Cr
  }, {
    some: function some(e) {
      return Nr(this, e, 1 < arguments.length ? arguments[1] : void 0);
    }
  });
  H = u(function () {
    Ke(1);
  });
  ae({
    target: "Object",
    stat: !0,
    forced: H
  }, {
    keys: function keys(e) {
      return Ke(ce(e));
    }
  });

  function Lr(e, t) {
    var n;
    return void 0 === (e = w(e).constructor) || null == (n = w(e)[Ur]) ? t : oe(n);
  }

  function xr(e) {
    var t;
    qr.hasOwnProperty(e) && (t = qr[e], delete qr[e], t());
  }

  function Pr(e) {
    return function () {
      xr(e);
    };
  }

  var Mr,
      Pt = p.Promise,
      Ur = ue("species"),
      vn = /(iphone|ipod|ipad).*applewebkit/i.test(Q),
      Vr = "process" == r(p.process),
      Fr = p.location,
      Ar = p.setImmediate,
      W = p.clearImmediate,
      Gr = p.process,
      Cr = p.MessageChannel,
      Br = p.Dispatch,
      jr = 0,
      qr = {},
      Hr = "onreadystatechange",
      H = function H(e) {
    xr(e.data);
  },
      Q = function Q(e) {
    p.postMessage(e + "", Fr.protocol + "//" + Fr.host);
  };

  Ar && W || (Ar = function Ar(e) {
    for (var t = [], n = 1; n < arguments.length;) {
      t.push(arguments[n++]);
    }

    return qr[++jr] = function () {
      ("function" == typeof e ? e : Function(e)).apply(void 0, t);
    }, Mr(jr), jr;
  }, W = function W(e) {
    delete qr[e];
  }, Vr ? Mr = function Mr(e) {
    Gr.nextTick(Pr(e));
  } : Br && Br.now ? Mr = function Mr(e) {
    Br.now(Pr(e));
  } : Cr && !vn ? (Jr = (Cr = new Cr()).port2, Cr.port1.onmessage = H, Mr = se(Jr.postMessage, Jr, 1)) : p.addEventListener && "function" == typeof postMessage && !p.importScripts && Fr && "file:" !== Fr.protocol && !u(Q) ? (Mr = Q, p.addEventListener("message", H, !1)) : Mr = Hr in n("script") ? function (e) {
    Ze.appendChild(n("script"))[Hr] = function () {
      Ze.removeChild(this), xr(e);
    };
  } : function (e) {
    setTimeout(Pr(e), 0);
  });
  var zr,
      Wr,
      Kr,
      Yr,
      Zr,
      Qr,
      Xr,
      $r,
      Jr = {
    set: Ar,
    clear: W
  },
      Q = T.f,
      ei = Jr.set,
      H = p.MutationObserver || p.WebKitMutationObserver,
      Ar = p.document,
      ti = p.process,
      W = p.Promise,
      Q = Q(p, "queueMicrotask"),
      Q = Q && Q.value;
  Q || (zr = function zr() {
    var e, t;

    for (Vr && (e = ti.domain) && e.exit(); Wr;) {
      t = Wr.fn, Wr = Wr.next;

      try {
        t();
      } catch (e) {
        throw Wr ? Yr() : Kr = void 0, e;
      }
    }

    Kr = void 0, e && e.enter();
  }, Yr = !vn && !Vr && H && Ar ? (Zr = !0, Qr = Ar.createTextNode(""), new H(zr).observe(Qr, {
    characterData: !0
  }), function () {
    Qr.data = Zr = !Zr;
  }) : W && W.resolve ? (Xr = W.resolve(void 0), $r = Xr.then, function () {
    $r.call(Xr, zr);
  }) : Vr ? function () {
    ti.nextTick(zr);
  } : function () {
    ei.call(p, zr);
  });

  function ni(e) {
    var n, r;
    this.promise = new e(function (e, t) {
      if (void 0 !== n || void 0 !== r) throw TypeError("Bad Promise constructor");
      n = e, r = t;
    }), this.resolve = oe(n), this.reject = oe(r);
  }

  function ri(e, t) {
    return w(e), h(t) && t.constructor === e ? t : ((0, (e = pi.f(e)).resolve)(t), e.promise);
  }

  function ii(e) {
    try {
      return {
        error: !1,
        value: e()
      };
    } catch (e) {
      return {
        error: !0,
        value: e
      };
    }
  }

  function ai(e) {
    var t;
    return !(!h(e) || "function" != typeof (t = e.then)) && t;
  }

  function oi(d, h) {
    var f;
    d.notified || (d.notified = !0, f = d.reactions, _i(function () {
      for (var e = d.value, t = 1 == d.state, n = 0; f.length > n;) {
        var r,
            i,
            a,
            o = f[n++],
            s = t ? o.ok : o.fail,
            c = o.resolve,
            u = o.reject,
            l = o.domain;

        try {
          s ? (t || (2 === d.rejection && xi(d), d.rejection = 1), !0 === s ? r = e : (l && l.enter(), r = s(e), l && (l.exit(), a = !0)), r === o.promise ? u(Ci("Promise-chain cycle")) : (i = ai(r)) ? i.call(r, c, u) : c(r)) : u(e);
        } catch (e) {
          l && !a && l.exit(), u(e);
        }
      }

      d.reactions = [], d.notified = !1, h && !d.rejection && Ni(d);
    }));
  }

  function si(e, t, n) {
    var r, i;
    bi ? ((r = Ii.createEvent("Event")).promise = t, r.reason = n, r.initEvent(e, !1, !0), p.dispatchEvent(r)) : r = {
      promise: t,
      reason: n
    }, !Oi && (i = p["on" + e]) ? i(r) : e === Di && function (e, t) {
      var n = p.console;
      n && n.error && (1 === arguments.length ? n.error(e) : n.error(e, t));
    }("Unhandled promise rejection", n);
  }

  function ci(t, n, r) {
    return function (e) {
      t(n, e, r);
    };
  }

  function ui(e, t, n) {
    e.done || (e.done = !0, n && (e = n), e.value = t, e.state = 2, oi(e, !0));
  }

  var li,
      di,
      hi,
      fi,
      _i = Q || function (e) {
    e = {
      fn: e,
      next: void 0
    };
    Kr && (Kr.next = e), Wr || (Wr = e, Yr()), Kr = e;
  },
      pi = {
    f: function f(e) {
      return new ni(e);
    }
  },
      vi = Jr.set,
      yi = ue("species"),
      mi = "Promise",
      gi = he.get,
      Ei = he.set,
      ki = he.getterFor(mi),
      _Ri = Pt,
      Ci = p.TypeError,
      Ii = p.document,
      wi = p.process,
      Ai = ee("fetch"),
      Ti = pi.f,
      Si = Ti,
      bi = !!(Ii && Ii.createEvent && p.dispatchEvent),
      Oi = "function" == typeof PromiseRejectionEvent,
      Di = "unhandledrejection",
      W = De(mi, function () {
    if (!(q(_Ri) !== String(_Ri))) {
      if (66 === vr) return !0;
      if (!Vr && !Oi) return !0;
    }

    if (51 <= vr && /native code/.test(_Ri)) return !1;

    function e(e) {
      e(function () {}, function () {});
    }

    var t = _Ri.resolve(1);

    return (t.constructor = {})[yi] = e, !(t.then(function () {}) instanceof e);
  }),
      Q = W || !Ht(function (e) {
    _Ri.all(e).catch(function () {});
  }),
      Ni = function Ni(i) {
    vi.call(p, function () {
      var e,
          t = i.facade,
          n = i.value,
          r = Li(i);
      if (r && (e = ii(function () {
        Vr ? wi.emit("unhandledRejection", n, t) : si(Di, t, n);
      }), i.rejection = Vr || Li(i) ? 2 : 1, e.error)) throw e.value;
    });
  },
      Li = function Li(e) {
    return 1 !== e.rejection && !e.parent;
  },
      xi = function xi(t) {
    vi.call(p, function () {
      var e = t.facade;
      Vr ? wi.emit("rejectionHandled", e) : si("rejectionhandled", e, t.value);
    });
  },
      Pi = function Pi(n, e, t) {
    if (!n.done) {
      n.done = !0, t && (n = t);

      try {
        if (n.facade === e) throw Ci("Promise can't be resolved itself");
        var r = ai(e);
        r ? _i(function () {
          var t = {
            done: !1
          };

          try {
            r.call(e, ci(Pi, t, n), ci(ui, t, n));
          } catch (e) {
            ui(t, e, n);
          }
        }) : (n.value = e, n.state = 1, oi(n, !1));
      } catch (e) {
        ui({
          done: !1
        }, e, n);
      }
    }
  };

  function Mi(e, t) {
    return RegExp(e, t);
  }

  W && (_Ri = function Ri(e) {
    xt(this, _Ri, mi), oe(e), li.call(this);
    var t = gi(this);

    try {
      e(ci(Pi, t), ci(ui, t));
    } catch (e) {
      ui(t, e);
    }
  }, (li = function li(e) {
    Ei(this, {
      type: mi,
      done: !1,
      notified: !1,
      parent: !1,
      reactions: [],
      rejection: !1,
      state: 0,
      value: void 0
    });
  }).prototype = Wt(_Ri.prototype, {
    then: function then(e, t) {
      var n = ki(this),
          r = Ti(Lr(this, _Ri));
      return r.ok = "function" != typeof e || e, r.fail = "function" == typeof t && t, r.domain = Vr ? wi.domain : void 0, n.parent = !0, n.reactions.push(r), 0 != n.state && oi(n, !1), r.promise;
    },
    catch: function _catch(e) {
      return this.then(void 0, e);
    }
  }), di = function di() {
    var e = new li(),
        t = gi(e);
    this.promise = e, this.resolve = ci(Pi, t), this.reject = ci(ui, t);
  }, pi.f = Ti = function Ti(e) {
    return e === _Ri || e === hi ? new di() : Si(e);
  }, "function" == typeof Pt && (fi = Pt.prototype.then, fe(Pt.prototype, "then", function (e, t) {
    var n = this;
    return new _Ri(function (e, t) {
      fi.call(n, e, t);
    }).then(e, t);
  }, {
    unsafe: !0
  }), "function" == typeof Ai && ae({
    global: !0,
    enumerable: !0,
    forced: !0
  }, {
    fetch: function fetch(e) {
      return ri(_Ri, Ai.apply(p, arguments));
    }
  }))), ae({
    global: !0,
    wrap: !0,
    forced: W
  }, {
    Promise: _Ri
  }), st(_Ri, mi, !1), Kt(mi), hi = ee(mi), ae({
    target: mi,
    stat: !0,
    forced: W
  }, {
    reject: function reject(e) {
      var t = Ti(this);
      return t.reject.call(void 0, e), t.promise;
    }
  }), ae({
    target: mi,
    stat: !0,
    forced: W
  }, {
    resolve: function resolve(e) {
      return ri(this, e);
    }
  }), ae({
    target: mi,
    stat: !0,
    forced: Q
  }, {
    all: function all(e) {
      var s = this,
          t = Ti(s),
          c = t.resolve,
          u = t.reject,
          n = ii(function () {
        var r = oe(s.resolve),
            i = [],
            a = 0,
            o = 1;
        Lt(e, function (e) {
          var t = a++,
              n = !1;
          i.push(void 0), o++, r.call(s, e).then(function (e) {
            n || (n = !0, i[t] = e, --o || c(i));
          }, u);
        }), --o || c(i);
      });
      return n.error && u(n.value), t.promise;
    },
    race: function race(e) {
      var n = this,
          r = Ti(n),
          i = r.reject,
          t = ii(function () {
        var t = oe(n.resolve);
        Lt(e, function (e) {
          t.call(n, e).then(r.resolve, i);
        });
      });
      return t.error && i(t.value), r.promise;
    }
  });
  var Jr = {
    UNSUPPORTED_Y: u(function () {
      var e = Mi("a", "y");
      return e.lastIndex = 2, null != e.exec("abcd");
    }),
    BROKEN_CARET: u(function () {
      var e = Mi("^r", "gy");
      return e.lastIndex = 2, null != e.exec("str");
    })
  },
      Ui = RegExp.prototype.exec,
      Vi = String.prototype.replace,
      Pt = Ui,
      Fi = (W = /a/, Q = /b*/g, Ui.call(W, "a"), Ui.call(Q, "a"), 0 !== W.lastIndex || 0 !== Q.lastIndex),
      Gi = Jr.UNSUPPORTED_Y || Jr.BROKEN_CARET,
      Bi = void 0 !== /()??/.exec("")[1];
  (Fi || Bi || Gi) && (Pt = function Pt(e) {
    var t,
        n,
        r,
        i,
        a = this,
        o = Gi && a.sticky,
        s = Rr.call(a),
        c = a.source,
        u = 0,
        l = e;
    return o && (-1 === (s = s.replace("y", "")).indexOf("g") && (s += "g"), l = String(e).slice(a.lastIndex), 0 < a.lastIndex && (!a.multiline || a.multiline && "\n" !== e[a.lastIndex - 1]) && (c = "(?: " + c + ")", l = " " + l, u++), n = new RegExp("^(?:" + c + ")", s)), Bi && (n = new RegExp("^" + c + "$(?!\\s)", s)), Fi && (t = a.lastIndex), r = Ui.call(o ? n : a, l), o ? r ? (r.input = r.input.slice(u), r[0] = r[0].slice(u), r.index = a.lastIndex, a.lastIndex += r[0].length) : a.lastIndex = 0 : Fi && r && (a.lastIndex = a.global ? r.index + r[0].length : t), Bi && r && 1 < r.length && Vi.call(r[0], n, function () {
      for (i = 1; i < arguments.length - 2; i++) {
        void 0 === arguments[i] && (r[i] = void 0);
      }
    }), r;
  });
  var ji = Pt;
  ae({
    target: "RegExp",
    proto: !0,
    forced: /./.exec !== ji
  }, {
    exec: ji
  });

  function qi(e, t, n) {
    return t + (n ? Qi(e, t).length : 1);
  }

  function Hi(e, t) {
    var n = e.exec;

    if ("function" == typeof n) {
      n = n.call(e, t);
      if ("object" != typeof n) throw TypeError("RegExp exec method returned something other than an Object or null");
      return n;
    }

    if ("RegExp" !== r(e)) throw TypeError("RegExp#exec called on incompatible receiver");
    return ji.call(e, t);
  }

  var zi = ue("species"),
      Wi = !u(function () {
    var e = /./;
    return e.exec = function () {
      var e = [];
      return e.groups = {
        a: "7"
      }, e;
    }, "7" !== "".replace(e, "$<a>");
  }),
      Ki = "$0" === "a".replace(/./, "$0"),
      Q = ue("replace"),
      Yi = !!/./[Q] && "" === /./[Q]("a", "$0"),
      Zi = !u(function () {
    var e = /(?:)/,
        t = e.exec;

    e.exec = function () {
      return t.apply(this, arguments);
    };

    e = "ab".split(e);
    return 2 !== e.length || "a" !== e[0] || "b" !== e[1];
  }),
      Jr = function Jr(n, e, t, r) {
    var a,
        i,
        o = ue(n),
        s = !u(function () {
      var e = {};
      return e[o] = function () {
        return 7;
      }, 7 != ""[n](e);
    }),
        c = s && !u(function () {
      var e = !1,
          t = /a/;
      return "split" === n && ((t = {
        constructor: {}
      }).constructor[zi] = function () {
        return t;
      }, t.flags = "", t[o] = /./[o]), t.exec = function () {
        return e = !0, null;
      }, t[o](""), !e;
    });
    s && c && ("replace" !== n || Wi && Ki && !Yi) && ("split" !== n || Zi) || (a = /./[o], t = (c = t(o, ""[n], function (e, t, n, r, i) {
      return t.exec === ji ? s && !i ? {
        done: !0,
        value: a.call(t, n, r)
      } : {
        done: !0,
        value: e.call(n, t, r)
      } : {
        done: !1
      };
    }, {
      REPLACE_KEEPS_$0: Ki,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: Yi
    }))[0], i = c[1], fe(String.prototype, n, t), fe(RegExp.prototype, o, 2 == e ? function (e, t) {
      return i.call(e, this, t);
    } : function (e) {
      return i.call(e, this);
    })), r && O(RegExp.prototype[o], "sham", !0);
  },
      Qi = yn.charAt;

  Jr("match", 1, function (r, c, u) {
    return [function (e) {
      var t = l(this),
          n = null == e ? void 0 : e[r];
      return void 0 !== n ? n.call(e, t) : new RegExp(e)[r](String(t));
    }, function (e) {
      var t = u(c, e, this);
      if (t.done) return t.value;
      var n = w(e),
          r = String(this);
      if (!n.global) return Hi(n, r);

      for (var i = n.unicode, a = [], o = n.lastIndex = 0; null !== (s = Hi(n, r));) {
        var s = String(s[0]);
        "" === (a[o] = s) && (n.lastIndex = qi(r, ne(n.lastIndex), i)), o++;
      }

      return 0 === o ? null : a;
    }];
  });
  var Xi = Math.max,
      $i = Math.min,
      Ji = Math.floor,
      ea = /\$([$&'`]|\d\d?|<[^>]*>)/g,
      ta = /\$([$&'`]|\d\d?)/g;
  Jr("replace", 2, function (i, E, k, e) {
    var R = e.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE,
        C = e.REPLACE_KEEPS_$0,
        I = R ? "$" : "$0";
    return [function (e, t) {
      var n = l(this),
          r = null == e ? void 0 : e[i];
      return void 0 !== r ? r.call(e, n, t) : E.call(String(n), e, t);
    }, function (e, t) {
      if (!R && C || "string" == typeof t && -1 === t.indexOf(I)) {
        var n = k(E, e, this, t);
        if (n.done) return n.value;
      }

      var r = w(e),
          i = String(this),
          a = "function" == typeof t;
      a || (t = String(t));
      var o,
          s = r.global;
      s && (o = r.unicode, r.lastIndex = 0);

      for (var c = [];;) {
        var u = Hi(r, i);
        if (null === u) break;
        if (c.push(u), !s) break;
        "" === String(u[0]) && (r.lastIndex = qi(i, ne(r.lastIndex), o));
      }

      for (var l, d = "", h = 0, f = 0; f < c.length; f++) {
        u = c[f];

        for (var _ = String(u[0]), p = Xi($i(te(u.index), i.length), 0), v = [], y = 1; y < u.length; y++) {
          v.push(void 0 === (l = u[y]) ? l : String(l));
        }

        var m,
            g = u.groups,
            g = a ? (m = [_].concat(v, p, i), void 0 !== g && m.push(g), String(t.apply(void 0, m))) : function (a, o, s, c, u, e) {
          var l = s + a.length,
              d = c.length,
              t = ta;
          void 0 !== u && (u = ce(u), t = ea);
          return E.call(e, t, function (e, t) {
            var n;

            switch (t.charAt(0)) {
              case "$":
                return "$";

              case "&":
                return a;

              case "`":
                return o.slice(0, s);

              case "'":
                return o.slice(l);

              case "<":
                n = u[t.slice(1, -1)];
                break;

              default:
                var r = +t;
                if (0 == r) return e;

                if (d < r) {
                  var i = Ji(r / 10);
                  return 0 === i ? e : i <= d ? void 0 === c[i - 1] ? t.charAt(1) : c[i - 1] + t.charAt(1) : e;
                }

                n = c[r - 1];
            }

            return void 0 === n ? "" : n;
          });
        }(_, i, p, v, g, t);
        h <= p && (d += i.slice(h, p) + g, h = p + _.length);
      }

      return d + i.slice(h);
    }];
  });

  var na = function () {
    qn(a, Yn(Error));
    var i = Xn(a);

    function a(e) {
      var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
          n = t.message,
          r = t.error,
          t = Zn(t, ["message", "error"]);
      Un(this, a);
      t = n || pr.getErrorMessage(e, t);
      return (t = i.call(this, t)).code = e, t._error = r, t;
    }

    return a;
  }(),
      ra = function () {
    qn(t, na);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return t;
  }();

  function ia(e) {
    return function (t) {
      e.then(function (e) {
        return t(e);
      }, function (e) {
        return t(null, e);
      });
    };
  }

  function aa(t, e) {
    if (Object.keys(t).some(function (e) {
      return "string" != typeof t[e];
    })) {
      var n = Promise.reject(new ra(Tn.INVALID_PARAMETER_TYPE));
      return e && ia(n)(e), [!1, n];
    }

    return [!0];
  }

  function oa(e, t) {
    if (e.some(function (e) {
      return "string" != typeof e;
    })) {
      e = Promise.reject(new ra(Tn.INVALID_PARAMETER_TYPE));
      return t && ia(e)(t), [!1, e];
    }

    return [!0];
  }

  function sa(e, t, n) {
    return (t = e.match(t)) && t.length >= n && parseInt(t[n], 10);
  }

  function ca() {
    var e = {
      browser: null,
      version: null
    };
    if ("undefined" == typeof window || !window.navigator) return e.browser = "Not a browser.", e;
    var t = window.navigator;
    if (t.mozGetUserMedia) e.browser = "firefox", e.version = sa(t.userAgent, /Firefox\/(\d+)\./, 1);else if (t.webkitGetUserMedia || !1 === window.isSecureContext && window.webkitRTCPeerConnection && !window.RTCIceGatherer) e.browser = "chrome", e.version = sa(t.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);else if (t.mediaDevices && t.userAgent.match(/Edge\/(\d+).(\d+)$/)) e.browser = "edge", e.version = sa(t.userAgent, /Edge\/(\d+).(\d+)$/, 2);else {
      if (!window.RTCPeerConnection || !t.userAgent.match(/AppleWebKit\/(\d+)\./)) return e.browser = "Not a supported browser.", e;
      e.browser = "safari", e.version = sa(t.userAgent, /AppleWebKit\/(\d+)\./, 1), e.supportsUnifiedPlan = window.RTCRtpTransceiver && "currentDirection" in window.RTCRtpTransceiver.prototype;
    }
    return e;
  }

  function ua(e) {
    return {
      userId: e.user_id,
      nickname: e.nickname,
      profileUrl: e.profile_url,
      metaData: e.meta_data,
      isActive: e.is_active
    };
  }

  var la,
      da,
      ha = "safari" === ca().browser,
      fa = "firefox" === ca().browser,
      _a = new (function () {
    function e() {
      Un(this, e), this.level = Tr.NONE;
    }

    return Fn(e, [{
      key: "setLoggerLevel",
      value: function value(e) {
        var t;
        return null !== (t = Dr[e]) && void 0 !== t && t.public && (this.level = e), this.level;
      }
    }, {
      key: "verbose",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        this._permit.apply(this, [Tr.VERBOSE].concat(t));
      }
    }, {
      key: "debug",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        this._permit.apply(this, [Tr.DEBUG].concat(t));
      }
    }, {
      key: "info",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        this._permit.apply(this, [Tr.INFO].concat(t));
      }
    }, {
      key: "warning",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        this._permit.apply(this, [Tr.WARNING].concat(t));
      }
    }, {
      key: "error",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        this._permit.apply(this, [Tr.ERROR].concat(t));
      }
    }, {
      key: "_enabledFor",
      value: function value(e) {
        try {
          return Dr[this.level].level <= Dr[e].level;
        } catch (e) {
          return !1;
        }
      }
    }, {
      key: "_getLogType",
      value: function value(e) {
        switch (e) {
          case Tr.ERROR:
            return "error";

          case Tr.WARNING:
            return "warn";

          default:
            return "log";
        }
      }
    }, {
      key: "_getTimeString",
      value: function value(e) {
        var t = e.getFullYear().toString().padStart(2, "0"),
            n = (e.getMonth() + 1).toString().padStart(2, "0"),
            r = e.getDate().toString().padStart(2, "0"),
            i = e.getHours().toString().padStart(2, "0"),
            a = e.getMinutes().toString().padStart(2, "0"),
            o = e.getSeconds().toString().padStart(2, "0"),
            e = e.getMilliseconds().toString().padStart(2, "0");
        return "[".concat(t, ".").concat(n, ".").concat(r, " ").concat(i, ":").concat(a, ":").concat(o, ":").concat(e, "]");
      }
    }, {
      key: "_permit",
      value: function value(e) {
        for (var t, n, r = this._getLogType(e), i = new Date(), a = arguments.length, o = new Array(1 < a ? a - 1 : 0), s = 1; s < a; s++) {
          o[s - 1] = arguments[s];
        }

        this._enabledFor(e) && console && console[r] && (n = "".concat(this._getTimeString(i), " [").concat(e, "]"), (t = console)[r].apply(t, [n].concat(o))), this._logCollector && (e = {
          logDt: i.getTime(),
          logLevel: e,
          logMessage: this._makeSDKLogMessage.apply(this, o)
        }, this._logCollector.addLog(e));
      }
    }, {
      key: "_makeSDKLogMessage",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        var r = t.map(function (e) {
          return JSON.stringify(e);
        });
        return r.toString().replace(/"access_token":".*?"/gm, '"access_token":"*************"').replace(/"password":".*?"/gm, '"password":"*************"').replace(/"sbcall_session_token":".*?"/gm, '"sbcall_session_token":"*************"').replace(/"turn_urls":\[".*?"\]/gm, '"turn_urls":"[*************]"').replace(/(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/gm, "*************").replace(/((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4}))*::((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4}))*|((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4})){7}/gm, "*************");
      }
    }, {
      key: "logCollector",
      set: function set(e) {
        this._logCollector = e;
      }
    }]), e;
  }())(),
      pa = function () {
    qn(t, na);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return t;
  }(),
      va = function () {
    function t(e) {
      Un(this, t);
      e = jn(jn({}, t.default), e);
      this.localMediaView = e.localMediaView, this.remoteMediaView = e.remoteMediaView, this.videoEnabled = e.videoEnabled, this.audioEnabled = e.audioEnabled, this.videoWidth = e.videoWidth, this.videoHeight = e.videoHeight, this.videoFps = e.videoFps, this.frontCamera = e.frontCamera;
    }

    return Fn(t, null, [{
      key: "default",
      get: function get() {
        return {
          localMediaView: null,
          remoteMediaView: null,
          audioEnabled: !0,
          videoEnabled: !0,
          videoWidth: null,
          videoHeight: null,
          videoFps: null,
          frontCamera: !0
        };
      }
    }]), t;
  }();

  (Pt = la = la || {}).NO_ANSWER = "no_answer", Pt.CANCELED = "canceled", Pt.DECLINED = "declined", Pt.OTHER_DEVICE_ACCEPTED = "other_device_accepted", Pt.COMPLETED = "completed", Pt.CONNECTION_LOST = "connection_lost", Pt.TIMED_OUT = "timed_out", Pt.DIAL_FAILED = "dial_failed", Pt.ACCEPT_FAILED = "accept_failed", Pt.UNKNOWN = "unknown", (Q = da = da || {}).CALLER = "dc_caller", Q.CALLEE = "dc_callee";
  var ya = Math.min,
      ma = [].lastIndexOf,
      ga = !!ma && 1 / [1].lastIndexOf(1, -0) < 0,
      Pt = $("lastIndexOf"),
      Q = a("indexOf", {
    ACCESSORS: !0,
    1: 0
  }),
      Pt = ga || !Pt || !Q ? function (e) {
    if (ga) return ma.apply(this, arguments) || 0;
    var t = d(this),
        n = ne(t.length),
        r = n - 1;

    for (1 < arguments.length && (r = ya(r, te(arguments[1]))), r < 0 && (r = n + r); 0 <= r; r--) {
      if (r in t && t[r] === e) return r || 0;
    }

    return -1;
  } : ma;
  ae({
    target: "Array",
    proto: !0,
    forced: Pt !== [].lastIndexOf
  }, {
    lastIndexOf: Pt
  });

  function Ea(e) {
    var t;
    return h(e) && (void 0 !== (t = e[Ra]) ? !!t : "RegExp" == r(e));
  }

  var ka,
      Ra = ue("match"),
      Ca = [].push,
      Ia = Math.min,
      wa = 4294967295,
      Aa = !u(function () {
    return !RegExp(wa, "y");
  });
  Jr("split", 2, function (i, _, p) {
    var v = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || 1 < ".".split(/()()/).length || "".split(/.?/).length ? function (e, t) {
      var n = String(l(this)),
          r = void 0 === t ? wa : t >>> 0;
      if (0 == r) return [];
      if (void 0 === e) return [n];
      if (!Ea(e)) return _.call(n, e, r);

      for (var i, a, o, s = [], t = (e.ignoreCase ? "i" : "") + (e.multiline ? "m" : "") + (e.unicode ? "u" : "") + (e.sticky ? "y" : ""), c = 0, u = new RegExp(e.source, t + "g"); (i = ji.call(u, n)) && !(c < (a = u.lastIndex) && (s.push(n.slice(c, i.index)), 1 < i.length && i.index < n.length && Ca.apply(s, i.slice(1)), o = i[0].length, c = a, s.length >= r));) {
        u.lastIndex === i.index && u.lastIndex++;
      }

      return c === n.length ? !o && u.test("") || s.push("") : s.push(n.slice(c)), s.length > r ? s.slice(0, r) : s;
    } : "0".split(void 0, 0).length ? function (e, t) {
      return void 0 === e && 0 === t ? [] : _.call(this, e, t);
    } : _;
    return [function (e, t) {
      var n = l(this),
          r = null == e ? void 0 : e[i];
      return void 0 !== r ? r.call(e, n, t) : v.call(String(n), e, t);
    }, function (e, t) {
      var n = p(v, e, this, t, v !== _);
      if (n.done) return n.value;
      var r = w(e),
          i = String(this),
          n = Lr(r, RegExp),
          a = r.unicode,
          e = (r.ignoreCase ? "i" : "") + (r.multiline ? "m" : "") + (r.unicode ? "u" : "") + (Aa ? "y" : "g"),
          o = new n(Aa ? r : "^(?:" + r.source + ")", e),
          s = void 0 === t ? wa : t >>> 0;
      if (0 == s) return [];
      if (0 === i.length) return null === Hi(o, i) ? [i] : [];

      for (var c = 0, u = 0, l = []; u < i.length;) {
        o.lastIndex = Aa ? u : 0;
        var d,
            h = Hi(o, Aa ? i : i.slice(u));
        if (null === h || (d = Ia(ne(o.lastIndex + (Aa ? 0 : u)), i.length)) === c) u = qi(i, u, a);else {
          if (l.push(i.slice(c, u)), l.length === s) return l;

          for (var f = 1; f <= h.length - 1; f++) {
            if (l.push(h[f]), l.length === s) return l;
          }

          u = c = d;
        }
      }

      return l.push(i.slice(c)), l;
    }];
  }, !Aa), (Q = ka = ka || {}).REMOTE_AUDIO_AND_VIDEO = "remote_audio_and_video", Q.REMOTE_AUDIO_ONLY = "remote_audio_only", Q.LOCAL_REMOTE_AUDIOS = "local_remote_audios", Q.LOCAL_AUDIO_REMOTE_AUDIO_AND_VIDEO = "local_audio_remote_audio_and_video", Q.LOCAL_AUDIO_AND_VIDEO_REMOTE_AUDIO = "local_audio_and_video_remote_audio";

  var Ta = function () {
    function n(e) {
      var t;
      Un(this, n), this.recordingType = e.recordingType, this.callId = e.callId, e.fileName ? (t = ha ? "mp4" : "webm", e.fileName.toLocaleLowerCase().split(".").reverse()[0] !== t ? this.fileName = "".concat(e.fileName, ".").concat(t) : this.fileName = e.fileName) : this.fileName = n.defaultFileName(this.recordingType, this.callId);
    }

    return Fn(n, [{
      key: "isVideo",
      get: function get() {
        return this.recordingType === ka.LOCAL_AUDIO_AND_VIDEO_REMOTE_AUDIO || this.recordingType === ka.LOCAL_AUDIO_REMOTE_AUDIO_AND_VIDEO || this.recordingType === ka.REMOTE_AUDIO_AND_VIDEO;
      }
    }], [{
      key: "defaultFileName",
      value: function value(e, t) {
        var n = new Date(Date.now() - 6e4 * new Date().getTimezoneOffset()).toISOString(),
            r = (n = n.replace(/-|:/g, "")).lastIndexOf(".");
        return "".concat(e, "_").concat(t, "_").concat(n.substring(0, r)).concat(ha ? ".mp4" : ".webm");
      }
    }]), n;
  }(),
      Sa = Object.assign,
      ba = Object.defineProperty,
      Pt = !Sa || u(function () {
    if (v && 1 !== Sa({
      b: 1
    }, Sa(ba({}, "a", {
      enumerable: !0,
      get: function get() {
        ba(this, "b", {
          value: 3,
          enumerable: !1
        });
      }
    }), {
      b: 2
    })).b) return 1;
    var e = {},
        t = {},
        n = Symbol(),
        r = "abcdefghijklmnopqrst";
    return e[n] = 7, r.split("").forEach(function (e) {
      t[e] = e;
    }), 7 != Sa({}, e)[n] || Ke(Sa({}, t)).join("") != r;
  }) ? function (e, t) {
    for (var n = ce(e), r = arguments.length, i = 1, a = Ie.f, o = m.f; i < r;) {
      for (var s, c = E(arguments[i++]), u = a ? Ke(c).concat(a(c)) : Ke(c), l = u.length, d = 0; d < l;) {
        s = u[d++], v && !o.call(c, s) || (n[s] = c[s]);
      }
    }

    return n;
  } : Sa;

  ae({
    target: "Object",
    stat: !0,
    forced: Object.assign !== Pt
  }, {
    assign: Pt
  });
  t(function (e) {
    var t = function (o) {
      var c,
          e = Object.prototype,
          u = e.hasOwnProperty,
          t = "function" == typeof Symbol ? Symbol : {},
          r = t.iterator || "@@iterator",
          n = t.asyncIterator || "@@asyncIterator",
          i = t.toStringTag || "@@toStringTag";

      function a(e, t, n) {
        return Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        a({}, "");
      } catch (e) {
        a = function a(e, t, n) {
          return e[t] = n;
        };
      }

      function s(e, t, n, r) {
        var i,
            a,
            o,
            s,
            t = t && t.prototype instanceof v ? t : v,
            t = Object.create(t.prototype),
            r = new w(r || []);
        return t._invoke = (i = e, a = n, o = r, s = d, function (e, t) {
          if (s === f) throw new Error("Generator is already running");

          if (s === _) {
            if ("throw" === e) throw t;
            return T();
          }

          for (o.method = e, o.arg = t;;) {
            var n = o.delegate;

            if (n) {
              var r = function e(t, n) {
                var r = t.iterator[n.method];

                if (r === c) {
                  if (n.delegate = null, "throw" === n.method) {
                    if (t.iterator.return && (n.method = "return", n.arg = c, e(t, n), "throw" === n.method)) return p;
                    n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
                  }

                  return p;
                }

                r = l(r, t.iterator, n.arg);
                if ("throw" === r.type) return n.method = "throw", n.arg = r.arg, n.delegate = null, p;
                var r = r.arg;
                if (!r) return n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, p;
                {
                  if (!r.done) return r;
                  n[t.resultName] = r.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = c);
                }
                n.delegate = null;
                return p;
              }(n, o);

              if (r) {
                if (r === p) continue;
                return r;
              }
            }

            if ("next" === o.method) o.sent = o._sent = o.arg;else if ("throw" === o.method) {
              if (s === d) throw s = _, o.arg;
              o.dispatchException(o.arg);
            } else "return" === o.method && o.abrupt("return", o.arg);
            s = f;
            r = l(i, a, o);

            if ("normal" === r.type) {
              if (s = o.done ? _ : h, r.arg !== p) return {
                value: r.arg,
                done: o.done
              };
            } else "throw" === r.type && (s = _, o.method = "throw", o.arg = r.arg);
          }
        }), t;
      }

      function l(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      o.wrap = s;
      var d = "suspendedStart",
          h = "suspendedYield",
          f = "executing",
          _ = "completed",
          p = {};

      function v() {}

      function y() {}

      function m() {}

      var g = {};

      g[r] = function () {
        return this;
      };

      t = Object.getPrototypeOf, t = t && t(t(A([])));
      t && t !== e && u.call(t, r) && (g = t);
      var E = m.prototype = v.prototype = Object.create(g);

      function k(e) {
        ["next", "throw", "return"].forEach(function (t) {
          a(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function R(o, s) {
        var t;

        this._invoke = function (n, r) {
          function e() {
            return new s(function (e, t) {
              !function t(e, n, r, i) {
                e = l(o[e], o, n);

                if ("throw" !== e.type) {
                  var a = e.arg,
                      n = a.value;
                  return n && "object" == typeof n && u.call(n, "__await") ? s.resolve(n.__await).then(function (e) {
                    t("next", e, r, i);
                  }, function (e) {
                    t("throw", e, r, i);
                  }) : s.resolve(n).then(function (e) {
                    a.value = e, r(a);
                  }, function (e) {
                    return t("throw", e, r, i);
                  });
                }

                i(e.arg);
              }(n, r, e, t);
            });
          }

          return t = t ? t.then(e, e) : e();
        };
      }

      function C(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function I(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function w(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(C, this), this.reset(!0);
      }

      function A(t) {
        if (t) {
          var e = t[r];
          if (e) return e.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var n = -1,
                e = function e() {
              for (; ++n < t.length;) {
                if (u.call(t, n)) return e.value = t[n], e.done = !1, e;
              }

              return e.value = c, e.done = !0, e;
            };

            return e.next = e;
          }
        }

        return {
          next: T
        };
      }

      function T() {
        return {
          value: c,
          done: !0
        };
      }

      return ((y.prototype = E.constructor = m).constructor = y).displayName = a(m, i, "GeneratorFunction"), o.isGeneratorFunction = function (e) {
        e = "function" == typeof e && e.constructor;
        return !!e && (e === y || "GeneratorFunction" === (e.displayName || e.name));
      }, o.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, m) : (e.__proto__ = m, a(e, i, "GeneratorFunction")), e.prototype = Object.create(E), e;
      }, o.awrap = function (e) {
        return {
          __await: e
        };
      }, k(R.prototype), R.prototype[n] = function () {
        return this;
      }, o.AsyncIterator = R, o.async = function (e, t, n, r, i) {
        void 0 === i && (i = Promise);
        var a = new R(s(e, t, n, r), i);
        return o.isGeneratorFunction(t) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, k(E), a(E, i, "Generator"), E[r] = function () {
        return this;
      }, E.toString = function () {
        return "[object Generator]";
      }, o.keys = function (n) {
        var e,
            r = [];

        for (e in n) {
          r.push(e);
        }

        return r.reverse(), function e() {
          for (; r.length;) {
            var t = r.pop();
            if (t in n) return e.value = t, e.done = !1, e;
          }

          return e.done = !0, e;
        };
      }, o.values = A, w.prototype = {
        constructor: w,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = c, this.done = !1, this.delegate = null, this.method = "next", this.arg = c, this.tryEntries.forEach(I), !e) for (var t in this) {
            "t" === t.charAt(0) && u.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = c);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(n) {
          if (this.done) throw n;
          var r = this;

          function e(e, t) {
            return a.type = "throw", a.arg = n, r.next = e, t && (r.method = "next", r.arg = c), !!t;
          }

          for (var t = this.tryEntries.length - 1; 0 <= t; --t) {
            var i = this.tryEntries[t],
                a = i.completion;
            if ("root" === i.tryLoc) return e("end");

            if (i.tryLoc <= this.prev) {
              var o = u.call(i, "catchLoc"),
                  s = u.call(i, "finallyLoc");

              if (o && s) {
                if (this.prev < i.catchLoc) return e(i.catchLoc, !0);
                if (this.prev < i.finallyLoc) return e(i.finallyLoc);
              } else if (o) {
                if (this.prev < i.catchLoc) return e(i.catchLoc, !0);
              } else {
                if (!s) throw new Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return e(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var n = this.tryEntries.length - 1; 0 <= n; --n) {
            var r = this.tryEntries[n];

            if (r.tryLoc <= this.prev && u.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
              var i = r;
              break;
            }
          }

          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, p) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), p;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; 0 <= t; --t) {
            var n = this.tryEntries[t];
            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), I(n), p;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; 0 <= t; --t) {
            var n = this.tryEntries[t];

            if (n.tryLoc === e) {
              var r,
                  i = n.completion;
              return "throw" === i.type && (r = i.arg, I(n)), r;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, n) {
          return this.delegate = {
            iterator: A(e),
            resultName: t,
            nextLoc: n
          }, "next" === this.method && (this.arg = c), p;
        }
      }, o;
    }(e.exports);

    try {
      regeneratorRuntime = t;
    } catch (e) {
      Function("r", "regeneratorRuntime = r")(t);
    }
  });
  var Jr = o("slice"),
      Q = a("slice", {
    ACCESSORS: !0,
    0: 0,
    1: 2
  }),
      Oa = ue("species"),
      Da = [].slice,
      Na = Math.max;
  ae({
    target: "Array",
    proto: !0,
    forced: !Jr || !Q
  }, {
    slice: function slice(e, t) {
      var n,
          r,
          i,
          a = d(this),
          o = ne(a.length),
          s = re(e, o),
          c = re(void 0 === t ? o : t, o);
      if (Le(a) && (("function" == typeof (n = a.constructor) && (n === Array || Le(n.prototype)) || h(n) && null === (n = n[Oa])) && (n = void 0), n === Array || void 0 === n)) return Da.call(a, s, c);

      for (r = new (void 0 === n ? Array : n)(Na(c - s, 0)), i = 0; s < c; s++, i++) {
        s in a && _r(r, i, a[s]);
      }

      return r.length = i, r;
    }
  });
  var Jr = o("splice"),
      Q = a("splice", {
    ACCESSORS: !0,
    0: 0,
    1: 2
  }),
      La = Math.max,
      xa = Math.min;
  ae({
    target: "Array",
    proto: !0,
    forced: !Jr || !Q
  }, {
    splice: function splice(e, t) {
      var n,
          r,
          i,
          a,
          o,
          s,
          c = ce(this),
          u = ne(c.length),
          l = re(e, u),
          e = arguments.length;
      if (0 === e ? n = r = 0 : r = 1 === e ? (n = 0, u - l) : (n = e - 2, xa(La(te(t), 0), u - l)), 9007199254740991 < u + n - r) throw TypeError("Maximum allowed length exceeded");

      for (i = le(c, r), a = 0; a < r; a++) {
        (o = l + a) in c && _r(i, a, c[o]);
      }

      if (n < (i.length = r)) {
        for (a = l; a < u - r; a++) {
          s = a + n, (o = a + r) in c ? c[s] = c[o] : delete c[s];
        }

        for (a = u; u - r + n < a; a--) {
          delete c[a - 1];
        }
      } else if (r < n) for (a = u - r; l < a; a--) {
        s = a + n - 1, (o = a + r - 1) in c ? c[s] = c[o] : delete c[s];
      }

      for (a = 0; a < n; a++) {
        c[a + l] = arguments[a + 2];
      }

      return c.length = u - r + n, i;
    }
  });

  var Pa = function () {
    function e() {
      Un(this, e), Gn(this, "_listeners", {}), Gn(this, "on", this.addEventListener), Gn(this, "off", this.removeEventListener);
    }

    return Fn(e, [{
      key: "addEventListener",
      value: function value(e, t) {
        var n = this;
        return e in this._listeners || (this._listeners[e] = []), this._listeners[e].push(t), function () {
          return n.removeEventListener(e, t);
        };
      }
    }, {
      key: "once",
      value: function value(e, t) {
        function n() {
          t.apply(void 0, arguments), r.removeEventListener(e, n);
        }

        var r = this;
        return this.on(e, n);
      }
    }, {
      key: "removeEventListener",
      value: function value(e, t) {
        if (e in this._listeners) for (var n = this._listeners[e], r = 0, i = n.length; r < i; r++) {
          if (n[r] === t) return void n.splice(r, 1);
        }
      }
    }, {
      key: "removeAllEventListeners",
      value: function value() {
        this._listeners = {};
      }
    }, {
      key: "_dispatchEvent",
      value: function value(e) {
        if (e in this._listeners) {
          for (var t = this._listeners[e].slice(), n = arguments.length, r = new Array(1 < n ? n - 1 : 0), i = 1; i < n; i++) {
            r[i - 1] = arguments[i];
          }

          for (var a, o = 0, s = t.length; o < s; o++) {
            (a = t[o]).call.apply(a, [this].concat(r));
          }
        }
      }
    }]), e;
  }(),
      Jr = b.f,
      Q = Function.prototype,
      Ma = Q.toString,
      Ua = /^\s*function ([^ (]*)/;

  !v || "name" in Q || Jr(Q, "name", {
    configurable: !0,
    get: function get() {
      try {
        return Ma.call(this).match(Ua)[1];
      } catch (e) {
        return "";
      }
    }
  });

  function Va() {
    Un(this, Va);
  }

  var Fa,
      Ga = function () {
    function t(e) {
      Un(this, t), this.active = !1, this.queue = [], this.name = e;
    }

    return Fn(t, [{
      key: "acquire",
      value: function value() {
        var n = this;
        return new Promise(function (e) {
          function t() {
            n.active = !0, e();
          }

          n.active ? n.queue.push(t) : t();
        });
      }
    }, {
      key: "release",
      value: function value() {
        var e;
        this.active && (this.active = !1, (e = this.queue.shift()) && e());
      }
    }]), t;
  }(),
      Ba = function () {
    qn(t, Va);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "getApiOption",
      value: function value() {
        return {
          auth: this.getAuth(),
          path: this.getPath(),
          method: this.getMethod(),
          body: this.getData(),
          headers: this.getHeaders()
        };
      }
    }, {
      key: "getAuth",
      value: function value() {
        return !0;
      }
    }, {
      key: "getHeaders",
      value: function value() {
        return {};
      }
    }]), t;
  }(),
      ja = function () {
    qn(r, Va);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this)).payload = e.payload || {}, t;
    }

    return r;
  }(),
      qa = function () {
    qn(r, Va);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this)).type = e.type, t.version = e.version, t.messageId = e.message_id, t.deliveryInfo = e.delivery_info, t.sequenceNumber = e.sequence_number, t.payload = t.parseData(e.payload), t;
    }

    return Fn(r, [{
      key: "isSequential",
      value: function value() {
        return "number" == typeof this.sequenceNumber;
      }
    }]), r;
  }(),
      Ha = function () {
    qn(r, Va);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this)).payload = t.parseData(e), t;
    }

    return r;
  }(),
      za = function () {
    qn(r, Va);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this)).version = e.version, t.messageId = e.message_id, t.type = e.type, t.deliveryInfo = e.delivery_info, t.sequenceNumber = e.sequence_number, t.payload = t.parseData(e.payload), t;
    }

    return Fn(r, [{
      key: "isSequential",
      value: function value() {
        return "number" == typeof this.sequenceNumber;
      }
    }]), r;
  }(),
      Wa = function () {
    qn(r, Ba);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this)).roomId = e, t;
    }

    return Fn(r, [{
      key: "getPath",
      value: function value() {
        return "/v1/rooms".concat(this.getSubPath());
      }
    }]), r;
  }(),
      Ka = function () {
    qn(t, qa);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "getRoomId",
      value: function value() {
        return this.payload.roomId;
      }
    }]), t;
  }(),
      Ya = function () {
    qn(t, Ha);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return t;
  }(),
      Za = function () {
    qn(t, za);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "getRoomId",
      value: function value() {
        return this.payload.roomId;
      }
    }]), t;
  }();

  (Q = Fa = Fa || {}).CREATE = "create", Q.GET = "get", Q.QUERY = "query", Q.ENTER = "enter", Q.EXIT = "exit", Q.ALIVE = "alive", Q.AUDIO = "audio", Q.VIDEO = "video", Q.CUSTOM_ITEMS_FETCH = "custom_items_fetch", Q.CUSTOM_ITEMS_UPDATE = "custom_items_update", Q.CUSTOM_ITEMS_DELETE = "custom_items_delete", Q.ATTACH = "attach", Q.CONNECTED = "connected", Q.DETACH = "detach", Q.CREATE_ENDPOINT = "create_endpoint", Q.PUT_ENDPOINT = "put_endpoint", Q.RELEASE_ENDPOINT = "release_endpoint", Q.ROOM_DELETED = "room_deleted", Q.PARTICIPANT_ENTERED = "participant_entered", Q.PARTICIPANT_CONNECTED = "participant_connected", Q.PARTICIPANT_EXITED = "participant_exited", Q.PARTICIPANT_DISCONNECTED = "participant_disconnected", Q.PARTICIPANT_AUDIO_STATUS_CHANGED = "participant_audio_status_changed", Q.PARTICIPANT_VIDEO_STATUS_CHANGED = "participant_video_status_changed";

  var Qa = function () {
    qn(r, Wa);
    var n = Xn(r);

    function r(e, t) {
      return Un(this, r), Gn(Qn(e = n.call(this, e)), "type", Fa.ALIVE), e.participantId = t, e;
    }

    return Fn(r, [{
      key: "getData",
      value: function value() {
        return {};
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "POST";
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.roomId, "/participants/").concat(this.participantId, "/alive");
      }
    }]), r;
  }(),
      Xa = function () {
    qn(a, Wa);
    var i = Xn(a);

    function a(e, t, n, r) {
      return Un(this, a), Gn(Qn(e = i.call(this, e)), "type", Fa.ATTACH), e.participantId = t, e.endpointId = n, e.attachTo = r, e;
    }

    return Fn(a, [{
      key: "getData",
      value: function value() {
        return {
          attach_to: this.attachTo
        };
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "POST";
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.roomId, "/participants/").concat(this.participantId, "/endpoints/").concat(this.endpointId, "/attach");
      }
    }]), a;
  }(),
      $a = function () {
    qn(i, Wa);
    var r = Xn(i);

    function i(e, t, n) {
      return Un(this, i), Gn(Qn(e = r.call(this, e)), "type", Fa.AUDIO), e.participantId = t, e.enabled = n, e;
    }

    return Fn(i, [{
      key: "getData",
      value: function value() {
        return {
          on: this.enabled
        };
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "PUT";
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.roomId, "/participants/").concat(this.participantId, "/audio");
      }
    }]), i;
  }(),
      Ja = function () {
    qn(i, Wa);
    var r = Xn(i);

    function i(e, t, n) {
      return Un(this, i), Gn(Qn(e = r.call(this, e)), "type", Fa.CONNECTED), e.participantId = t, e.endpointId = n, e;
    }

    return Fn(i, [{
      key: "getData",
      value: function value() {
        return {};
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "POST";
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.roomId, "/participants/").concat(this.participantId, "/endpoints/").concat(this.endpointId, "/connected");
      }
    }]), i;
  }(),
      eo = function () {
    qn(r, Wa);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), Gn(Qn(t = n.call(this, void 0)), "type", Fa.CREATE), t.params = e, t;
    }

    return Fn(r, [{
      key: "getData",
      value: function value() {
        return {
          type: this.params.roomType,
          custom_items: this.params.customItems
        };
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "POST";
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "";
      }
    }]), r;
  }(),
      to = function () {
    qn(a, Wa);
    var i = Xn(a);

    function a(e, t, n, r) {
      return Un(this, a), Gn(Qn(e = i.call(this, e)), "type", Fa.CREATE_ENDPOINT), e.participantId = t, e.sdp = n, e.mediaDirection = r, e;
    }

    return Fn(a, [{
      key: "getData",
      value: function value() {
        return {
          sdp: this.sdp,
          audio_attr: this.mediaDirection.audio,
          video_attr: this.mediaDirection.video
        };
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "POST";
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.roomId, "/participants/").concat(this.participantId, "/endpoints");
      }
    }]), a;
  }(),
      no = function () {
    qn(r, Wa);
    var n = Xn(r);

    function r(e, t) {
      return Un(this, r), Gn(Qn(e = n.call(this, e)), "type", Fa.CUSTOM_ITEMS_DELETE), e.customItemKeys = t, e;
    }

    return Fn(r, [{
      key: "getData",
      value: function value() {
        return 0 < this.customItemKeys.length ? {
          keys: this.customItemKeys
        } : {};
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "DELETE";
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.roomId, "/custom_items");
      }
    }]), r;
  }(),
      ro = function () {
    qn(a, Wa);
    var i = Xn(a);

    function a(e, t, n, r) {
      return Un(this, a), Gn(Qn(e = i.call(this, e)), "type", Fa.DETACH), e.participantId = t, e.endpointId = n, e.attachTo = r, e;
    }

    return Fn(a, [{
      key: "getData",
      value: function value() {
        return {
          attach_to: this.attachTo
        };
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "DELETE";
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.roomId, "/participants/").concat(this.participantId, "/endpoints/").concat(this.endpointId);
      }
    }]), a;
  }(),
      io = function () {
    qn(r, Wa);
    var n = Xn(r);

    function r(e, t) {
      return Un(this, r), Gn(Qn(e = n.call(this, e)), "type", Fa.ENTER), e.params = t, e;
    }

    return Fn(r, [{
      key: "getData",
      value: function value() {
        return {
          is_audio_on: this.params.audioEnabled,
          is_video_on: this.params.videoEnabled
        };
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "POST";
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.roomId, "/participants");
      }
    }]), r;
  }(),
      ao = function () {
    qn(r, Wa);
    var n = Xn(r);

    function r(e, t) {
      return Un(this, r), Gn(Qn(e = n.call(this, e)), "type", Fa.EXIT), e.participantId = t, e;
    }

    return Fn(r, [{
      key: "getData",
      value: function value() {
        return {};
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "DELETE";
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.roomId, "/participants/").concat(this.participantId);
      }
    }]), r;
  }(),
      oo = function () {
    qn(n, Wa);
    var t = Xn(n);

    function n(e) {
      return Un(this, n), Gn(Qn(e = t.call(this, e)), "type", Fa.CUSTOM_ITEMS_FETCH), e;
    }

    return Fn(n, [{
      key: "getData",
      value: function value() {}
    }, {
      key: "getMethod",
      value: function value() {
        return "GET";
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.roomId, "/custom_items");
      }
    }]), n;
  }(),
      so = function () {
    qn(a, Wa);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", Fa.GET), e;
    }

    return Fn(a, [{
      key: "getData",
      value: function value() {}
    }, {
      key: "getMethod",
      value: function value() {
        return "GET";
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.roomId);
      }
    }]), a;
  }(),
      co = function () {
    qn(a, Wa);
    var i = Xn(a);

    function a(e, t, n, r) {
      return Un(this, a), Gn(Qn(e = i.call(this, e)), "type", Fa.PUT_ENDPOINT), e.participantId = t, e.endpointId = n, e.sdp = r, e;
    }

    return Fn(a, [{
      key: "getData",
      value: function value() {
        return {
          sdp: this.sdp
        };
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "PUT";
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.roomId, "/participants/").concat(this.participantId, "/endpoints/").concat(this.endpointId);
      }
    }]), a;
  }(),
      uo = function () {
    qn(i, Wa);
    var r = Xn(i);

    function i(e, t, n) {
      return Un(this, i), Gn(Qn(e = r.call(this, e)), "type", Fa.RELEASE_ENDPOINT), e.participantId = t, e.endpointId = n, e;
    }

    return Fn(i, [{
      key: "getData",
      value: function value() {
        return {};
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "DELETE";
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.roomId, "/participants/").concat(this.participantId, "/endpoints/").concat(this.endpointId);
      }
    }]), i;
  }(),
      lo = z.filter,
      Q = o("filter"),
      o = a("filter");

  ae({
    target: "Array",
    proto: !0,
    forced: !Q || !o
  }, {
    filter: function filter(e) {
      return lo(this, e, 1 < arguments.length ? arguments[1] : void 0);
    }
  });
  var ho = [].join,
      Q = E != Object,
      o = $("join", ",");
  ae({
    target: "Array",
    proto: !0,
    forced: Q || !o
  }, {
    join: function join(e) {
      return ho.call(d(this), void 0 === e ? "," : e);
    }
  });

  function fo(e) {
    Un(this, fo), Object.assign(this, e);
  }

  var _o = function () {
    function e() {
      Un(this, e);
    }

    return Fn(e, null, [{
      key: "createQuery",
      value: function value(t) {
        var n = this;
        return Object.keys(t).filter(function (e) {
          return null != t[e];
        }).map(function (e) {
          return "".concat(encodeURIComponent(e), "=").concat(n.toQueryParam(t[e]));
        }).join("&");
      }
    }, {
      key: "toQueryParam",
      value: function value(e) {
        return Array.isArray(e) ? e.map(function (e) {
          return encodeURIComponent(e.toString());
        }).join(",") : encodeURIComponent(e.toString());
      }
    }]), e;
  }(),
      po = function () {
    qn(a, Wa);
    var i = Xn(a);

    function a(e, t, n) {
      var r;
      return Un(this, a), Gn(Qn(r = i.call(this)), "type", Fa.QUERY), r.params = r._normalizeParams(e), r.prev = t, r.next = n, r;
    }

    return Fn(a, [{
      key: "getData",
      value: function value() {}
    }, {
      key: "getSubPath",
      value: function value() {
        return "?".concat(this._createQuery());
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "GET";
      }
    }, {
      key: "_normalizeParams",
      value: function value(e) {
        var t = e.type,
            n = e.limit,
            r = e.state,
            i = e.currentParticipantCount,
            a = e.createdByUserIds,
            o = e.roomIds,
            e = e.createdAt;
        return {
          type: t,
          limit: null != n ? Math.min(Math.max(1, n), 100) : void 0,
          state: r,
          currentParticipantCount: i,
          createdByUserIds: a,
          roomIds: o,
          createdAt: e
        };
      }
    }, {
      key: "_createQuery",
      value: function value() {
        var e;
        return _o.createQuery({
          type: this.params.type,
          limit: this.params.limit,
          state: this.params.state,
          current_participant_range_gte: null === (e = this.params.currentParticipantCount) || void 0 === e ? void 0 : e[0],
          current_participant_range_lte: null === (e = this.params.currentParticipantCount) || void 0 === e ? void 0 : e[1],
          created_by_user_ids: this.params.createdByUserIds,
          room_ids: this.params.roomIds,
          created_at_start_date: null === (e = this.params.createdAt) || void 0 === e ? void 0 : e[0],
          created_at_end_date: null === (e = this.params.createdAt) || void 0 === e ? void 0 : e[1],
          prev: this.prev,
          next: this.next
        });
      }
    }]), a;
  }(),
      vo = function () {
    qn(i, Wa);
    var r = Xn(i);

    function i(e, t, n) {
      return Un(this, i), Gn(Qn(e = r.call(this, e)), "type", Fa.CUSTOM_ITEMS_UPDATE), e.customItems = t, e.mode = n, e;
    }

    return Fn(i, [{
      key: "getData",
      value: function value() {
        return {
          custom_items: this.customItems,
          mode: this.mode
        };
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "PUT";
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.roomId, "/custom_items");
      }
    }]), i;
  }(),
      yo = function () {
    qn(i, Wa);
    var r = Xn(i);

    function i(e, t, n) {
      return Un(this, i), Gn(Qn(e = r.call(this, e)), "type", Fa.VIDEO), e.participantId = t, e.enabled = n, e;
    }

    return Fn(i, [{
      key: "getData",
      value: function value() {
        return {
          on: this.enabled
        };
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "PUT";
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.roomId, "/participants/").concat(this.participantId, "/video");
      }
    }]), i;
  }(),
      mo = function () {
    qn(a, Ka);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", Fa.CUSTOM_ITEMS_DELETE), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          roomId: e.room_id,
          deleted: e.deleted,
          customItems: e.custom_items,
          affectedAt: e.affected_at
        };
      }
    }]), a;
  }(),
      go = function () {
    qn(t, Ka);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return {
          roomId: e.room_id
        };
      }
    }]), t;
  }(),
      Eo = function () {
    function t() {
      Un(this, t);
    }

    return Fn(t, null, [{
      key: "parseRoom",
      value: function value(e) {
        return e ? {
          roomId: e.room_id,
          state: e.state,
          roomType: e.room_type,
          customItems: e.custom_items,
          createdAt: e.created_at,
          createdBy: e.created_by,
          participants: t.parseParticipants(e.current_participants)
        } : {};
      }
    }, {
      key: "parseCustomItemsResult",
      value: function value(e) {
        return {
          customItems: e.custom_items || {},
          affectedKeys: [].concat(er(e.updated || []), er(e.deleted || [])),
          affectedAt: e.affected_at || 0
        };
      }
    }, {
      key: "parseParticipants",
      value: function value(e) {
        return e && Array.isArray(e) ? e.map(function (e) {
          return t.parseParticipant(e);
        }) : [];
      }
    }, {
      key: "parseParticipant",
      value: function value(e) {
        return e ? {
          participantId: e.participant_id,
          enteredAt: e.entered_at,
          updatedAt: e.updated_at,
          exitedAt: e.exited_at,
          duration: e.duration,
          state: e.state,
          user: new fo(ua(e.user)),
          isLocalParticipant: e.is_local_participant,
          clientId: e.client_id,
          isAudioEnabled: e.is_audio_on,
          isVideoEnabled: e.is_video_on
        } : {};
      }
    }]), t;
  }(),
      ko = function () {
    qn(a, Ka);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", Fa.PARTICIPANT_AUDIO_STATUS_CHANGED), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          roomId: e.room_id,
          participant: Eo.parseParticipant(e.participant),
          on: e.on
        };
      }
    }]), a;
  }(),
      Ro = function () {
    qn(a, Ka);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", Fa.PARTICIPANT_CONNECTED), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          roomId: e.room_id,
          participant: Eo.parseParticipant(e.participant)
        };
      }
    }]), a;
  }(),
      Co = function () {
    qn(a, Ka);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", Fa.PARTICIPANT_DISCONNECTED), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          roomId: e.room_id,
          participant: Eo.parseParticipant(e.participant),
          reason: e.reason
        };
      }
    }]), a;
  }(),
      Io = function () {
    qn(a, Ka);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", Fa.PARTICIPANT_ENTERED), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          roomId: e.room_id,
          participant: Eo.parseParticipant(e.participant)
        };
      }
    }]), a;
  }(),
      wo = function () {
    qn(a, Ka);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", Fa.PARTICIPANT_EXITED), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          roomId: e.room_id,
          participant: Eo.parseParticipant(e.participant)
        };
      }
    }]), a;
  }(),
      Ao = function () {
    qn(a, Ka);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", Fa.PARTICIPANT_VIDEO_STATUS_CHANGED), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          roomId: e.room_id,
          participant: Eo.parseParticipant(e.participant),
          on: e.on
        };
      }
    }]), a;
  }(),
      To = function () {
    qn(a, Ka);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", Fa.CUSTOM_ITEMS_UPDATE), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          roomId: e.room_id,
          updated: e.updated,
          customItems: e.custom_items,
          affectedAt: e.affected_at
        };
      }
    }]), a;
  }(),
      So = function () {
    qn(t, Ya);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return {};
      }
    }]), t;
  }(),
      bo = function () {
    qn(t, Ya);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return {};
      }
    }]), t;
  }(),
      Oo = function () {
    qn(t, Ya);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return {
          me: Eo.parseParticipant(e.me)
        };
      }
    }]), t;
  }(),
      Do = function () {
    qn(t, Ya);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return {};
      }
    }]), t;
  }(),
      No = function () {
    qn(t, Ya);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return {
          endpointId: e.endpoint_id,
          sdp: e.sdp
        };
      }
    }]), t;
  }(),
      Lo = function () {
    qn(t, Ya);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return {
          room: Eo.parseRoom(e.room)
        };
      }
    }]), t;
  }(),
      xo = function () {
    qn(t, Ya);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return Eo.parseCustomItemsResult(e);
      }
    }]), t;
  }(),
      Po = function () {
    qn(t, Ya);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return {};
      }
    }]), t;
  }(),
      Mo = z.find,
      o = "find",
      Uo = !0,
      z = a(o);

  o in [] && Array(1)[o](function () {
    Uo = !1;
  }), ae({
    target: "Array",
    proto: !0,
    forced: Uo || !z
  }, {
    find: function find(e) {
      return Mo(this, e, 1 < arguments.length ? arguments[1] : void 0);
    }
  }), D(o);

  var Vo = function () {
    qn(t, Ya);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(t) {
        return t.room.current_participants.find(function (e) {
          return e.participant_id === t.me.participant_id;
        }).is_local_participant = !0, t.me.is_local_participant = !0, {
          me: Eo.parseParticipant(t.me),
          room: Eo.parseRoom(t.room)
        };
      }
    }]), t;
  }(),
      Fo = function () {
    qn(t, Ya);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return {};
      }
    }]), t;
  }(),
      Go = function () {
    qn(t, Ya);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return Eo.parseCustomItemsResult(e);
      }
    }]), t;
  }(),
      Bo = function () {
    qn(t, Ya);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return {
          room: Eo.parseRoom(e.room)
        };
      }
    }]), t;
  }(),
      jo = function () {
    qn(t, Ya);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return {
          endpointId: e.endpoint_id,
          sdp: e.sdp
        };
      }
    }]), t;
  }(),
      qo = function () {
    qn(t, Ya);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return {};
      }
    }]), t;
  }(),
      Ho = function () {
    qn(t, Ya);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return {
          rooms: e.rooms.map(function (e) {
            return Eo.parseRoom(e);
          }),
          prev: e.prev,
          next: e.next
        };
      }
    }]), t;
  }(),
      zo = function () {
    qn(t, Ya);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return Eo.parseCustomItemsResult(e);
      }
    }]), t;
  }(),
      Wo = function () {
    qn(t, Ya);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return {
          me: Eo.parseParticipant(e.me)
        };
      }
    }]), t;
  }(),
      Ko = function () {
    function e() {
      Un(this, e);
    }

    return Fn(e, null, [{
      key: "createCreate",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return Kn(eo, t);
      }
    }, {
      key: "createGet",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return Kn(so, t);
      }
    }, {
      key: "createRoomListQuery",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return Kn(po, t);
      }
    }, {
      key: "createEnter",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return Kn(io, t);
      }
    }, {
      key: "createExit",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return Kn(ao, t);
      }
    }, {
      key: "createCreateEndpoint",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return Kn(to, t);
      }
    }, {
      key: "createPutEndpoint",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return Kn(co, t);
      }
    }, {
      key: "createReleaseEndpoint",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return Kn(uo, t);
      }
    }, {
      key: "createAttach",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return Kn(Xa, t);
      }
    }, {
      key: "createConnected",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return Kn(Ja, t);
      }
    }, {
      key: "createDetach",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return Kn(ro, t);
      }
    }, {
      key: "createAlive",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return Kn(Qa, t);
      }
    }, {
      key: "createAudio",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return Kn($a, t);
      }
    }, {
      key: "createVideo",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return Kn(yo, t);
      }
    }, {
      key: "createFetchCustomItems",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return Kn(oo, t);
      }
    }, {
      key: "createUpdateCustomItems",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return Kn(vo, t);
      }
    }, {
      key: "createDeleteCustomItems",
      value: function value() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return Kn(no, t);
      }
    }, {
      key: "parseResponse",
      value: function value(e, t) {
        switch (e) {
          case Fa.CREATE:
            return new Lo(t);

          case Fa.GET:
            return new Bo(t);

          case Fa.QUERY:
            return new Ho(t);

          case Fa.ENTER:
            return new Vo(t);

          case Fa.EXIT:
            return new Fo(t);

          case Fa.CUSTOM_ITEMS_FETCH:
            return new Go(t);

          case Fa.CUSTOM_ITEMS_UPDATE:
            return new zo(t);

          case Fa.CUSTOM_ITEMS_DELETE:
            return new xo(t);

          case Fa.CREATE_ENDPOINT:
            return new No(t);

          case Fa.PUT_ENDPOINT:
            return new jo(t);

          case Fa.RELEASE_ENDPOINT:
            return new qo(t);

          case Fa.ATTACH:
            return new bo(t);

          case Fa.CONNECTED:
            return new Do(t);

          case Fa.DETACH:
            return new Po(t);

          case Fa.ALIVE:
            return new So(t);

          case Fa.AUDIO:
            return new Oo(t);

          case Fa.VIDEO:
            return new Wo(t);

          default:
            return void _a.error(new ra(Tn.ERR_WRONG_RESPONSE, {
              error: new Error("unhandled command data. ".concat(JSON.stringify(t)))
            }));
        }
      }
    }, {
      key: "parse",
      value: function value(e) {
        switch (e.type) {
          case Fa.CUSTOM_ITEMS_UPDATE:
            return new To(e);

          case Fa.CUSTOM_ITEMS_DELETE:
            return new mo(e);

          case Fa.ROOM_DELETED:
            return new go(e);

          case Fa.PARTICIPANT_ENTERED:
            return new Io(e);

          case Fa.PARTICIPANT_CONNECTED:
            return new Ro(e);

          case Fa.PARTICIPANT_EXITED:
            return new wo(e);

          case Fa.PARTICIPANT_DISCONNECTED:
            return new Co(e);

          case Fa.PARTICIPANT_AUDIO_STATUS_CHANGED:
            return new ko(e);

          case Fa.PARTICIPANT_VIDEO_STATUS_CHANGED:
            return new Ao(e);

          default:
            return void _a.error(new ra(Tn.ERR_WRONG_RESPONSE, {
              error: new Error("unhandled command data. ".concat(JSON.stringify(e)))
            }));
        }
      }
    }]), e;
  }();

  for (var Yo, Zo = (function (e) {
    var t,
        n,
        r = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);
    r ? (t = new Uint8Array(16), e.exports = function () {
      return r(t), t;
    }) : (n = new Array(16), e.exports = function () {
      for (var e, t = 0; t < 16; t++) {
        0 == (3 & t) && (e = 4294967296 * Math.random()), n[t] = e >>> ((3 & t) << 3) & 255;
      }

      return n;
    });
  }(Yo = {
    exports: {}
  }), Yo.exports), Qo = [], Xo = 0; Xo < 256; ++Xo) {
    Qo[Xo] = (Xo + 256).toString(16).substr(1);
  }

  var $o = function $o(e, t) {
    return t = t || 0, [Qo[e[t++]], Qo[e[t++]], Qo[e[t++]], Qo[e[t++]], "-", Qo[e[t++]], Qo[e[t++]], "-", Qo[e[t++]], Qo[e[t++]], "-", Qo[e[t++]], Qo[e[t++]], "-", Qo[e[t++]], Qo[e[t++]], Qo[e[t++]], Qo[e[t++]], Qo[e[t++]], Qo[e[t++]]].join("");
  };

  var Jo = function Jo(e, t, n) {
    var r = t && n || 0;
    "string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null);
    var i = (e = e || {}).random || (e.rng || Zo)();
    if (i[6] = 15 & i[6] | 64, i[8] = 63 & i[8] | 128, t) for (var a = 0; a < 16; ++a) {
      t[r + a] = i[a];
    }
    return t || $o(i);
  },
      es = e.includes,
      o = a("indexOf", {
    ACCESSORS: !0,
    1: 0
  });

  ae({
    target: "Array",
    proto: !0,
    forced: !o
  }, {
    includes: function includes(e) {
      return es(this, e, 1 < arguments.length ? arguments[1] : void 0);
    }
  }), D("includes");
  var ts = ue("match");
  ae({
    target: "String",
    proto: !0,
    forced: !function (t) {
      var n = /./;

      try {
        "/./"[t](n);
      } catch (e) {
        try {
          return n[ts] = !1, "/./"[t](n);
        } catch (e) {}
      }

      return !1;
    }("includes")
  }, {
    includes: function includes(e) {
      return !!~String(l(this)).indexOf(function (e) {
        if (Ea(e)) throw TypeError("The method doesn't accept regular expressions");
        return e;
      }(e), 1 < arguments.length ? arguments[1] : void 0);
    }
  });

  function ns(e) {
    var t,
        n,
        r,
        i,
        a,
        o,
        s,
        c = f(e, !1);
    if ("string" == typeof c && 2 < c.length) if (43 === (t = (c = ss(c)).charCodeAt(0)) || 45 === t) {
      if (88 === (e = c.charCodeAt(2)) || 120 === e) return NaN;
    } else if (48 === t) {
      switch (c.charCodeAt(1)) {
        case 66:
        case 98:
          n = 2, r = 49;
          break;

        case 79:
        case 111:
          n = 8, r = 55;
          break;

        default:
          return +c;
      }

      for (a = (i = c.slice(2)).length, o = 0; o < a; o++) {
        if ((s = i.charCodeAt(o)) < 48 || r < s) return NaN;
      }

      return parseInt(i, n);
    }
    return +c;
  }

  var o = "[\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]",
      rs = RegExp("^" + o + o + "*"),
      is = RegExp(o + o + "*$"),
      D = function D(t) {
    return function (e) {
      e = String(l(e));
      return 1 & t && (e = e.replace(rs, "")), 2 & t && (e = e.replace(is, "")), e;
    };
  },
      o = {
    start: D(1),
    end: D(2),
    trim: D(3)
  },
      D = Ce.f,
      as = T.f,
      os = b.f,
      ss = o.trim,
      cs = "Number",
      us = p[cs],
      ls = us.prototype,
      ds = r(et(ls)) == cs;

  if (De(cs, !us(" 0o1") || !us("0b1") || us("+0x1"))) {
    for (var hs, fs = function fs(e) {
      var e = arguments.length < 1 ? 0 : e,
          t = this;
      return t instanceof fs && (ds ? u(function () {
        ls.valueOf.call(t);
      }) : r(t) != cs) ? zt(new us(ns(e)), t, fs) : ns(e);
    }, _s = v ? D(us) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,fromString,range".split(","), ps = 0; _s.length > ps; ps++) {
      y(us, hs = _s[ps]) && !y(fs, hs) && os(fs, hs, as(us, hs));
    }

    (fs.prototype = ls).constructor = fs, fe(p, cs, fs);
  }

  ae({
    target: "Number",
    stat: !0
  }, {
    isNaN: function isNaN(e) {
      return e != e;
    }
  });

  function vs(e) {
    return void 0 === e || Number.isNaN(e) || "" === e || e === [];
  }

  function ys(t) {
    Object.keys(t).forEach(function (e) {
      vs(t[e]) && delete t[e];
    });
  }

  function ms(e) {
    var t = jn(jn({}, e), {}, {
      transport_info: jn({}, e.transport_info),
      audio: jn({}, e.audio)
    });
    return e.video && (t.video = jn({}, e.video)), t;
  }

  function gs(e, t) {
    var n = ms(e),
        r = n.audio,
        e = n.video;
    return r.packets_lost = r.total_packets_lost, r.packets_received = r.total_packets_received, t && (r.packets_lost -= t.audio.total_packets_lost, r.packets_received -= t.audio.total_packets_received), r.packets_lost_rate = r.packets_lost / (r.packets_lost + r.packets_received) * 100, e.packets_lost = e.total_packets_lost, e.packets_received = e.total_packets_received, t && (e.packets_lost -= t.video.total_packets_lost, e.packets_received -= t.video.total_packets_received), e.packets_lost_rate = e.packets_lost / (e.packets_lost + e.packets_received) * 100, r.rtt && (r.mos = function (e, t, n) {
      if (!(vs(e) || vs(t) || vs(n))) {
        var r,
            t = n + 2 * t + 10,
            t = t < 160 ? 93.2 - t / 40 : 93.2 - (t - 120) / 10;
        return (t -= 2.5 * e) <= 0 ? r = 1 : 0 < t && t < 100 ? r = 1 + .035 * t + 7e-6 * t * (t - 60) * (100 - t) : 100 <= t && (r = 4.5), r;
      }
    }(r.packets_lost, r.jitter, r.rtt)), n;
  }

  function Es(e, t) {
    return (null != e ? e : 0) + (null != t ? t : 0);
  }

  function ks(e, t, n) {
    return (null != e ? e : 0) * n + (null != t ? t : 0) * (1 - n);
  }

  function Rs(e, t) {
    var n = ms(e);
    return t && (r("audio")("total_packets_sent"), r("audio")("total_packets_received"), r("audio")("total_packets_lost"), r("audio")("total_packets_lost_rate"), r("audio")("retransmitted_packets_sent"), r("audio")("jitter_buffer_delay"), r("video")("fir_count"), r("video")("pli_count"), r("video")("nack_count"), r("video")("qp_sum"), r("video")("retransmitted_packets_sent"), r("video")("quality_limitation_resolution_changes"), "none" === n.video.quality_limitation_reason && (n.video.quality_limitation_reason = t.video.quality_limitation_reason), r("video")("header_bytes_received"), r("video")("key_frames_decoded"), r("video")("total_decode_time"), r("video")("total_inter_frame_delay"), r("video")("total_squared_inter_frame_delay"), r("video")("total_packets_lost"), r("video")("total_packets_received"), r("video")("total_packets_lost_rate"), r("video")("jitter_buffer_delay"), r("video")("jitter_buffer_emitted_count"), r("video")("frames_received"), r("video")("frames_decoded"), r("video")("frames_dropped"), r("video")("freeze_count"), r("video")("pause_count"), r("video")("total_freezes_duration"), r("video")("total_pauses_duration"), r("video")("total_frames_duration"), r("video")("sum_of_squared_frames_duration")), n;

    function r(e) {
      return "audio" === e ? function (e) {
        n.audio[e] = Es(n.audio[e], t.audio[e]);
      } : function (e) {
        n.video[e] = Es(n.video[e], t.video[e]);
      };
    }
  }

  function Cs(e, t, n) {
    var r = ms(e);
    if (n <= 1 || !t) return r;
    var i = 1 / n,
        a = 1 / (n - 1);

    function o(e) {
      return "audio" === e ? function (e) {
        r.audio[e] = Es(r.audio[e], t.audio[e]);
      } : function (e) {
        r.video[e] = Es(r.video[e], t.video[e]);
      };
    }

    function s(e) {
      return "audio" === e ? function (e) {
        r.audio[e] = ks(r.audio[e], t.audio[e], ["rtt", "mos"].includes(e) ? a : i);
      } : function (e) {
        r.video[e] = ks(r.video[e], t.video[e], ["rtt", "mos"].includes(e) ? a : i);
      };
    }

    function c(e) {
      return "audio" === e ? function (e) {
        r.audio[e] = t.audio[e];
      } : function (e) {
        r.video[e] = t.video[e];
      };
    }

    return c("audio")("codec"), s("audio")("rtt"), s("audio")("jitter"), o("audio")("packets_lost"), s("audio")("packets_lost_rate"), s("audio")("mos"), c("video")("codec"), s("video")("rtt"), o("video")("packets_lost"), s("video")("packets_lost_rate"), s("video")("video_source_width"), s("video")("video_source_height"), s("video")("video_source_frames_per_second"), s("video")("received_frame_width"), s("video")("received_frame_height"), s("video")("sent_frame_width"), s("video")("sent_frame_height"), r;
  }

  var Is,
      ws = function () {
    var t = Mn(_regeneratorRuntime.mark(function e(t) {
      var n, r, i, a, o, s, c, u;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t) {
                e.next = 2;
                break;
              }

              throw new Error("'getCandidateInfo()' is called without rtcConnection");

            case 2:
              return e.next = 4, t.getStats();

            case 4:
              n = e.sent, i = n.entries(), a = 0;

            case 7:
              if (!(a < n.size)) {
                e.next = 18;
                break;
              }

              if (o = i.next(), o = o.value) {
                e.next = 11;
                break;
              }

              return e.abrupt("continue", 15);

            case 11:
              if ("candidate-pair" === (u = o[1]).type && "succeeded" === u.state) return r = u.localCandidateId, e.abrupt("break", 18);
              e.next = 15;
              break;

            case 15:
              a++, e.next = 7;
              break;

            case 18:
              if (!(a < n.size)) {
                e.next = 28;
                break;
              }

              if (c = i.next(), s = c.value) {
                e.next = 22;
                break;
              }

              return e.abrupt("continue", 25);

            case 22:
              if ("local-candidate" === (u = s[1]).type && u.id === r) return e.abrupt("return", {
                connectionType: null !== (c = u.candidateType) && void 0 !== c ? c : "",
                protocol: null !== (c = u.protocol) && void 0 !== c ? c : "",
                relayProtocol: null !== (u = u.relayProtocol) && void 0 !== u ? u : ""
              });
              e.next = 25;
              break;

            case 25:
              a++, e.next = 18;
              break;

            case 28:
              return e.abrupt("return", null);

            case 29:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (e) {
      return t.apply(this, arguments);
    };
  }(),
      As = function () {
    var t = Mn(_regeneratorRuntime.mark(function e(t) {
      var n, i, a, o, s, c, u;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return n = {}, i = {}, a = {}, o = {}, s = new Map(), c = new Map(), t.forEach(function (e) {
                "codec" === e.type && s.set(e.id, e), "candidate-pair" === e.type && "succeeded" === e.state && (u = e.localCandidateId, n.webrtc_timestamp = e.time), "media-source" === e.type && c.set(e.kind, e);
              }), t.forEach(function (e) {
                var t, n, r;
                "local-candidate" === e.type && e.id === u && (i.network_type = e.networkType, i.protocol = e.protocol, i.candidate_type = e.candidateType), "audio" !== e.kind && "audio" !== e.mediaType || ("outbound-rtp" === e.type && (a.codec = null === (t = s.get(e.codecId)) || void 0 === t ? void 0 : t.mimeType, a.total_packets_sent = e.packetsSent, a.retransmitted_packets_sent = e.retransmittedPacketsSent), "remote-inbound-rtp" === e.type && (a.rtt = 1e3 * e.roundTripTime), "inbound-rtp" === e.type && (n = e.packetsLost / (e.packetsLost + e.packetsReceived) * 100, a.total_packets_received = e.packetsReceived, a.total_packets_lost_rate = n, a.total_packets_lost = e.packetsLost, a.jitter = 1e3 * e.jitter), "track" === e.type && e.remoteSource && (a.jitter_buffer_delay = e.jitterBufferDelay, a.jitter_buffer_emitted_count = e.jitterBufferDelayEmittedCount)), "video" !== e.kind && "video" !== e.mediaType || (o.video_source_width = null === (n = c.get("video")) || void 0 === n ? void 0 : n.width, o.video_source_height = null === (n = c.get("video")) || void 0 === n ? void 0 : n.height, o.video_source_frames_per_second = null === (n = c.get("video")) || void 0 === n ? void 0 : n.framesPerSecond, "outbound-rtp" === e.type && (o.codec = null === (r = s.get(e.codecId)) || void 0 === r ? void 0 : r.mimeType, o.fir_count = e.firCount, o.pli_count = e.pliCount, o.nack_count = e.nackCount, o.qp_sum = e.qpSum, o.retransmitted_packets_sent = e.retransmittedBytesSent, o.quality_limitation_reason = e.qualityLimitationReason, o.quality_limitation_resolution_changes = e.qualityLimitationResolutionChanges), "remote-inbound-rtp" === e.type && (o.rtt = 1e3 * e.roundTripTime), "inbound-rtp" === e.type && (o.header_bytes_received = e.headerBytesReceived, o.key_frames_decoded = e.keyFramesDecoded, o.total_decode_time = e.totalDecodeTime, o.total_inter_frame_delay = e.totalInterFrameDelay, o.total_squared_inter_frame_delay = e.totalSquaredInterFrameDelay, r = e.packetsLost / (e.packetsLost + e.packetsReceived) * 100, o.total_packets_lost = e.packetsLost, o.total_packets_received = e.packetsReceived, o.total_packets_lost_rate = r), "track" === e.type && (e.remoteSource ? (o.jitter_buffer_delay = e.jitterBufferDelay, o.jitter_buffer_emitted_count = e.jitterBufferDelayEmittedCount, o.received_frame_width = e.frameWidth, o.received_frame_height = e.frameHeight, o.frames_received = e.framesReceived, o.frames_decoded = e.framesDecoded, o.frames_dropped = e.framesDropped, o.freeze_count = e.freezeCount, o.pause_count = e.pauseCount, o.total_freezes_duration = e.totalFreezesDuration, o.total_pauses_duration = e.totalPausesDuration, o.total_frames_duration = e.totalFramesDuration, o.sum_of_squared_frames_duration = e.sumOfSquaredFramesDuration) : (o.sent_frame_width = e.frameWidth, o.sent_frame_height = e.frameHeight)));
              }), ys(i), ys(a), ys(o), n.transport_info = i, n.audio = a, n.video = o, e.abrupt("return", n);

            case 15:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (e) {
      return t.apply(this, arguments);
    };
  }(),
      Ts = function () {
    var t = Mn(_regeneratorRuntime.mark(function e(t) {
      var n;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t) {
                e.next = 2;
                break;
              }

              throw new Error("'getStats()' is called without rtcConnection");

            case 2:
              return e.next = 4, t.getStats();

            case 4:
              return n = e.sent, e.abrupt("return", As(n));

            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (e) {
      return t.apply(this, arguments);
    };
  }(),
      Ss = function () {
    qn(t, ja);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return t;
  }();

  (D = Is = Is || {}).OFFER = "offer", D.ANSWER = "answer", D.CANDIDATE = "candidate";

  var bs,
      Os = function () {
    qn(n, Ss);
    var t = Xn(n);

    function n(e) {
      return Un(this, n), Gn(Qn(e = t.call(this, {
        payload: e
      })), "type", Is.ANSWER), e;
    }

    return n;
  }(),
      Ds = function () {
    qn(n, Ss);
    var t = Xn(n);

    function n(e) {
      return Un(this, n), Gn(Qn(e = t.call(this, {
        payload: e
      })), "type", Is.CANDIDATE), e;
    }

    return n;
  }(),
      Ns = function () {
    qn(n, Ss);
    var t = Xn(n);

    function n(e) {
      return Un(this, n), Gn(Qn(e = t.call(this, {
        payload: e
      })), "type", Is.OFFER), e;
    }

    return n;
  }(),
      Ls = function () {
    function e() {
      Un(this, e);
    }

    return Fn(e, null, [{
      key: "createOffer",
      value: function value(e, t) {
        return new Ns({
          peerConnectionId: e,
          sdp: t
        });
      }
    }, {
      key: "createAnswer",
      value: function value(e, t) {
        return new Os({
          peerConnectionId: e,
          sdp: t
        });
      }
    }, {
      key: "createCandidate",
      value: function value(e, t) {
        return new Ds({
          peerConnectionId: e,
          candidate: t
        });
      }
    }]), e;
  }(),
      xs = function () {
    function t(e) {
      Un(this, t), this._context = e;
    }

    return Fn(t, [{
      key: "_changeState",
      value: function value(e) {
        this._state && this._state.type === e.type ? _a.error(new Error("self-transition is not allowed")) : (_a.debug("[".concat(this.name, "] state: ").concat(this._state ? this._state.type : "null", " -> ").concat(e.type)), this._state && this._state.destroy(), this._state = e, this._state.context = this._context, this._state.start());
      }
    }, {
      key: "state",
      get: function get() {
        return this._state;
      }
    }]), t;
  }(),
      Ps = function () {
    function t(e) {
      Un(this, t), this._stateMutator = e;
    }

    return Fn(t, [{
      key: "start",
      value: function value() {
        this._onStart();
      }
    }, {
      key: "destroy",
      value: function value() {
        this._onDestroy();
      }
    }, {
      key: "context",
      set: function set(e) {
        this._context = e;
      }
    }]), t;
  }(),
      Ms = function () {
    function n(e, t) {
      Un(this, n), this._context = e, this._stateMutator = t;
    }

    return Fn(n, [{
      key: "state",
      get: function get() {
        return this._stateMutator.state;
      }
    }]), n;
  }(),
      Us = function () {
    qn(r, Ps);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this, e))._stateMutator = e, t;
    }

    return r;
  }();

  (D = bs = bs || {}).IDLE = "idle", D.OFFERING = "offering", D.ANSWERING = "answering", D.CONNECTED = "connected", D.RECONNECTING = "reconnecting", D.ICE_RESTART_OFFERING = "iceRestartOffering", D.ICE_RESTART_ANSWERING = "iceRestartAnswering", D.CLOSED = "closed";

  var Vs,
      Fs = function () {
    qn(i, Us);
    var t,
        r = Xn(i);

    function i(e, t) {
      var n;
      return Un(this, i), Gn(Qn(n = r.call(this, e)), "type", bs.ANSWERING), n._stateMutator = e, n._offerCommand = t, n;
    }

    return Fn(i, [{
      key: "_onStart",
      value: function value() {
        this._context.dispatchEvent("answering"), this._context.createRTCConnection(), this._offerCommand && this.onOfferReceived(this._offerCommand);
      }
    }, {
      key: "_onDestroy",
      value: function value() {}
    }, {
      key: "onOfferReceived",
      value: (t = Mn(_regeneratorRuntime.mark(function e(t) {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._context.setRemoteDescription("offer", t.payload.sdp);

              case 2:
                this._context.prepareSessionDescription(), this._context.sendAnswer().catch(function (e) {
                  return _a.debug(e);
                });

              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "onIceConnected",
      value: function value() {
        this._stateMutator.toConnected(!1);
      }
    }, {
      key: "onClose",
      value: function value() {
        this._stateMutator.toClosed();
      }
    }]), i;
  }(),
      Gs = function () {
    qn(a, Us);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", bs.CLOSED), e;
    }

    return Fn(a, [{
      key: "_onStart",
      value: function value() {
        this._context.dispatchEvent("closed");
      }
    }, {
      key: "_onDestroy",
      value: function value() {}
    }]), a;
  }(),
      Bs = function () {
    qn(i, Us);
    var t,
        r = Xn(i);

    function i(e, t) {
      var n;
      return Un(this, i), Gn(Qn(n = r.call(this, e)), "type", bs.CONNECTED), n._stateMutator = e, n._isReconnected = t, n;
    }

    return Fn(i, [{
      key: "_onStart",
      value: function value() {
        this._context.dispatchEvent("connected");
      }
    }, {
      key: "_onDestroy",
      value: function value() {}
    }, {
      key: "onOfferReceived",
      value: (t = Mn(_regeneratorRuntime.mark(function e(t) {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                this._stateMutator.toReconnecting(t);

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "onIceDisconnected",
      value: function value() {
        this._stateMutator.toReconnecting();
      }
    }, {
      key: "onIceFailed",
      value: function value() {
        this._context.isDisposable && this.onClose(), this._context.isInitiator ? this._stateMutator.toIceRestartOffering() : this._stateMutator.toIceRestartAnswering();
      }
    }, {
      key: "onClose",
      value: function value() {
        this._stateMutator.toClosed();
      }
    }]), i;
  }(),
      js = function () {
    qn(i, Us);
    var t,
        r = Xn(i);

    function i(e, t) {
      var n;
      return Un(this, i), Gn(Qn(n = r.call(this, e)), "type", bs.ICE_RESTART_ANSWERING), n._stateMutator = e, n._offerCommand = t, n;
    }

    return Fn(i, [{
      key: "_onStart",
      value: function value() {
        this._context.dispatchEvent("iceRestartAnswering"), this._offerCommand && this.onOfferReceived(this._offerCommand);
      }
    }, {
      key: "_onDestroy",
      value: function value() {}
    }, {
      key: "onOfferReceived",
      value: (t = Mn(_regeneratorRuntime.mark(function e(t) {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._context.setRemoteDescription("offer", t.payload.sdp);

              case 2:
                this._context.sendAnswer().catch(function (e) {
                  return _a.debug(e);
                });

              case 3:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "onIceConnected",
      value: function value() {
        this._stateMutator.toConnected(!0);
      }
    }, {
      key: "onClose",
      value: function value() {
        this._stateMutator.toClosed();
      }
    }]), i;
  }(),
      qs = function () {
    qn(a, Us);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", bs.ICE_RESTART_OFFERING), e;
    }

    return Fn(a, [{
      key: "_onStart",
      value: function value() {
        this._context.dispatchEvent("iceRestartOffering"), this._context.sendOffer(!0);
      }
    }, {
      key: "_onDestroy",
      value: function value() {}
    }, {
      key: "onAnswerReceived",
      value: function value(e) {
        this._context.setRemoteDescription("answer", e.payload.sdp);
      }
    }, {
      key: "onIceConnected",
      value: function value() {
        this._stateMutator.toConnected(!0);
      }
    }, {
      key: "onClose",
      value: function value() {
        this._stateMutator.toClosed();
      }
    }]), a;
  }(),
      Hs = function () {
    qn(a, Us);
    var t,
        i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", bs.IDLE), e;
    }

    return Fn(a, [{
      key: "_onStart",
      value: function value() {}
    }, {
      key: "_onDestroy",
      value: function value() {}
    }, {
      key: "createOffer",
      value: function value() {
        this._stateMutator.toOffering();
      }
    }, {
      key: "onOfferReceived",
      value: (t = Mn(_regeneratorRuntime.mark(function e(t) {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                this._stateMutator.toAnswering(t);

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "onClose",
      value: function value() {
        this._stateMutator.toClosed();
      }
    }]), a;
  }(),
      zs = function () {
    qn(a, Us);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", bs.OFFERING), e;
    }

    return Fn(a, [{
      key: "_onStart",
      value: function value() {
        this._context.dispatchEvent("offering"), this._context.createRTCConnection(), this._context.prepareSessionDescription();
      }
    }, {
      key: "_onDestroy",
      value: function value() {}
    }, {
      key: "onAnswerReceived",
      value: function value(e) {
        this._context.setRemoteDescription("answer", e.payload.sdp);
      }
    }, {
      key: "onIceConnected",
      value: function value() {
        this._stateMutator.toConnected(!1);
      }
    }, {
      key: "onClose",
      value: function value() {
        this._stateMutator.toClosed();
      }
    }]), a;
  }(),
      Ws = function () {
    qn(i, Us);
    var r = Xn(i);

    function i(e, t) {
      var n;
      return Un(this, i), Gn(Qn(n = r.call(this, e)), "type", bs.RECONNECTING), n._stateMutator = e, n._offerCommand = t, n;
    }

    return Fn(i, [{
      key: "_onStart",
      value: function value() {
        this._context.dispatchEvent("reconnecting"), this._offerCommand && this.onOfferReceived(this._offerCommand);
      }
    }, {
      key: "_onDestroy",
      value: function value() {}
    }, {
      key: "onOfferReceived",
      value: function value(e) {
        this._stateMutator.toIceRestartAnswering(e);
      }
    }, {
      key: "onIceConnected",
      value: function value() {
        this._stateMutator.toConnected(!0);
      }
    }, {
      key: "onIceFailed",
      value: function value() {
        this._context.isDisposable && this.onClose(), this._context.isInitiator ? this._stateMutator.toIceRestartOffering() : this._stateMutator.toIceRestartAnswering();
      }
    }, {
      key: "onClose",
      value: function value() {
        this._stateMutator.toClosed();
      }
    }]), i;
  }(),
      Ks = function () {
    qn(t, xs);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "toIdle",
      value: function value() {
        this._changeState(new Hs(this));
      }
    }, {
      key: "toOffering",
      value: function value() {
        this._changeState(new zs(this));
      }
    }, {
      key: "toAnswering",
      value: function value(e) {
        this._changeState(new Fs(this, e));
      }
    }, {
      key: "toConnected",
      value: function value(e) {
        this._changeState(new Bs(this, e));
      }
    }, {
      key: "toReconnecting",
      value: function value(e) {
        this._changeState(new Ws(this, e));
      }
    }, {
      key: "toIceRestartOffering",
      value: function value() {
        this._changeState(new qs(this));
      }
    }, {
      key: "toIceRestartAnswering",
      value: function value(e) {
        this._changeState(new js(this, e));
      }
    }, {
      key: "toClosed",
      value: function value() {
        this._changeState(new Gs(this));
      }
    }, {
      key: "state",
      get: function get() {
        return this._state;
      }
    }, {
      key: "name",
      get: function get() {
        return "PeerConnection";
      }
    }]), t;
  }(),
      Ys = function () {
    qn(r, Ms);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this, e, new Ks(e)))._context = e, t._stateMutator.toIdle(), t;
    }

    return Fn(r, [{
      key: "onOfferReceived",
      value: function value(e) {
        _a.verbose("[".concat(this.state.type, "] onOfferReceived"));

        var t = this.state;

        switch (t.type) {
          case bs.IDLE:
          case bs.ANSWERING:
          case bs.CONNECTED:
          case bs.RECONNECTING:
          case bs.ICE_RESTART_ANSWERING:
            t.onOfferReceived(e);
            break;

          default:
            _a.error("[".concat(this.state.type, "] onOfferReceived"));

        }
      }
    }, {
      key: "onAnswerReceived",
      value: function value(e) {
        _a.verbose("[".concat(this.state.type, "] onAnswerReceived"));

        var t = this.state;

        switch (t.type) {
          case bs.OFFERING:
          case bs.ICE_RESTART_OFFERING:
            t.onAnswerReceived(e);
            break;

          default:
            _a.error("[".concat(this.state.type, "] onAnswerReceived"));

        }
      }
    }, {
      key: "onClose",
      value: function value() {
        _a.verbose("[".concat(this.state.type, "] onClose"));

        var e = this.state;

        switch (e.type) {
          case bs.IDLE:
          case bs.OFFERING:
          case bs.ANSWERING:
          case bs.CONNECTED:
          case bs.RECONNECTING:
          case bs.ICE_RESTART_OFFERING:
          case bs.ICE_RESTART_ANSWERING:
            e.onClose();
            break;

          default:
            _a.error("[".concat(this.state.type, "] onClose"));

        }
      }
    }, {
      key: "createOffer",
      value: function value() {
        _a.verbose("[".concat(this.state.type, "] createOffer"));

        var e = this.state;
        e.type === bs.IDLE ? e.createOffer() : _a.error("[".concat(this.state.type, "] createOffer"));
      }
    }, {
      key: "onIceConnected",
      value: function value() {
        _a.verbose("[".concat(this.state.type, "] onIceConnected"));

        var e = this.state;

        switch (e.type) {
          case bs.OFFERING:
          case bs.ANSWERING:
          case bs.RECONNECTING:
          case bs.ICE_RESTART_OFFERING:
          case bs.ICE_RESTART_ANSWERING:
            e.onIceConnected();
            break;

          default:
            _a.error("[".concat(this.state.type, "] onIceConnected"));

        }
      }
    }, {
      key: "onIceDisconnected",
      value: function value() {
        _a.verbose("[".concat(this.state.type, "] onIceDisconnected"));

        var e = this.state;
        e.type === bs.CONNECTED ? e.onIceDisconnected() : _a.error("[".concat(this.state.type, "] onIceDisconnected"));
      }
    }, {
      key: "onIceFailed",
      value: function value() {
        _a.verbose("[".concat(this.state.type, "] onIceFailed"));

        var e = this.state;

        switch (e.type) {
          case bs.CONNECTED:
          case bs.RECONNECTING:
            e.onIceFailed();
            break;

          default:
            _a.error("[".concat(this.state.type, "] onIceFailed"));

        }
      }
    }, {
      key: "state",
      get: function get() {
        return this._stateMutator.state;
      }
    }]), r;
  }();

  (D = Vs = Vs || {}).RELAY = "relay", D.ALL = "all";

  function Zs() {
    var n = this;
    Un(this, Zs), this.promise = new Promise(function (e, t) {
      n.resolve = e, n.reject = t;
    });
  }

  var Qs,
      Xs = function () {
    qn(l, Pa);
    var e,
        t,
        n,
        r,
        u = Xn(l);

    function l(e, t, n, r, i, a, o, s) {
      var c;
      return Un(this, l), (c = u.call(this))._ctx = e, c.id = t, c._signalingClient = n, c._localStream = r, c._isInitiator = i, c._turnCredential = a, c._mediaDirections = o, c._isDisposable = s, c._stateMachine = new Ys({
        dispatchEvent: c._dispatchEvent.bind(Qn(c)),
        isInitiator: c._isInitiator,
        setRemoteDescription: c._setRemoteDescription.bind(Qn(c)),
        sendAnswer: c._sendAnswer.bind(Qn(c)),
        sendOffer: c._sendOffer.bind(Qn(c)),
        createRTCConnection: c._createRTCConnection.bind(Qn(c)),
        prepareSessionDescription: c._prepareSessionDescription.bind(Qn(c)),
        isDisposable: c._isDisposable
      }), r && r.on("streamChanged", function (e) {
        return c.onLocalStream(e);
      }), c;
    }

    return Fn(l, [{
      key: "onEvent",
      value: function value(e) {
        switch (e.type) {
          case Is.CANDIDATE:
            return void this._receiveCandidate(e);

          case Is.OFFER:
            this._stateMachine.onOfferReceived(e);

            break;

          case Is.ANSWER:
            this._stateMachine.onAnswerReceived(e);

            break;

          default:
            _a.error(new Error("unhandled call event ".concat(e)));

        }
      }
    }, {
      key: "createOffer",
      value: function value() {
        this._stateMachine.createOffer();
      }
    }, {
      key: "close",
      value: function value() {
        this._closeRTCConnection(), this._stateMachine.onClose();
      }
    }, {
      key: "onLocalStream",
      value: function value(e) {
        if (this._rtcConnection) {
          var t = or(e.getTracks());

          try {
            for (t.s(); !(n = t.n()).done;) {
              var n = n.value;

              this._replaceTrack(n);
            }
          } catch (e) {
            t.e(e);
          } finally {
            t.f();
          }
        }
      }
    }, {
      key: "getCandidateInfo",
      value: (r = Mn(_regeneratorRuntime.mark(function e() {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", ws(this.rtcConnection));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return r.apply(this, arguments);
      })
    }, {
      key: "getStatsLog",
      value: (n = Mn(_regeneratorRuntime.mark(function e() {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", Ts(this.rtcConnection));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return n.apply(this, arguments);
      })
    }, {
      key: "_replaceTrack",
      value: function value(e) {
        var t = or(this._rtcConnection.getSenders());

        try {
          for (t.s(); !(n = t.n()).done;) {
            var n = n.value;
            n.track && n.track.kind === e.kind && n.replaceTrack(e);
          }
        } catch (e) {
          t.e(e);
        } finally {
          t.f();
        }
      }
    }, {
      key: "_createRTCConnection",
      value: function value() {
        var e,
            r = this;
        this._turnCredential && (e = {
          iceServers: [{
            username: this._turnCredential.username,
            credential: this._turnCredential.password,
            urls: this._turnCredential.turnUrls
          }],
          iceTransportPolicy: this._turnCredential.transportPolicy || Vs.ALL
        });
        var t = new RTCPeerConnection(e);
        t.onnegotiationneeded = function () {
          r._sendOffer(!1);
        }, t.onicecandidate = function (e) {
          var t, n;
          e.candidate && null !== (t = (n = r._signalingClient).sendCandidate) && void 0 !== t && t.call(n, e.candidate);
        }, t.onconnectionstatechange = function () {
          return r._handleConnectionStateChange(t);
        }, t.oniceconnectionstatechange = function () {
          return r._handleIceConnectionStateChange(t);
        }, t.ontrack = function (e) {
          return r._onRemoteTrack(e);
        }, this._rtcConnection = t;
      }
    }, {
      key: "_closeRTCConnection",
      value: function value() {
        this._rtcConnection && (this._rtcConnection.onnegotiationneeded = null, this._rtcConnection.onicecandidate = null, this._rtcConnection.oniceconnectionstatechange = null, this._rtcConnection.onconnectionstatechange = null, this._rtcConnection.close(), this._rtcConnection = null, delete this._remoteStream);
      }
    }, {
      key: "_prepareSessionDescription",
      value: function value() {
        var e = this._mediaDirections,
            t = e.audio,
            n = e.video,
            e = {
          sendrecv: [],
          sendonly: [],
          recvonly: [],
          none: []
        };
        e[t].push("audio"), e[n].push("video"), e.sendrecv.length && this._addTracks(e.sendrecv), e.sendonly.length && this._addSendOnlyTransceivers(e.sendonly), e.recvonly.length && this._addReceiveOnlyTransceivers(e.recvonly);
      }
    }, {
      key: "_addTracks",
      value: function value(t) {
        var n = this;

        _a.debug("_addTracks()");

        var r = this._localStream.localStream;
        r.getTracks().forEach(function (e) {
          t.includes(e.kind) && n._rtcConnection.addTrack(e, r);
        });
      }
    }, {
      key: "_addReceiveOnlyTransceivers",
      value: function value(e) {
        var t = this;
        e.forEach(function (e) {
          t._rtcConnection.addTransceiver(e, {
            direction: "recvonly"
          });
        });
      }
    }, {
      key: "_addSendOnlyTransceivers",
      value: function value(e) {
        var n = this,
            r = this._localStream.localStream;
        e.forEach(function (t) {
          r.getTracks().forEach(function (e) {
            e.kind === t && n._rtcConnection.addTransceiver(e, {
              direction: "sendonly",
              streams: [r]
            });
          });
        });
      }
    }, {
      key: "_setRemoteDescription",
      value: function value(e, t) {
        t = t.replace(/a=extmap:0 ulpfec\r\n/, ""), t = new RTCSessionDescription({
          type: e,
          sdp: t
        });
        return this._rtcConnection.setRemoteDescription(t);
      }
    }, {
      key: "_sendOffer",
      value: (t = Mn(_regeneratorRuntime.mark(function e(t) {
        var n;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = {
                  iceRestart: t || !1
                }, e.next = 3, this._rtcConnection.createOffer(n);

              case 3:
                return n = e.sent, e.next = 6, this._rtcConnection.setLocalDescription(n);

              case 6:
                return e.abrupt("return", this._signalingClient.sendOfferSdp(this._rtcConnection.localDescription));

              case 7:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "_sendAnswer",
      value: (e = Mn(_regeneratorRuntime.mark(function e() {
        var t;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._rtcConnection.createAnswer();

              case 2:
                return (t = e.sent).sdp = t.sdp.replace("actpass", "active"), e.next = 6, this._rtcConnection.setLocalDescription(t);

              case 6:
                return e.abrupt("return", this._signalingClient.sendAnswerSdp(this._rtcConnection.localDescription));

              case 7:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return e.apply(this, arguments);
      })
    }, {
      key: "_handleIceConnectionStateChange",
      value: function value(e) {
        switch (_a.verbose("[".concat(this._state.type, "] iceConnectionState ").concat(e.iceConnectionState)), e.iceConnectionState) {
          case "connected":
            this._stateMachine.onIceConnected();

            break;

          case "disconnected":
            this._stateMachine.onIceDisconnected();

            break;

          case "failed":
            this._dispatchEvent("iceFailed");

        }
      }
    }, {
      key: "_handleConnectionStateChange",
      value: function value(e) {
        _a.verbose("[".concat(this._state.type, "] connectionState ").concat(e.connectionState));
      }
    }, {
      key: "_receiveCandidate",
      value: function value(e) {
        e = e.payload.candidate;

        this._rtcConnection.addIceCandidate({
          sdpMLineIndex: e.sdpMLineIndex,
          sdpMid: e.sdpMid,
          candidate: e.sdp
        }).catch(function (e) {
          _a.error(e);
        });
      }
    }, {
      key: "_onRemoteTrack",
      value: function value(e) {
        this._remoteStream = e.streams[0], this._dispatchEvent("remoteStream", this._remoteStream);
      }
    }, {
      key: "_state",
      get: function get() {
        return this._stateMachine.state;
      }
    }, {
      key: "rtcConnection",
      get: function get() {
        return this._rtcConnection;
      }
    }, {
      key: "remoteStream",
      get: function get() {
        return this._remoteStream;
      }
    }, {
      key: "signalingClient",
      get: function get() {
        return this._signalingClient;
      }
    }]), l;
  }(),
      $s = function () {
    function e() {
      Un(this, e);
    }

    var t;
    return Fn(e, [{
      key: "addStatsLog",
      value: function value(e) {
        this._accumulated = Rs(e, this._accumulated);
      }
    }, {
      key: "getAccumulatedStats",
      value: (t = Mn(_regeneratorRuntime.mark(function e(t) {
        var n;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, t.getStatsLog();

              case 2:
                return n = e.sent, e.abrupt("return", Rs(n, this._accumulated));

              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }]), e;
  }(),
      Js = function () {
    qn(i, Pa);
    var e,
        r = Xn(i);

    function i(e, t) {
      var n;
      return Un(this, i), Gn(Qn(n = r.call(this)), "_peerConnections", new Map()), Gn(Qn(n), "_unhandledCommands", []), n._ctx = e, n._mediaDirections = t, n._statsLogAccumulator = new $s(), n;
    }

    return Fn(i, [{
      key: "_activePC",
      get: function get() {
        return this._peerConnections.get(this._activePCId);
      },
      set: function set(e) {
        this._peerConnections.has(e.id) || this._addPC(e), this._activePCId = e.id;
      }
    }, {
      key: "_preparingPC",
      get: function get() {
        return this._peerConnections.get(this._preparingPCId);
      },
      set: function set(e) {
        this._peerConnections.has(e.id) || this._addPC(e), this._preparingPCId = e.id;
      }
    }, {
      key: "activePeerConnection",
      get: function get() {
        return this._activePC;
      }
    }]), Fn(i, [{
      key: "createPeerConnection",
      value: function value(e, t, n, r, i) {
        _a.debug("Create new peer connection");

        i = new Xs(this._ctx, e, t, n, r, i, this._mediaDirections, !1);
        return this._activePC ? this._replacePreparing(i, r) : (this._activePC = i, this._dispatchEvent("initialized")), this._dispatchUnhandledCommands(i), i;
      }
    }, {
      key: "createOffer",
      value: function value() {
        this._activePC && this._activePC.createOffer();
      }
    }, {
      key: "close",
      value: function value() {
        this._deactivatePreparing(), this._deactivateActive();
      }
    }, {
      key: "onEvent",
      value: function value(e) {
        var t = null !== (n = e.payload.peerConnectionId) && void 0 !== n ? n : void 0,
            n = this._peerConnections.get(t);

        this._isActive(t) || this._isPreparing(t) ? n.onEvent(e) : this._isInactive(t) || this._dispatchOnCreation(e);
      }
    }, {
      key: "getStatsLog",
      value: (e = Mn(_regeneratorRuntime.mark(function e() {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this._activePC) {
                  e.next = 2;
                  break;
                }

                return e.abrupt("return", void 0);

              case 2:
                return e.abrupt("return", this._statsLogAccumulator.getAccumulatedStats(this._activePC));

              case 3:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return e.apply(this, arguments);
      })
    }, {
      key: "_addPC",
      value: function value(e) {
        this._peerConnections.set(e.id, e);
      }
    }, {
      key: "_isActive",
      value: function value(e) {
        return e === this._activePCId;
      }
    }, {
      key: "_isPreparing",
      value: function value(e) {
        return e === this._preparingPCId;
      }
    }, {
      key: "_isInactive",
      value: function value(e) {
        return !this._isActive(e) && !this._isPreparing(e) && !!this._peerConnections.get(e);
      }
    }, {
      key: "_deactivateActive",
      value: function value() {
        _a.debug("Close active pc if exist"), this._activePC && (this._activePC.removeAllEventListeners(), this._activePC.close(), delete this._activePCId);
      }
    }, {
      key: "_activatePreparing",
      value: function value() {
        var t,
            n = this;
        _a.debug("Activate preparing pc if exist"), this._preparingPC && (t = this._activePC, this._activePC = this._preparingPC, delete this._preparingPCId, this._dispatchEvent("replaced"), t.removeAllEventListeners(), t.getStatsLog().then(function (e) {
          n._statsLogAccumulator.addStatsLog(e), t.close();
        }));
      }
    }, {
      key: "_deactivatePreparing",
      value: function value() {
        _a.debug("Close preparing pc if exist"), this._preparingPC && (this._preparingPC.removeAllEventListeners(), this._preparingPC.close(), delete this._preparingPCId);
      }
    }, {
      key: "_replacePreparing",
      value: function value(e, t) {
        var n = this;
        _a.debug("Create preparing peer connection"), this._deactivatePreparing(), this._preparingPC = e;
        this._preparingPC.once("connected", function () {
          setTimeout(function () {
            n._activatePreparing();
          }, 2e3);
        }), t && this._preparingPC.createOffer();
      }
    }, {
      key: "_dispatchUnhandledCommands",
      value: function value(t) {
        this._unhandledCommands.filter(function (e) {
          return e.payload.peerConnectionId === t.id;
        }).forEach(function (e) {
          return t.onEvent(e);
        }), this._unhandledCommands = this._unhandledCommands.filter(function (e) {
          return e.payload.peerConnectionId !== t.id;
        });
      }
    }, {
      key: "_dispatchOnCreation",
      value: function value(e) {
        this._unhandledCommands.push(e);
      }
    }]), i;
  }(),
      ec = function () {
    var r = Mn(_regeneratorRuntime.mark(function e(t, n, r) {
      var i,
          a,
          o,
          s,
          c,
          u = arguments;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return c = 3 < u.length && void 0 !== u[3] ? u[3] : {
                count: 0,
                deferred: new Zs()
              }, i = c.deferred, a = c.count, e.prev = 2, e.next = 5, n();

            case 5:
              s = e.sent, 0 < a && null !== (o = r.onRecover) && void 0 !== o && o.call(r), i.resolve(s), e.next = 19;
              break;

            case 10:
              if (e.prev = 10, e.t0 = e.catch(2), null !== (c = r.onError) && void 0 !== c && c.call(r, e.t0), 0 <= (s = t.calcTimeout(a + 1))) return null !== (c = r.onRetrial) && void 0 !== c && c.call(r, a + 1, e.t0), setTimeout(function () {
                ec(t, n, r, {
                  count: a + 1,
                  deferred: i
                });
              }, s), e.abrupt("return", i.promise);
              e.next = 18;
              break;

            case 18:
              i.reject(e.t0);

            case 19:
              return e.abrupt("return", i.promise);

            case 20:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[2, 10]]);
    }));
    return function (e, t, n) {
      return r.apply(this, arguments);
    };
  }(),
      tc = function () {
    function e() {
      Un(this, e);
    }

    return Fn(e, [{
      key: "calcTimeout",
      value: function value(e) {
        switch (e) {
          case 1:
            return 1e3;

          case 2:
            return 2e3;

          case 3:
            return 3e3;

          default:
            return -1;
        }
      }
    }]), e;
  }(),
      nc = function () {
    function r(e, t, n) {
      Un(this, r), this.interval = e, this.noise = t, this.maxRetrial = n;
    }

    return Fn(r, [{
      key: "calcTimeout",
      value: function value(e) {
        return e > this.maxRetrial ? -1 : e * this.interval + (Math.random() - .5) * this.noise * 2;
      }
    }]), r;
  }(),
      rc = function () {
    function t(e) {
      Un(this, t), this._requests = new Map(), this.timeoutTime = e;
    }

    return Fn(t, [{
      key: "has",
      value: function value(e) {
        return this._requests.has(e);
      }
    }, {
      key: "get",
      value: function value(e) {
        return this._requests.get(e);
      }
    }, {
      key: "register",
      value: function value(e) {
        if (!e) throw new Error("invalid request id");
        if (this._requests.has(e)) throw new Error("duplicate requests");
        var t = new Zs();
        return this._requests.set(e, {
          deferred: t,
          timer: this._createTimeoutTimer(e)
        }), t;
      }
    }, {
      key: "unregister",
      value: function value(e) {
        if (!this._requests.has(e)) return null;

        var t = this._requests.get(e),
            n = t.timer,
            t = t.deferred;

        return clearTimeout(n), this._requests.delete(e), t;
      }
    }, {
      key: "_createTimeoutTimer",
      value: function value(e) {
        var t = this;
        return setTimeout(function () {
          t.unregister(e).reject(new ra(Tn.ERR_NO_RESPONSE_DUE_TO_TIMEOUT));
        }, this._getTimeoutTime());
      }
    }, {
      key: "rejectAll",
      value: function value(e) {
        var t = or(this._requests.keys());

        try {
          for (t.s(); !(n = t.n()).done;) {
            var n = n.value,
                n = this._requests.get(n);

            clearTimeout(n.timer), n.deferred.reject(e);
          }
        } catch (e) {
          t.e(e);
        } finally {
          t.f();
        }

        this._requests.clear();
      }
    }, {
      key: "_getTimeoutTime",
      value: function value() {
        return this.timeoutTime;
      }
    }]), t;
  }(),
      ic = function () {
    function i(e, t, n, r) {
      Un(this, i), Gn(this, "_timeoutTime", 6e4), this._ctx = e, this._participantId = t, this._mediaDirections = n, this._endpointId = r, this._requestMap = new rc(this._timeoutTime);
    }

    var t, n, r;
    return Fn(i, [{
      key: "sendOfferSdp",
      value: (r = Mn(_regeneratorRuntime.mark(function e(t) {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this._endpointId) {
                  e.next = 5;
                  break;
                }

                return e.next = 3, this._sendOfferAndUnregisterCreateEndpointRequest(t);

              case 3:
                e.next = 7;
                break;

              case 5:
                return e.next = 7, this._sendOfferAndUnregisterPutEndpointRequest(t);

              case 7:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return r.apply(this, arguments);
      })
    }, {
      key: "_sendOfferAndUnregisterCreateEndpointRequest",
      value: (n = Mn(_regeneratorRuntime.mark(function e(t) {
        var n, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = this._requestMap.unregister("".concat(this._participantId, ":create-endpoint-request")), e.prev = 1, e.next = 4, this._sendCreateEndpoint(t);

              case 4:
                return r = e.sent, n && n.resolve(r), e.abrupt("return", r);

              case 9:
                throw e.prev = 9, e.t0 = e.catch(1), n && n.reject(e.t0), e.t0;

              case 13:
              case "end":
                return e.stop();
            }
          }
        }, e, this, [[1, 9]]);
      })), function (e) {
        return n.apply(this, arguments);
      })
    }, {
      key: "_sendOfferAndUnregisterPutEndpointRequest",
      value: (t = Mn(_regeneratorRuntime.mark(function e(t) {
        var n, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = this._requestMap.unregister("".concat(this._participantId, ":put-endpoint-request")), e.prev = 1, e.next = 4, this._sendCreateEndpoint(t);

              case 4:
                return r = e.sent, n && n.resolve(r), e.abrupt("return", r);

              case 9:
                throw e.prev = 9, e.t0 = e.catch(1), n && n.reject(e.t0), e.t0;

              case 13:
              case "end":
                return e.stop();
            }
          }
        }, e, this, [[1, 9]]);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "registerCreateEndpointRequest",
      value: function value() {
        if (_a.debug("registerCreateEndpointRequest()"), this._endpointId) throw new Error("Cannot register create endpoint request on endpoint recycle");
        return this._requestMap.register("".concat(this._participantId, ":create-endpoint-request"));
      }
    }, {
      key: "registerPutEndpointRequest",
      value: function value() {
        if (_a.debug("registerPutEndpointRequest()"), !this._endpointId) throw new Error("Cannot register put endpoint request without endpoint id");
        return this._requestMap.register("".concat(this._participantId, ":put-endpoint-request"));
      }
    }, {
      key: "_sendCreateEndpoint",
      value: function value(e) {
        e = Ko.createCreateEndpoint(this._ctx.roomId, this._participantId, e.sdp, this._mediaDirections);
        return this._ctx.sender.send(e);
      }
    }, {
      key: "_sendPutEndpoint",
      value: function value(e) {
        e = Ko.createPutEndpoint(this._ctx.roomId, this._participantId, this._endpointId, e.sdp);
        return this._ctx.sender.send(e);
      }
    }]), i;
  }(),
      ac = function () {
    qn(r, Ps);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this, e))._stateMutator = e, t;
    }

    return r;
  }();

  (D = Qs = Qs || {}).PENDING = "pending", D.ESTABLISHED = "established", D.CONNECTED = "connected", D.FAILED = "failed", D.RELEASING = "releasing", D.CLOSED = "closed";

  var oc = function () {
    qn(a, ac);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", Qs.CLOSED), e;
    }

    return Fn(a, [{
      key: "_onStart",
      value: function value() {
        this._context.dispatchEvent("closed");
      }
    }, {
      key: "_onDestroy",
      value: function value() {}
    }]), a;
  }(),
      sc = function () {
    qn(r, ac);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), Gn(Qn(t = n.call(this, e)), "type", Qs.CONNECTED), t._stateMutator = e, t;
    }

    return Fn(r, [{
      key: "_onStart",
      value: function value() {
        this._context.dispatchEvent("connected");
      }
    }, {
      key: "_onDestroy",
      value: function value() {}
    }, {
      key: "onICEFailed",
      value: function value() {
        this._stateMutator.toPending();
      }
    }, {
      key: "onAttach",
      value: function value() {
        this._context.requestAttach();
      }
    }, {
      key: "onRelease",
      value: function value() {
        this._stateMutator.toReleasing();
      }
    }, {
      key: "onExit",
      value: function value() {
        this._stateMutator.toClosed();
      }
    }]), r;
  }(),
      cc = function () {
    qn(a, ac);
    var i = Xn(a);

    function a(e, t, n) {
      var r;
      return Un(this, a), Gn(Qn(r = i.call(this, e)), "type", Qs.ESTABLISHED), r._stateMutator = e, r._sdp = t, r._hasPendingAttach = n, r;
    }

    return Fn(a, [{
      key: "_onStart",
      value: function value() {
        this._context.dispatchEvent("established"), this._context.setRemoteDescription(this._sdp), this._hasPendingAttach && this.onAttach();
      }
    }, {
      key: "_onDestroy",
      value: function value() {}
    }, {
      key: "onPCConnected",
      value: function value() {
        this._stateMutator.toConnected();
      }
    }, {
      key: "onICEFailed",
      value: function value() {
        this._stateMutator.toPending();
      }
    }, {
      key: "onAttach",
      value: function value() {
        this._context.requestAttach();
      }
    }, {
      key: "onRelease",
      value: function value() {
        this._stateMutator.toReleasing();
      }
    }, {
      key: "onExit",
      value: function value() {
        this._stateMutator.toClosed();
      }
    }]), a;
  }(),
      uc = function () {
    qn(a, ac);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", Qs.FAILED), e;
    }

    return Fn(a, [{
      key: "_onStart",
      value: function value() {
        this._context.dispatchEvent("failed"), this._context.endpoint.id ? this._stateMutator.toReleasing() : this._stateMutator.toClosed();
      }
    }, {
      key: "_onDestroy",
      value: function value() {}
    }, {
      key: "onExit",
      value: function value() {
        this._stateMutator.toClosed();
      }
    }]), a;
  }(),
      lc = function () {
    qn(a, ac);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", Qs.PENDING), e;
    }

    return Fn(a, [{
      key: "_onStart",
      value: function value() {
        this._context.dispatchEvent("pending"), this._request();
      }
    }, {
      key: "_onDestroy",
      value: function value() {
        this._requestTimeout && clearTimeout(this._requestTimeout), delete this._requestTimeout;
      }
    }, {
      key: "_request",
      value: function value() {
        var e = this;
        this._context.trialCount += 1;
        var t = this._context.trialCount;
        9 <= t ? this._stateMutator.toFailed() : 1 < t ? this._requestTimeout = setTimeout(function () {
          e._context.createSession();
        }, 5e3 * t + 2e3 * (Math.random() - .5)) : this._context.createSession();
      }
    }, {
      key: "onEndpointRequestSucceeded",
      value: function value(e) {
        this._stateMutator.toEstablished(e, this._hasPendingAttach);
      }
    }, {
      key: "onEndpointRequestFailed",
      value: function value() {
        this._request();
      }
    }, {
      key: "onAttach",
      value: function value() {
        this._hasPendingAttach = !0;
      }
    }, {
      key: "onRelease",
      value: function value() {
        this._stateMutator.toReleasing();
      }
    }, {
      key: "onExit",
      value: function value() {
        this._stateMutator.toClosed();
      }
    }]), a;
  }(),
      dc = function () {
    qn(a, ac);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", Qs.RELEASING), e;
    }

    return Fn(a, [{
      key: "_onStart",
      value: function value() {
        this._context.dispatchEvent("releasing"), this._context.closePeerConnection(), this._context.endpoint.id && this._context.requestRelease();
      }
    }, {
      key: "_onDestroy",
      value: function value() {}
    }, {
      key: "onEndpointRequestSucceeded",
      value: function value() {
        this._context.requestRelease();
      }
    }, {
      key: "onEndpointRequestFailed",
      value: function value() {
        this._stateMutator.toClosed();
      }
    }, {
      key: "onReleased",
      value: function value() {
        this._stateMutator.toClosed();
      }
    }, {
      key: "onExit",
      value: function value() {
        this._stateMutator.toClosed();
      }
    }]), a;
  }(),
      hc = function () {
    qn(t, xs);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "toPending",
      value: function value() {
        this._changeState(new lc(this));
      }
    }, {
      key: "toEstablished",
      value: function value(e, t) {
        this._changeState(new cc(this, e, t));
      }
    }, {
      key: "toConnected",
      value: function value() {
        this._changeState(new sc(this));
      }
    }, {
      key: "toFailed",
      value: function value() {
        this._changeState(new uc(this));
      }
    }, {
      key: "toReleasing",
      value: function value() {
        this._changeState(new dc(this));
      }
    }, {
      key: "toClosed",
      value: function value() {
        this._changeState(new oc(this));
      }
    }, {
      key: "state",
      get: function get() {
        return this._state;
      }
    }, {
      key: "name",
      get: function get() {
        return "PeerConnection";
      }
    }]), t;
  }(),
      fc = function () {
    qn(r, Ms);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this, e, new hc(e)))._context = e, t._stateMutator.toPending(), t;
    }

    return Fn(r, [{
      key: "onEndpointRequestSucceeded",
      value: function value(e) {
        _a.verbose("[".concat(this.state.type, "] onEndpointRequestSucceeded"));

        var t = this.state;

        switch (t.type) {
          case Qs.PENDING:
            t.onEndpointRequestSucceeded(e);
            break;

          case Qs.RELEASING:
            t.onEndpointRequestSucceeded();
            break;

          default:
            _a.error("[".concat(this.state.type, "] onEndpointRequestSucceeded"));

        }
      }
    }, {
      key: "onEndpointRequestFailed",
      value: function value() {
        _a.verbose("[".concat(this.state.type, "] onEndpointCreateFailed"));

        var e = this.state;

        switch (e.type) {
          case Qs.PENDING:
          case Qs.RELEASING:
            e.onEndpointRequestFailed();
            break;

          default:
            _a.error("[".concat(this.state.type, "] onEndpointCreateFailed"));

        }
      }
    }, {
      key: "onICEFailed",
      value: function value() {
        _a.verbose("[".concat(this.state.type, "] onICEFailed"));

        var e = this.state;

        switch (e.type) {
          case Qs.ESTABLISHED:
          case Qs.CONNECTED:
            e.onICEFailed();
            break;

          default:
            _a.error("[".concat(this.state.type, "] onICEFailed"));

        }
      }
    }, {
      key: "onPCConnected",
      value: function value() {
        _a.verbose("[".concat(this.state.type, "] onPCConnected"));

        var e = this.state;
        e.type === Qs.ESTABLISHED ? e.onPCConnected() : _a.error("[".concat(this.state.type, "] onPCConnected"));
      }
    }, {
      key: "onAttach",
      value: function value() {
        _a.verbose("[".concat(this.state.type, "] onAttach"));

        var e = this.state;

        switch (e.type) {
          case Qs.PENDING:
          case Qs.ESTABLISHED:
          case Qs.CONNECTED:
            e.onAttach();
            break;

          default:
            _a.error("[".concat(this.state.type, "] onAttach"));

        }
      }
    }, {
      key: "onRelease",
      value: function value() {
        _a.verbose("[".concat(this.state.type, "] onRelease"));

        var e = this.state;

        switch (e.type) {
          case Qs.PENDING:
          case Qs.ESTABLISHED:
          case Qs.CONNECTED:
            e.onRelease();
            break;

          default:
            _a.error("[".concat(this.state.type, "] onRelease"));

        }
      }
    }, {
      key: "onReleased",
      value: function value() {
        _a.verbose("[".concat(this.state.type, "] onReleased"));

        var e = this.state;
        e.type === Qs.RELEASING ? e.onReleased() : _a.error("[".concat(this.state.type, "] onReleased"));
      }
    }, {
      key: "onExit",
      value: function value() {
        _a.verbose("[".concat(this.state.type, "] onExit"));

        var e = this.state;

        switch (e.type) {
          case Qs.RELEASING:
          case Qs.PENDING:
          case Qs.CONNECTED:
          case Qs.ESTABLISHED:
          case Qs.FAILED:
            e.onExit();
            break;

          default:
            _a.error("[".concat(this.state.type, "] onExit"));

        }
      }
    }, {
      key: "state",
      get: function get() {
        return this._stateMutator.state;
      }
    }]), r;
  }(),
      _c = function () {
    qn(a, Pa);
    var i = Xn(a);

    function a(e, t, n) {
      var r;
      return Un(this, a), Gn(Qn(r = i.call(this)), "tmpId", Jo()), Gn(Qn(r), "_createSession", function () {
        switch (_a.debug("_createSession()"), r._type) {
          case "master":
            r._createMasterSession();

            break;

          case "viewer":
            r._createViewerSession();

            break;

          default:
            _a.error("Not supported endpoint type : ", r._type);

        }
      }), Gn(Qn(r), "_closePeerConnection", function () {
        _a.debug("_closePeerConnection()"), r._pc.removeAllEventListeners(), r._pc.close();
      }), Gn(Qn(r), "_requestAttach", function () {
        var t = r._attachedTo;
        ec(new nc(5e3, 1e3, 8), function () {
          return r._sendAttach(t.id);
        }, {
          onError: function onError(e) {
            _a.error("Fail attach endpoint endpointId = ".concat(r.id, ", to = ").concat(t.id, " ErrorCode = ").concat(e.code));
          }
        }).then(function () {
          r._dispatchEvent("attached", t);
        });
      }), Gn(Qn(r), "_requestRelease", function () {
        _a.debug("_requestRelease()"), r._sendReleaseEndpoint().then(function () {
          r._stateMachine.onReleased();
        }).catch(function (e) {
          _a.error("Release request failed", e), r._stateMachine.onReleased();
        });
      }), Gn(Qn(r), "_setRemoteDescription", function (e) {
        _a.debug("_setRemoteDescription()");

        var t = r._pc,
            e = Ls.createAnswer(void 0, e);
        t.onEvent(e), t.once("connected", function () {
          r._stateMachine.onPCConnected(), r._sendConnected();
        }), t.once("iceFailed", function () {
          r._stateMachine.onICEFailed();
        });
      }), r._ctx = e, r._collection = t, r._type = n, r._stateMachine = new fc({
        endpoint: Qn(r),
        dispatchEvent: r._dispatchEvent.bind(Qn(r)),
        createSession: r._createSession,
        setRemoteDescription: r._setRemoteDescription,
        closePeerConnection: r._closePeerConnection,
        requestAttach: r._requestAttach,
        requestRelease: r._requestRelease,
        trialCount: 0
      }), r;
    }

    return Fn(a, [{
      key: "attach",
      value: function value(e) {
        _a.debug("attach()"), (e.viewerEndpoint = this)._attachedTo = e, this._stateMachine.onAttach();
      }
    }, {
      key: "release",
      value: function value() {
        _a.debug("release()"), this._stateMachine.onRelease();
      }
    }, {
      key: "exit",
      value: function value() {
        _a.debug("exit()"), this._closePeerConnection(), this._stateMachine.onExit();
      }
    }, {
      key: "_createMasterSession",
      value: function value() {
        _a.debug("_createMasterSession()"), this._createPeerConnection(this._masterSessionDirection, this._localParticipant.localStream), this._requestCreateEndpoint();
      }
    }, {
      key: "_createViewerSession",
      value: function value() {
        _a.debug("_createViewerSession()"), this._createPeerConnection(this._viewerSessionDirection, void 0), this._requestCreateEndpoint();
      }
    }, {
      key: "_createPeerConnection",
      value: function value(e, t) {
        _a.debug("_createPeerConnection()");

        var n = new ic(this._ctx, this._localParticipant.id, e, this.id);
        this._pc = new Xs(this._ctx, void 0, n, t, !0, void 0, e, !0), this._dispatchEvent("pcChanged", this._pc);
      }
    }, {
      key: "_requestCreateEndpoint",
      value: function value() {
        var t = this;

        _a.debug("_requestCreateEndpoint()");

        var e = this._pc,
            n = this.id ? e.signalingClient.registerPutEndpointRequest() : e.signalingClient.registerCreateEndpointRequest();
        e.createOffer(), n.promise.then(function (e) {
          t.id = e.payload.endpointId, t._stateMachine.onEndpointRequestSucceeded(e.payload.sdp);
        }).catch(function (e) {
          _a.error("Endpoint request failed", e), t._stateMachine.onEndpointRequestFailed();
        });
      }
    }, {
      key: "_sendConnected",
      value: function value() {
        var e = Ko.createConnected(this._ctx.roomId, this._localParticipant.id, this.id);
        return this._ctx.sender.send(e);
      }
    }, {
      key: "_sendReleaseEndpoint",
      value: function value() {
        var e = Ko.createReleaseEndpoint(this._ctx.roomId, this._localParticipant.id, this.id);
        return this._ctx.sender.sendWithRetry(e);
      }
    }, {
      key: "_sendAttach",
      value: function value(e) {
        e = Ko.createAttach(this._ctx.roomId, this._localParticipant.id, this.id, e);
        return this._ctx.sender.sendWithRetry(e, new tc());
      }
    }, {
      key: "pc",
      get: function get() {
        return this._pc;
      }
    }, {
      key: "_state",
      get: function get() {
        return this._stateMachine.state;
      }
    }, {
      key: "_localParticipant",
      get: function get() {
        return this._collection.localParticipant;
      }
    }, {
      key: "_masterSessionDirection",
      get: function get() {
        switch (this._ctx.roomType) {
          case Gc.SMALL_ROOM_FOR_AUDIO_ONLY:
            return {
              audio: "sendonly",
              video: "none"
            };

          case Gc.LARGE_ROOM_FOR_AUDIO_ONLY:
            return {
              audio: "sendrecv",
              video: "none"
            };

          case Gc.SMALL_ROOM_FOR_VIDEO:
            return {
              audio: "sendonly",
              video: "sendonly"
            };

          case Gc.LARGE_ROOM_FOR_VIDEO:
            return {
              audio: "sendrecv",
              video: "sendonly"
            };

          default:
            return _a.error("Not supported room type : ", this._ctx.roomType), {
              audio: "sendonly",
              video: "sendonly"
            };
        }
      }
    }, {
      key: "_viewerSessionDirection",
      get: function get() {
        switch (this._ctx.roomType) {
          case Gc.SMALL_ROOM_FOR_AUDIO_ONLY:
            return {
              audio: "recvonly",
              video: "none"
            };

          case Gc.LARGE_ROOM_FOR_AUDIO_ONLY:
            return {
              audio: "none",
              video: "none"
            };

          case Gc.SMALL_ROOM_FOR_VIDEO:
            return {
              audio: "recvonly",
              video: "recvonly"
            };

          case Gc.LARGE_ROOM_FOR_VIDEO:
            return {
              audio: "none",
              video: "recvonly"
            };

          default:
            return _a.error("Not supported room type : ", this._ctx.roomType), {
              audio: "recvonly",
              video: "recvonly"
            };
        }
      }
    }]), a;
  }(),
      pc = function () {
    function n(e, t) {
      Un(this, n), Gn(this, "_endpoints", new Map()), this._ctx = e, this._collection = t;
    }

    return Fn(n, [{
      key: "exit",
      value: function value() {
        var e,
            t = or(this._endpoints.values());

        try {
          for (t.s(); !(e = t.n()).done;) {
            e.value.exit();
          }
        } catch (e) {
          t.e(e);
        } finally {
          t.f();
        }
      }
    }, {
      key: "releaseEndpoint",
      value: function value(e) {
        e.release();
      }
    }, {
      key: "createMaster",
      value: function value() {
        return _a.debug("_createSendSession()"), this._createEndpoint("master");
      }
    }, {
      key: "createViewer",
      value: function value() {
        return _a.debug("_createRecvSession()"), this._createEndpoint("viewer");
      }
    }, {
      key: "_createEndpoint",
      value: function value(e) {
        var t = this,
            n = new _c(this._ctx, this._collection, e);
        return this._endpoints.set(n.tmpId, n), n.once("established", function () {
          t._endpoints.delete(n.tmpId), t._endpoints.set(n.id, n);
        }), n.once("closed", function () {
          t._endpoints.delete(n.id);
        }), n;
      }
    }]), n;
  }(),
      vc = function () {
    qn(i, Pa);
    var r = Xn(i);

    function i(e, t) {
      var n;
      return Un(this, i), Gn(Qn(n = r.call(this)), "_unsubscribes", []), n._ctx = e, n._collection = t, n._endpointManager = new pc(e, t), n._registerParticipantCollectionListeners(), n;
    }

    return Fn(i, [{
      key: "_registerParticipantCollectionListeners",
      value: function value() {
        var t = this;
        this._unsubscribes.length && this._unregisterParticipantCollectionListeners(), this._unsubscribes = [this._collection.on("entered", function (e) {
          return t._onParticipantEntered(e);
        }), this._collection.on("connected", function (e) {
          return t._onParticipantConnected(e);
        }), this._collection.on("exited", function (e) {
          return t._onParticipantExited(e);
        })];
      }
    }, {
      key: "_unregisterParticipantCollectionListeners",
      value: function value() {
        this._unsubscribes.forEach(function (e) {
          return e();
        }), this._unsubscribes = [];
      }
    }, {
      key: "_clearParticipantToEndpoint",
      value: function value() {
        this._collection.remoteParticipants.forEach(function (e) {
          e.viewerEndpoint = null;
        });
      }
    }, {
      key: "onSelfEntered",
      value: function value() {
        _a.debug("onSelfEntered()");

        var e = this._endpointManager.createMaster();

        this._localParticipant.masterEndpoint = e;
      }
    }, {
      key: "exit",
      value: function value() {
        _a.debug("exit()"), this._unregisterParticipantCollectionListeners(), this._clearParticipantToEndpoint(), this._endpointManager.exit();
      }
    }, {
      key: "_onParticipantEntered",
      value: function value(e) {
        _a.debug("_onParticipantEntered(id: ".concat(e.id, ")"));
      }
    }, {
      key: "_onParticipantConnected",
      value: function value(e) {
        _a.debug("_onParticipantConnected(id : ".concat(e.id, ")"));
      }
    }, {
      key: "_onParticipantExited",
      value: function value(e) {
        _a.debug("_onParticipantExited(id : ".concat(e.id, ")"));

        var t = e.viewerEndpoint;
        e.viewerEndpoint = null, t && this._endpointManager.releaseEndpoint(t);
      }
    }, {
      key: "_updateLocalResolution",
      value: function value(e) {
        this._localParticipant.updateResolution(e);
      }
    }, {
      key: "_localParticipant",
      get: function get() {
        return this._collection.localParticipant;
      }
    }]), i;
  }(),
      yc = function () {
    function n(e, t) {
      Un(this, n), this.key = e, this.value = t;
    }

    return Fn(n, [{
      key: "toString",
      value: function value() {
        return this.key;
      }
    }, {
      key: "equals",
      value: function value(e) {
        return this.value.width === e.value.width && this.value.height === e.value.height;
      }
    }]), n;
  }();

  Gn(yc, "_720P", new yc("_720P", {
    width: 1280,
    height: 720
  })), Gn(yc, "_540P", new yc("_540P", {
    width: 960,
    height: 540
  })), Gn(yc, "_480P", new yc("_480P", {
    width: 848,
    height: 480
  })), Gn(yc, "_360P", new yc("_360P", {
    width: 640,
    height: 360
  }));
  var mc = yc._720P,
      gc = e.indexOf,
      Ec = [].indexOf,
      kc = !!Ec && 1 / [1].indexOf(1, -0) < 0,
      D = $("indexOf"),
      e = a("indexOf", {
    ACCESSORS: !0,
    1: 0
  });
  ae({
    target: "Array",
    proto: !0,
    forced: kc || !D || !e
  }, {
    indexOf: function indexOf(e) {
      return kc ? Ec.apply(this, arguments) || 0 : gc(this, e, 1 < arguments.length ? arguments[1] : void 0);
    }
  });

  var D = function D(u) {
    return function (e, t, n, r) {
      oe(t);
      var i = ce(e),
          a = E(i),
          o = ne(i.length),
          s = u ? o - 1 : 0,
          c = u ? -1 : 1;
      if (n < 2) for (;;) {
        if (s in a) {
          r = a[s], s += c;
          break;
        }

        if (s += c, u ? s < 0 : o <= s) throw TypeError("Reduce of empty array with no initial value");
      }

      for (; u ? 0 <= s : s < o; s += c) {
        s in a && (r = t(r, a[s], s, i));
      }

      return r;
    };
  },
      Rc = {
    left: D(!1),
    right: D(!0)
  }.left,
      e = $("reduce"),
      D = a("reduce", {
    1: 0
  });

  ae({
    target: "Array",
    proto: !0,
    forced: !e || !D || !Vr && 79 < vr && vr < 83
  }, {
    reduce: function reduce(e) {
      return Rc(this, e, arguments.length, 1 < arguments.length ? arguments[1] : void 0);
    }
  });

  function Cc(e, t) {
    t.audio && 0 === e.getAudioTracks().length && e.addTrack(function () {
      var e = Ic = Ic || new (window.AudioContext || window.webkitAudioContext)();
      wc = e.createOscillator();
      var t = e.createMediaStreamDestination(),
          n = e.createGain();
      return n.gain.setValueAtTime(0, e.currentTime), wc.connect(n).connect(t), wc.start(), Sc = t.stream.getAudioTracks()[0], t.stream.getAudioTracks()[0];
    }()), t.video && 0 === e.getVideoTracks().length && e.addTrack(function (e) {
      var t = e.width,
          n = e.height,
          e = e.frameRate;
      (Ac = Ac || document.createElement("canvas")).width = t, Ac.height = n, Ac.getContext("2d").fillRect(0, 0, t, n), Tc = Tc || setInterval(function () {
        Ac.getContext("2d").fillRect(0, 0, t, n);
      }, 1e3);
      e = Ac.captureStream(e);
      return bc = e.getVideoTracks()[0], e.getVideoTracks()[0];
    }(jn(jn({}, mc.value), {}, {
      frameRate: 24
    })));
  }

  var Ic,
      wc,
      Ac,
      Tc,
      Sc,
      bc,
      Oc = function () {
    qn(i, Pa);
    var r = Xn(i);

    function i(e, t) {
      var n;
      return Un(this, i), Gn(Qn(n = r.call(this)), "hasPermission", !1), n._streamManger = e, n.constraints = t, n;
    }

    return Fn(i, [{
      key: "dispose",
      value: function value() {
        var e;
        this.removeAllEventListeners(), null !== (e = this.onDisposed) && void 0 !== e && e.call(this);
      }
    }, {
      key: "streamChanged",
      value: function value(e) {
        this._dispatchEvent("streamChanged", e);
      }
    }, {
      key: "audioOutputChanged",
      value: function value() {
        this._dispatchEvent("audioOutputChanged");
      }
    }, {
      key: "stream",
      get: function get() {
        return this._streamManger.stream;
      }
    }]), i;
  }();

  function Dc() {
    Sc && Sc.stop(), bc && bc.stop(), bc = Sc = null, Tc && (clearInterval(Tc), Tc = null), wc && (wc.onended = function () {
      wc.disconnect(), wc = null;
    }, wc.stop());
  }

  function Nc(e) {
    if (e) {
      var t,
          n = or(e.getTracks());

      try {
        for (n.s(); !(t = n.n()).done;) {
          t.value.stop();
        }
      } catch (e) {
        n.e(e);
      } finally {
        n.f();
      }
    }
  }

  var Lc = function () {
    function t(e) {
      Un(this, t), Gn(this, "_hasPermission", !1), this._deviceManager = e, this._updateQueued = !1;
    }

    var e;
    return Fn(t, [{
      key: "updateStream",
      value: (e = Mn(_regeneratorRuntime.mark(function e() {
        var t, n, r, i, a, o, s, c, u;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this._updateAt) return this._updateQueued = !0, e.abrupt("return");
                e.next = 3;
                break;

              case 3:
                if (t = this._deviceManager.mediaAccesses.some(function (e) {
                  return e.constraints.audio;
                }), n = this._deviceManager.mediaAccesses.some(function (e) {
                  return e.constraints.video;
                }), t || n) {
                  e.next = 9;
                  break;
                }

                return Nc(this.stream), Dc(), e.abrupt("return");

              case 9:
                return this._updateAt = Date.now(), (r = this.stream) || (a = new MediaStream(), Cc(a, {
                  audio: t,
                  video: n
                }), this.stream = a), ha && Nc(r), e.prev = 13, e.next = 16, this._deviceManager.getMediaConstraints({
                  usingAudio: t,
                  usingVideo: n
                });

              case 16:
                return a = e.sent, e.next = 19, navigator.mediaDevices.getUserMedia(a);

              case 19:
                i = e.sent, this._hasPermission = !0, o = or(this._deviceManager.mediaAccesses);

                try {
                  for (o.s(); !(s = o.n()).done;) {
                    s.value.hasPermission = !0;
                  }
                } catch (e) {
                  o.e(e);
                } finally {
                  o.f();
                }

                Dc(), e.next = 30;
                break;

              case 26:
                e.prev = 26, e.t0 = e.catch(13), _a.error("Fail get local media stream Error[".concat(e.t0, "]")), i = new MediaStream();

              case 30:
                Cc(i, {
                  audio: t,
                  video: n
                }), ha || Nc(r), this.stream = i, c = or(this._deviceManager.mediaAccesses);

                try {
                  for (c.s(); !(u = c.n()).done;) {
                    u.value.streamChanged(this.stream);
                  }
                } catch (e) {
                  c.e(e);
                } finally {
                  c.f();
                }

                delete this._updateAt, this._updateQueued ? (this._updateQueued = !1, this.updateStream()) : this._deviceManager.refreshMediaDevices({
                  audio: t,
                  video: n
                }, !0);

              case 37:
              case "end":
                return e.stop();
            }
          }
        }, e, this, [[13, 26]]);
      })), function () {
        return e.apply(this, arguments);
      })
    }]), t;
  }();

  function xc(e, t) {
    return (null == e ? void 0 : e.deviceId) === (null == t ? void 0 : t.deviceId) && (null == e ? void 0 : e.label) === (null == t ? void 0 : t.label) && (null == e ? void 0 : e.groupId) === (null == t ? void 0 : t.groupId);
  }

  var Pc,
      Mc = function () {
    function t() {
      var e = this;
      Un(this, t), this.mediaAccesses = [], this._availableMediaDevices = {
        audioinput: [],
        audiooutput: [],
        videoinput: []
      }, this._currentMediaDevices = {
        audioinput: void 0,
        audiooutput: void 0,
        videoinput: void 0
      }, this._sendbirdCallListeners = new Map(), this._streamManager = new Lc(this), navigator.mediaDevices.ondevicechange = function () {
        return e._onDeviceChanged();
      };
    }

    var n, r, e, i;
    return Fn(t, [{
      key: "_onDeviceChanged",
      value: function value() {
        0 !== this.mediaAccesses.length && this.refreshMediaDevices({
          audio: this.mediaAccesses.some(function (e) {
            return e.constraints.audio;
          }),
          video: this.mediaAccesses.some(function (e) {
            return e.constraints.video;
          })
        });
      }
    }, {
      key: "addSendBirdCallListener",
      value: function value(e, t) {
        this._sendbirdCallListeners.set(e, t);
      }
    }, {
      key: "removeSendBirdCallListener",
      value: function value(e) {
        this._sendbirdCallListeners.delete(e);
      }
    }, {
      key: "removeAllSendBirdCallListener",
      value: function value() {
        this._sendbirdCallListeners.clear();
      }
    }, {
      key: "getCurrentAudioInputDevice",
      value: function value() {
        return this._currentMediaDevices.audioinput;
      }
    }, {
      key: "getCurrentAudioOutputDevice",
      value: function value() {
        return this._currentMediaDevices.audiooutput;
      }
    }, {
      key: "getCurrentVideoInputDevice",
      value: function value() {
        return this._currentMediaDevices.videoinput;
      }
    }, {
      key: "getAvailableAudioInputDevices",
      value: function value() {
        return this._availableMediaDevices.audioinput;
      }
    }, {
      key: "getAvailableAudioOutputDevices",
      value: function value() {
        return this._availableMediaDevices.audiooutput;
      }
    }, {
      key: "getAvailableVideoInputDevices",
      value: function value() {
        return this._availableMediaDevices.videoinput;
      }
    }, {
      key: "_updateStream",
      value: (i = Mn(_regeneratorRuntime.mark(function e() {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this._streamManager.updateStream());

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return i.apply(this, arguments);
      })
    }, {
      key: "_registerMediaAccess",
      value: function value(e) {
        var t = this;
        this.mediaAccesses.push(e), e.onDisposed = function () {
          return t.stopMedia(e);
        };
      }
    }, {
      key: "useMedia",
      value: function value(e) {
        if (e.audio || e.video) {
          e = new Oc(this._streamManager, e);
          return this._registerMediaAccess(e), this._updateStream(), e;
        }

        _a.error(new Error("you should set true for at least 1 media type."));
      }
    }, {
      key: "stopMedia",
      value: function value(e) {
        this.mediaAccesses.splice(this.mediaAccesses.indexOf(e), 1), this._updateStream();
      }
    }, {
      key: "fetchMediaDevices",
      value: (e = Mn(_regeneratorRuntime.mark(function e() {
        var t;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, navigator.mediaDevices.enumerateDevices();

              case 2:
                return t = e.sent, e.abrupt("return", t.reduce(function (e, t) {
                  return e[t.kind].push(t), e;
                }, {
                  audioinput: [],
                  audiooutput: [],
                  videoinput: []
                }));

              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function () {
        return e.apply(this, arguments);
      })
    }, {
      key: "getMediaConstraints",
      value: (r = Mn(_regeneratorRuntime.mark(function e(t) {
        var n, r, i, a, o;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = t.usingAudio, r = t.usingVideo, i = {
                  audio: !1,
                  video: !1
                }, e.next = 4, this.fetchMediaDevices();

              case 4:
                return o = e.sent, a = o.audioinput, o = o.videoinput, n && a.length && (a = this.getCurrentAudioInputDevice(), i.audio = {
                  deviceId: null == a ? void 0 : a.deviceId
                }), r && o.length && (o = this.getCurrentVideoInputDevice(), i.video = jn(jn({
                  deviceId: null == o ? void 0 : o.deviceId
                }, mc.value), {}, {
                  frameRate: 24
                })), e.abrupt("return", i);

              case 10:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return r.apply(this, arguments);
      })
    }, {
      key: "_updateCurrentMediaDevice",
      value: function value(e, t) {
        var n = this._availableMediaDevices[e],
            r = this._currentMediaDevices[e],
            i = n.find(function (e) {
          return e.deviceId === (null == t ? void 0 : t.deviceId);
        });
        return i || (_a.warning("Selected device is unavailable. fallback to default device."), i = (null !== i && void 0 !== i ? i : 0 < n.length) ? n[0] : null), !xc(r, this._currentMediaDevices[e] = i);
      }
    }, {
      key: "_onAudioOutputChanged",
      value: function value() {
        var t = or(this.mediaAccesses);

        try {
          for (t.s(); !(e = t.n()).done;) {
            var e = e.value;
            e.constraints.audio && e.audioOutputChanged();
          }
        } catch (e) {
          t.e(e);
        } finally {
          t.f();
        }
      }
    }, {
      key: "selectDevice",
      value: function value(e, t) {
        t.kind === e ? this._updateCurrentMediaDevice(e, t) && ("audioinput" !== e && "videoinput" !== e || this._updateStream(), "audiooutput" === e && this._onAudioOutputChanged()) : _a.error(new Error("Tried to select invalid device of type"));
      }
    }, {
      key: "_updateAvailableDevices",
      value: function value(e, t) {
        var n,
            r,
            i = this._currentMediaDevices[e];
        if (!!function (e, t) {
          if (e.length === t.length) {
            for (var n = 0; n < t.length; n++) {
              if (!xc(e[n], t[n])) return;
            }

            return 1;
          }
        }(this._availableMediaDevices[e], t)) return !1;
        var a;
        this._availableMediaDevices[e] = t, a = this._updateCurrentMediaDevice(e, i);
        var o,
            s = or(this._sendbirdCallListeners.values());

        try {
          for (s.s(); !(o = s.n()).done;) {
            var c = o.value,
                u = this._currentMediaDevices[e];

            switch (e) {
              case "audioinput":
                null !== (n = c.onAudioInputDeviceChanged) && void 0 !== n && n.call(c, u, t);
                break;

              case "audiooutput":
                null !== (r = c.onAudioOutputDeviceChanged) && void 0 !== r && r.call(c, u, t);
                break;

              case "videoinput":
                null !== (r = c.onVideoInputDeviceChanged) && void 0 !== r && r.call(c, u, t);
            }
          }
        } catch (e) {
          s.e(e);
        } finally {
          s.f();
        }

        return a;
      }
    }, {
      key: "refreshMediaDevices",
      value: (n = Mn(_regeneratorRuntime.mark(function e(t) {
        var n,
            r,
            i,
            a,
            o,
            s,
            c,
            u,
            l = arguments;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (n = t.audio, r = t.video, i = 1 < l.length && void 0 !== l[1] && l[1], n || r) {
                  e.next = 4;
                  break;
                }

                throw new Error("at least one of the audio or video must be true");

              case 4:
                return e.next = 6, this.fetchMediaDevices();

              case 6:
                u = e.sent, a = u.audioinput, o = u.audiooutput, s = u.videoinput, u = c = !1, n && (c = this._updateAvailableDevices("audioinput", a), u = this._updateAvailableDevices("audiooutput", o)), r && (c = this._updateAvailableDevices("videoinput", s) || c), !i && c && this._updateStream(), u && this._onAudioOutputChanged();

              case 16:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return n.apply(this, arguments);
      })
    }]), t;
  }(),
      Uc = function () {
    function i(e, t, n) {
      var r = this;
      Un(this, i), this._ctx = e, Object.assign(this, t), this._localStream = n, this._localStream.on("audioOutputChanged", function () {
        r._onAudioOutputChanged();
      });
    }

    var e, n, t;
    return Fn(i, [{
      key: "id",
      get: function get() {
        return this.participantId;
      }
    }]), Fn(i, [{
      key: "updateInfo",
      value: function value(t) {
        var n = this,
            r = new Map();
        return Object.keys(t).forEach(function (e) {
          n[e] !== t[e] && r.set(e, t[e]);
        }), Object.assign(this, t), r;
      }
    }, {
      key: "setMediaView",
      value: (t = Mn(_regeneratorRuntime.mark(function e(t) {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this._mediaView === t) return e.abrupt("return");
                e.next = 2;
                break;

              case 2:
                if (this._mediaView && (this._mediaView.srcObject = null), t) {
                  e.next = 6;
                  break;
                }

                return delete this._mediaView, e.abrupt("return");

              case 6:
                return e.next = 8, this._updateMediaViewStream(t, this.stream);

              case 8:
                this._mediaView = e.sent;

              case 9:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "_updateMediaViewStream",
      value: (n = Mn(_regeneratorRuntime.mark(function e(t, n) {
        var r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (r = this._ctx.deviceManager.getCurrentAudioOutputDevice()) return e.next = 4, null === (i = t.setSinkId) || void 0 === i ? void 0 : i.call(t, r.deviceId);
                e.next = 4;
                break;

              case 4:
                return n && (t.srcObject = n), e.abrupt("return", t);

              case 6:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, t) {
        return n.apply(this, arguments);
      })
    }, {
      key: "_onAudioOutputChanged",
      value: (e = Mn(_regeneratorRuntime.mark(function e() {
        var t, n, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this._ctx.roomType === Gc.SMALL_ROOM_FOR_VIDEO || this._ctx.roomType === Gc.SMALL_ROOM_FOR_AUDIO_ONLY) return r = this._ctx.deviceManager.getCurrentAudioOutputDevice(), console.log("currentAudioOutputDevice: ".concat(r)), e.next = 5, null === (t = this._mediaView) || void 0 === t || null === (n = t.setSinkId) || void 0 === n ? void 0 : n.call(t, r.deviceId);
                e.next = 5;
                break;

              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return e.apply(this, arguments);
      })
    }]), i;
  }(),
      Vc = function () {
    qn(a, Uc);
    var t,
        i = Xn(a);

    function a(e, t, n) {
      var r;
      return Un(this, a), Gn(Qn(r = i.call(this, e, t, n)), "isLocalParticipant", !0), Gn(Qn(r), "_resolution", yc._720P), r._localStream.on("streamChanged", function (e) {
        return r._onStream(e);
      }), r;
    }

    return Fn(a, [{
      key: "stream",
      get: function get() {
        var e;
        return null === (e = this._localStream) || void 0 === e ? void 0 : e.localStream;
      }
    }, {
      key: "localStream",
      get: function get() {
        return this._localStream;
      }
    }, {
      key: "masterEndpoint",
      get: function get() {
        return this._masterEndpoint;
      },
      set: function set(e) {
        this._masterEndpoint = e;
      }
    }]), Fn(a, [{
      key: "exit",
      value: function value() {
        this._release();
      }
    }, {
      key: "setLocalMediaView",
      value: (t = Mn(_regeneratorRuntime.mark(function e(t) {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.setMediaView(t));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "muteMicrophone",
      value: function value() {
        _a.info("muteMicrophone()"), this._toggleAudio(!1);
      }
    }, {
      key: "unmuteMicrophone",
      value: function value() {
        _a.info("unmuteMicrophone()"), this._toggleAudio(!0);
      }
    }, {
      key: "startVideo",
      value: function value() {
        _a.info("startVideo()"), this._toggleVideo(!0);
      }
    }, {
      key: "stopVideo",
      value: function value() {
        _a.info("stopVideo()"), this._toggleVideo(!1);
      }
    }, {
      key: "updateResolution",
      value: function value(e) {
        this._resolution.equals(e) || (this._resolution = e, this._applyConstraints());
      }
    }, {
      key: "_toggleAudio",
      value: function value(t) {
        this.isAudioEnabled !== t && (this.stream.getAudioTracks().forEach(function (e) {
          e.enabled = t;
        }), this.isAudioEnabled = t, this._sendAudioCommand(t).catch(function (e) {
          return _a.debug(e);
        }));
      }
    }, {
      key: "_toggleVideo",
      value: function value(t) {
        this.isVideoEnabled !== t && (this.stream.getVideoTracks().forEach(function (e) {
          e.enabled = t;
        }), this.isVideoEnabled = t, this._sendVideoCommand(t).catch(function (e) {
          return _a.debug(e);
        }));
      }
    }, {
      key: "_isMediaEnabled",
      value: function value(e) {
        switch (e) {
          case "audio":
            return this.isAudioEnabled;

          case "video":
            return this.isVideoEnabled;

          default:
            return _a.error(new Error("unrecognized media type ".concat(e))), !1;
        }
      }
    }, {
      key: "_applyConstraints",
      value: function value() {
        var e;

        if (_a.debug("_applyConstraints()"), this.stream && null !== (e = this._localStream) && void 0 !== e && e.hasPermission) {
          var t = or(this.stream.getVideoTracks());

          try {
            for (t.s(); !(r = t.n()).done;) {
              var n = r.value,
                  r = void 0,
                  r = this._resolution.equals(yc._360P) && fa ? {
                height: this._resolution.value.height
              } : this._resolution.value;
              n.applyConstraints(r).catch(function (e) {
                return _a.error("Fail change local video resolution error = ", e);
              });
            }
          } catch (e) {
            t.e(e);
          } finally {
            t.f();
          }
        }
      }
    }, {
      key: "_onStream",
      value: function value(e) {
        var t = or(e.getTracks());

        try {
          for (t.s(); !(n = t.n()).done;) {
            var n = n.value;
            n.enabled = this._isMediaEnabled(n.kind);
          }
        } catch (e) {
          t.e(e);
        } finally {
          t.f();
        }

        this._applyConstraints(), this._mediaView && (this._mediaView.srcObject = e);
      }
    }, {
      key: "_release",
      value: function value() {
        this._localStream.release(), delete this._localStream;
      }
    }, {
      key: "_sendAudioCommand",
      value: function value(e) {
        e = Ko.createAudio(this._ctx.roomId, this.id, e);
        return this._ctx.sender.send(e);
      }
    }, {
      key: "_sendVideoCommand",
      value: function value(e) {
        e = Ko.createVideo(this._ctx.roomId, this.id, e);
        return this._ctx.sender.send(e);
      }
    }]), a;
  }(),
      Fc = function () {
    qn(a, Uc);
    var i = Xn(a);

    function a() {
      var t;
      Un(this, a);

      for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(t = i.call.apply(i, [this].concat(n))), "isLocalParticipant", !1), Gn(Qn(t), "_onStream", function () {
        var e = Qn(t).stream;
        t._mediaView && t._updateMediaViewStream(t._mediaView, e);
      }), t;
    }

    return Fn(a, [{
      key: "viewerEndpoint",
      set: function set(e) {
        var t;
        null !== (t = this._unsubscribePCChange) && void 0 !== t && t.call(this), (this._viewerEndpoint = e) && (this._unsubscribePCChange = e.pc.on("remoteStream", this._onStream)), this._onStream();
      }
    }, {
      key: "stream",
      get: function get() {
        var e, t;
        return null === (e = this._viewerEndpoint) || void 0 === e || null === (t = e.pc) || void 0 === t ? void 0 : t.remoteStream;
      }
    }]), a;
  }();

  ($ = Pc = Pc || {}).ENTERED = "entered", $.CONNECTED = "connected", $.EXITED = "exited";

  var Gc,
      Bc = function () {
    qn(n, vc);
    var t,
        e = Xn(n);

    function n() {
      return Un(this, n), e.apply(this, arguments);
    }

    return Fn(n, [{
      key: "onSelfEntered",
      value: function value() {
        this._updateLocalResolution(this._localResolution), $n(Hn(n.prototype), "onSelfEntered", this).call(this), this._createRecvSessionsForConnectedParticipants();
      }
    }, {
      key: "_onParticipantEntered",
      value: function value(e) {
        $n(Hn(n.prototype), "_onParticipantEntered", this).call(this, e), this._updateLocalResolution(this._localResolution);
      }
    }, {
      key: "_onParticipantConnected",
      value: (t = Mn(_regeneratorRuntime.mark(function e(t) {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return $n(Hn(n.prototype), "_onParticipantConnected", this).call(this, t), e.abrupt("return", this._createParticipantRecvSession(t));

              case 2:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "_onParticipantExited",
      value: function value(e) {
        $n(Hn(n.prototype), "_onParticipantExited", this).call(this, e), this._updateLocalResolution(this._localResolution);
      }
    }, {
      key: "_createParticipantRecvSession",
      value: function value(e) {
        var t = this;

        _a.debug("_createParticipantRecvSession(".concat(e.id, ")"));

        var n = this._endpointManager.createViewer();

        return n.attach(e), n.once("attached", function () {
          t._dispatchEvent("remoteParticipantStream", e);
        }), n;
      }
    }, {
      key: "_createRecvSessionsForConnectedParticipants",
      value: function value() {
        _a.debug("_createRecvSessionForConnectedParticipant()");

        var t = or(this._collection.remoteParticipants);

        try {
          for (t.s(); !(e = t.n()).done;) {
            var e = e.value;
            e.isLocalParticipant || e.state === Pc.CONNECTED && this._createParticipantRecvSession(e);
          }
        } catch (e) {
          t.e(e);
        } finally {
          t.f();
        }
      }
    }, {
      key: "_localResolution",
      get: function get() {
        switch (this._collection.connectedRemoteParticipants.length) {
          case 0:
          case 1:
            return yc._720P;

          case 2:
            return yc._540P;

          case 3:
            return yc._480P;

          default:
            return yc._360P;
        }
      }
    }]), n;
  }(),
      jc = function () {
    qn(o, vc);
    var e,
        n,
        t,
        r,
        i,
        a = Xn(o);

    function o(e, t) {
      var n;
      return Un(this, o), (n = a.call(this, e, t))._ctx = e, (n._collection = t).localStream.on("audioOutputChanged", function () {
        n._onAudioOutputChanged();
      }), n;
    }

    return Fn(o, [{
      key: "onSelfEntered",
      value: (i = Mn(_regeneratorRuntime.mark(function e() {
        var t = this;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                $n(Hn(o.prototype), "onSelfEntered", this).call(this), this._localParticipant.masterEndpoint.pc.once("remoteStream", function (e) {
                  t._onRemoteStream(e);
                });

              case 2:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return i.apply(this, arguments);
      })
    }, {
      key: "_onParticipantEntered",
      value: function value(e) {}
    }, {
      key: "_onParticipantConnected",
      value: (r = Mn(_regeneratorRuntime.mark(function e(t) {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function (e) {
        return r.apply(this, arguments);
      })
    }, {
      key: "_onParticipantExited",
      value: function value(e) {}
    }, {
      key: "_onRemoteStream",
      value: function value(e) {
        this._mediaView && (this._mediaView.srcObject = e);
      }
    }, {
      key: "setMediaView",
      value: (t = Mn(_regeneratorRuntime.mark(function e(t) {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this._mediaView === t) return e.abrupt("return");
                e.next = 2;
                break;

              case 2:
                if (this._mediaView && (this._mediaView.srcObject = null), t) {
                  e.next = 6;
                  break;
                }

                return delete this._mediaView, e.abrupt("return");

              case 6:
                return e.next = 8, this._updateMediaViewStream(t, this._stream);

              case 8:
                this._mediaView = e.sent;

              case 9:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "_updateMediaViewStream",
      value: (n = Mn(_regeneratorRuntime.mark(function e(t, n) {
        var r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (r = this._ctx.deviceManager.getCurrentAudioOutputDevice()) return e.next = 4, null === (i = t.setSinkId) || void 0 === i ? void 0 : i.call(t, r.deviceId);
                e.next = 4;
                break;

              case 4:
                return n && (t.srcObject = n), e.abrupt("return", t);

              case 6:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, t) {
        return n.apply(this, arguments);
      })
    }, {
      key: "_onAudioOutputChanged",
      value: (e = Mn(_regeneratorRuntime.mark(function e() {
        var t, n, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return r = this._ctx.deviceManager.getCurrentAudioOutputDevice(), e.next = 3, null === (t = this._mediaView) || void 0 === t || null === (n = t.setSinkId) || void 0 === n ? void 0 : n.call(t, r.deviceId);

              case 3:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return e.apply(this, arguments);
      })
    }, {
      key: "_stream",
      get: function get() {
        return this._localParticipant.masterEndpoint.pc.remoteStream;
      }
    }]), o;
  }(),
      qc = function () {
    qn(i, Pa);
    var t,
        r = Xn(i);

    function i(e, t) {
      var n;
      return Un(this, i), (n = r.call(this))._ctx = e, n._participantCollection = t, n._aliveFailureCount = 0, n;
    }

    return Fn(i, [{
      key: "onEntered",
      value: function value() {
        var t = this;

        switch (this._keepAliveInterval = setInterval(function () {
          Promise.race([t._sendAlive(), new Promise(function (e, t) {
            return setTimeout(t, 5e3);
          })]).then(function () {
            t._aliveFailureCount = 0;
          }).catch(function (e) {
            e && (e.code !== Tn.ERR_ROOM_DELETED ? (t._aliveFailureCount += 1, (8 <= t._aliveFailureCount || e.code === Tn.ERR_INVALID_ROOM_PARTICIPANT) && t._dispatchEvent("aliveFailed")) : t._dispatchEvent("deleted"));
          });
        }, 5e3), this._ctx.roomType) {
          case "small_room_for_video":
            this._participantManager = new Bc(this._ctx, this._participantCollection);
            break;

          case "large_room_for_audio_only":
            this._participantManager = new jc(this._ctx, this._participantCollection);
            break;

          default:
            throw new Error("Unsupported room type : ".concat(this._ctx.roomType));
        }

        this._registerEventListeners(), this._participantManager.onSelfEntered();
      }
    }, {
      key: "exit",
      value: function value() {
        clearInterval(this._keepAliveInterval), delete this._keepAliveInterval, this._participantManager.removeAllEventListeners(), this._participantManager.exit();
      }
    }, {
      key: "setAudioForLargeRoom",
      value: (t = Mn(_regeneratorRuntime.mark(function e(t) {
        var n;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (_a.info("setAudioForLargeRoom()"), "large_room_for_audio_only" !== this._ctx.roomType) throw n = new Error("Room type not audio mcu"), _a.error(n), n;
                e.next = 5;
                break;

              case 5:
                return e.abrupt("return", this._participantManager.setMediaView(t));

              case 6:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "_sendAlive",
      value: function value() {
        var e = Ko.createAlive(this._ctx.roomId, this._localParticipant.id);
        return this._ctx.sender.send(e);
      }
    }, {
      key: "_registerEventListeners",
      value: function value() {
        var t = this;

        this._participantManager.on("remoteParticipantStream", function (e) {
          t._dispatchEvent("remoteParticipantStream", e);
        });
      }
    }, {
      key: "_localParticipant",
      get: function get() {
        return this._participantCollection.localParticipant;
      }
    }]), i;
  }(),
      Hc = function () {
    qn(n, Pa);
    var e,
        t = Xn(n);

    function n() {
      return Un(this, n), t.call(this);
    }

    return Fn(n, [{
      key: "startStream",
      value: (e = Mn(_regeneratorRuntime.mark(function e() {
        var t,
            n,
            r = this;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.prev = 0, e.next = 3, navigator.mediaDevices.getDisplayMedia({
                  video: !0
                });

              case 3:
                t = e.sent, this._stream = t, this._stream.getVideoTracks()[0].onended = function () {
                  r._releaseStream(), r._dispatchEvent("streamStopped");
                }, e.next = 23;
                break;

              case 8:
                e.prev = 8, e.t0 = e.catch(0), e.t1 = e.t0.name, e.next = "InvalidStateError" === e.t1 ? 13 : "NotAllowedError" === e.t1 ? 15 : "NotFoundError" === e.t1 ? 17 : "NotReadableError" === e.t1 ? 19 : 21;
                break;

              case 13:
                return n = Tn.ERR_NOT_SUPPORTED_APP_STATE_FOR_SCREEN_SHARE, e.abrupt("break", 22);

              case 15:
                return n = Tn.ERR_PERMISSION_DENIED_FOR_SCREEN_SHARE, e.abrupt("break", 22);

              case 17:
                return n = Tn.ERR_SELECTED_CONTENT_NOT_EXIST, e.abrupt("break", 22);

              case 19:
                return n = Tn.ERR_SELECTED_CONTENT_INACCESSIBLE, e.abrupt("break", 22);

              case 21:
                n = Tn.ERR_SCREEN_SHARE_FAILED_DUE_TO_UNKNOWN_REASON;

              case 22:
                throw new ra(n);

              case 23:
              case "end":
                return e.stop();
            }
          }
        }, e, this, [[0, 8]]);
      })), function () {
        return e.apply(this, arguments);
      })
    }, {
      key: "stopStream",
      value: function value() {
        this._releaseStream(), this._dispatchEvent("streamStopped");
      }
    }, {
      key: "_releaseStream",
      value: function value() {
        if (this._stream) {
          var e,
              t = or(this._stream.getTracks());

          try {
            for (t.s(); !(e = t.n()).done;) {
              e.value.stop();
            }
          } catch (e) {
            t.e(e);
          } finally {
            t.f();
          }

          delete this._stream;
        }
      }
    }, {
      key: "stream",
      get: function get() {
        return this._stream;
      }
    }, {
      key: "isSharing",
      get: function get() {
        return !!this._stream;
      }
    }]), n;
  }(),
      zc = function () {
    qn(i, Pa);
    var e,
        r = Xn(i);

    function i(e) {
      var t,
          n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {
        audio: !0,
        video: !0
      };
      return Un(this, i), (t = r.call(this))._deviceManager = e, t._mediaConstraints = n, t._screenShare = new Hc(), t._screenShare.on("streamStopped", function () {
        t._releaseMergedStream(), t._dispatchEvent("screenShareStreamStopped");
      }), t;
    }

    return Fn(i, [{
      key: "useScreenStream",
      value: (e = Mn(_regeneratorRuntime.mark(function e() {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return function () {
                  if (!navigator.mediaDevices.getDisplayMedia) {
                    var e = pr.getErrorMessage(Tn.ERR_NOT_SUPPORTED_BROWSER_FOR_SCREEN_SHARE);
                    throw _a.error(e), e;
                  }
                }(), e.next = 3, this._screenShare.startStream();

              case 3:
                this._mergeScreenShareStream(), this._dispatchEvent("streamChanged", this.localStream);

              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return e.apply(this, arguments);
      })
    }, {
      key: "getLocalMediaStream",
      value: function value() {
        return this._mediaAccess || this._grantMediaAccess(this._mediaConstraints), this._mediaAccess.stream;
      }
    }, {
      key: "stopScreenShare",
      value: function value() {
        this._screenShare.isSharing && this._screenShare.stopStream();
      }
    }, {
      key: "revokeMediaAccess",
      value: function value() {
        this._mediaAccess && (this._mediaAccess.dispose(), this._mediaAccess = null);
      }
    }, {
      key: "release",
      value: function value() {
        this.stopScreenShare(), this.revokeMediaAccess();
      }
    }, {
      key: "_grantMediaAccess",
      value: function value(e) {
        var t = this;
        this._mediaAccess = this._deviceManager.useMedia(e), this._mediaAccess.on("streamChanged", function () {
          t._screenShare.isSharing && t._mergeScreenShareStream(), t._dispatchEvent("streamChanged", t.localStream);
        }), this._mediaAccess.on("audioOutputChanged", function () {
          return t._dispatchEvent("audioOutputChanged");
        });
      }
    }, {
      key: "_mergeScreenShareStream",
      value: function value() {
        var e;
        this._screenShare.isSharing && (e = new MediaStream(), this._mediaAccess.stream && 0 < this._mediaAccess.stream.getAudioTracks().length && e.addTrack(this._mediaAccess.stream.getAudioTracks()[0]), e.addTrack(this.screenStream.getVideoTracks()[0]), this._mergedStream = e);
      }
    }, {
      key: "_releaseMergedStream",
      value: function value() {
        this._mergedStream && (this._mergedStream.removeTrack(this._mergedStream.getAudioTracks()[0]), delete this._mergedStream, this._dispatchEvent("streamChanged", this.localStream));
      }
    }, {
      key: "mediaConstraints",
      set: function set(e) {
        this._mediaConstraints = e;
      }
    }, {
      key: "hasPermission",
      get: function get() {
        var e;
        return null === (e = this._mediaAccess) || void 0 === e ? void 0 : e.hasPermission;
      }
    }, {
      key: "localStream",
      get: function get() {
        return this.isScreenSharing ? this._mergedStream : this.getLocalMediaStream();
      }
    }, {
      key: "mergedStream",
      get: function get() {
        return this._mergedStream;
      }
    }, {
      key: "screenStream",
      get: function get() {
        return this._screenShare.stream;
      }
    }, {
      key: "isScreenSharing",
      get: function get() {
        return this._screenShare.isSharing;
      }
    }]), i;
  }(),
      Wc = function () {
    qn(i, Pa);
    var r = Xn(i);

    function i(e) {
      var t,
          n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [];
      return Un(this, i), Gn(Qn(t = r.call(this)), "_remoteParticipants", []), t._ctx = e, t.initialize(n), t;
    }

    return Fn(i, [{
      key: "_getMediaConstraints",
      value: function value() {
        switch (this._ctx.roomType) {
          case "large_room_for_audio_only":
          case "small_room_for_audio_only":
            return {
              audio: !0,
              video: !1
            };

          case "large_room_for_video":
          case "small_room_for_video":
          default:
            return {
              audio: !0,
              video: !0
            };
        }
      }
    }, {
      key: "findRemoteById",
      value: function value(t) {
        return this._remoteParticipants.find(function (e) {
          return e.participantId === t;
        });
      }
    }, {
      key: "initialize",
      value: function value(e) {
        var t = this;
        _a.debug("initialize()", e), this._localStream = new zc(this._ctx.deviceManager), this._localStream.mediaConstraints = this._getMediaConstraints(), e.forEach(function (e) {
          e.isLocalParticipant ? t._localParticipant = new Vc(t._ctx, e, t._localStream) : t._remoteParticipants.push(new Fc(t._ctx, e, t._localStream));
        });
      }
    }, {
      key: "updateInfo",
      value: function value(e) {
        _a.debug("updateInfo()", e), this._stampLocalParticipant(e);
        var t = e.filter(function (e) {
          return e.isLocalParticipant;
        })[0],
            e = e.filter(function (e) {
          return !e.isLocalParticipant;
        });
        t && this._upsertLocalParticipantInfo(t), this._updateRemoteParticipantsInfo(e);
      }
    }, {
      key: "exit",
      value: function value() {
        _a.debug("exit()"), this._localParticipant.exit(), delete this._localParticipant;
      }
    }, {
      key: "onEvent",
      value: function value(e) {
        switch (e.type) {
          case Fa.PARTICIPANT_ENTERED:
            this._onEntered(e.payload.participant);

            break;

          case Fa.PARTICIPANT_CONNECTED:
            this._onConnected(e.payload.participant);

            break;

          case Fa.PARTICIPANT_EXITED:
            this._onExited(e.payload.participant);

            break;

          case Fa.PARTICIPANT_DISCONNECTED:
            this._onDisconnected(e.payload.participant);

            break;

          case Fa.PARTICIPANT_AUDIO_STATUS_CHANGED:
            this._onAudioSettingsChanged(e.payload.participant);

            break;

          case Fa.PARTICIPANT_VIDEO_STATUS_CHANGED:
            this._onVideoSettingsChanged(e.payload.participant);

        }
      }
    }, {
      key: "_upsertLocalParticipantInfo",
      value: function value(e) {
        _a.debug("_upsertLocalParticipantInfo()"), this._localParticipant ? this._localParticipant.updateInfo(e) : this._localParticipant = new Vc(this._ctx, e, this._localStream);
      }
    }, {
      key: "_updateRemoteParticipantsInfo",
      value: function value(e) {
        var t = this;
        _a.debug("_updateRemoteParticipantsInfo()"), e.forEach(function (e) {
          return t._upsertParticipantInfo(e);
        }), this._remoteParticipants.filter(function (t) {
          return !e.some(function (e) {
            return e.participantId === t.id;
          });
        }).forEach(function (e) {
          t._deleteParticipantInfo(e);
        });
      }
    }, {
      key: "_upsertParticipantInfo",
      value: function value(e) {
        _a.debug("_upsertParticipantInfo()");

        var t = this._updateParticipantInfo(e);

        return t || this._insertParticipantInfo(e);
      }
    }, {
      key: "_insertParticipantInfo",
      value: function value(e) {
        _a.debug("_insertParticipantInfo()");

        e = new Fc(this._ctx, e, this._localStream);
        return this._dispatchEventIfOnCall("entered", e), "connected" === e.state && this._dispatchEventIfOnCall("connected", e), this._remoteParticipants.push(e), e;
      }
    }, {
      key: "_updateParticipantInfo",
      value: function value(e) {
        _a.debug("_updateParticipantInfo()");

        var t = this.findRemoteById(e.participantId);
        if (!t) return !1;
        var n = or(t.updateInfo(e).entries());

        try {
          for (n.s(); !(r = n.n()).done;) {
            var r = Jn(r.value, 2),
                i = r[0],
                a = r[1];

            switch (i) {
              case "isAudioEnabled":
                this._dispatchEventIfOnCall("audioSettingsChanged", t);

                break;

              case "isVideoEnabled":
                this._dispatchEventIfOnCall("videoSettingsChanged", t);

                break;

              case "state":
                "connected" === a && this._dispatchEventIfOnCall("connected", t);
                break;

              default:
                _a.debug("_updateParticipantInfo() => Ignore diff\nkey : ", i, "\nvalue : ", a);

            }
          }
        } catch (e) {
          n.e(e);
        } finally {
          n.f();
        }

        return t;
      }
    }, {
      key: "_deleteParticipantInfo",
      value: function value(e) {
        _a.debug("_deleteParticipantInfo()");

        var t = this.findRemoteById(e.participantId);
        t && (e = this._remoteParticipants.indexOf(t), this._remoteParticipants.splice(e, 1), this._dispatchEventIfOnCall("exited", t));
      }
    }, {
      key: "_stampLocalParticipant",
      value: function value(e) {
        var t = this;
        this._localParticipant && (e.find(function (e) {
          return e.participantId === t._localParticipant.participantId;
        }).isLocalParticipant = !0);
      }
    }, {
      key: "_onEntered",
      value: function value(e) {
        _a.debug("_onEntered()"), this._upsertParticipantInfo(e);
      }
    }, {
      key: "_onConnected",
      value: function value(e) {
        _a.debug("_onConnected()"), this._upsertParticipantInfo(e);
      }
    }, {
      key: "_onExited",
      value: function value(e) {
        _a.debug("_onExited()"), this._deleteParticipantInfo(e);
      }
    }, {
      key: "_onDisconnected",
      value: function value(e) {
        _a.debug("_onDisconnected()"), e.isLocalParticipant ? this._dispatchEvent("selfDisconnected") : this._deleteParticipantInfo(e);
      }
    }, {
      key: "_onAudioSettingsChanged",
      value: function value(e) {
        _a.debug("_onAudioSettingsChanged()"), this._upsertParticipantInfo(e);
      }
    }, {
      key: "_onVideoSettingsChanged",
      value: function value(e) {
        _a.debug("_onVideoSettingsChanged()"), this._upsertParticipantInfo(e);
      }
    }, {
      key: "_dispatchEventIfOnCall",
      value: function value(e) {
        if (this._isOnCall) {
          for (var t = arguments.length, n = new Array(1 < t ? t - 1 : 0), r = 1; r < t; r++) {
            n[r - 1] = arguments[r];
          }

          this._dispatchEvent.apply(this, [e].concat(n));
        }
      }
    }, {
      key: "participants",
      get: function get() {
        var e = er(this._remoteParticipants);
        return this._localParticipant && e.unshift(this._localParticipant), e;
      }
    }, {
      key: "localParticipant",
      get: function get() {
        return this._localParticipant;
      }
    }, {
      key: "remoteParticipants",
      get: function get() {
        return this._remoteParticipants;
      }
    }, {
      key: "connectedRemoteParticipants",
      get: function get() {
        return this._remoteParticipants.filter(function (e) {
          return e.state === Pc.CONNECTED;
        });
      }
    }, {
      key: "localStream",
      get: function get() {
        return this._localStream;
      }
    }, {
      key: "_isOnCall",
      get: function get() {
        return this._ctx.room.isOnCall;
      }
    }]), i;
  }();

  (a = Gc = Gc || {}).SMALL_ROOM_FOR_AUDIO_ONLY = "small_room_for_audio_only", a.LARGE_ROOM_FOR_AUDIO_ONLY = "large_room_for_audio_only", a.SMALL_ROOM_FOR_VIDEO = "small_room_for_video", a.LARGE_ROOM_FOR_VIDEO = "large_room_for_video";

  var Kc = function () {
    qn(i, Pa);
    var t,
        n,
        r = Xn(i);

    function i(e, t) {
      var n;
      return Un(this, i), Gn(Qn(n = r.call(this)), "_enterLock", new Ga()), Gn(Qn(n), "_customItemsUpdatedAt", 0), n._ctx = jn(jn({}, e), {}, {
        room: Qn(n),
        roomId: t.roomId,
        roomType: t.roomType,
        customItems: t.customItems
      }), n.initialize(t), n._registerCollectionEventListeners(), n;
    }

    return Fn(i, [{
      key: "_send",
      value: function value(e) {
        return this._ctx.sender.send(e);
      }
    }, {
      key: "initialize",
      value: function value(e) {
        var t = e.participants,
            n = Zn(e, ["participants"]);
        Object.assign(this, n), this._participantCollection ? this._participantCollection.initialize(t) : this._participantCollection = new Wc(this._ctx, e.participants);
      }
    }, {
      key: "updateInfo",
      value: function value(e) {
        var t = e.participants,
            e = Zn(e, ["participants"]);
        return Object.assign(this, e), this._participantCollection.updateInfo(t), this;
      }
    }, {
      key: "onEvent",
      value: function value(e) {
        var t = this;

        this._enterLock.acquire().then(function () {
          t._processEvent(e), t._enterLock.release();
        });
      }
    }, {
      key: "fetchCustomItems",
      value: function value() {
        var t = this,
            e = Ko.createFetchCustomItems(this.roomId);
        return this._send(e).then(function (e) {
          e = e.payload;
          return t._setCustomItems(e.customItems, e.affectedAt), e;
        }).catch(function (e) {
          throw _a.error("failed to update customItems"), e;
        });
      }
    }, {
      key: "updateCustomItems",
      value: function value(e) {
        var t = this,
            n = Jn(aa(e), 2)[1];
        if (n) return n;
        e = Ko.createUpdateCustomItems(this.roomId, e, "upsert");
        return this._send(e).then(function (e) {
          e = e.payload;
          return t._setCustomItems(e.customItems, e.affectedAt), e;
        }).catch(function (e) {
          throw _a.error("failed to update customItems"), e;
        });
      }
    }, {
      key: "deleteCustomItems",
      value: function value(e) {
        var t = this,
            n = Jn(oa(e), 2)[1];
        if (n) return n;
        e = Ko.createDeleteCustomItems(this.roomId, e);
        return this._send(e).then(function (e) {
          e = e.payload;
          return t._setCustomItems(e.customItems, e.affectedAt), e;
        }).catch(function (e) {
          throw _a.error("failed to delete customItems"), e;
        });
      }
    }, {
      key: "_setCustomItems",
      value: function value(e, t) {
        return t > this._customItemsUpdatedAt && (this._customItemsUpdatedAt = t, this.customItems = e || {}, !0);
      }
    }, {
      key: "_processEvent",
      value: function value(e) {
        switch (e.type) {
          case Fa.CUSTOM_ITEMS_UPDATE:
            this._updateCustomItems(e);

            break;

          case Fa.CUSTOM_ITEMS_DELETE:
            this._deleteCustomItems(e);

            break;

          case Fa.ROOM_DELETED:
            this._dispatchEvent("deleted"), this._teardown();
            break;

          case Fa.PARTICIPANT_ENTERED:
          case Fa.PARTICIPANT_CONNECTED:
          case Fa.PARTICIPANT_EXITED:
          case Fa.PARTICIPANT_DISCONNECTED:
          case Fa.PARTICIPANT_AUDIO_STATUS_CHANGED:
          case Fa.PARTICIPANT_VIDEO_STATUS_CHANGED:
            this._passToCollection(e);

        }
      }
    }, {
      key: "enter",
      value: (n = Mn(_regeneratorRuntime.mark(function e(t) {
        var n, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (_a.info("enter()"), this._session) throw n = new ra(Tn.ERR_CLIENT_ALREADY_ENTERED), _a.debug(n), n;
                e.next = 5;
                break;

              case 5:
                return e.next = 7, this._enterLock.acquire();

              case 7:
                return e.prev = 7, e.next = 10, this._sendEnter(t);

              case 10:
                r = e.sent, e.next = 18;
                break;

              case 13:
                throw e.prev = 13, e.t0 = e.catch(7), this._enterLock.release(), _a.error(e.t0), e.t0;

              case 18:
                this.updateInfo(r.payload.room), this._session = new qc(this._ctx, this._participantCollection), this._registerSessionEventListeners(), this._session.onEntered(), this._enterLock.release();

              case 23:
              case "end":
                return e.stop();
            }
          }
        }, e, this, [[7, 13]]);
      })), function (e) {
        return n.apply(this, arguments);
      })
    }, {
      key: "exit",
      value: function value() {
        _a.info("exit()"), this._validateEntered();
        var e = this.localParticipant.id;
        this._teardown(), this._sendExit(e).catch(function (e) {
          _a.error("_sendExit() failed : ", e);
        });
      }
    }, {
      key: "setAudioForLargeRoom",
      value: (t = Mn(_regeneratorRuntime.mark(function e(t) {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return _a.info("setAudioForLargeRoom()"), this._validateEntered(), e.abrupt("return", this._session.setAudioForLargeRoom(t));

              case 3:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "_validateEntered",
      value: function value() {
        if (!this._session) {
          var e = new ra(Tn.ERR_PARTICIPANT_NOT_IN_ROOM);
          throw _a.debug(e), e;
        }
      }
    }, {
      key: "_registerSessionEventListeners",
      value: function value() {
        var t = this;
        this._session.on("remoteParticipantStream", function (e) {
          t._dispatchEvent("remoteParticipantStreamStarted", e);
        }), this._session.on("aliveFailed", function () {
          t._dispatchEvent("error", new ra(Tn.ERR_LOCAL_PARTICIPANT_LOST_CONNECTION)), t._teardown();
        }), this._session.on("deleted", function () {
          t._dispatchEvent("deleted"), t._teardown();
        });
      }
    }, {
      key: "_registerCollectionEventListeners",
      value: function value() {
        var t = this;
        this._participantCollection.on("entered", function (e) {
          t._dispatchEvent("remoteParticipantEntered", e);
        }), this._participantCollection.on("connected", function (e) {
          t._dispatchEvent("remoteParticipantConnected", e);
        }), this._participantCollection.on("exited", function (e) {
          t._dispatchEvent("remoteParticipantExited", e);
        }), this._participantCollection.on("audioSettingsChanged", function (e) {
          t._dispatchEvent("remoteAudioSettingsChanged", e);
        }), this._participantCollection.on("videoSettingsChanged", function (e) {
          t._dispatchEvent("remoteVideoSettingsChanged", e);
        }), this._participantCollection.on("selfDisconnected", function () {
          t._teardown(), t._dispatchEvent("error", new ra(Tn.ERR_LOCAL_PARTICIPANT_LOST_CONNECTION));
        });
      }
    }, {
      key: "_updateCustomItems",
      value: function value(e) {
        var t = e.payload,
            n = t.customItems,
            e = t.updated,
            t = t.affectedAt;
        this._setCustomItems(n, t) && this._dispatchEvent("customItemsUpdated", n, e);
      }
    }, {
      key: "_deleteCustomItems",
      value: function value(e) {
        var t = e.payload,
            n = t.customItems,
            e = t.deleted,
            t = t.affectedAt;
        this._setCustomItems(n, t) && this._dispatchEvent("customItemsDeleted", n, e);
      }
    }, {
      key: "_passToCollection",
      value: function value(e) {
        this._participantCollection.onEvent(e);
      }
    }, {
      key: "_sendEnter",
      value: function value(e) {
        e = Ko.createEnter(this._ctx.roomId, e);
        return this._ctx.sender.send(e);
      }
    }, {
      key: "_sendExit",
      value: function value(e) {
        e = Ko.createExit(this._ctx.roomId, e);
        return this._ctx.sender.send(e);
      }
    }, {
      key: "_teardown",
      value: function value() {
        this._session.removeAllEventListeners(), this._session.exit(), this._participantCollection.exit(), delete this._session;
      }
    }, {
      key: "participants",
      get: function get() {
        return this._participantCollection.participants;
      }
    }, {
      key: "localParticipant",
      get: function get() {
        return this._participantCollection.localParticipant;
      }
    }, {
      key: "remoteParticipants",
      get: function get() {
        return this._participantCollection.remoteParticipants;
      }
    }, {
      key: "isOnCall",
      get: function get() {
        return !!this._session;
      }
    }]), i;
  }();

  (e = {}).OPEN = "open", e.DELETED = "deleted";

  var Yc,
      Zc = function () {
    function t(e) {
      Un(this, t), this._ctx = e;
    }

    return Fn(t, [{
      key: "createRoom",
      value: function value(e) {
        return new Kc(this._ctx, e);
      }
    }]), t;
  }(),
      Qc = function () {
    function t(e) {
      Un(this, t), this._ctx = e, this._factory = new Zc(e), this._rooms = new Map();
    }

    var n, r;
    return Fn(t, [{
      key: "_hasRoom",
      value: function value(e) {
        return this._rooms.has(e);
      }
    }, {
      key: "onEvent",
      value: function value(e) {
        switch (e.type) {
          case Fa.CUSTOM_ITEMS_UPDATE:
          case Fa.CUSTOM_ITEMS_DELETE:
          case Fa.ROOM_DELETED:
          case Fa.PARTICIPANT_CONNECTED:
          case Fa.PARTICIPANT_ENTERED:
          case Fa.PARTICIPANT_EXITED:
          case Fa.PARTICIPANT_DISCONNECTED:
          case Fa.PARTICIPANT_AUDIO_STATUS_CHANGED:
          case Fa.PARTICIPANT_VIDEO_STATUS_CHANGED:
            this._passToRoom(e);

            break;

          default:
            _a.error(new Error("unhandled room event ".concat(e.type)));

        }
      }
    }, {
      key: "_passToRoom",
      value: function value(e) {
        this._hasRoom(e.getRoomId()) ? this._rooms.get(e.getRoomId()).onEvent(e) : _a.debug("received command ".concat(e.type, " for non-existing room ").concat(e.getRoomId()));
      }
    }, {
      key: "createRoom",
      value: (r = Mn(_regeneratorRuntime.mark(function e(t) {
        var n;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._sendCreate(t);

              case 2:
                return n = e.sent, n = this._factory.createRoom(n.payload.room), this._rooms.set(n.roomId, n), e.abrupt("return", n);

              case 6:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return r.apply(this, arguments);
      })
    }, {
      key: "getCachedRoomById",
      value: function value(e) {
        return this._rooms.get(e);
      }
    }, {
      key: "fetchRoomById",
      value: (n = Mn(_regeneratorRuntime.mark(function e(t) {
        var n, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._sendGetRoom(t);

              case 2:
                if (n = e.sent, r = this._rooms.get(t)) return r.updateInfo(n.payload.room), e.abrupt("return", r);
                e.next = 7;
                break;

              case 7:
                return r = this._factory.createRoom(n.payload.room), this._rooms.set(r.roomId, r), e.abrupt("return", r);

              case 10:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return n.apply(this, arguments);
      })
    }, {
      key: "_sendCreate",
      value: function value(e) {
        e = Ko.createCreate(e);
        return this._ctx.sender.send(e);
      }
    }, {
      key: "_sendGetRoom",
      value: function value(e) {
        e = Ko.createGet(e);
        return this._ctx.sender.send(e);
      }
    }, {
      key: "clear",
      value: function value() {
        var t = or(this._rooms.values());

        try {
          for (t.s(); !(e = t.n()).done;) {
            var e = e.value;
            e.isOnCall && e.exit();
          }
        } catch (e) {
          t.e(e);
        } finally {
          t.f();
        }

        this._rooms.clear();
      }
    }]), t;
  }();

  (D = Yc = Yc || {}).DIALING = "DIALING", D.RINGING = "RINGING", D.RECONNECTING = "RECONNECTING", D.RECONNECTED = "RECONNECTED";

  var Xc,
      $c,
      Jc,
      eu = function () {
    function e() {
      Un(this, e), this.audioElms = new Map();
    }

    var t, n;
    return Fn(e, [{
      key: "loadSound",
      value: (n = Mn(_regeneratorRuntime.mark(function e(t, n) {
        var r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if ("string" == typeof n && n) {
                  e.next = 2;
                  break;
                }

                return e.abrupt("return", !1);

              case 2:
                return (r = this._createAudio(t)).src = n, r.volume = 0, e.prev = 5, e.next = 8, r.play();

              case 8:
                r.pause(), r.currentTime = 0, r.volume = 1, this.audioElms.set(t, r), e.next = 18;
                break;

              case 14:
                return e.prev = 14, e.t0 = e.catch(5), _a.error(e.t0), e.abrupt("return", !1);

              case 18:
                return e.abrupt("return", !0);

              case 19:
              case "end":
                return e.stop();
            }
          }
        }, e, this, [[5, 14]]);
      })), function (e, t) {
        return n.apply(this, arguments);
      })
    }, {
      key: "unloadSound",
      value: function value(e) {
        return !!this.audioElms.get(e) && this.audioElms.delete(e);
      }
    }, {
      key: "playSound",
      value: (t = Mn(_regeneratorRuntime.mark(function e(t) {
        var n;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (n = this.audioElms.get(t)) {
                  e.next = 3;
                  break;
                }

                return e.abrupt("return", !1);

              case 3:
                return e.prev = 3, n.currentTime = 0, e.next = 7, n.play();

              case 7:
                e.next = 13;
                break;

              case 9:
                return e.prev = 9, e.t0 = e.catch(3), _a.error(e.t0), e.abrupt("return", !1);

              case 13:
                return e.abrupt("return", !0);

              case 14:
              case "end":
                return e.stop();
            }
          }
        }, e, this, [[3, 9]]);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "stopSound",
      value: function value(e) {
        e = this.audioElms.get(e);
        return !!e && e.pause();
      }
    }, {
      key: "stopAllSound",
      value: function value() {
        var e,
            t = or(this.audioElms.values());

        try {
          for (t.s(); !(e = t.n()).done;) {
            e.value.pause();
          }
        } catch (e) {
          t.e(e);
        } finally {
          t.f();
        }
      }
    }, {
      key: "isPlaying",
      value: function value(e) {
        e = this.audioElms.get(e);
        return e && !e.paused;
      }
    }, {
      key: "_isLoop",
      value: function value(e) {
        return e === Yc.DIALING || e === Yc.RINGING;
      }
    }, {
      key: "_createAudio",
      value: function value(e) {
        var t = new Audio();
        return t.autoplay = !1, t.muted = !1, t.loop = this._isLoop(e), t;
      }
    }]), e;
  }();

  function tu(a) {
    return function (r) {
      var i = r.descriptor.value;
      return r.descriptor.value = function () {
        if (tu.checkIE()) throw new Error(null != a ? a : "Method ".concat(r.key, " is not supported in Internet Explorer"));

        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return i.call.apply(i, [this].concat(t));
      }, r;
    };
  }

  ($ = Xc = Xc || {}).INFO = "INFO", $.WARNING = "WARNING", $.ERROR = "ERROR", $.NONE = "NONE", (a = $c = $c || {}).RECORDING = "recording", a.NONE = "none", (e = Jc = Jc || {}).APNS = "apns_voip", e.FCM = "fcm_voip", tu.checkIE = function () {
    return !!window && (0 < window.navigator.userAgent.indexOf("MSIE ") || !!navigator.userAgent.match(/Trident.*rv:11\./));
  }, tu.messages = {
    CALL_IS_NOT_SUPPORTED: "Call is not supported in Internet Explorer"
  };

  var nu,
      ru,
      iu,
      au = "1.9.3",
      ou = function () {
    qn(t, na);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return t;
  }(),
      su = function () {
    qn(t, Va);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.call(this);
    }

    return Fn(t, [{
      key: "getApiOption",
      value: function value() {
        return {
          auth: this.getAuth(),
          path: this.getPath(),
          method: this.getMethod(),
          body: this.getData(),
          headers: this.getHeaders()
        };
      }
    }, {
      key: "getAuth",
      value: function value() {
        return !0;
      }
    }, {
      key: "getHeaders",
      value: function value() {
        return {};
      }
    }]), t;
  }(),
      cu = function () {
    qn(r, su);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this)).statsLog = e, t;
    }

    return Fn(r, [{
      key: "getData",
      value: function value() {
        return {
          log_group: "sdk_webrtc_statistics_v1.1",
          log_data: this.statsLog
        };
      }
    }, {
      key: "getPath",
      value: function value() {
        return "/v1/sdk/logs";
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "POST";
      }
    }]), r;
  }(),
      uu = function () {
    qn(i, su);
    var r = Xn(i);

    function i(e, t) {
      var n;
      return Un(this, i), (n = r.call(this)).version = 1, n.isOverflowLogs = t, n.logs = e, n;
    }

    return Fn(i, [{
      key: "getData",
      value: function value() {
        return {
          version: this.version,
          is_overflow_logs: this.isOverflowLogs,
          logs: this.getLogsData()
        };
      }
    }, {
      key: "getPath",
      value: function value() {
        return "/v1/sdk/debug_logs";
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "POST";
      }
    }, {
      key: "getLogsData",
      value: function value() {
        return this.logs.map(function (e) {
          return {
            log_dt: e.logDt,
            log_level: e.logLevel,
            log_message: e.logMessage
          };
        });
      }
    }]), i;
  }(),
      lu = function () {
    qn(a, su);
    var i = Xn(a);

    function a(e, t, n) {
      var r;
      return Un(this, a), (r = i.call(this)).appId = e, r.userId = t, r.accessToken = n, r;
    }

    return Fn(a, [{
      key: "getAuth",
      value: function value() {
        return !1;
      }
    }, {
      key: "getData",
      value: function value() {
        return {
          app_id: this.appId,
          user_id: this.userId,
          access_token: this.accessToken
        };
      }
    }, {
      key: "getPath",
      value: function value() {
        return "/v1/users/".concat(encodeURIComponent(this.userId), "/login");
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "POST";
      }
    }]), a;
  }(),
      du = function () {
    qn(a, su);
    var i = Xn(a);

    function a(e, t, n) {
      var r;
      return Un(this, a), (r = i.call(this)).userId = e, r.params = t, r.next = n, r;
    }

    return Fn(a, [{
      key: "getData",
      value: function value() {}
    }, {
      key: "getPath",
      value: function value() {
        return "/v1/users/".concat(encodeURIComponent(this.userId), "/calls?").concat(this._createQuery());
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "GET";
      }
    }, {
      key: "_createQuery",
      value: function value() {
        var e;
        return _o.createQuery({
          role: this.params.myRole,
          limit: this._applyLimitConstraints(null === (e = this.params) || void 0 === e ? void 0 : e.limit),
          end_result: this.params.endResults,
          next: this.next
        });
      }
    }, {
      key: "_applyLimitConstraints",
      value: function value(e) {
        return null != e ? Math.min(Math.max(e, 10), 100) : void 0;
      }
    }]), a;
  }(),
      hu = function () {
    qn(a, su);
    var i = Xn(a);

    function a(e, t, n) {
      var r;
      return Un(this, a), (r = i.call(this)).userId = e, r.pushToken = t, r.tokenType = n, r;
    }

    return Fn(a, [{
      key: "getAuth",
      value: function value() {
        return !0;
      }
    }, {
      key: "getData",
      value: function value() {
        return {
          token: this.pushToken,
          is_unique: !0
        };
      }
    }, {
      key: "getPath",
      value: function value() {
        return "/v1/users/".concat(encodeURIComponent(this.userId), "/push/").concat(this.tokenType);
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "POST";
      }
    }]), a;
  }(),
      fu = function () {
    qn(a, su);
    var i = Xn(a);

    function a(e, t, n) {
      var r;
      return Un(this, a), (r = i.call(this)).userId = e, r.pushToken = t, r.tokenType = n, r;
    }

    return Fn(a, [{
      key: "getAuth",
      value: function value() {
        return !0;
      }
    }, {
      key: "getData",
      value: function value() {
        return {};
      }
    }, {
      key: "getPath",
      value: function value() {
        return "/v1/users/".concat(encodeURIComponent(this.userId), "/push/").concat(this.tokenType, "/").concat(this.pushToken);
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "DELETE";
      }
    }]), a;
  }(),
      _u = function () {
    qn(i, su);
    var r = Xn(i);

    function i(e, t) {
      var n;
      return Un(this, i), (n = r.call(this)).userId = e, n.tokenType = t, n;
    }

    return Fn(i, [{
      key: "getAuth",
      value: function value() {
        return !0;
      }
    }, {
      key: "getData",
      value: function value() {
        return {};
      }
    }, {
      key: "getPath",
      value: function value() {
        return "/v1/users/".concat(encodeURIComponent(this.userId), "/push/").concat(this.tokenType);
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "DELETE";
      }
    }]), i;
  }(),
      pu = function () {
    qn(r, su);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this)).callId = e, t;
    }

    return Fn(r, [{
      key: "getPath",
      value: function value() {
        return "/v1/direct_calls".concat(this.getSubPath());
      }
    }]), r;
  }();

  (D = nu = nu || {}).CALL = "CALL", D.SGNL = "SGNL", D.COMM = "COMM", D.UTIL = "UTIL", ($ = ru = ru || {})[$.WS = 0] = "WS", $[$.API = 1] = "API", $[$.BOTH = 2] = "BOTH", (a = {}).API = "api", a.CMD_RETRIEVING = "cmd_retrieving", a.WEBHOOK = "webhook", a.WS = "ws", a.PUSH = "push", (e = iu = iu || {}).REMOTE_PUSH = "remote_push", e.VOIP_PUSH = "voip_push", e.WEBHOOK = "webhook", e.WS = "ws";

  var vu,
      yu = function () {
    qn(n, Va);
    var t = Xn(n);

    function n() {
      var e;
      return Un(this, n), (e = t.call(this)).version = 1, e.requestId = Jo(), e;
    }

    return Fn(n, [{
      key: "getApiOption",
      value: function value() {
        return {
          auth: !0,
          path: "/v1/action/direct_call",
          method: "POST",
          headers: this.getHeaders(),
          body: {
            version: this.version,
            request_id: this.requestId,
            cmd: this.getCMD(),
            type: this.getType(),
            payload: this.getData()
          }
        };
      }
    }, {
      key: "serialize",
      value: function value() {
        return JSON.stringify({
          version: this.version,
          request_id: this.requestId,
          cmd: this.getCMD(),
          type: this.getType(),
          payload: this.getData()
        });
      }
    }, {
      key: "requireResponse",
      value: function value() {
        return !1;
      }
    }, {
      key: "getHeaders",
      value: function value() {
        return {};
      }
    }, {
      key: "sendStrategy",
      get: function get() {
        return ru.WS;
      }
    }]), n;
  }(),
      mu = function () {
    qn(r, Va);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this)).cmd = e.cmd, t.type = e.type, t.payload = e.payload || {}, t;
    }

    return r;
  }(),
      gu = function () {
    qn(t, mu);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "getCallId",
      value: function value() {
        return this.payload.callId;
      }
    }]), t;
  }(),
      Eu = function () {
    qn(r, Va);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this)).version = e.version, t.messageId = e.message_id, t.cmd = e.cmd, t.type = e.type, t.deliveryInfo = e.delivery_info, t.sequenceNumber = e.sequence_number, t.payload = t.parseData(e.payload), t;
    }

    return Fn(r, [{
      key: "getCallId",
      value: function value() {
        return this.payload.callId;
      }
    }, {
      key: "isSequential",
      value: function value() {
        return "number" == typeof this.sequenceNumber;
      }
    }]), r;
  }(),
      ku = function () {
    qn(r, Va);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this)).version = e.version, t.requestId = e.request_id, t.cmd = e.cmd, t.type = e.type, t.deliveryInfo = e.delivery_info, t.sequenceNumber = e.sequence_number, t.payload = t.parseData(e.payload), t;
    }

    return Fn(r, [{
      key: "getCallId",
      value: function value() {
        return this.payload.callId;
      }
    }, {
      key: "isSequential",
      value: function value() {
        return "number" == typeof this.sequenceNumber;
      }
    }]), r;
  }(),
      Ru = function () {
    qn(r, Va);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this)).version = e.version, t.messageId = e.message_id, t.cmd = e.cmd, t.type = e.type, t.deliveryInfo = e.delivery_info, t.sequenceNumber = e.sequence_number, t.payload = t.parseData(e.payload), t;
    }

    return Fn(r, [{
      key: "isSequential",
      value: function value() {
        return "number" == typeof this.sequenceNumber;
      }
    }]), r;
  }(),
      Cu = function () {
    qn(t, Ru);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "getCallId",
      value: function value() {
        return this.payload.callId;
      }
    }]), t;
  }(),
      Iu = function () {
    qn(r, pu);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this, null)).callIds = e, t;
    }

    return Fn(r, [{
      key: "requireResponse",
      value: function value() {
        return !0;
      }
    }, {
      key: "getData",
      value: function value() {}
    }, {
      key: "getSubPath",
      value: function value() {
        var e = this.callIds.join(",");
        return "/missed_signal?call_ids=".concat(encodeURIComponent(e));
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "GET";
      }
    }]), r;
  }(),
      wu = function () {
    qn(t, pu);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "getData",
      value: function value() {
        return {};
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.callId, "/custom_items");
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "DELETE";
      }
    }]), t;
  }(),
      Au = function () {
    qn(r, pu);
    var n = Xn(r);

    function r(e, t) {
      return Un(this, r), (e = n.call(this, e)).keys = t, e;
    }

    return Fn(r, [{
      key: "getData",
      value: function value() {
        return {
          keys: this.keys
        };
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.callId, "/custom_items");
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "DELETE";
      }
    }]), r;
  }(),
      Tu = function () {
    qn(r, pu);
    var n = Xn(r);

    function r(e, t) {
      return Un(this, r), (e = n.call(this, e)).customItems = t, e;
    }

    return Fn(r, [{
      key: "getData",
      value: function value() {
        return {
          custom_items: this.customItems,
          mode: "upsert"
        };
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.callId, "/custom_items");
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "PUT";
      }
    }]), r;
  }(),
      Su = function () {
    qn(i, pu);
    var r = Xn(i);

    function i(e, t, n) {
      return Un(this, i), (e = r.call(this, e)).userRole = t, e.data = n, e;
    }

    return Fn(i, [{
      key: "getData",
      value: function value() {
        return {
          version: 1,
          user_role: this.userRole,
          summary_data: this.data
        };
      }
    }, {
      key: "getSubPath",
      value: function value() {
        return "/".concat(this.callId, "/summary");
      }
    }, {
      key: "getMethod",
      value: function value() {
        return "POST";
      }
    }]), i;
  }();

  (D = vu = vu || {}).DIAL = "dial", D.DIAL_ACK = "dial_ack", D.DIAL_RCV = "dial_rcv", D.CANCEL = "cancel", D.ACCEPT = "accept", D.ACCEPT_ACK = "accept_ack", D.OTHER_DEVICE_ACCEPTED = "other_device_accepted", D.DECLINE = "decline", D.DECLINE_ACK = "decline_ack", D.OFFER = "offer", D.ANSWER = "answer", D.CANDIDATE = "candidate", D.REMOVE_CANDIDATES = "remove_candidates", D.AUDIO = "audio", D.VIDEO = "video", D.HOLD = "hold", D.HOLD_ACK = "hold_ack", D.CUSTOM_ITEMS_UPDATE = "custom_items_update", D.CUSTOM_ITEMS_DELETE = "custom_items_delete", D.RECORDING = "recording", D.END = "end", D.TIME_OUT = "timeout", D.CONNECTION_LOST = "connection_lost", D.UNKNOWN_END = "unknown_end", D.ALIVE = "alive", D.NO_ANSWER = "no_answer", D.CANCEL_ACK = "cancel_ack", D.END_ACK = "end_ack", D.TIMEOUT_ACK = "timeout_ack", D.NO_ANSWER_ACK = "no_answer_ack", D.CONNECTION_LOST_ACK = "connection_lost_ack", D.UNKNOWN_END_ACK = "unknown_end_ack", D.ALIVE_ACK = "alive_ack", D.CONNECTED = "connected", D.SNAPSHOT = "snapshot", D.TURN_CHANGED = "turn_changed";

  var bu = function () {
    qn(n, gu);
    var t = Xn(n);

    function n(e) {
      return Un(this, n), Gn(Qn(e = t.call(this, {
        type: vu.DECLINE_ACK,
        cmd: nu.SGNL,
        payload: e
      })), "type", vu.DECLINE_ACK), e;
    }

    return n;
  }(),
      Ou = function () {
    qn(n, gu);
    var t = Xn(n);

    function n(e) {
      return Un(this, n), Gn(Qn(e = t.call(this, {
        type: vu.SNAPSHOT,
        cmd: nu.SGNL,
        payload: e
      })), "type", vu.SNAPSHOT), e;
    }

    return n;
  }(),
      Du = function () {
    qn(a, Eu);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.ACCEPT), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id,
          turnCredential: {
            username: e.turn_credential.username,
            password: e.turn_credential.password,
            turnUrls: e.turn_credential.turn_urls,
            transportPolicy: e.turn_credential.transport_policy
          },
          constraints: {
            audio: e.audio,
            video: e.video
          },
          capabilities: e.capabilities || []
        };
      }
    }]), a;
  }(),
      Nu = function () {
    qn(a, Eu);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.OTHER_DEVICE_ACCEPTED), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id
        };
      }
    }]), a;
  }(),
      Lu = t(function (e, t) {
    var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
    t.assign = function (e) {
      for (var t, n, r = Array.prototype.slice.call(arguments, 1); r.length;) {
        var i = r.shift();

        if (i) {
          if ("object" != typeof i) throw new TypeError(i + "must be non-object");

          for (var a in i) {
            t = i, n = a, Object.prototype.hasOwnProperty.call(t, n) && (e[a] = i[a]);
          }
        }
      }

      return e;
    }, t.shrinkBuf = function (e, t) {
      return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
    };
    var r = {
      arraySet: function arraySet(e, t, n, r, i) {
        if (t.subarray && e.subarray) e.set(t.subarray(n, n + r), i);else for (var a = 0; a < r; a++) {
          e[i + a] = t[n + a];
        }
      },
      flattenChunks: function flattenChunks(e) {
        for (var t, n, r, i = 0, a = 0, o = e.length; a < o; a++) {
          i += e[a].length;
        }

        for (r = new Uint8Array(i), a = t = 0, o = e.length; a < o; a++) {
          n = e[a], r.set(n, t), t += n.length;
        }

        return r;
      }
    },
        i = {
      arraySet: function arraySet(e, t, n, r, i) {
        for (var a = 0; a < r; a++) {
          e[i + a] = t[n + a];
        }
      },
      flattenChunks: function flattenChunks(e) {
        return [].concat.apply([], e);
      }
    };
    t.setTyped = function (e) {
      e ? (t.Buf8 = Uint8Array, t.Buf16 = Uint16Array, t.Buf32 = Int32Array, t.assign(t, r)) : (t.Buf8 = Array, t.Buf16 = Array, t.Buf32 = Array, t.assign(t, i));
    }, t.setTyped(n);
  }),
      xu = (Lu.assign, Lu.shrinkBuf, Lu.setTyped, Lu.Buf8, Lu.Buf16, Lu.Buf32, 0),
      Pu = 1;

  function Mu(e) {
    for (var t = e.length; 0 <= --t;) {
      e[t] = 0;
    }
  }

  var Uu = 0,
      Vu = 29,
      Fu = 256,
      Gu = Fu + 1 + Vu,
      Bu = 30,
      ju = 19,
      qu = 2 * Gu + 1,
      Hu = 15,
      zu = 16,
      Wu = 7,
      Ku = 256,
      Yu = 16,
      Zu = 17,
      Qu = 18,
      Xu = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0],
      $u = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13],
      Ju = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7],
      el = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
      tl = new Array(2 * (Gu + 2));
  Mu(tl);
  var nl = new Array(2 * Bu);
  Mu(nl);
  var rl = new Array(512);
  Mu(rl);
  var il = new Array(256);
  Mu(il);
  var al = new Array(Vu);
  Mu(al);
  var ol,
      sl,
      cl,
      ul = new Array(Bu);

  function ll(e, t, n, r, i) {
    this.static_tree = e, this.extra_bits = t, this.extra_base = n, this.elems = r, this.max_length = i, this.has_stree = e && e.length;
  }

  function dl(e, t) {
    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
  }

  function hl(e) {
    return e < 256 ? rl[e] : rl[256 + (e >>> 7)];
  }

  function fl(e, t) {
    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
  }

  function _l(e, t, n) {
    e.bi_valid > zu - n ? (e.bi_buf |= t << e.bi_valid & 65535, fl(e, e.bi_buf), e.bi_buf = t >> zu - e.bi_valid, e.bi_valid += n - zu) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += n);
  }

  function pl(e, t, n) {
    _l(e, n[2 * t], n[2 * t + 1]);
  }

  function vl(e, t) {
    for (var n = 0; n |= 1 & e, e >>>= 1, n <<= 1, 0 < --t;) {
      ;
    }

    return n >>> 1;
  }

  function yl(e, t, n) {
    for (var r, i = new Array(Hu + 1), a = 0, o = 1; o <= Hu; o++) {
      i[o] = a = a + n[o - 1] << 1;
    }

    for (r = 0; r <= t; r++) {
      var s = e[2 * r + 1];
      0 !== s && (e[2 * r] = vl(i[s]++, s));
    }
  }

  function ml(e) {
    for (var t = 0; t < Gu; t++) {
      e.dyn_ltree[2 * t] = 0;
    }

    for (t = 0; t < Bu; t++) {
      e.dyn_dtree[2 * t] = 0;
    }

    for (t = 0; t < ju; t++) {
      e.bl_tree[2 * t] = 0;
    }

    e.dyn_ltree[2 * Ku] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
  }

  function gl(e) {
    8 < e.bi_valid ? fl(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
  }

  function El(e, t, n, r) {
    var i = 2 * t,
        a = 2 * n;
    return e[i] < e[a] || e[i] === e[a] && r[t] <= r[n];
  }

  function kl(e, t, n) {
    for (var r = e.heap[n], i = n << 1; i <= e.heap_len && (i < e.heap_len && El(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !El(t, r, e.heap[i], e.depth));) {
      e.heap[n] = e.heap[i], n = i, i <<= 1;
    }

    e.heap[n] = r;
  }

  function Rl(e, t, n) {
    var r,
        i,
        a,
        o,
        s = 0;
    if (0 !== e.last_lit) for (; r = e.pending_buf[e.d_buf + 2 * s] << 8 | e.pending_buf[e.d_buf + 2 * s + 1], i = e.pending_buf[e.l_buf + s], s++, 0 == r ? pl(e, i, t) : (pl(e, (a = il[i]) + Fu + 1, t), 0 !== (o = Xu[a]) && _l(e, i -= al[a], o), pl(e, a = hl(--r), n), 0 !== (o = $u[a]) && _l(e, r -= ul[a], o)), s < e.last_lit;) {
      ;
    }
    pl(e, Ku, t);
  }

  function Cl(e, p) {
    var t,
        n,
        r,
        i = p.dyn_tree,
        a = p.stat_desc.static_tree,
        o = p.stat_desc.has_stree,
        s = p.stat_desc.elems,
        c = -1;

    for (e.heap_len = 0, e.heap_max = qu, t = 0; t < s; t++) {
      0 !== i[2 * t] ? (e.heap[++e.heap_len] = c = t, e.depth[t] = 0) : i[2 * t + 1] = 0;
    }

    for (; e.heap_len < 2;) {
      i[2 * (r = e.heap[++e.heap_len] = c < 2 ? ++c : 0)] = 1, e.depth[r] = 0, e.opt_len--, o && (e.static_len -= a[2 * r + 1]);
    }

    for (p.max_code = c, t = e.heap_len >> 1; 1 <= t; t--) {
      kl(e, i, t);
    }

    for (r = s; t = e.heap[1], e.heap[1] = e.heap[e.heap_len--], kl(e, i, 1), n = e.heap[1], e.heap[--e.heap_max] = t, e.heap[--e.heap_max] = n, i[2 * r] = i[2 * t] + i[2 * n], e.depth[r] = (e.depth[t] >= e.depth[n] ? e.depth[t] : e.depth[n]) + 1, i[2 * t + 1] = i[2 * n + 1] = r, e.heap[1] = r++, kl(e, i, 1), 2 <= e.heap_len;) {
      ;
    }

    e.heap[--e.heap_max] = e.heap[1], function (e) {
      for (var t, n, r, i, a, o = p.dyn_tree, s = p.max_code, c = p.stat_desc.static_tree, u = p.stat_desc.has_stree, l = p.stat_desc.extra_bits, d = p.stat_desc.extra_base, h = p.stat_desc.max_length, f = 0, _ = 0; _ <= Hu; _++) {
        e.bl_count[_] = 0;
      }

      for (o[2 * e.heap[e.heap_max] + 1] = 0, t = e.heap_max + 1; t < qu; t++) {
        h < (_ = o[2 * o[2 * (n = e.heap[t]) + 1] + 1] + 1) && (_ = h, f++), o[2 * n + 1] = _, s < n || (e.bl_count[_]++, i = 0, d <= n && (i = l[n - d]), a = o[2 * n], e.opt_len += a * (_ + i), u && (e.static_len += a * (c[2 * n + 1] + i)));
      }

      if (0 !== f) {
        do {
          for (_ = h - 1; 0 === e.bl_count[_];) {
            _--;
          }
        } while ((e.bl_count[_]--, e.bl_count[_ + 1] += 2, e.bl_count[h]--, 0 < (f -= 2)));

        for (_ = h; 0 !== _; _--) {
          for (n = e.bl_count[_]; 0 !== n;) {
            s < (r = e.heap[--t]) || (o[2 * r + 1] !== _ && (e.opt_len += (_ - o[2 * r + 1]) * o[2 * r], o[2 * r + 1] = _), n--);
          }
        }
      }
    }(e), yl(i, c, e.bl_count);
  }

  function Il(e, t, n) {
    var r,
        i,
        a = -1,
        o = t[1],
        s = 0,
        c = 7,
        u = 4;

    for (0 === o && (c = 138, u = 3), t[2 * (n + 1) + 1] = 65535, r = 0; r <= n; r++) {
      i = o, o = t[2 * (r + 1) + 1], ++s < c && i === o || (s < u ? e.bl_tree[2 * i] += s : 0 !== i ? (i !== a && e.bl_tree[2 * i]++, e.bl_tree[2 * Yu]++) : s <= 10 ? e.bl_tree[2 * Zu]++ : e.bl_tree[2 * Qu]++, a = i, u = (s = 0) === o ? (c = 138, 3) : i === o ? (c = 6, 3) : (c = 7, 4));
    }
  }

  function wl(e, t, n) {
    var r,
        i,
        a = -1,
        o = t[1],
        s = 0,
        c = 7,
        u = 4;

    for (0 === o && (c = 138, u = 3), r = 0; r <= n; r++) {
      if (i = o, o = t[2 * (r + 1) + 1], !(++s < c && i === o)) {
        if (s < u) for (; pl(e, i, e.bl_tree), 0 != --s;) {
          ;
        } else 0 !== i ? (i !== a && (pl(e, i, e.bl_tree), s--), pl(e, Yu, e.bl_tree), _l(e, s - 3, 2)) : s <= 10 ? (pl(e, Zu, e.bl_tree), _l(e, s - 3, 3)) : (pl(e, Qu, e.bl_tree), _l(e, s - 11, 7));
        a = i, u = (s = 0) === o ? (c = 138, 3) : i === o ? (c = 6, 3) : (c = 7, 4);
      }
    }
  }

  Mu(ul);
  var Al = !1;

  function Tl(e, t, n, r) {
    _l(e, (Uu << 1) + (r ? 1 : 0), 3), r = t, t = n, n = !0, gl(e = e), n && (fl(e, t), fl(e, ~t)), Lu.arraySet(e.pending_buf, e.window, r, t, e.pending), e.pending += t;
  }

  var Sl = {
    _tr_init: function _tr_init(e) {
      Al || (function () {
        for (var e, t, n, r = new Array(Hu + 1), i = 0, a = 0; a < Vu - 1; a++) {
          for (al[a] = i, e = 0; e < 1 << Xu[a]; e++) {
            il[i++] = a;
          }
        }

        for (il[i - 1] = a, a = n = 0; a < 16; a++) {
          for (ul[a] = n, e = 0; e < 1 << $u[a]; e++) {
            rl[n++] = a;
          }
        }

        for (n >>= 7; a < Bu; a++) {
          for (ul[a] = n << 7, e = 0; e < 1 << $u[a] - 7; e++) {
            rl[256 + n++] = a;
          }
        }

        for (t = 0; t <= Hu; t++) {
          r[t] = 0;
        }

        for (e = 0; e <= 143;) {
          tl[2 * e + 1] = 8, e++, r[8]++;
        }

        for (; e <= 255;) {
          tl[2 * e + 1] = 9, e++, r[9]++;
        }

        for (; e <= 279;) {
          tl[2 * e + 1] = 7, e++, r[7]++;
        }

        for (; e <= 287;) {
          tl[2 * e + 1] = 8, e++, r[8]++;
        }

        for (yl(tl, Gu + 1, r), e = 0; e < Bu; e++) {
          nl[2 * e + 1] = 5, nl[2 * e] = vl(e, 5);
        }

        ol = new ll(tl, Xu, Fu + 1, Gu, Hu), sl = new ll(nl, $u, 0, Bu, Hu), cl = new ll(new Array(0), Ju, 0, ju, Wu);
      }(), Al = !0), e.l_desc = new dl(e.dyn_ltree, ol), e.d_desc = new dl(e.dyn_dtree, sl), e.bl_desc = new dl(e.bl_tree, cl), e.bi_buf = 0, e.bi_valid = 0, ml(e);
    },
    _tr_stored_block: Tl,
    _tr_flush_block: function _tr_flush_block(e, t, n, r) {
      var i,
          a,
          o = 0;
      0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function (e) {
        for (var t = 4093624447, n = 0; n <= 31; n++, t >>>= 1) {
          if (1 & t && 0 !== e.dyn_ltree[2 * n]) return xu;
        }

        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return Pu;

        for (n = 32; n < Fu; n++) {
          if (0 !== e.dyn_ltree[2 * n]) return Pu;
        }

        return xu;
      }(e)), Cl(e, e.l_desc), Cl(e, e.d_desc), o = function (e) {
        var t;

        for (Il(e, e.dyn_ltree, e.l_desc.max_code), Il(e, e.dyn_dtree, e.d_desc.max_code), Cl(e, e.bl_desc), t = ju - 1; 3 <= t && 0 === e.bl_tree[2 * el[t] + 1]; t--) {
          ;
        }

        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
      }(e), i = e.opt_len + 3 + 7 >>> 3, (a = e.static_len + 3 + 7 >>> 3) <= i && (i = a)) : i = a = n + 5, n + 4 <= i && -1 !== t ? Tl(e, t, n, r) : 4 === e.strategy || a === i ? (_l(e, 2 + (r ? 1 : 0), 3), Rl(e, tl, nl)) : (_l(e, 4 + (r ? 1 : 0), 3), function (e, t, n, r) {
        var i;

        for (_l(e, t - 257, 5), _l(e, n - 1, 5), _l(e, r - 4, 4), i = 0; i < r; i++) {
          _l(e, e.bl_tree[2 * el[i] + 1], 3);
        }

        wl(e, e.dyn_ltree, t - 1), wl(e, e.dyn_dtree, n - 1);
      }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, o + 1), Rl(e, e.dyn_ltree, e.dyn_dtree)), ml(e), r && gl(e);
    },
    _tr_tally: function _tr_tally(e, t, n) {
      return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & n, e.last_lit++, 0 === t ? e.dyn_ltree[2 * n]++ : (e.matches++, t--, e.dyn_ltree[2 * (il[n] + Fu + 1)]++, e.dyn_dtree[2 * hl(t)]++), e.last_lit === e.lit_bufsize - 1;
    },
    _tr_align: function _tr_align(e) {
      _l(e, 2, 3), pl(e, Ku, tl), 16 === (e = e).bi_valid ? (fl(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
    }
  };

  var bl = function bl(e, t, n, r) {
    for (var i = 65535 & e | 0, a = e >>> 16 & 65535 | 0, o = 0; 0 !== n;) {
      for (o = 2e3 < n ? 2e3 : n, n -= o; a = a + (i = i + t[r++] | 0) | 0, --o;) {
        ;
      }

      i %= 65521, a %= 65521;
    }

    return i | a << 16 | 0;
  };

  var Ol = function () {
    for (var e, t = [], n = 0; n < 256; n++) {
      e = n;

      for (var r = 0; r < 8; r++) {
        e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
      }

      t[n] = e;
    }

    return t;
  }();

  var Dl,
      Nl = function Nl(e, t, n, r) {
    var i = Ol,
        a = r + n;
    e ^= -1;

    for (var o = r; o < a; o++) {
      e = e >>> 8 ^ i[255 & (e ^ t[o])];
    }

    return -1 ^ e;
  },
      Ll = {
    2: "need dictionary",
    1: "stream end",
    0: "",
    "-1": "file error",
    "-2": "stream error",
    "-3": "data error",
    "-4": "insufficient memory",
    "-5": "buffer error",
    "-6": "incompatible version"
  },
      xl = 0,
      Pl = 4,
      Ml = 0,
      Ul = -2,
      Vl = -1,
      Fl = 4,
      Gl = 2,
      Bl = 8,
      jl = 9,
      ql = 286,
      Hl = 30,
      zl = 19,
      Wl = 2 * ql + 1,
      Kl = 15,
      Yl = 3,
      Zl = 258,
      Ql = Zl + Yl + 1,
      Xl = 42,
      $l = 113,
      Jl = 1,
      ed = 2,
      td = 3,
      nd = 4;

  function rd(e, t) {
    return e.msg = Ll[t], t;
  }

  function id(e) {
    return (e << 1) - (4 < e ? 9 : 0);
  }

  function ad(e) {
    for (var t = e.length; 0 <= --t;) {
      e[t] = 0;
    }
  }

  function od(e) {
    var t = e.state,
        n = t.pending;
    n > e.avail_out && (n = e.avail_out), 0 !== n && (Lu.arraySet(e.output, t.pending_buf, t.pending_out, n, e.next_out), e.next_out += n, t.pending_out += n, e.total_out += n, e.avail_out -= n, t.pending -= n, 0 === t.pending && (t.pending_out = 0));
  }

  function sd(e, t) {
    Sl._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, od(e.strm);
  }

  function cd(e, t) {
    e.pending_buf[e.pending++] = t;
  }

  function ud(e, t) {
    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
  }

  function ld(e, t) {
    var n,
        r,
        i = e.max_chain_length,
        a = e.strstart,
        o = e.prev_length,
        s = e.nice_match,
        c = e.strstart > e.w_size - Ql ? e.strstart - (e.w_size - Ql) : 0,
        u = e.window,
        l = e.w_mask,
        d = e.prev,
        h = e.strstart + Zl,
        f = u[a + o - 1],
        _ = u[a + o];
    e.prev_length >= e.good_match && (i >>= 2), s > e.lookahead && (s = e.lookahead);

    do {
      if (u[(n = t) + o] === _ && u[n + o - 1] === f && u[n] === u[a] && u[++n] === u[a + 1]) {
        for (a += 2, n++; u[++a] === u[++n] && u[++a] === u[++n] && u[++a] === u[++n] && u[++a] === u[++n] && u[++a] === u[++n] && u[++a] === u[++n] && u[++a] === u[++n] && u[++a] === u[++n] && a < h;) {
          ;
        }

        if (r = Zl - (h - a), a = h - Zl, o < r) {
          if (e.match_start = t, s <= (o = r)) break;
          f = u[a + o - 1], _ = u[a + o];
        }
      }
    } while ((t = d[t & l]) > c && 0 != --i);

    return o <= e.lookahead ? o : e.lookahead;
  }

  function dd(e) {
    var t,
        n,
        r,
        i,
        a,
        o,
        s,
        c,
        u,
        l = e.w_size;

    do {
      if (u = e.window_size - e.lookahead - e.strstart, e.strstart >= l + (l - Ql)) {
        for (Lu.arraySet(e.window, e.window, l, l, 0), e.match_start -= l, e.strstart -= l, e.block_start -= l, n = e.hash_size, t = n; r = e.head[--t], e.head[t] = l <= r ? r - l : 0, --n;) {
          ;
        }

        for (n = l, t = n; r = e.prev[--t], e.prev[t] = l <= r ? r - l : 0, --n;) {
          ;
        }

        u += l;
      }

      if (0 === e.strm.avail_in) break;
      if (a = e.strm, o = e.window, s = e.strstart + e.lookahead, c = u, u = void 0, u = a.avail_in, c < u && (u = c), n = 0 === u ? 0 : (a.avail_in -= u, Lu.arraySet(o, a.input, a.next_in, u, s), 1 === a.state.wrap ? a.adler = bl(a.adler, o, u, s) : 2 === a.state.wrap && (a.adler = Nl(a.adler, o, u, s)), a.next_in += u, a.total_in += u, u), e.lookahead += n, e.lookahead + e.insert >= Yl) for (i = e.strstart - e.insert, e.ins_h = e.window[i], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[i + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[i + Yl - 1]) & e.hash_mask, e.prev[i & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = i, i++, e.insert--, !(e.lookahead + e.insert < Yl));) {
        ;
      }
    } while (e.lookahead < Ql && 0 !== e.strm.avail_in);
  }

  function hd(e, t) {
    for (var n, r;;) {
      if (e.lookahead < Ql) {
        if (dd(e), e.lookahead < Ql && t === xl) return Jl;
        if (0 === e.lookahead) break;
      }

      if (n = 0, e.lookahead >= Yl && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + Yl - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== n && e.strstart - n <= e.w_size - Ql && (e.match_length = ld(e, n)), e.match_length >= Yl) {
        if (r = Sl._tr_tally(e, e.strstart - e.match_start, e.match_length - Yl), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= Yl) {
          for (e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + Yl - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;) {
            ;
          }

          e.strstart++;
        } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
      } else r = Sl._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
      if (r && (sd(e, !1), 0 === e.strm.avail_out)) return Jl;
    }

    return e.insert = e.strstart < Yl - 1 ? e.strstart : Yl - 1, t === Pl ? (sd(e, !0), 0 === e.strm.avail_out ? td : nd) : e.last_lit && (sd(e, !1), 0 === e.strm.avail_out) ? Jl : ed;
  }

  function fd(e, t) {
    for (var n, r, i;;) {
      if (e.lookahead < Ql) {
        if (dd(e), e.lookahead < Ql && t === xl) return Jl;
        if (0 === e.lookahead) break;
      }

      if (n = 0, e.lookahead >= Yl && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + Yl - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = Yl - 1, 0 !== n && e.prev_length < e.max_lazy_match && e.strstart - n <= e.w_size - Ql && (e.match_length = ld(e, n), e.match_length <= 5 && (1 === e.strategy || e.match_length === Yl && 4096 < e.strstart - e.match_start) && (e.match_length = Yl - 1)), e.prev_length >= Yl && e.match_length <= e.prev_length) {
        for (i = e.strstart + e.lookahead - Yl, r = Sl._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - Yl), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + Yl - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;) {
          ;
        }

        if (e.match_available = 0, e.match_length = Yl - 1, e.strstart++, r && (sd(e, !1), 0 === e.strm.avail_out)) return Jl;
      } else if (e.match_available) {
        if ((r = Sl._tr_tally(e, 0, e.window[e.strstart - 1])) && sd(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return Jl;
      } else e.match_available = 1, e.strstart++, e.lookahead--;
    }

    return e.match_available && (r = Sl._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < Yl - 1 ? e.strstart : Yl - 1, t === Pl ? (sd(e, !0), 0 === e.strm.avail_out ? td : nd) : e.last_lit && (sd(e, !1), 0 === e.strm.avail_out) ? Jl : ed;
  }

  function _d(e, t, n, r, i) {
    this.good_length = e, this.max_lazy = t, this.nice_length = n, this.max_chain = r, this.func = i;
  }

  function pd() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Bl, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Lu.Buf16(2 * Wl), this.dyn_dtree = new Lu.Buf16(2 * (2 * Hl + 1)), this.bl_tree = new Lu.Buf16(2 * (2 * zl + 1)), ad(this.dyn_ltree), ad(this.dyn_dtree), ad(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Lu.Buf16(Kl + 1), this.heap = new Lu.Buf16(2 * ql + 1), ad(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Lu.Buf16(2 * ql + 1), ad(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }

  function vd(e) {
    var t;
    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = Gl, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? Xl : $l, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = xl, Sl._tr_init(t), Ml) : rd(e, Ul);
  }

  function yd(e) {
    var t = vd(e);
    return t === Ml && ((e = e.state).window_size = 2 * e.w_size, ad(e.head), e.max_lazy_match = Dl[e.level].max_lazy, e.good_match = Dl[e.level].good_length, e.nice_match = Dl[e.level].nice_length, e.max_chain_length = Dl[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = Yl - 1, e.match_available = 0, e.ins_h = 0), t;
  }

  function md(e, t, n, r, i, a) {
    if (!e) return Ul;
    var o = 1;
    if (t === Vl && (t = 6), r < 0 ? (o = 0, r = -r) : 15 < r && (o = 2, r -= 16), i < 1 || jl < i || n !== Bl || r < 8 || 15 < r || t < 0 || 9 < t || a < 0 || Fl < a) return rd(e, Ul);
    8 === r && (r = 9);
    var s = new pd();
    return (e.state = s).strm = e, s.wrap = o, s.gzhead = null, s.w_bits = r, s.w_size = 1 << s.w_bits, s.w_mask = s.w_size - 1, s.hash_bits = i + 7, s.hash_size = 1 << s.hash_bits, s.hash_mask = s.hash_size - 1, s.hash_shift = ~~((s.hash_bits + Yl - 1) / Yl), s.window = new Lu.Buf8(2 * s.w_size), s.head = new Lu.Buf16(s.hash_size), s.prev = new Lu.Buf16(s.w_size), s.lit_bufsize = 1 << i + 6, s.pending_buf_size = 4 * s.lit_bufsize, s.pending_buf = new Lu.Buf8(s.pending_buf_size), s.d_buf = +s.lit_bufsize, s.l_buf = 3 * s.lit_bufsize, s.level = t, s.strategy = a, s.method = n, yd(e);
  }

  Dl = [new _d(0, 0, 0, 0, function (e, t) {
    var n = 65535;

    for (n > e.pending_buf_size - 5 && (n = e.pending_buf_size - 5);;) {
      if (e.lookahead <= 1) {
        if (dd(e), 0 === e.lookahead && t === xl) return Jl;
        if (0 === e.lookahead) break;
      }

      e.strstart += e.lookahead, e.lookahead = 0;
      var r = e.block_start + n;
      if ((0 === e.strstart || e.strstart >= r) && (e.lookahead = e.strstart - r, e.strstart = r, sd(e, !1), 0 === e.strm.avail_out)) return Jl;
      if (e.strstart - e.block_start >= e.w_size - Ql && (sd(e, !1), 0 === e.strm.avail_out)) return Jl;
    }

    return e.insert = 0, t === Pl ? (sd(e, !0), 0 === e.strm.avail_out ? td : nd) : (e.strstart > e.block_start && (sd(e, !1), e.strm.avail_out), Jl);
  }), new _d(4, 4, 8, 4, hd), new _d(4, 5, 16, 8, hd), new _d(4, 6, 32, 32, hd), new _d(4, 4, 16, 16, fd), new _d(8, 16, 32, 32, fd), new _d(8, 16, 128, 128, fd), new _d(8, 32, 128, 256, fd), new _d(32, 128, 258, 1024, fd), new _d(32, 258, 258, 4096, fd)];
  var gd = {
    deflateInit: function deflateInit(e, t) {
      return md(e, t, Bl, 15, 8, 0);
    },
    deflateInit2: md,
    deflateReset: yd,
    deflateResetKeep: vd,
    deflateSetHeader: function deflateSetHeader(e, t) {
      return !e || !e.state || 2 !== e.state.wrap ? Ul : (e.state.gzhead = t, Ml);
    },
    deflate: function deflate(e, t) {
      var n, r, i, a;
      if (!e || !e.state || 5 < t || t < 0) return e ? rd(e, Ul) : Ul;
      if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== Pl) return rd(e, 0 === e.avail_out ? -5 : Ul);
      if (n.strm = e, o = n.last_flush, n.last_flush = t, n.status === Xl && (2 === n.wrap ? (e.adler = 0, cd(n, 31), cd(n, 139), cd(n, 8), n.gzhead ? (cd(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), cd(n, 255 & n.gzhead.time), cd(n, n.gzhead.time >> 8 & 255), cd(n, n.gzhead.time >> 16 & 255), cd(n, n.gzhead.time >> 24 & 255), cd(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), cd(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (cd(n, 255 & n.gzhead.extra.length), cd(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = Nl(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (cd(n, 0), cd(n, 0), cd(n, 0), cd(n, 0), cd(n, 0), cd(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), cd(n, 3), n.status = $l)) : (a = Bl + (n.w_bits - 8 << 4) << 8, a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = $l, ud(n, a), 0 !== n.strstart && (ud(n, e.adler >>> 16), ud(n, 65535 & e.adler)), e.adler = 1)), 69 === n.status) if (n.gzhead.extra) {
        for (r = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > r && (e.adler = Nl(e.adler, n.pending_buf, n.pending - r, r)), od(e), r = n.pending, n.pending !== n.pending_buf_size));) {
          cd(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
        }

        n.gzhead.hcrc && n.pending > r && (e.adler = Nl(e.adler, n.pending_buf, n.pending - r, r)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
      } else n.status = 73;
      if (73 === n.status) if (n.gzhead.name) {
        r = n.pending;

        do {
          if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > r && (e.adler = Nl(e.adler, n.pending_buf, n.pending - r, r)), od(e), r = n.pending, n.pending === n.pending_buf_size)) {
            i = 1;
            break;
          }
        } while ((i = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, cd(n, i), 0 !== i));

        n.gzhead.hcrc && n.pending > r && (e.adler = Nl(e.adler, n.pending_buf, n.pending - r, r)), 0 === i && (n.gzindex = 0, n.status = 91);
      } else n.status = 91;
      if (91 === n.status) if (n.gzhead.comment) {
        r = n.pending;

        do {
          if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > r && (e.adler = Nl(e.adler, n.pending_buf, n.pending - r, r)), od(e), r = n.pending, n.pending === n.pending_buf_size)) {
            i = 1;
            break;
          }
        } while ((i = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, cd(n, i), 0 !== i));

        n.gzhead.hcrc && n.pending > r && (e.adler = Nl(e.adler, n.pending_buf, n.pending - r, r)), 0 === i && (n.status = 103);
      } else n.status = 103;

      if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && od(e), n.pending + 2 <= n.pending_buf_size && (cd(n, 255 & e.adler), cd(n, e.adler >> 8 & 255), e.adler = 0, n.status = $l)) : n.status = $l), 0 !== n.pending) {
        if (od(e), 0 === e.avail_out) return n.last_flush = -1, Ml;
      } else if (0 === e.avail_in && id(t) <= id(o) && t !== Pl) return rd(e, -5);

      if (666 === n.status && 0 !== e.avail_in) return rd(e, -5);

      if (0 !== e.avail_in || 0 !== n.lookahead || t !== xl && 666 !== n.status) {
        var o = 2 === n.strategy ? function (e, t) {
          for (var n;;) {
            if (0 === e.lookahead && (dd(e), 0 === e.lookahead)) {
              if (t === xl) return Jl;
              break;
            }

            if (e.match_length = 0, n = Sl._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, n && (sd(e, !1), 0 === e.strm.avail_out)) return Jl;
          }

          return e.insert = 0, t === Pl ? (sd(e, !0), 0 === e.strm.avail_out ? td : nd) : e.last_lit && (sd(e, !1), 0 === e.strm.avail_out) ? Jl : ed;
        }(n, t) : 3 === n.strategy ? function (e, t) {
          for (var n, r, i, a, o = e.window;;) {
            if (e.lookahead <= Zl) {
              if (dd(e), e.lookahead <= Zl && t === xl) return Jl;
              if (0 === e.lookahead) break;
            }

            if (e.match_length = 0, e.lookahead >= Yl && 0 < e.strstart && (r = o[i = e.strstart - 1]) === o[++i] && r === o[++i] && r === o[++i]) {
              for (a = e.strstart + Zl; r === o[++i] && r === o[++i] && r === o[++i] && r === o[++i] && r === o[++i] && r === o[++i] && r === o[++i] && r === o[++i] && i < a;) {
                ;
              }

              e.match_length = Zl - (a - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
            }

            if (e.match_length >= Yl ? (n = Sl._tr_tally(e, 1, e.match_length - Yl), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (n = Sl._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), n && (sd(e, !1), 0 === e.strm.avail_out)) return Jl;
          }

          return e.insert = 0, t === Pl ? (sd(e, !0), 0 === e.strm.avail_out ? td : nd) : e.last_lit && (sd(e, !1), 0 === e.strm.avail_out) ? Jl : ed;
        }(n, t) : Dl[n.level].func(n, t);
        if (o !== td && o !== nd || (n.status = 666), o === Jl || o === td) return 0 === e.avail_out && (n.last_flush = -1), Ml;
        if (o === ed && (1 === t ? Sl._tr_align(n) : 5 !== t && (Sl._tr_stored_block(n, 0, 0, !1), 3 === t && (ad(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), od(e), 0 === e.avail_out)) return n.last_flush = -1, Ml;
      }

      return t !== Pl ? Ml : n.wrap <= 0 ? 1 : (2 === n.wrap ? (cd(n, 255 & e.adler), cd(n, e.adler >> 8 & 255), cd(n, e.adler >> 16 & 255), cd(n, e.adler >> 24 & 255), cd(n, 255 & e.total_in), cd(n, e.total_in >> 8 & 255), cd(n, e.total_in >> 16 & 255), cd(n, e.total_in >> 24 & 255)) : (ud(n, e.adler >>> 16), ud(n, 65535 & e.adler)), od(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? Ml : 1);
    },
    deflateEnd: function deflateEnd(e) {
      var t;
      return e && e.state ? (t = e.state.status) !== Xl && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== $l && 666 !== t ? rd(e, Ul) : (e.state = null, t === $l ? rd(e, -3) : Ml) : Ul;
    },
    deflateSetDictionary: function deflateSetDictionary(e, t) {
      var n,
          r,
          i,
          a,
          o,
          s,
          c,
          u = t.length;
      if (!e || !e.state) return Ul;
      if (2 === (a = (n = e.state).wrap) || 1 === a && n.status !== Xl || n.lookahead) return Ul;

      for (1 === a && (e.adler = bl(e.adler, t, u, 0)), n.wrap = 0, u >= n.w_size && (0 === a && (ad(n.head), n.strstart = 0, n.block_start = 0, n.insert = 0), c = new Lu.Buf8(n.w_size), Lu.arraySet(c, t, u - n.w_size, n.w_size, 0), t = c, u = n.w_size), o = e.avail_in, s = e.next_in, c = e.input, e.avail_in = u, e.next_in = 0, e.input = t, dd(n); n.lookahead >= Yl;) {
        for (r = n.strstart, i = n.lookahead - (Yl - 1); n.ins_h = (n.ins_h << n.hash_shift ^ n.window[r + Yl - 1]) & n.hash_mask, n.prev[r & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = r, r++, --i;) {
          ;
        }

        n.strstart = r, n.lookahead = Yl - 1, dd(n);
      }

      return n.strstart += n.lookahead, n.block_start = n.strstart, n.insert = n.lookahead, n.lookahead = 0, n.match_length = n.prev_length = Yl - 1, n.match_available = 0, e.next_in = s, e.input = c, e.avail_in = o, n.wrap = a, Ml;
    },
    deflateInfo: "pako deflate (from Nodeca project)"
  },
      Ed = !0,
      kd = !0;

  try {
    String.fromCharCode.apply(null, [0]);
  } catch (e) {
    Ed = !1;
  }

  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch (e) {
    kd = !1;
  }

  for (var Rd = new Lu.Buf8(256), Cd = 0; Cd < 256; Cd++) {
    Rd[Cd] = 252 <= Cd ? 6 : 248 <= Cd ? 5 : 240 <= Cd ? 4 : 224 <= Cd ? 3 : 192 <= Cd ? 2 : 1;
  }

  Rd[254] = Rd[254] = 1;

  function Id(e, t) {
    if (t < 65534 && (e.subarray && kd || !e.subarray && Ed)) return String.fromCharCode.apply(null, Lu.shrinkBuf(e, t));

    for (var n = "", r = 0; r < t; r++) {
      n += String.fromCharCode(e[r]);
    }

    return n;
  }

  var wd = {
    string2buf: function string2buf(e) {
      for (var t, n, r, i, a = e.length, o = 0, s = 0; s < a; s++) {
        55296 == (64512 & (n = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (r = e.charCodeAt(s + 1))) && (n = 65536 + (n - 55296 << 10) + (r - 56320), s++), o += n < 128 ? 1 : n < 2048 ? 2 : n < 65536 ? 3 : 4;
      }

      for (t = new Lu.Buf8(o), s = i = 0; i < o; s++) {
        55296 == (64512 & (n = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (r = e.charCodeAt(s + 1))) && (n = 65536 + (n - 55296 << 10) + (r - 56320), s++), n < 128 ? t[i++] = n : (n < 2048 ? t[i++] = 192 | n >>> 6 : (n < 65536 ? t[i++] = 224 | n >>> 12 : (t[i++] = 240 | n >>> 18, t[i++] = 128 | n >>> 12 & 63), t[i++] = 128 | n >>> 6 & 63), t[i++] = 128 | 63 & n);
      }

      return t;
    },
    buf2binstring: function buf2binstring(e) {
      return Id(e, e.length);
    },
    binstring2buf: function binstring2buf(e) {
      for (var t = new Lu.Buf8(e.length), n = 0, r = t.length; n < r; n++) {
        t[n] = e.charCodeAt(n);
      }

      return t;
    },
    buf2string: function buf2string(e, t) {
      for (var n, r, i = t || e.length, a = new Array(2 * i), o = 0, s = 0; s < i;) {
        if ((n = e[s++]) < 128) a[o++] = n;else if (4 < (r = Rd[n])) a[o++] = 65533, s += r - 1;else {
          for (n &= 2 === r ? 31 : 3 === r ? 15 : 7; 1 < r && s < i;) {
            n = n << 6 | 63 & e[s++], r--;
          }

          1 < r ? a[o++] = 65533 : n < 65536 ? a[o++] = n : (n -= 65536, a[o++] = 55296 | n >> 10 & 1023, a[o++] = 56320 | 1023 & n);
        }
      }

      return Id(a, o);
    },
    utf8border: function utf8border(e, t) {
      var n;

      for ((t = t || e.length) > e.length && (t = e.length), n = t - 1; 0 <= n && 128 == (192 & e[n]);) {
        n--;
      }

      return !(n < 0) && 0 !== n && n + Rd[e[n]] > t ? n : t;
    }
  };

  var Ad = function Ad() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  },
      Td = Object.prototype.toString,
      Sd = 0,
      bd = -1,
      Od = 0,
      Dd = 8;

  function Nd(e) {
    if (!(this instanceof Nd)) return new Nd(e);
    this.options = Lu.assign({
      level: bd,
      method: Dd,
      chunkSize: 16384,
      windowBits: 15,
      memLevel: 8,
      strategy: Od,
      to: ""
    }, e || {});
    var t = this.options;
    if (t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new Ad(), this.strm.avail_out = 0, (e = gd.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy)) !== Sd) throw new Error(Ll[e]);

    if (t.header && gd.deflateSetHeader(this.strm, t.header), t.dictionary) {
      t = "string" == typeof t.dictionary ? wd.string2buf(t.dictionary) : "[object ArrayBuffer]" === Td.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary;
      if ((e = gd.deflateSetDictionary(this.strm, t)) !== Sd) throw new Error(Ll[e]);
      this._dict_set = !0;
    }
  }

  function Ld(e, t) {
    t = new Nd(t);
    if (t.push(e, !0), t.err) throw t.msg || Ll[t.err];
    return t.result;
  }

  Nd.prototype.push = function (e, t) {
    var n,
        r,
        i = this.strm,
        a = this.options.chunkSize;
    if (this.ended) return !1;
    r = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = wd.string2buf(e) : "[object ArrayBuffer]" === Td.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;

    do {
      if (0 === i.avail_out && (i.output = new Lu.Buf8(a), i.next_out = 0, i.avail_out = a), 1 !== (n = gd.deflate(i, r)) && n !== Sd) return this.onEnd(n), !(this.ended = !0);
    } while ((0 !== i.avail_out && (0 !== i.avail_in || 4 !== r && 2 !== r) || ("string" === this.options.to ? this.onData(wd.buf2binstring(Lu.shrinkBuf(i.output, i.next_out))) : this.onData(Lu.shrinkBuf(i.output, i.next_out))), (0 < i.avail_in || 0 === i.avail_out) && 1 !== n));

    return 4 === r ? (n = gd.deflateEnd(this.strm), this.onEnd(n), this.ended = !0, n === Sd) : 2 !== r || (this.onEnd(Sd), !(i.avail_out = 0));
  }, Nd.prototype.onData = function (e) {
    this.chunks.push(e);
  }, Nd.prototype.onEnd = function (e) {
    e === Sd && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = Lu.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
  };

  var $ = {
    Deflate: Nd,
    deflate: Ld,
    deflateRaw: function deflateRaw(e, t) {
      return (t = t || {}).raw = !0, Ld(e, t);
    },
    gzip: function gzip(e, t) {
      return (t = t || {}).gzip = !0, Ld(e, t);
    }
  },
      xd = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0],
      Pd = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78],
      Md = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0],
      Ud = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64],
      Vd = function Vd(e, t, n, r, i, a, o, s) {
    for (var c, u, l, d, h, f, _, p, v, y = s.bits, m = 0, g = 0, E = 0, k = 0, R = 0, C = 0, I = 0, w = 0, A = 0, T = 0, S = null, b = 0, O = new Lu.Buf16(16), D = new Lu.Buf16(16), N = null, L = 0, m = 0; m <= 15; m++) {
      O[m] = 0;
    }

    for (g = 0; g < r; g++) {
      O[t[n + g]]++;
    }

    for (R = y, k = 15; 1 <= k && 0 === O[k]; k--) {
      ;
    }

    if (k < R && (R = k), 0 === k) return i[a++] = 20971520, i[a++] = 20971520, s.bits = 1, 0;

    for (E = 1; E < k && 0 === O[E]; E++) {
      ;
    }

    for (R < E && (R = E), m = w = 1; m <= 15; m++) {
      if (w <<= 1, (w -= O[m]) < 0) return -1;
    }

    if (0 < w && (0 === e || 1 !== k)) return -1;

    for (D[1] = 0, m = 1; m < 15; m++) {
      D[m + 1] = D[m] + O[m];
    }

    for (g = 0; g < r; g++) {
      0 !== t[n + g] && (o[D[t[n + g]]++] = g);
    }

    if (f = 0 === e ? (S = N = o, 19) : 1 === e ? (S = xd, b -= 257, N = Pd, L -= 257, 256) : (S = Md, N = Ud, -1), m = E, h = a, I = g = T = 0, l = -1, d = (A = 1 << (C = R)) - 1, 1 === e && 852 < A || 2 === e && 592 < A) return 1;

    for (;;) {
      for (_ = m - I, v = o[g] < f ? (p = 0, o[g]) : o[g] > f ? (p = N[L + o[g]], S[b + o[g]]) : (p = 96, 0), c = 1 << m - I, u = 1 << C, E = u; i[h + (T >> I) + (u -= c)] = _ << 24 | p << 16 | v | 0, 0 !== u;) {
        ;
      }

      for (c = 1 << m - 1; T & c;) {
        c >>= 1;
      }

      if (0 !== c ? (T &= c - 1, T += c) : T = 0, g++, 0 == --O[m]) {
        if (m === k) break;
        m = t[n + o[g]];
      }

      if (R < m && (T & d) !== l) {
        for (0 === I && (I = R), h += E, w = 1 << (C = m - I); C + I < k && !((w -= O[C + I]) <= 0);) {
          C++, w <<= 1;
        }

        if (A += 1 << C, 1 === e && 852 < A || 2 === e && 592 < A) return 1;
        i[l = T & d] = R << 24 | C << 16 | h - a | 0;
      }
    }

    return 0 !== T && (i[h + T] = m - I << 24 | 64 << 16 | 0), s.bits = R, 0;
  },
      Fd = 1,
      Gd = 2,
      Bd = 0,
      jd = -2,
      qd = 1,
      Hd = 852,
      zd = 592;

  function Wd(e) {
    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
  }

  function Kd() {
    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Lu.Buf16(320), this.work = new Lu.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }

  function Yd(e) {
    var t;
    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = qd, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new Lu.Buf32(Hd), t.distcode = t.distdyn = new Lu.Buf32(zd), t.sane = 1, t.back = -1, Bd) : jd;
  }

  function Zd(e) {
    var t;
    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, Yd(e)) : jd;
  }

  function Qd(e, t) {
    var n, r;
    return e && e.state ? (r = e.state, t < 0 ? (n = 0, t = -t) : (n = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? jd : (null !== r.window && r.wbits !== t && (r.window = null), r.wrap = n, r.wbits = t, Zd(e))) : jd;
  }

  function Xd(e, t) {
    var n;
    return e ? (n = new Kd(), (e.state = n).window = null, (t = Qd(e, t)) !== Bd && (e.state = null), t) : jd;
  }

  var $d,
      Jd,
      eh = !0;

  function th(e, t, n, r) {
    var i = e.state;
    return null === i.window && (i.wsize = 1 << i.wbits, i.wnext = 0, i.whave = 0, i.window = new Lu.Buf8(i.wsize)), r >= i.wsize ? (Lu.arraySet(i.window, t, n - i.wsize, i.wsize, 0), i.wnext = 0, i.whave = i.wsize) : (r < (e = i.wsize - i.wnext) && (e = r), Lu.arraySet(i.window, t, n - r, e, i.wnext), (r -= e) ? (Lu.arraySet(i.window, t, n - r, r, 0), i.wnext = r, i.whave = i.wsize) : (i.wnext += e, i.wnext === i.wsize && (i.wnext = 0), i.whave < i.wsize && (i.whave += e))), 0;
  }

  var nh = {
    inflateReset: Zd,
    inflateReset2: Qd,
    inflateResetKeep: Yd,
    inflateInit: function inflateInit(e) {
      return Xd(e, 15);
    },
    inflateInit2: Xd,
    inflate: function inflate(e, t) {
      var n,
          r,
          i,
          a,
          o,
          s,
          c,
          u,
          l,
          d,
          A,
          h,
          f,
          _,
          p,
          v,
          y,
          m,
          g,
          E,
          k,
          R,
          C,
          I,
          w = 0,
          T = new Lu.Buf8(4),
          S = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];

      if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return jd;
      12 === (n = e.state).mode && (n.mode = 13), o = e.next_out, i = e.output, c = e.avail_out, a = e.next_in, r = e.input, s = e.avail_in, u = n.hold, l = n.bits, d = s, A = c, R = Bd;

      e: for (;;) {
        switch (n.mode) {
          case qd:
            if (0 === n.wrap) {
              n.mode = 13;
              break;
            }

            for (; l < 16;) {
              if (0 === s) break e;
              s--, u += r[a++] << l, l += 8;
            }

            if (2 & n.wrap && 35615 === u) {
              T[n.check = 0] = 255 & u, T[1] = u >>> 8 & 255, n.check = Nl(n.check, T, 2, 0), l = u = 0, n.mode = 2;
              break;
            }

            if (n.flags = 0, n.head && (n.head.done = !1), !(1 & n.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
              e.msg = "incorrect header check", n.mode = 30;
              break;
            }

            if (8 != (15 & u)) {
              e.msg = "unknown compression method", n.mode = 30;
              break;
            }

            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === n.wbits) n.wbits = k;else if (k > n.wbits) {
              e.msg = "invalid window size", n.mode = 30;
              break;
            }
            n.dmax = 1 << k, e.adler = n.check = 1, n.mode = 512 & u ? 10 : 12, l = u = 0;
            break;

          case 2:
            for (; l < 16;) {
              if (0 === s) break e;
              s--, u += r[a++] << l, l += 8;
            }

            if (n.flags = u, 8 != (255 & n.flags)) {
              e.msg = "unknown compression method", n.mode = 30;
              break;
            }

            if (57344 & n.flags) {
              e.msg = "unknown header flags set", n.mode = 30;
              break;
            }

            n.head && (n.head.text = u >> 8 & 1), 512 & n.flags && (T[0] = 255 & u, T[1] = u >>> 8 & 255, n.check = Nl(n.check, T, 2, 0)), l = u = 0, n.mode = 3;

          case 3:
            for (; l < 32;) {
              if (0 === s) break e;
              s--, u += r[a++] << l, l += 8;
            }

            n.head && (n.head.time = u), 512 & n.flags && (T[0] = 255 & u, T[1] = u >>> 8 & 255, T[2] = u >>> 16 & 255, T[3] = u >>> 24 & 255, n.check = Nl(n.check, T, 4, 0)), l = u = 0, n.mode = 4;

          case 4:
            for (; l < 16;) {
              if (0 === s) break e;
              s--, u += r[a++] << l, l += 8;
            }

            n.head && (n.head.xflags = 255 & u, n.head.os = u >> 8), 512 & n.flags && (T[0] = 255 & u, T[1] = u >>> 8 & 255, n.check = Nl(n.check, T, 2, 0)), l = u = 0, n.mode = 5;

          case 5:
            if (1024 & n.flags) {
              for (; l < 16;) {
                if (0 === s) break e;
                s--, u += r[a++] << l, l += 8;
              }

              n.length = u, n.head && (n.head.extra_len = u), 512 & n.flags && (T[0] = 255 & u, T[1] = u >>> 8 & 255, n.check = Nl(n.check, T, 2, 0)), l = u = 0;
            } else n.head && (n.head.extra = null);

            n.mode = 6;

          case 6:
            if (1024 & n.flags && (s < (h = n.length) && (h = s), h && (n.head && (k = n.head.extra_len - n.length, n.head.extra || (n.head.extra = new Array(n.head.extra_len)), Lu.arraySet(n.head.extra, r, a, h, k)), 512 & n.flags && (n.check = Nl(n.check, r, h, a)), s -= h, a += h, n.length -= h), n.length)) break e;
            n.length = 0, n.mode = 7;

          case 7:
            if (2048 & n.flags) {
              if (0 === s) break e;

              for (h = 0; k = r[a + h++], n.head && k && n.length < 65536 && (n.head.name += String.fromCharCode(k)), k && h < s;) {
                ;
              }

              if (512 & n.flags && (n.check = Nl(n.check, r, h, a)), s -= h, a += h, k) break e;
            } else n.head && (n.head.name = null);

            n.length = 0, n.mode = 8;

          case 8:
            if (4096 & n.flags) {
              if (0 === s) break e;

              for (h = 0; k = r[a + h++], n.head && k && n.length < 65536 && (n.head.comment += String.fromCharCode(k)), k && h < s;) {
                ;
              }

              if (512 & n.flags && (n.check = Nl(n.check, r, h, a)), s -= h, a += h, k) break e;
            } else n.head && (n.head.comment = null);

            n.mode = 9;

          case 9:
            if (512 & n.flags) {
              for (; l < 16;) {
                if (0 === s) break e;
                s--, u += r[a++] << l, l += 8;
              }

              if (u !== (65535 & n.check)) {
                e.msg = "header crc mismatch", n.mode = 30;
                break;
              }

              l = u = 0;
            }

            n.head && (n.head.hcrc = n.flags >> 9 & 1, n.head.done = !0), e.adler = n.check = 0, n.mode = 12;
            break;

          case 10:
            for (; l < 32;) {
              if (0 === s) break e;
              s--, u += r[a++] << l, l += 8;
            }

            e.adler = n.check = Wd(u), l = u = 0, n.mode = 11;

          case 11:
            if (0 === n.havedict) return e.next_out = o, e.avail_out = c, e.next_in = a, e.avail_in = s, n.hold = u, n.bits = l, 2;
            e.adler = n.check = 1, n.mode = 12;

          case 12:
            if (5 === t || 6 === t) break e;

          case 13:
            if (n.last) {
              u >>>= 7 & l, l -= 7 & l, n.mode = 27;
              break;
            }

            for (; l < 3;) {
              if (0 === s) break e;
              s--, u += r[a++] << l, l += 8;
            }

            switch (n.last = 1 & u, --l, 3 & (u >>>= 1)) {
              case 0:
                n.mode = 14;
                break;

              case 1:
                if (!function (e) {
                  if (eh) {
                    var t;

                    for ($d = new Lu.Buf32(512), Jd = new Lu.Buf32(32), t = 0; t < 144;) {
                      e.lens[t++] = 8;
                    }

                    for (; t < 256;) {
                      e.lens[t++] = 9;
                    }

                    for (; t < 280;) {
                      e.lens[t++] = 7;
                    }

                    for (; t < 288;) {
                      e.lens[t++] = 8;
                    }

                    for (Vd(Fd, e.lens, 0, 288, $d, 0, e.work, {
                      bits: 9
                    }), t = 0; t < 32;) {
                      e.lens[t++] = 5;
                    }

                    Vd(Gd, e.lens, 0, 32, Jd, 0, e.work, {
                      bits: 5
                    }), eh = !1;
                  }

                  e.lencode = $d, e.lenbits = 9, e.distcode = Jd, e.distbits = 5;
                }(n), n.mode = 20, 6 !== t) break;
                u >>>= 2, l -= 2;
                break e;

              case 2:
                n.mode = 17;
                break;

              case 3:
                e.msg = "invalid block type", n.mode = 30;
            }

            u >>>= 2, l -= 2;
            break;

          case 14:
            for (u >>>= 7 & l, l -= 7 & l; l < 32;) {
              if (0 === s) break e;
              s--, u += r[a++] << l, l += 8;
            }

            if ((65535 & u) != (u >>> 16 ^ 65535)) {
              e.msg = "invalid stored block lengths", n.mode = 30;
              break;
            }

            if (n.length = 65535 & u, l = u = 0, n.mode = 15, 6 === t) break e;

          case 15:
            n.mode = 16;

          case 16:
            if (h = n.length) {
              if (s < h && (h = s), c < h && (h = c), 0 === h) break e;
              Lu.arraySet(i, r, a, h, o), s -= h, a += h, c -= h, o += h, n.length -= h;
              break;
            }

            n.mode = 12;
            break;

          case 17:
            for (; l < 14;) {
              if (0 === s) break e;
              s--, u += r[a++] << l, l += 8;
            }

            if (n.nlen = 257 + (31 & u), u >>>= 5, l -= 5, n.ndist = 1 + (31 & u), u >>>= 5, l -= 5, n.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < n.nlen || 30 < n.ndist) {
              e.msg = "too many length or distance symbols", n.mode = 30;
              break;
            }

            n.have = 0, n.mode = 18;

          case 18:
            for (; n.have < n.ncode;) {
              for (; l < 3;) {
                if (0 === s) break e;
                s--, u += r[a++] << l, l += 8;
              }

              n.lens[S[n.have++]] = 7 & u, u >>>= 3, l -= 3;
            }

            for (; n.have < 19;) {
              n.lens[S[n.have++]] = 0;
            }

            if (n.lencode = n.lendyn, n.lenbits = 7, C = {
              bits: n.lenbits
            }, R = Vd(0, n.lens, 0, 19, n.lencode, 0, n.work, C), n.lenbits = C.bits, R) {
              e.msg = "invalid code lengths set", n.mode = 30;
              break;
            }

            n.have = 0, n.mode = 19;

          case 19:
            for (; n.have < n.nlen + n.ndist;) {
              for (; v = (w = n.lencode[u & (1 << n.lenbits) - 1]) >>> 16 & 255, y = 65535 & w, !((p = w >>> 24) <= l);) {
                if (0 === s) break e;
                s--, u += r[a++] << l, l += 8;
              }

              if (y < 16) u >>>= p, l -= p, n.lens[n.have++] = y;else {
                if (16 === y) {
                  for (I = p + 2; l < I;) {
                    if (0 === s) break e;
                    s--, u += r[a++] << l, l += 8;
                  }

                  if (u >>>= p, l -= p, 0 === n.have) {
                    e.msg = "invalid bit length repeat", n.mode = 30;
                    break;
                  }

                  k = n.lens[n.have - 1], h = 3 + (3 & u), u >>>= 2, l -= 2;
                } else if (17 === y) {
                  for (I = p + 3; l < I;) {
                    if (0 === s) break e;
                    s--, u += r[a++] << l, l += 8;
                  }

                  l -= p, k = 0, h = 3 + (7 & (u >>>= p)), u >>>= 3, l -= 3;
                } else {
                  for (I = p + 7; l < I;) {
                    if (0 === s) break e;
                    s--, u += r[a++] << l, l += 8;
                  }

                  l -= p, k = 0, h = 11 + (127 & (u >>>= p)), u >>>= 7, l -= 7;
                }

                if (n.have + h > n.nlen + n.ndist) {
                  e.msg = "invalid bit length repeat", n.mode = 30;
                  break;
                }

                for (; h--;) {
                  n.lens[n.have++] = k;
                }
              }
            }

            if (30 === n.mode) break;

            if (0 === n.lens[256]) {
              e.msg = "invalid code -- missing end-of-block", n.mode = 30;
              break;
            }

            if (n.lenbits = 9, C = {
              bits: n.lenbits
            }, R = Vd(Fd, n.lens, 0, n.nlen, n.lencode, 0, n.work, C), n.lenbits = C.bits, R) {
              e.msg = "invalid literal/lengths set", n.mode = 30;
              break;
            }

            if (n.distbits = 6, n.distcode = n.distdyn, C = {
              bits: n.distbits
            }, R = Vd(Gd, n.lens, n.nlen, n.ndist, n.distcode, 0, n.work, C), n.distbits = C.bits, R) {
              e.msg = "invalid distances set", n.mode = 30;
              break;
            }

            if (n.mode = 20, 6 === t) break e;

          case 20:
            n.mode = 21;

          case 21:
            if (6 <= s && 258 <= c) {
              e.next_out = o, e.avail_out = c, e.next_in = a, e.avail_in = s, n.hold = u, n.bits = l, function (e) {
                var t,
                    n,
                    r,
                    i,
                    a,
                    o,
                    s = e.state,
                    c = e.next_in,
                    u = e.input,
                    l = c + (e.avail_in - 5),
                    d = e.next_out,
                    h = e.output,
                    f = d - (A - e.avail_out),
                    _ = d + (e.avail_out - 257),
                    p = s.dmax,
                    v = s.wsize,
                    y = s.whave,
                    m = s.wnext,
                    g = s.window,
                    E = s.hold,
                    k = s.bits,
                    R = s.lencode,
                    C = s.distcode,
                    I = (1 << s.lenbits) - 1,
                    w = (1 << s.distbits) - 1;

                t: do {
                  k < 15 && (E += u[c++] << k, k += 8, E += u[c++] << k, k += 8), t = R[E & I];

                  n: for (;;) {
                    if (E >>>= n = t >>> 24, k -= n, 0 === (n = t >>> 16 & 255)) h[d++] = 65535 & t;else {
                      if (!(16 & n)) {
                        if (0 == (64 & n)) {
                          t = R[(65535 & t) + (E & (1 << n) - 1)];
                          continue n;
                        }

                        if (32 & n) {
                          s.mode = 12;
                          break t;
                        }

                        e.msg = "invalid literal/length code", s.mode = 30;
                        break t;
                      }

                      r = 65535 & t, (n &= 15) && (k < n && (E += u[c++] << k, k += 8), r += E & (1 << n) - 1, E >>>= n, k -= n), k < 15 && (E += u[c++] << k, k += 8, E += u[c++] << k, k += 8), t = C[E & w];

                      r: for (;;) {
                        if (E >>>= n = t >>> 24, k -= n, !(16 & (n = t >>> 16 & 255))) {
                          if (0 == (64 & n)) {
                            t = C[(65535 & t) + (E & (1 << n) - 1)];
                            continue r;
                          }

                          e.msg = "invalid distance code", s.mode = 30;
                          break t;
                        }

                        if (i = 65535 & t, k < (n &= 15) && (E += u[c++] << k, (k += 8) < n && (E += u[c++] << k, k += 8)), p < (i += E & (1 << n) - 1)) {
                          e.msg = "invalid distance too far back", s.mode = 30;
                          break t;
                        }

                        if (E >>>= n, k -= n, (n = d - f) < i) {
                          if (n = i - n, y < n && s.sane) {
                            e.msg = "invalid distance too far back", s.mode = 30;
                            break t;
                          }

                          if (o = g, (a = 0) === m) {
                            if (a += v - n, n < r) {
                              for (r -= n; h[d++] = g[a++], --n;) {
                                ;
                              }

                              a = d - i, o = h;
                            }
                          } else if (m < n) {
                            if (a += v + m - n, (n -= m) < r) {
                              for (r -= n; h[d++] = g[a++], --n;) {
                                ;
                              }

                              if (a = 0, m < r) {
                                for (n = m, r -= n; h[d++] = g[a++], --n;) {
                                  ;
                                }

                                a = d - i, o = h;
                              }
                            }
                          } else if (a += m - n, n < r) {
                            for (r -= n; h[d++] = g[a++], --n;) {
                              ;
                            }

                            a = d - i, o = h;
                          }

                          for (; 2 < r;) {
                            h[d++] = o[a++], h[d++] = o[a++], h[d++] = o[a++], r -= 3;
                          }

                          r && (h[d++] = o[a++], 1 < r && (h[d++] = o[a++]));
                        } else {
                          for (a = d - i; h[d++] = h[a++], h[d++] = h[a++], h[d++] = h[a++], r -= 3, 2 < r;) {
                            ;
                          }

                          r && (h[d++] = h[a++], 1 < r && (h[d++] = h[a++]));
                        }

                        break;
                      }
                    }
                    break;
                  }
                } while (c < l && d < _);

                c -= r = k >> 3, E &= (1 << (k -= r << 3)) - 1, e.next_in = c, e.next_out = d, e.avail_in = c < l ? l - c + 5 : 5 - (c - l), e.avail_out = d < _ ? _ - d + 257 : 257 - (d - _), s.hold = E, s.bits = k;
              }(e), o = e.next_out, i = e.output, c = e.avail_out, a = e.next_in, r = e.input, s = e.avail_in, u = n.hold, l = n.bits, 12 === n.mode && (n.back = -1);
              break;
            }

            for (n.back = 0; v = (w = n.lencode[u & (1 << n.lenbits) - 1]) >>> 16 & 255, y = 65535 & w, !((p = w >>> 24) <= l);) {
              if (0 === s) break e;
              s--, u += r[a++] << l, l += 8;
            }

            if (v && 0 == (240 & v)) {
              for (m = p, g = v, E = y; v = (w = n.lencode[E + ((u & (1 << m + g) - 1) >> m)]) >>> 16 & 255, y = 65535 & w, !(m + (p = w >>> 24) <= l);) {
                if (0 === s) break e;
                s--, u += r[a++] << l, l += 8;
              }

              u >>>= m, l -= m, n.back += m;
            }

            if (u >>>= p, l -= p, n.back += p, n.length = y, 0 === v) {
              n.mode = 26;
              break;
            }

            if (32 & v) {
              n.back = -1, n.mode = 12;
              break;
            }

            if (64 & v) {
              e.msg = "invalid literal/length code", n.mode = 30;
              break;
            }

            n.extra = 15 & v, n.mode = 22;

          case 22:
            if (n.extra) {
              for (I = n.extra; l < I;) {
                if (0 === s) break e;
                s--, u += r[a++] << l, l += 8;
              }

              n.length += u & (1 << n.extra) - 1, u >>>= n.extra, l -= n.extra, n.back += n.extra;
            }

            n.was = n.length, n.mode = 23;

          case 23:
            for (; v = (w = n.distcode[u & (1 << n.distbits) - 1]) >>> 16 & 255, y = 65535 & w, !((p = w >>> 24) <= l);) {
              if (0 === s) break e;
              s--, u += r[a++] << l, l += 8;
            }

            if (0 == (240 & v)) {
              for (m = p, g = v, E = y; v = (w = n.distcode[E + ((u & (1 << m + g) - 1) >> m)]) >>> 16 & 255, y = 65535 & w, !(m + (p = w >>> 24) <= l);) {
                if (0 === s) break e;
                s--, u += r[a++] << l, l += 8;
              }

              u >>>= m, l -= m, n.back += m;
            }

            if (u >>>= p, l -= p, n.back += p, 64 & v) {
              e.msg = "invalid distance code", n.mode = 30;
              break;
            }

            n.offset = y, n.extra = 15 & v, n.mode = 24;

          case 24:
            if (n.extra) {
              for (I = n.extra; l < I;) {
                if (0 === s) break e;
                s--, u += r[a++] << l, l += 8;
              }

              n.offset += u & (1 << n.extra) - 1, u >>>= n.extra, l -= n.extra, n.back += n.extra;
            }

            if (n.offset > n.dmax) {
              e.msg = "invalid distance too far back", n.mode = 30;
              break;
            }

            n.mode = 25;

          case 25:
            if (0 === c) break e;

            if (h = A - c, n.offset > h) {
              if (h = n.offset - h, h > n.whave && n.sane) {
                e.msg = "invalid distance too far back", n.mode = 30;
                break;
              }

              f = h > n.wnext ? (h -= n.wnext, n.wsize - h) : n.wnext - h, h > n.length && (h = n.length), _ = n.window;
            } else _ = i, f = o - n.offset, h = n.length;

            for (c < h && (h = c), c -= h, n.length -= h; i[o++] = _[f++], --h;) {
              ;
            }

            0 === n.length && (n.mode = 21);
            break;

          case 26:
            if (0 === c) break e;
            i[o++] = n.length, c--, n.mode = 21;
            break;

          case 27:
            if (n.wrap) {
              for (; l < 32;) {
                if (0 === s) break e;
                s--, u |= r[a++] << l, l += 8;
              }

              if (A -= c, e.total_out += A, n.total += A, A && (e.adler = n.check = (n.flags ? Nl : bl)(n.check, i, A, o - A)), A = c, (n.flags ? u : Wd(u)) !== n.check) {
                e.msg = "incorrect data check", n.mode = 30;
                break;
              }

              l = u = 0;
            }

            n.mode = 28;

          case 28:
            if (n.wrap && n.flags) {
              for (; l < 32;) {
                if (0 === s) break e;
                s--, u += r[a++] << l, l += 8;
              }

              if (u !== (4294967295 & n.total)) {
                e.msg = "incorrect length check", n.mode = 30;
                break;
              }

              l = u = 0;
            }

            n.mode = 29;

          case 29:
            R = 1;
            break e;

          case 30:
            R = -3;
            break e;

          case 31:
            return -4;

          case 32:
          default:
            return jd;
        }
      }

      return e.next_out = o, e.avail_out = c, e.next_in = a, e.avail_in = s, n.hold = u, n.bits = l, (n.wsize || A !== e.avail_out && n.mode < 30 && (n.mode < 27 || 4 !== t)) && th(e, e.output, e.next_out, A - e.avail_out), d -= e.avail_in, A -= e.avail_out, e.total_in += d, e.total_out += A, n.total += A, n.wrap && A && (e.adler = n.check = (n.flags ? Nl : bl)(n.check, i, A, e.next_out - A)), e.data_type = n.bits + (n.last ? 64 : 0) + (12 === n.mode ? 128 : 0) + (20 === n.mode || 15 === n.mode ? 256 : 0), (0 == d && 0 === A || 4 === t) && R === Bd && (R = -5), R;
    },
    inflateEnd: function inflateEnd(e) {
      if (!e || !e.state) return jd;
      var t = e.state;
      return t.window && (t.window = null), e.state = null, Bd;
    },
    inflateGetHeader: function inflateGetHeader(e, t) {
      return !e || !e.state || 0 == (2 & (e = e.state).wrap) ? jd : ((e.head = t).done = !1, Bd);
    },
    inflateSetDictionary: function inflateSetDictionary(e, t) {
      var n,
          r = t.length;
      return !e || !e.state || 0 !== (n = e.state).wrap && 11 !== n.mode ? jd : 11 === n.mode && bl(1, t, r, 0) !== n.check ? -3 : th(e, t, r, r) ? (n.mode = 31, -4) : (n.havedict = 1, Bd);
    },
    inflateInfo: "pako inflate (from Nodeca project)"
  },
      rh = {
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_BUF_ERROR: -5,
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    Z_BINARY: 0,
    Z_TEXT: 1,
    Z_UNKNOWN: 2,
    Z_DEFLATED: 8
  };

  var ih = function ih() {
    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
  },
      ah = Object.prototype.toString;

  function oh(e) {
    if (!(this instanceof oh)) return new oh(e);
    this.options = Lu.assign({
      chunkSize: 16384,
      windowBits: 0,
      to: ""
    }, e || {});
    var t = this.options;
    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new Ad(), this.strm.avail_out = 0;
    e = nh.inflateInit2(this.strm, t.windowBits);
    if (e !== rh.Z_OK) throw new Error(Ll[e]);
    if (this.header = new ih(), nh.inflateGetHeader(this.strm, this.header), t.dictionary && ("string" == typeof t.dictionary ? t.dictionary = wd.string2buf(t.dictionary) : "[object ArrayBuffer]" === ah.call(t.dictionary) && (t.dictionary = new Uint8Array(t.dictionary)), t.raw && (e = nh.inflateSetDictionary(this.strm, t.dictionary)) !== rh.Z_OK)) throw new Error(Ll[e]);
  }

  function sh(e, t) {
    t = new oh(t);
    if (t.push(e, !0), t.err) throw t.msg || Ll[t.err];
    return t.result;
  }

  oh.prototype.push = function (e, t) {
    var n,
        r,
        i,
        a,
        o,
        s = this.strm,
        c = this.options.chunkSize,
        u = this.options.dictionary,
        l = !1;
    if (this.ended) return !1;
    r = t === ~~t ? t : !0 === t ? rh.Z_FINISH : rh.Z_NO_FLUSH, "string" == typeof e ? s.input = wd.binstring2buf(e) : "[object ArrayBuffer]" === ah.call(e) ? s.input = new Uint8Array(e) : s.input = e, s.next_in = 0, s.avail_in = s.input.length;

    do {
      if (0 === s.avail_out && (s.output = new Lu.Buf8(c), s.next_out = 0, s.avail_out = c), (n = nh.inflate(s, rh.Z_NO_FLUSH)) === rh.Z_NEED_DICT && u && (n = nh.inflateSetDictionary(this.strm, u)), n === rh.Z_BUF_ERROR && !0 === l && (n = rh.Z_OK, l = !1), n !== rh.Z_STREAM_END && n !== rh.Z_OK) return this.onEnd(n), !(this.ended = !0);
    } while ((s.next_out && (0 !== s.avail_out && n !== rh.Z_STREAM_END && (0 !== s.avail_in || r !== rh.Z_FINISH && r !== rh.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = wd.utf8border(s.output, s.next_out), a = s.next_out - i, o = wd.buf2string(s.output, i), s.next_out = a, s.avail_out = c - a, a && Lu.arraySet(s.output, s.output, i, a, 0), this.onData(o)) : this.onData(Lu.shrinkBuf(s.output, s.next_out)))), 0 === s.avail_in && 0 === s.avail_out && (l = !0), (0 < s.avail_in || 0 === s.avail_out) && n !== rh.Z_STREAM_END));

    return n === rh.Z_STREAM_END && (r = rh.Z_FINISH), r === rh.Z_FINISH ? (n = nh.inflateEnd(this.strm), this.onEnd(n), this.ended = !0, n === rh.Z_OK) : r !== rh.Z_SYNC_FLUSH || (this.onEnd(rh.Z_OK), !(s.avail_out = 0));
  }, oh.prototype.onData = function (e) {
    this.chunks.push(e);
  }, oh.prototype.onEnd = function (e) {
    e === rh.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = Lu.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
  };
  a = {
    Inflate: oh,
    inflate: sh,
    inflateRaw: function inflateRaw(e, t) {
      return (t = t || {}).raw = !0, sh(e, t);
    },
    ungzip: sh
  }, e = {};
  (0, Lu.assign)(e, $, a, rh);

  var ch,
      uh = e.gzip,
      lh = e.ungzip,
      dh = function () {
    function e() {
      Un(this, e);
    }

    return Fn(e, null, [{
      key: "encode",
      value: function value(e) {
        return btoa(e);
      }
    }, {
      key: "decode",
      value: function value(e) {
        return atob(e);
      }
    }]), e;
  }(),
      hh = function () {
    function e() {
      Un(this, e);
    }

    return Fn(e, null, [{
      key: "compress",
      value: function value(e) {
        e = uh(e, {
          to: "string"
        });
        return dh.encode(e);
      }
    }, {
      key: "decompress",
      value: function value(e) {
        e = dh.decode(e);
        return lh(e, {
          to: "string"
        });
      }
    }]), e;
  }(),
      fh = function () {
    qn(a, Eu);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.ANSWER), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id,
          peerConnectionId: e.peer_connection_id,
          sdp: hh.decompress(e.sdp)
        };
      }
    }]), a;
  }(),
      _h = function () {
    qn(a, Eu);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.AUDIO), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id,
          isEnabled: e.is_enabled
        };
      }
    }]), a;
  }(),
      ph = function () {
    qn(a, Eu);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.CANDIDATE), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id,
          peerConnectionId: e.peer_connection_id,
          candidate: {
            sdpMLineIndex: e.candidate.sdp_mline_index,
            sdpMid: e.candidate.sdp_mid,
            sdp: e.candidate.sdp
          }
        };
      }
    }]), a;
  }(),
      vh = function () {
    qn(a, Eu);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.CUSTOM_ITEMS_DELETE), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id,
          deleted: e.deleted,
          customItems: e.custom_items
        };
      }
    }]), a;
  }(),
      yh = function e(t) {
    Un(this, e), this.userId = t.user_id, this.nickname = t.nickname, this.profileUrl = t.profile_url, this.metaData = t.meta_data, this.isActive = t.is_active, this.role = t.role;
  },
      mh = function () {
    qn(a, Eu);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.DIAL), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          isVideoCall: e.is_video_call,
          callId: e.call_id,
          caller: new yh(e.caller),
          callee: new yh(e.callee),
          turnCredential: {
            username: e.turn_credential.username,
            password: e.turn_credential.password,
            turnUrls: e.turn_credential.turn_urls,
            transportPolicy: e.turn_credential.transport_policy
          },
          constraints: {
            audio: e.constraints.audio,
            video: e.constraints.video
          },
          customItems: e.custom_items,
          shortLivedToken: e.sbcall_short_lived_token,
          capabilities: e.capabilities || []
        };
      }
    }]), a;
  }(),
      gh = function () {
    qn(a, Eu);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.DIAL_RCV), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id,
          calleeDeliveryInfo: e.callee_delivery_info,
          receivedType: e.received_type
        };
      }
    }]), a;
  }(),
      Eh = function () {
    function n(t) {
      var e = 1 < arguments.length && void 0 !== arguments[1] && arguments[1];
      Un(this, n), this.callId = t.call_id, this.isVideoCall = t.is_video_call, this._customItems = t.custom_items, this.userRole = t.user_role, this.startedAt = t.started_at, this.endedAt = t.ended_at, this._participants = t.participants.map(function (e) {
        return new yh(e);
      }), this.endedBy = this._participants.find(function (e) {
        return e.userId === t.ended_by;
      }), this.duration = t.duration, this.endResult = t.end_result, this.callType = t.call_type, this._isFromServer = e;
    }

    return Fn(n, [{
      key: "caller",
      get: function get() {
        return this._participants.find(function (e) {
          return e.role === da.CALLER;
        });
      }
    }, {
      key: "callee",
      get: function get() {
        return this._participants.find(function (e) {
          return e.role === da.CALLEE;
        });
      }
    }, {
      key: "customItems",
      get: function get() {
        return jn({}, this._customItems);
      }
    }, {
      key: "isFromServer",
      get: function get() {
        return this._isFromServer;
      }
    }]), n;
  }(),
      kh = function () {
    qn(t, Eu);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id,
          endedCall: new Eh(e.ended_call)
        };
      }
    }]), t;
  }(),
      Rh = function () {
    qn(a, Eu);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.HOLD), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id,
          holdedBy: e.holded_by,
          isPeerOnHold: e.is_peer_on_hold,
          isRelayed: e.is_relayed
        };
      }
    }]), a;
  }(),
      Ch = function () {
    qn(a, Eu);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.OFFER), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id,
          peerConnectionId: e.peer_connection_id,
          sdp: hh.decompress(e.sdp)
        };
      }
    }]), a;
  }(),
      Ih = function () {
    qn(a, Eu);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.RECORDING), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id,
          recordingId: e.recording_id,
          recordingType: e.recording_type,
          recordingStatus: e.recording_status
        };
      }
    }]), a;
  }(),
      wh = function () {
    qn(a, Eu);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.REMOVE_CANDIDATES), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id,
          candidates: e.candidates.map(function (e) {
            return {
              sdpMLineIndex: e.sdp_mline_index,
              sdpMid: e.sdp_mid,
              candidate: e.sdp
            };
          })
        };
      }
    }]), a;
  }(),
      Ah = function () {
    qn(a, Eu);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.CUSTOM_ITEMS_UPDATE), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id,
          updated: e.updated,
          customItems: e.custom_items
        };
      }
    }]), a;
  }(),
      Th = function () {
    qn(a, Eu);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.VIDEO), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id,
          isEnabled: e.is_enabled
        };
      }
    }]), a;
  }(),
      Sh = ["turn_changed"],
      bh = function () {
    qn(i, yu);
    var r = Xn(i);

    function i(e, t) {
      var n;
      return Un(this, i), (n = r.call(this)).callId = e, n.constraints = t, n.capabilities = Sh, n;
    }

    return Fn(i, [{
      key: "requireResponse",
      value: function value() {
        return !0;
      }
    }, {
      key: "getCMD",
      value: function value() {
        return nu.CALL;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.ACCEPT;
      }
    }, {
      key: "getData",
      value: function value() {
        return {
          call_id: this.callId,
          constraints: {
            audio: this.constraints.audio,
            video: this.constraints.video
          },
          capabilities: this.capabilities
        };
      }
    }]), i;
  }(),
      Oh = function () {
    qn(r, yu);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this)).callId = e, t;
    }

    return Fn(r, [{
      key: "getCMD",
      value: function value() {
        return nu.SGNL;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.ALIVE;
      }
    }, {
      key: "getData",
      value: function value() {
        return {
          call_id: this.callId
        };
      }
    }]), r;
  }(),
      Dh = function () {
    qn(a, yu);
    var i = Xn(a);

    function a(e, t, n) {
      var r;
      return Un(this, a), (r = i.call(this)).callId = e, r.peerConnectionId = t, r.sdp = n, r;
    }

    return Fn(a, [{
      key: "getCMD",
      value: function value() {
        return nu.SGNL;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.ANSWER;
      }
    }, {
      key: "getData",
      value: function value() {
        var e = {
          call_id: this.callId,
          sdp: hh.compress(this.sdp)
        };
        return this.peerConnectionId ? jn(jn({}, e), {}, {
          peer_connection_id: this.peerConnectionId
        }) : e;
      }
    }]), a;
  }(),
      Nh = function () {
    qn(i, yu);
    var r = Xn(i);

    function i(e, t) {
      var n;
      return Un(this, i), (n = r.call(this)).callId = e, n.isEnabled = t, n;
    }

    return Fn(i, [{
      key: "getCMD",
      value: function value() {
        return nu.COMM;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.AUDIO;
      }
    }, {
      key: "getData",
      value: function value() {
        return {
          call_id: this.callId,
          is_enabled: this.isEnabled
        };
      }
    }]), i;
  }(),
      Lh = function () {
    qn(r, yu);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this)).callId = e, t;
    }

    return Fn(r, [{
      key: "requireResponse",
      value: function value() {
        return !0;
      }
    }, {
      key: "getCMD",
      value: function value() {
        return nu.CALL;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.CANCEL;
      }
    }, {
      key: "getData",
      value: function value() {
        return {
          call_id: this.callId
        };
      }
    }]), r;
  }(),
      xh = function () {
    qn(s, yu);
    var o = Xn(s);

    function s(e, t, n, r, i) {
      var a;
      return Un(this, s), Gn(Qn(a = o.call(this)), "type", vu.CANDIDATE), a.callId = e, a.peerConnectionId = t, a.sdp = n, a.sdpMLineIndex = r, a.sdpMid = i, a;
    }

    return Fn(s, [{
      key: "getCMD",
      value: function value() {
        return nu.SGNL;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.CANDIDATE;
      }
    }, {
      key: "getData",
      value: function value() {
        var e = {
          call_id: this.callId,
          candidate: {
            sdp: this.sdp,
            sdp_mline_index: this.sdpMLineIndex,
            sdp_mid: this.sdpMid
          }
        };
        return this.peerConnectionId ? jn(jn({}, e), {}, {
          peer_connection_id: this.peerConnectionId
        }) : e;
      }
    }]), s;
  }(),
      Ph = function () {
    qn(a, yu);
    var i = Xn(a);

    function a(e, t, n) {
      var r;
      return Un(this, a), (r = i.call(this)).callId = e, r.reconnect = n, r.connectionType = t.connectionType, r.relayProtocol = t.relayProtocol, r.protocol = t.protocol, r;
    }

    return Fn(a, [{
      key: "getCMD",
      value: function value() {
        return nu.SGNL;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.CONNECTED;
      }
    }, {
      key: "getData",
      value: function value() {
        return {
          call_id: this.callId,
          connection: {
            connection_type: this.connectionType,
            relay_protocol: this.relayProtocol,
            protocol: this.protocol
          },
          reconnect: this.reconnect
        };
      }
    }]), a;
  }(),
      Mh = function () {
    qn(r, yu);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this)).callId = e, t;
    }

    return Fn(r, [{
      key: "requireResponse",
      value: function value() {
        return !0;
      }
    }, {
      key: "getCMD",
      value: function value() {
        return nu.CALL;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.CONNECTION_LOST;
      }
    }, {
      key: "getData",
      value: function value() {
        return {
          call_id: this.callId
        };
      }
    }]), r;
  }(),
      Uh = function () {
    qn(r, yu);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this)).callId = e, t;
    }

    return Fn(r, [{
      key: "requireResponse",
      value: function value() {
        return !0;
      }
    }, {
      key: "getCMD",
      value: function value() {
        return nu.CALL;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.DECLINE;
      }
    }, {
      key: "getData",
      value: function value() {
        return {
          call_id: this.callId
        };
      }
    }]), r;
  }(),
      Vh = function () {
    qn(s, yu);
    var o = Xn(s);

    function s(e, t, n, r, i) {
      var a;
      return Un(this, s), (a = o.call(this)).calleeId = e, a.isVideoCall = t, a.customItems = n, a.sendBirdChatOptions = r, a.constraints = i, a.capabilities = Sh, a;
    }

    return Fn(s, [{
      key: "requireResponse",
      value: function value() {
        return !0;
      }
    }, {
      key: "getCMD",
      value: function value() {
        return nu.CALL;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.DIAL;
      }
    }, {
      key: "getData",
      value: function value() {
        var e;
        return {
          callee_id: this.calleeId,
          is_video_call: this.isVideoCall,
          custom_items: this.customItems,
          sb_chat: {
            channel_url: null === (e = this.sendBirdChatOptions) || void 0 === e ? void 0 : e.channelUrl
          },
          constraints: {
            audio: this.constraints.audio,
            video: this.constraints.video
          },
          capabilities: this.capabilities
        };
      }
    }]), s;
  }(),
      Fh = function () {
    qn(o, yu);
    var a = Xn(o);

    function o(e, t, n, r) {
      var i;
      return Un(this, o), (i = a.call(this)).callId = e, i.calleeDeliveryInfo = t, i.receivedType = n, i.shortLivedToken = r, i;
    }

    return Fn(o, [{
      key: "getHeaders",
      value: function value() {
        return {
          "SBCall-Short-Lived-Token": this.shortLivedToken
        };
      }
    }, {
      key: "getData",
      value: function value() {
        return {
          call_id: this.callId,
          callee_delivery_info: this.calleeDeliveryInfo,
          received_type: this.receivedType
        };
      }
    }, {
      key: "getCMD",
      value: function value() {
        return nu.CALL;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.DIAL_RCV;
      }
    }, {
      key: "sendStrategy",
      get: function get() {
        return ru.API;
      }
    }]), o;
  }(),
      Gh = function () {
    qn(r, yu);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this)).callId = e, t;
    }

    return Fn(r, [{
      key: "requireResponse",
      value: function value() {
        return !0;
      }
    }, {
      key: "getCMD",
      value: function value() {
        return nu.CALL;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.END;
      }
    }, {
      key: "getData",
      value: function value() {
        return {
          call_id: this.callId
        };
      }
    }]), r;
  }(),
      Bh = function () {
    qn(a, yu);
    var i = Xn(a);

    function a(e, t, n) {
      var r;
      return Un(this, a), (r = i.call(this)).callId = e, r.isOnHold = t, r.wasRelayed = n, r;
    }

    return Fn(a, [{
      key: "requireResponse",
      value: function value() {
        return !0;
      }
    }, {
      key: "getCMD",
      value: function value() {
        return nu.CALL;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.HOLD;
      }
    }, {
      key: "getData",
      value: function value() {
        return {
          call_id: this.callId,
          is_on_hold: this.isOnHold,
          was_relayed: this.wasRelayed
        };
      }
    }]), a;
  }(),
      jh = function () {
    qn(r, yu);
    var n = Xn(r);

    function r(e) {
      var t;
      return Un(this, r), (t = n.call(this)).callId = e, t;
    }

    return Fn(r, [{
      key: "requireResponse",
      value: function value() {
        return !0;
      }
    }, {
      key: "getCMD",
      value: function value() {
        return nu.CALL;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.NO_ANSWER;
      }
    }, {
      key: "getData",
      value: function value() {
        return {
          call_id: this.callId
        };
      }
    }]), r;
  }(),
      qh = function () {
    qn(a, yu);
    var i = Xn(a);

    function a(e, t, n) {
      var r;
      return Un(this, a), (r = i.call(this)).callId = e, r.peerConnectionId = t, r.sdp = n, r;
    }

    return Fn(a, [{
      key: "getCMD",
      value: function value() {
        return nu.SGNL;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.OFFER;
      }
    }, {
      key: "getData",
      value: function value() {
        var e = {
          call_id: this.callId,
          sdp: hh.compress(this.sdp)
        };
        return this.peerConnectionId ? jn(jn({}, e), {}, {
          peer_connection_id: this.peerConnectionId
        }) : e;
      }
    }]), a;
  }(),
      Hh = function () {
    qn(o, yu);
    var a = Xn(o);

    function o(e, t, n, r) {
      var i;
      return Un(this, o), (i = a.call(this)).callId = e, i.recordingId = t, i.recordingType = n, i.recordingStatus = r, i;
    }

    return Fn(o, [{
      key: "getCMD",
      value: function value() {
        return nu.COMM;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.RECORDING;
      }
    }, {
      key: "getData",
      value: function value() {
        return {
          call_id: this.callId,
          recording_id: this.recordingId,
          recording_type: this.recordingType,
          recording_status: this.recordingStatus
        };
      }
    }]), o;
  }(),
      zh = function () {
    qn(i, yu);
    var r = Xn(i);

    function i(e, t) {
      var n;
      return Un(this, i), (n = r.call(this)).callId = e, n.reason = t, n;
    }

    return Fn(i, [{
      key: "requireResponse",
      value: function value() {
        return !0;
      }
    }, {
      key: "getCMD",
      value: function value() {
        return nu.CALL;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.TIME_OUT;
      }
    }, {
      key: "getData",
      value: function value() {
        return {
          call_id: this.callId,
          reason: this.reason
        };
      }
    }]), i;
  }(),
      Wh = function () {
    qn(i, yu);
    var r = Xn(i);

    function i(e, t) {
      var n;
      return Un(this, i), (n = r.call(this)).callId = e, n.isEnabled = t, n;
    }

    return Fn(i, [{
      key: "getCMD",
      value: function value() {
        return nu.COMM;
      }
    }, {
      key: "getType",
      value: function value() {
        return vu.VIDEO;
      }
    }, {
      key: "getData",
      value: function value() {
        return {
          call_id: this.callId,
          is_enabled: this.isEnabled
        };
      }
    }]), i;
  }(),
      Kh = function () {
    qn(a, ku);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.ACCEPT_ACK), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id
        };
      }
    }]), a;
  }(),
      Yh = function () {
    qn(a, ku);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.ALIVE_ACK), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id,
          alive_at: e.alive_at
        };
      }
    }]), a;
  }(),
      Zh = function () {
    qn(a, ku);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.DIAL_ACK), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          isVideoCall: e.is_video_call,
          callId: e.call_id,
          caller: new yh(e.caller),
          callee: new yh(e.callee)
        };
      }
    }]), a;
  }(),
      Qh = function () {
    qn(t, ku);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id,
          endedCall: new Eh(e.ended_call)
        };
      }
    }]), t;
  }(),
      Xh = function () {
    qn(a, ku);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.HOLD_ACK), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id,
          holdedBy: e.holded_by,
          isRelayed: e.is_relayed
        };
      }
    }]), a;
  }(),
      $h = function () {
    qn(a, Cu);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", vu.TURN_CHANGED), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          callId: e.call_id,
          turnCredential: {
            username: e.turn_credential.username,
            password: e.turn_credential.password,
            turnUrls: e.turn_credential.turn_urls,
            transportPolicy: e.turn_credential.transport_policy
          },
          eventId: e.event_id
        };
      }
    }]), a;
  }(),
      Jh = function () {
    qn(t, Ru);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return t;
  }();

  (ch = ch || {}).LOG = "log";

  var ef,
      tf = function () {
    qn(a, Jh);
    var i = Xn(a);

    function a() {
      var e;
      Un(this, a);

      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
        n[r] = arguments[r];
      }

      return Gn(Qn(e = i.call.apply(i, [this].concat(n))), "type", ch.LOG), e;
    }

    return Fn(a, [{
      key: "parseData",
      value: function value(e) {
        return {
          logLevel: e.log_level.toUpperCase()
        };
      }
    }]), a;
  }(),
      nf = function () {
    qn(t, mu);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return t;
  }();

  (ef = ef || {}).CONNECTED = "websocket_connected";

  function rf(e) {
    var t,
        n,
        r,
        i,
        a,
        o,
        s = ce(e),
        c = "function" == typeof this ? this : Array,
        u = arguments.length,
        l = 1 < u ? arguments[1] : void 0,
        d = void 0 !== l,
        e = Ot(s),
        h = 0;
    if (d && (l = se(l, 2 < u ? arguments[2] : void 0, 2)), null == e || c == Array && wt(e)) for (n = new c(t = ne(s.length)); h < t; h++) {
      o = d ? l(s[h], h) : s[h], _r(n, h, o);
    } else for (a = (i = e.call(s)).next, n = new c(); !(r = a.call(i)).done; h++) {
      o = d ? function (t, e, n, r) {
        try {
          return r ? e(w(n)[0], n[1]) : e(n);
        } catch (e) {
          throw Dt(t), e;
        }
      }(i, l, [r.value, h], !0) : r.value, _r(n, h, o);
    }
    return n.length = h, n;
  }

  var af = function () {
    qn(t, nf);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.call(this, {
        type: ef.CONNECTED
      });
    }

    return t;
  }(),
      of = function () {
    function e() {
      Un(this, e);
    }

    return Fn(e, null, [{
      key: "createAuthRequest",
      value: function value(e, t, n) {
        return new lu(e, t, n);
      }
    }, {
      key: "createDial",
      value: function value(e, t, n, r, i) {
        return new Vh(e, t, n, r, i);
      }
    }, {
      key: "createDialReceive",
      value: function value(e, t, n, r) {
        return new Fh(e, t, n, r);
      }
    }, {
      key: "createAccept",
      value: function value(e, t) {
        return new bh(e, t);
      }
    }, {
      key: "createDecline",
      value: function value(e) {
        return new Uh(e);
      }
    }, {
      key: "createCancel",
      value: function value(e) {
        return new Lh(e);
      }
    }, {
      key: "createEnd",
      value: function value(e) {
        return new Gh(e);
      }
    }, {
      key: "createTimeout",
      value: function value(e, t) {
        return new zh(e, t);
      }
    }, {
      key: "createConnectionLost",
      value: function value(e) {
        return new Mh(e);
      }
    }, {
      key: "createNoAnswer",
      value: function value(e) {
        return new jh(e);
      }
    }, {
      key: "createOffer",
      value: function value(e, t, n) {
        return new qh(e, t, n);
      }
    }, {
      key: "createAnswer",
      value: function value(e, t, n) {
        return new Dh(e, t, n);
      }
    }, {
      key: "createCandidate",
      value: function value(e, t, n, r, i) {
        return new xh(e, t, n, r, i);
      }
    }, {
      key: "createAudio",
      value: function value(e, t) {
        return new Nh(e, t);
      }
    }, {
      key: "createVideo",
      value: function value(e, t) {
        return new Wh(e, t);
      }
    }, {
      key: "createAlive",
      value: function value(e) {
        return new Oh(e);
      }
    }, {
      key: "createConnected",
      value: function value(e, t, n) {
        return new Ph(e, t, n);
      }
    }, {
      key: "createStatsLogCommand",
      value: function value(e) {
        return new cu(e);
      }
    }, {
      key: "createCallSummaryCommand",
      value: function value(e, t, n) {
        return new Su(e, t, n);
      }
    }, {
      key: "createUpdateCustomItems",
      value: function value(e, t) {
        return new Tu(e, t);
      }
    }, {
      key: "createDeleteCustomItems",
      value: function value(e, t) {
        return new Au(e, t);
      }
    }, {
      key: "createDeleteAllCustomItems",
      value: function value(e) {
        return new wu(e);
      }
    }, {
      key: "createRecording",
      value: function value(e, t, n, r) {
        return new Hh(e, t, n, r);
      }
    }, {
      key: "createHoldCommand",
      value: function value(e, t, n) {
        return new Bh(e, t, n);
      }
    }, {
      key: "createCommandList",
      value: function value(e) {
        return new Iu(e);
      }
    }, {
      key: "createUploadLogsCommand",
      value: function value(e, t) {
        return new uu(e, t);
      }
    }, {
      key: "createRegisterPushToken",
      value: function value(e, t, n) {
        return new hu(e, t, n);
      }
    }, {
      key: "createUnregisterPushToken",
      value: function value(e, t, n) {
        return new fu(e, t, n);
      }
    }, {
      key: "createUnregisterAllPushTokens",
      value: function value(e, t) {
        return new _u(e, t);
      }
    }, {
      key: "createAccepted",
      value: function value(e) {
        return new Nu({
          type: "other_device_accepted",
          payload: {
            call_id: e
          }
        });
      }
    }, {
      key: "createDeclined",
      value: function value(e, t) {
        return new bu({
          callId: e,
          endedCall: t
        });
      }
    }, {
      key: "createWebSocketConnectedCommand",
      value: function value() {
        return new af();
      }
    }, {
      key: "createSnapshot",
      value: function value(e, t) {
        return new Ou(jn({
          callId: e
        }, t));
      }
    }, {
      key: "parse",
      value: function value(e) {
        try {
          switch (e.type) {
            case vu.DIAL_ACK:
              return new Zh(e);

            case vu.DIAL:
              return new mh(e);

            case vu.DIAL_RCV:
              return new gh(e);

            case vu.NO_ANSWER_ACK:
              return new Qh(e);

            case vu.NO_ANSWER:
              return new kh(e);

            case vu.CANCEL_ACK:
              return new Qh(e);

            case vu.CANCEL:
              return new kh(e);

            case vu.ACCEPT_ACK:
              return new Kh(e);

            case vu.ACCEPT:
              return new Du(e);

            case vu.OTHER_DEVICE_ACCEPTED:
              return new Nu(e);

            case vu.DECLINE_ACK:
              return new Qh(e);

            case vu.DECLINE:
              return new kh(e);

            case vu.OFFER:
              return new Ch(e);

            case vu.ANSWER:
              return new fh(e);

            case vu.CANDIDATE:
              return new ph(e);

            case vu.REMOVE_CANDIDATES:
              return new wh(e);

            case vu.AUDIO:
              return new _h(e);

            case vu.VIDEO:
              return new Th(e);

            case vu.HOLD:
              return new Rh(e);

            case vu.HOLD_ACK:
              return new Xh(e);

            case vu.END_ACK:
              return new Qh(e);

            case vu.END:
              return new kh(e);

            case vu.TIMEOUT_ACK:
              return new Qh(e);

            case vu.TIME_OUT:
              return new kh(e);

            case vu.CONNECTION_LOST_ACK:
              return new Qh(e);

            case vu.CONNECTION_LOST:
              return new kh(e);

            case vu.UNKNOWN_END_ACK:
              return new Qh(e);

            case vu.UNKNOWN_END:
              return new kh(e);

            case vu.CUSTOM_ITEMS_UPDATE:
              return new Ah(e);

            case vu.CUSTOM_ITEMS_DELETE:
              return new vh(e);

            case vu.ALIVE_ACK:
              return new Yh(e);

            case vu.RECORDING:
              return new Ih(e);

            case vu.TURN_CHANGED:
              return new $h(e);

            case ch.LOG:
              return new tf(e);

            default:
              throw new Error("unhandled command data. ".concat(JSON.stringify(e)));
          }
        } catch (e) {
          return void _a.error(new ra(Tn.ERR_WRONG_RESPONSE, {
            error: e
          }));
        }
      }
    }]), e;
  }(),
      sf = function () {
    function t(e) {
      Un(this, t), Gn(this, "_isOverflowLogs", !1), Gn(this, "_logs", []), this._ctx = e;
    }

    return Fn(t, [{
      key: "addLog",
      value: function value(e) {
        500 <= this._logs.length && (this._isOverflowLogs = !0, this._logs.shift()), this._logs.push(e);
      }
    }, {
      key: "_flush",
      value: function value(t) {
        var e = this._logs.filter(function (e) {
          return Dr[e.logLevel].level >= Dr[t].level;
        }),
            e = of.createUploadLogsCommand(e, this._isOverflowLogs);

        this._isOverflowLogs = !1, this._logs = [], this._ctx.sender.send(e);
      }
    }, {
      key: "onEvent",
      value: function value(e) {
        e.type === ch.LOG ? this._flush(e.payload.logLevel) : console.error("Cannot reach here");
      }
    }]), t;
  }(),
      D = !Ht(function (e) {
    Array.from(e);
  });

  ae({
    target: "Array",
    stat: !0,
    forced: D
  }, {
    from: rf
  });

  var cf = m.f,
      $ = function $(s) {
    return function (e) {
      for (var t, n = d(e), r = Ke(n), i = r.length, a = 0, o = []; a < i;) {
        t = r[a++], v && !cf.call(n, t) || o.push(s ? [t, n[t]] : n[t]);
      }

      return o;
    };
  },
      a = {
    entries: $(!0),
    values: $(!1)
  },
      uf = a.values;

  ae({
    target: "Object",
    stat: !0
  }, {
    values: function values(e) {
      return uf(e);
    }
  });
  var lf = a.entries;

  function df(e, t) {
    var a = 0,
        o = null;

    if ("number" == typeof e) {
      if (!t) throw new Error("'obj' parameter is required");
      a = e, o = t;
    } else {
      if (!e || t) throw new Error("'obj' parameter is required");
      o = e;
    }

    return function (e) {
      var i = e.descriptor.value;
      return e.descriptor.value = function () {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        var r = t[a];
        if ("object" !== xn(r)) throw new Error("'object' is expected");
        return Object.entries(o).forEach(function (e) {
          var t = Jn(e, 2),
              e = t[0],
              t = t[1];
          !r[e] || r[e] instanceof t || (r[e] = new t(r[e]));
        }), i.call.apply(i, [this].concat(t));
      }, e;
    };
  }

  ae({
    target: "Object",
    stat: !0
  }, {
    entries: function entries(e) {
      return lf(e);
    }
  });

  function hf(e) {
    return e + 22 + 75 * (e < 26);
  }

  function ff(e) {
    var t,
        n = [],
        r = (e = function (e) {
      for (var t = [], n = 0, r = e.length; n < r;) {
        var i,
            a = e.charCodeAt(n++);
        55296 <= a && a <= 56319 && n < r ? 56320 == (64512 & (i = e.charCodeAt(n++))) ? t.push(((1023 & a) << 10) + (1023 & i) + 65536) : (t.push(a), n--) : t.push(a);
      }

      return t;
    }(e)).length,
        i = 128,
        a = 0,
        o = 72;

    for (l = 0; l < e.length; l++) {
      (t = e[l]) < 128 && n.push(Df(t));
    }

    var s = n.length,
        c = s;

    for (s && n.push("-"); c < r;) {
      for (var u = Af, l = 0; l < e.length; l++) {
        i <= (t = e[l]) && t < u && (u = t);
      }

      var d = c + 1;
      if (u - i > Of((Af - a) / d)) throw RangeError(bf);

      for (a += (u - i) * d, i = u, l = 0; l < e.length; l++) {
        if ((t = e[l]) < i && ++a > Af) throw RangeError(bf);

        if (t == i) {
          for (var h = a, f = 36;; f += 36) {
            var _ = f <= o ? 1 : o + 26 <= f ? 26 : f - o;

            if (h < _) break;
            var p = h - _,
                v = 36 - _;
            n.push(Df(hf(_ + p % v))), h = Of(p / v);
          }

          n.push(Df(hf(h))), o = function (e, t, n) {
            var r = 0;

            for (e = n ? Of(e / 700) : e >> 1, e += Of(e / t); 455 < e; r += 36) {
              e = Of(e / 35);
            }

            return Of(r + 36 * e / (e + 38));
          }(a, d, c == s), a = 0, ++c;
        }
      }

      ++a, ++i;
    }

    return n.join("");
  }

  function _f(e) {
    var t = Ot(e);
    if ("function" != typeof t) throw TypeError(String(e) + " is not iterable");
    return w(t.call(e));
  }

  function pf(t) {
    try {
      return decodeURIComponent(t);
    } catch (e) {
      return t;
    }
  }

  function vf(e) {
    var t,
        n = e.replace(Ff, " "),
        r = 4;

    try {
      return decodeURIComponent(n);
    } catch (e) {
      for (; r;) {
        n = n.replace((t = r--, Gf[t - 1] || (Gf[t - 1] = RegExp("((?:%[\\da-f]{2}){" + t + "})", "gi"))), pf);
      }

      return n;
    }
  }

  function yf(e) {
    return jf[e];
  }

  function mf(e) {
    return encodeURIComponent(e).replace(Bf, yf);
  }

  function gf(e, t) {
    if (t) for (var n, r = t.split("&"), i = 0; i < r.length;) {
      (n = r[i++]).length && (n = n.split("="), e.push({
        key: vf(n.shift()),
        value: vf(n.join("="))
      }));
    }
  }

  function Ef(e) {
    this.entries.length = 0, gf(this.entries, e);
  }

  function kf(e, t) {
    if (e < t) throw TypeError("Not enough arguments");
  }

  var e = function () {
    qn(t, Pa);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.call(this);
    }

    return t;
  }(),
      Rf = function () {
    function n(e, t) {
      Un(this, n), Gn(this, "_count", 0), this._ctx = e, this._call = t;
    }

    return Fn(n, [{
      key: "_insertInfo",
      value: function value() {
        var e = this._call;
        Object.assign(this._accumulated, {
          app_id: this._ctx.appId,
          browser_type: ca(),
          call_id: e.callId,
          device_timestamp: new Date().getTime(),
          role: e.myRole,
          caller_id: e.caller.userId,
          callee_id: e.callee.userId,
          is_video_call: e.isVideoCall,
          metadata: {
            measure_count: e.options.statsIntervalValue / 1e3,
            measure_interval: e.options.statsIntervalValue / 1e3
          }
        });
      }
    }, {
      key: "insertStatsLog",
      value: function value(e) {
        var t = this._accumulated;
        this._count += 1;
        t = gs(e, t);
        this._accumulated = Cs(t, this._accumulated, this._count), this._count % (this._interval / 1e3) == 0 && (this._sendStatsLogCommand(this._accumulated), delete this._accumulated, this._count = 0);
      }
    }, {
      key: "_sendStatsLogCommand",
      value: function value(e) {
        this._insertInfo();

        e = of.createStatsLogCommand(e);
        return this._ctx.sender.send(e);
      }
    }, {
      key: "_interval",
      get: function get() {
        return this._call.options.statsIntervalValue;
      }
    }]), n;
  }(),
      Cf = function () {
    function t(e) {
      Un(this, t), Gn(this, "_count", 0), this._call = e, this._init();
    }

    return Fn(t, [{
      key: "_init",
      value: function value() {
        this._reconnectionCount = 0;
      }
    }, {
      key: "insertStatsLog",
      value: function value(e) {
        var t = this._accumulatedStatsLog;
        this._count += 1;
        t = gs(e, t);
        this._accumulatedStatsLog = Cs(t, this._accumulatedStatsLog, this._count);
      }
    }, {
      key: "onDial",
      value: function value() {
        this._dialSentAt = Date.now();
      }
    }, {
      key: "onDialAck",
      value: function value() {
        this._pdd = Date.now() - this._dialSentAt;
      }
    }, {
      key: "onAccept",
      value: function value() {
        this._callSetupStartedAt = Date.now();
      }
    }, {
      key: "onAcceptAck",
      value: function value() {
        this._callSetupStartedAt = Date.now();
      }
    }, {
      key: "onConnected",
      value: function value() {
        this._setupTime = Date.now() - this._callSetupStartedAt;
      }
    }, {
      key: "increaseReconnectedCount",
      value: function value() {
        this._reconnectionCount += 1;
      }
    }, {
      key: "getSummary",
      value: function value() {
        var e = {};
        if (e.pdd = this._pdd, e.setup_time = this._setupTime, e.reconnection_count = this._reconnectionCount, !this._accumulatedStatsLog) return e;
        var t = this._accumulatedStatsLog,
            n = t.transport_info,
            r = t.audio,
            t = t.video;
        return e.network_type = n.network_type, e.transport_info_candidate_type = n.candidate_type, e.audio_codec = r.codec, e.audio_mos = r.mos, e.audio_packets_lost_rate = r.packets_lost_rate, e.audio_rtt = r.rtt, e.video_codec = t.codec, e.video_freeze_count = t.freeze_count, e.video_jitter_buffer_delay = t.jitter_buffer_delay, e.video_jitter_buffer_emitted_count = t.jitter_buffer_emitted_count, e.video_packets_lost_rate = t.packets_lost_rate, e.video_received_frame_height = t.received_frame_height, e.video_received_frame_width = t.received_frame_width, e.video_rtt = t.rtt, e.video_sent_frame_height = t.sent_frame_height, e.video_sent_frame_width = t.sent_frame_width, e.video_total_decode_time = t.total_decode_time, e.video_total_frames_duration = t.total_frames_duration, e.video_total_freezes_duration = t.total_freezes_duration, e.video_total_inter_frame_delay = t.total_inter_frame_delay, e.video_source_frames_per_second = t.video_source_frames_per_second, e.video_source_height = t.video_source_height, e.video_source_width = t.video_source_width, e;
      }
    }]), t;
  }(),
      If = function () {
    function n(e, t) {
      Un(this, n), this._ctx = e, this._call = t, this._collector = new Rf(e, t), this._summary = new Cf(t);
    }

    return Fn(n, [{
      key: "startGetWebRtcStats",
      value: function value(e) {
        var t = this;
        this._statsIntervalId || (this._statsIntervalId = setInterval(function () {
          e.getStatsLog().then(function (e) {
            t._summary.insertStatsLog(e), t._collector.insertStatsLog(e);
          });
        }, 1e3));
      }
    }, {
      key: "stopGetWebRtcStats",
      value: function value() {
        this._statsIntervalId && (clearInterval(this._statsIntervalId), delete this._statsIntervalId);
      }
    }, {
      key: "getCallSummary",
      value: function value() {
        return this._summary.getSummary();
      }
    }, {
      key: "summary",
      get: function get() {
        return this._summary;
      }
    }]), n;
  }(),
      wf = ue("iterator"),
      D = !u(function () {
    var e = new URL("b?a=1&b=2&c=3", "http://a"),
        n = e.searchParams,
        r = "";
    return e.pathname = "c%20d", n.forEach(function (e, t) {
      n.delete("b"), r += t + e;
    }), !n.sort || "http://a/c%20d?a=1&c=3" !== e.href || "3" !== n.get("c") || "a=1" !== String(new URLSearchParams("?a=1")) || !n[wf] || "a" !== new URL("https://a@b").username || "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") || "xn--e1aybc" !== new URL("http://тест").host || "#%D0%B1" !== new URL("http://a#б").hash || "a1c3" !== r || "x" !== new URL("http://x", void 0).host;
  }),
      Af = 2147483647,
      Tf = /[^\0-\u007E]/,
      Sf = /[.\u3002\uFF0E\uFF61]/g,
      bf = "Overflow: input needs wider integers to process",
      Of = Math.floor,
      Df = String.fromCharCode,
      Nf = ee("fetch"),
      Lf = ee("Headers"),
      $ = ue("iterator"),
      xf = "URLSearchParams",
      Pf = xf + "Iterator",
      Mf = he.set,
      Uf = he.getterFor(xf),
      Vf = he.getterFor(Pf),
      Ff = /\+/g,
      Gf = Array(4),
      Bf = /[!'()~]|%20/g,
      jf = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  },
      qf = ut(function (e, t) {
    Mf(this, {
      type: Pf,
      iterator: _f(Uf(e).entries),
      kind: t
    });
  }, "Iterator", function () {
    var e = Vf(this),
        t = e.kind,
        n = e.iterator.next(),
        e = n.value;
    return n.done || (n.value = "keys" === t ? e.key : "values" === t ? e.value : [e.key, e.value]), n;
  }),
      Hf = function Hf() {
    xt(this, Hf, xf);
    var e,
        t,
        n,
        r,
        i,
        a,
        o,
        s,
        c = 0 < arguments.length ? arguments[0] : void 0,
        u = [];
    if (Mf(this, {
      type: xf,
      entries: u,
      updateURL: function updateURL() {},
      updateSearchParams: Ef
    }), void 0 !== c) if (h(c)) {
      if ("function" == typeof (e = Ot(c))) for (n = (t = e.call(c)).next; !(a = n.call(t)).done;) {
        if ((a = (i = (r = _f(w(a.value))).next).call(r)).done || (o = i.call(r)).done || !i.call(r).done) throw TypeError("Expected sequence with length 2");
        u.push({
          key: a.value + "",
          value: o.value + ""
        });
      } else for (s in c) {
        y(c, s) && u.push({
          key: s,
          value: c[s] + ""
        });
      }
    } else gf(u, "string" == typeof c ? "?" === c.charAt(0) ? c.slice(1) : c : c + "");
  },
      a = Hf.prototype;

  Wt(a, {
    append: function append(e, t) {
      kf(arguments.length, 2);
      var n = Uf(this);
      n.entries.push({
        key: e + "",
        value: t + ""
      }), n.updateURL();
    },
    delete: function _delete(e) {
      kf(arguments.length, 1);

      for (var t = Uf(this), n = t.entries, r = e + "", i = 0; i < n.length;) {
        n[i].key === r ? n.splice(i, 1) : i++;
      }

      t.updateURL();
    },
    get: function get(e) {
      kf(arguments.length, 1);

      for (var t = Uf(this).entries, n = e + "", r = 0; r < t.length; r++) {
        if (t[r].key === n) return t[r].value;
      }

      return null;
    },
    getAll: function getAll(e) {
      kf(arguments.length, 1);

      for (var t = Uf(this).entries, n = e + "", r = [], i = 0; i < t.length; i++) {
        t[i].key === n && r.push(t[i].value);
      }

      return r;
    },
    has: function has(e) {
      kf(arguments.length, 1);

      for (var t = Uf(this).entries, n = e + "", r = 0; r < t.length;) {
        if (t[r++].key === n) return !0;
      }

      return !1;
    },
    set: function set(e, t) {
      kf(arguments.length, 1);

      for (var n, r = Uf(this), i = r.entries, a = !1, o = e + "", s = t + "", c = 0; c < i.length; c++) {
        (n = i[c]).key === o && (a ? i.splice(c--, 1) : (a = !0, n.value = s));
      }

      a || i.push({
        key: o,
        value: s
      }), r.updateURL();
    },
    sort: function sort() {
      for (var e, t, n = Uf(this), r = n.entries, i = r.slice(), a = r.length = 0; a < i.length; a++) {
        for (e = i[a], t = 0; t < a; t++) {
          if (r[t].key > e.key) {
            r.splice(t, 0, e);
            break;
          }
        }

        t === a && r.push(e);
      }

      n.updateURL();
    },
    forEach: function forEach(e) {
      for (var t, n = Uf(this).entries, r = se(e, 1 < arguments.length ? arguments[1] : void 0, 3), i = 0; i < n.length;) {
        r((t = n[i++]).value, t.key, this);
      }
    },
    keys: function keys() {
      return new qf(this, "keys");
    },
    values: function values() {
      return new qf(this, "values");
    },
    entries: function entries() {
      return new qf(this, "entries");
    }
  }, {
    enumerable: !0
  }), fe(a, $, a.entries), fe(a, "toString", function () {
    for (var e, t = Uf(this).entries, n = [], r = 0; r < t.length;) {
      e = t[r++], n.push(mf(e.key) + "=" + mf(e.value));
    }

    return n.join("&");
  }, {
    enumerable: !0
  }), st(Hf, xf), ae({
    global: !0,
    forced: !D
  }, {
    URLSearchParams: Hf
  }), D || "function" != typeof Nf || "function" != typeof Lf || ae({
    global: !0,
    enumerable: !0,
    forced: !0
  }, {
    fetch: function fetch(e) {
      var t,
          n,
          r = [e];
      return 1 < arguments.length && (h(t = arguments[1]) && (n = t.body, Vt(n) === xf && ((e = t.headers ? new Lf(t.headers) : new Lf()).has("content-type") || e.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), t = et(t, {
        body: i(0, String(n)),
        headers: i(0, e)
      }))), r.push(t)), Nf.apply(this, r);
    }
  });

  function zf(e, t) {
    var n, r, i;
    if ("[" == t.charAt(0)) return "]" == t.charAt(t.length - 1) && (n = w_(t.slice(1, -1))) ? void (e.host = n) : d_;
    if (N_(e)) return t = function (e) {
      for (var t, n = [], r = e.toLowerCase().replace(Sf, ".").split("."), i = 0; i < r.length; i++) {
        t = r[i], n.push(Tf.test(t) ? "xn--" + ff(t) : t);
      }

      return n.join(".");
    }(t), E_.test(t) || null === (n = I_(t)) ? d_ : void (e.host = n);
    if (k_.test(t)) return d_;

    for (n = "", r = rf(t), i = 0; i < r.length; i++) {
      n += O_(r[i], A_);
    }

    e.host = n;
  }

  function Wf(e) {
    var t, n, r, i;

    if ("number" == typeof e) {
      for (t = [], n = 0; n < 4; n++) {
        t.unshift(e % 256), e = c_(e / 256);
      }

      return t.join(".");
    }

    if ("object" != typeof e) return e;

    for (t = "", r = function (e) {
      for (var t = null, n = 1, r = null, i = 0, a = 0; a < 8; a++) {
        0 !== e[a] ? (n < i && (t = r, n = i), r = null, i = 0) : (null === r && (r = a), ++i);
      }

      return n < i && (t = r, n = i), t;
    }(e), n = 0; n < 8; n++) {
      i && 0 === e[n] || (i = i && !1, r === n ? (t += n ? ":" : "::", i = !0) : (t += e[n].toString(16), n < 7 && (t += ":")));
    }

    return "[" + t + "]";
  }

  function Kf(e) {
    return "" != e.username || "" != e.password;
  }

  function Yf(e) {
    return !e.host || e.cannotBeABaseURL || "file" == e.scheme;
  }

  function Zf(e, t) {
    return 2 == e.length && f_.test(e.charAt(0)) && (":" == (e = e.charAt(1)) || !t && "|" == e);
  }

  function Qf(e) {
    var t;
    return 1 < e.length && Zf(e.slice(0, 2)) && (2 == e.length || "/" === (t = e.charAt(2)) || "\\" === t || "?" === t || "#" === t);
  }

  function Xf(e) {
    var t = e.path,
        n = t.length;
    !n || "file" == e.scheme && 1 == n && Zf(t[0], !0) || t.pop();
  }

  function $f(e, t, n, r) {
    var i,
        a,
        o,
        s,
        c = n || L_,
        u = 0,
        l = "",
        d = !1,
        h = !1,
        f = !1;

    for (n || (e.scheme = "", e.username = "", e.password = "", e.host = null, e.port = null, e.path = [], e.query = null, e.fragment = null, e.cannotBeABaseURL = !1, t = t.replace(R_, "")), t = t.replace(C_, ""), i = rf(t); u <= i.length;) {
      switch (a = i[u], c) {
        case L_:
          if (!a || !f_.test(a)) {
            if (n) return l_;
            c = P_;
            continue;
          }

          l += a.toLowerCase(), c = x_;
          break;

        case x_:
          if (a && (__.test(a) || "+" == a || "-" == a || "." == a)) l += a.toLowerCase();else {
            if (":" != a) {
              if (n) return l_;
              l = "", c = P_, u = 0;
              continue;
            }

            if (n && (N_(e) != y(D_, l) || "file" == l && (Kf(e) || null !== e.port) || "file" == e.scheme && !e.host)) return;
            if (e.scheme = l, n) return void (N_(e) && D_[e.scheme] == e.port && (e.port = null));
            l = "", "file" == e.scheme ? c = W_ : N_(e) && r && r.scheme == e.scheme ? c = M_ : N_(e) ? c = G_ : "/" == i[u + 1] ? (c = U_, u++) : (e.cannotBeABaseURL = !0, e.path.push(""), c = X_);
          }
          break;

        case P_:
          if (!r || r.cannotBeABaseURL && "#" != a) return l_;

          if (r.cannotBeABaseURL && "#" == a) {
            e.scheme = r.scheme, e.path = r.path.slice(), e.query = r.query, e.fragment = "", e.cannotBeABaseURL = !0, c = J_;
            break;
          }

          c = "file" == r.scheme ? W_ : V_;
          continue;

        case M_:
          if ("/" != a || "/" != i[u + 1]) {
            c = V_;
            continue;
          }

          c = B_, u++;
          break;

        case U_:
          if ("/" == a) {
            c = j_;
            break;
          }

          c = Q_;
          continue;

        case V_:
          if (e.scheme = r.scheme, a == Jf) e.username = r.username, e.password = r.password, e.host = r.host, e.port = r.port, e.path = r.path.slice(), e.query = r.query;else if ("/" == a || "\\" == a && N_(e)) c = F_;else if ("?" == a) e.username = r.username, e.password = r.password, e.host = r.host, e.port = r.port, e.path = r.path.slice(), e.query = "", c = $_;else {
            if ("#" != a) {
              e.username = r.username, e.password = r.password, e.host = r.host, e.port = r.port, e.path = r.path.slice(), e.path.pop(), c = Q_;
              continue;
            }

            e.username = r.username, e.password = r.password, e.host = r.host, e.port = r.port, e.path = r.path.slice(), e.query = r.query, e.fragment = "", c = J_;
          }
          break;

        case F_:
          if (!N_(e) || "/" != a && "\\" != a) {
            if ("/" != a) {
              e.username = r.username, e.password = r.password, e.host = r.host, e.port = r.port, c = Q_;
              continue;
            }

            c = j_;
          } else c = B_;

          break;

        case G_:
          if (c = B_, "/" != a || "/" != l.charAt(u + 1)) continue;
          u++;
          break;

        case B_:
          if ("/" == a || "\\" == a) break;
          c = j_;
          continue;

        case j_:
          if ("@" == a) {
            d && (l = "%40" + l), d = !0, o = rf(l);

            for (var _ = 0; _ < o.length; _++) {
              var p = o[_];
              ":" != p || f ? (p = O_(p, b_), f ? e.password += p : e.username += p) : f = !0;
            }

            l = "";
          } else if (a == Jf || "/" == a || "?" == a || "#" == a || "\\" == a && N_(e)) {
            if (d && "" == l) return "Invalid authority";
            u -= rf(l).length + 1, l = "", c = q_;
          } else l += a;

          break;

        case q_:
        case H_:
          if (n && "file" == e.scheme) {
            c = Y_;
            continue;
          }

          if (":" != a || h) {
            if (a == Jf || "/" == a || "?" == a || "#" == a || "\\" == a && N_(e)) {
              if (N_(e) && "" == l) return d_;
              if (n && "" == l && (Kf(e) || null !== e.port)) return;
              if (s = zf(e, l)) return s;
              if (l = "", c = Z_, n) return;
              continue;
            }

            "[" == a ? h = !0 : "]" == a && (h = !1), l += a;
          } else {
            if ("" == l) return d_;
            if (s = zf(e, l)) return s;
            if (l = "", c = z_, n == H_) return;
          }

          break;

        case z_:
          if (!p_.test(a)) {
            if (a == Jf || "/" == a || "?" == a || "#" == a || "\\" == a && N_(e) || n) {
              if ("" != l) {
                var v = parseInt(l, 10);
                if (65535 < v) return h_;
                e.port = N_(e) && v === D_[e.scheme] ? null : v, l = "";
              }

              if (n) return;
              c = Z_;
              continue;
            }

            return h_;
          }

          l += a;
          break;

        case W_:
          if (e.scheme = "file", "/" == a || "\\" == a) c = K_;else {
            if (!r || "file" != r.scheme) {
              c = Q_;
              continue;
            }

            if (a == Jf) e.host = r.host, e.path = r.path.slice(), e.query = r.query;else if ("?" == a) e.host = r.host, e.path = r.path.slice(), e.query = "", c = $_;else {
              if ("#" != a) {
                Qf(i.slice(u).join("")) || (e.host = r.host, e.path = r.path.slice(), Xf(e)), c = Q_;
                continue;
              }

              e.host = r.host, e.path = r.path.slice(), e.query = r.query, e.fragment = "", c = J_;
            }
          }
          break;

        case K_:
          if ("/" == a || "\\" == a) {
            c = Y_;
            break;
          }

          r && "file" == r.scheme && !Qf(i.slice(u).join("")) && (Zf(r.path[0], !0) ? e.path.push(r.path[0]) : e.host = r.host), c = Q_;
          continue;

        case Y_:
          if (a == Jf || "/" == a || "\\" == a || "?" == a || "#" == a) {
            if (!n && Zf(l)) c = Q_;else if ("" == l) {
              if (e.host = "", n) return;
              c = Z_;
            } else {
              if (s = zf(e, l)) return s;
              if ("localhost" == e.host && (e.host = ""), n) return;
              l = "", c = Z_;
            }
            continue;
          }

          l += a;
          break;

        case Z_:
          if (N_(e)) {
            if (c = Q_, "/" != a && "\\" != a) continue;
          } else if (n || "?" != a) {
            if (n || "#" != a) {
              if (a != Jf && (c = Q_, "/" != a)) continue;
            } else e.fragment = "", c = J_;
          } else e.query = "", c = $_;

          break;

        case Q_:
          if (a == Jf || "/" == a || "\\" == a && N_(e) || !n && ("?" == a || "#" == a)) {
            if (".." === (v = (v = l).toLowerCase()) || "%2e." === v || ".%2e" === v || "%2e%2e" === v ? (Xf(e), "/" == a || "\\" == a && N_(e) || e.path.push("")) : "." === (v = l) || "%2e" === v.toLowerCase() ? "/" == a || "\\" == a && N_(e) || e.path.push("") : ("file" == e.scheme && !e.path.length && Zf(l) && (e.host && (e.host = ""), l = l.charAt(0) + ":"), e.path.push(l)), l = "", "file" == e.scheme && (a == Jf || "?" == a || "#" == a)) for (; 1 < e.path.length && "" === e.path[0];) {
              e.path.shift();
            }
            "?" == a ? (e.query = "", c = $_) : "#" == a && (e.fragment = "", c = J_);
          } else l += O_(a, S_);

          break;

        case X_:
          "?" == a ? (e.query = "", c = $_) : "#" == a ? (e.fragment = "", c = J_) : a != Jf && (e.path[0] += O_(a, A_));
          break;

        case $_:
          n || "#" != a ? a != Jf && ("'" == a && N_(e) ? e.query += "%27" : e.query += "#" == a ? "%23" : O_(a, A_)) : (e.fragment = "", c = J_);
          break;

        case J_:
          a != Jf && (e.fragment += O_(a, T_));
      }

      u++;
    }
  }

  var Jf,
      e_,
      t_,
      a = {
    URLSearchParams: Hf,
    getState: Uf
  },
      n_ = yn.codeAt,
      r_ = p.URL,
      i_ = a.URLSearchParams,
      a_ = a.getState,
      o_ = he.set,
      s_ = he.getterFor("URL"),
      c_ = Math.floor,
      u_ = Math.pow,
      l_ = "Invalid scheme",
      d_ = "Invalid host",
      h_ = "Invalid port",
      f_ = /[A-Za-z]/,
      __ = /[\d+-.A-Za-z]/,
      p_ = /\d/,
      v_ = /^(0x|0X)/,
      y_ = /^[0-7]+$/,
      m_ = /^\d+$/,
      g_ = /^[\dA-Fa-f]+$/,
      E_ = /[\u0000\u0009\u000A\u000D #%/:?@[\\]]/,
      k_ = /[\u0000\u0009\u000A\u000D #/:?@[\\]]/,
      R_ = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g,
      C_ = /[\u0009\u000A\u000D]/g,
      I_ = function I_(e) {
    var t,
        n,
        r,
        i,
        a,
        o,
        s,
        c = e.split(".");
    if (c.length && "" == c[c.length - 1] && c.pop(), 4 < (t = c.length)) return e;

    for (n = [], r = 0; r < t; r++) {
      if ("" == (i = c[r])) return e;
      if (a = 10, 1 < i.length && "0" == i.charAt(0) && (a = v_.test(i) ? 16 : 8, i = i.slice(8 == a ? 1 : 2)), "" === i) o = 0;else {
        if (!(10 == a ? m_ : 8 == a ? y_ : g_).test(i)) return e;
        o = parseInt(i, a);
      }
      n.push(o);
    }

    for (r = 0; r < t; r++) {
      if (o = n[r], r == t - 1) {
        if (o >= u_(256, 5 - t)) return null;
      } else if (255 < o) return null;
    }

    for (s = n.pop(), r = 0; r < n.length; r++) {
      s += n[r] * u_(256, 3 - r);
    }

    return s;
  },
      w_ = function w_(e) {
    function t() {
      return e.charAt(h);
    }

    var n,
        r,
        i,
        a,
        o,
        s,
        c,
        u = [0, 0, 0, 0, 0, 0, 0, 0],
        l = 0,
        d = null,
        h = 0;

    if (":" == t()) {
      if (":" != e.charAt(1)) return;
      h += 2, d = ++l;
    }

    for (; t();) {
      if (8 == l) return;

      if (":" != t()) {
        for (n = r = 0; r < 4 && g_.test(t());) {
          n = 16 * n + parseInt(t(), 16), h++, r++;
        }

        if ("." == t()) {
          if (0 == r) return;
          if (h -= r, 6 < l) return;

          for (i = 0; t();) {
            if (a = null, 0 < i) {
              if (!("." == t() && i < 4)) return;
              h++;
            }

            if (!p_.test(t())) return;

            for (; p_.test(t());) {
              if (o = parseInt(t(), 10), null === a) a = o;else {
                if (0 == a) return;
                a = 10 * a + o;
              }
              if (255 < a) return;
              h++;
            }

            u[l] = 256 * u[l] + a, 2 != ++i && 4 != i || l++;
          }

          if (4 != i) return;
          break;
        }

        if (":" == t()) {
          if (h++, !t()) return;
        } else if (t()) return;

        u[l++] = n;
      } else {
        if (null !== d) return;
        h++, d = ++l;
      }
    }

    if (null !== d) for (s = l - d, l = 7; 0 != l && 0 < s;) {
      c = u[l], u[l--] = u[d + s - 1], u[d + --s] = c;
    } else if (8 != l) return;
    return u;
  },
      A_ = {},
      T_ = Pt({}, A_, {
    " ": 1,
    '"': 1,
    "<": 1,
    ">": 1,
    "`": 1
  }),
      S_ = Pt({}, T_, {
    "#": 1,
    "?": 1,
    "{": 1,
    "}": 1
  }),
      b_ = Pt({}, S_, {
    "/": 1,
    ":": 1,
    ";": 1,
    "=": 1,
    "@": 1,
    "[": 1,
    "\\": 1,
    "]": 1,
    "^": 1,
    "|": 1
  }),
      O_ = function O_(e, t) {
    var n = n_(e, 0);
    return 32 < n && n < 127 && !y(t, e) ? e : encodeURIComponent(e);
  },
      D_ = {
    ftp: 21,
    file: null,
    http: 80,
    https: 443,
    ws: 80,
    wss: 443
  },
      N_ = function N_(e) {
    return y(D_, e.scheme);
  },
      L_ = {},
      x_ = {},
      P_ = {},
      M_ = {},
      U_ = {},
      V_ = {},
      F_ = {},
      G_ = {},
      B_ = {},
      j_ = {},
      q_ = {},
      H_ = {},
      z_ = {},
      W_ = {},
      K_ = {},
      Y_ = {},
      Z_ = {},
      Q_ = {},
      X_ = {},
      $_ = {},
      J_ = {},
      ep = function ep(e) {
    var t,
        n = xt(this, ep, "URL"),
        r = 1 < arguments.length ? arguments[1] : void 0,
        e = String(e),
        i = o_(n, {
      type: "URL"
    });
    if (void 0 !== r) if (r instanceof ep) t = s_(r);else if (o = $f(t = {}, String(r))) throw TypeError(o);
    if (o = $f(i, e, null, t)) throw TypeError(o);
    var a = i.searchParams = new i_(),
        o = a_(a);
    o.updateSearchParams(i.query), o.updateURL = function () {
      i.query = String(a) || null;
    }, v || (n.href = tp.call(n), n.origin = np.call(n), n.protocol = rp.call(n), n.username = ip.call(n), n.password = ap.call(n), n.host = op.call(n), n.hostname = sp.call(n), n.port = cp.call(n), n.pathname = up.call(n), n.search = lp.call(n), n.searchParams = dp.call(n), n.hash = hp.call(n));
  },
      a = ep.prototype,
      tp = function tp() {
    var e = s_(this),
        t = e.scheme,
        n = e.username,
        r = e.password,
        i = e.host,
        a = e.port,
        o = e.path,
        s = e.query,
        c = e.fragment,
        u = t + ":";
    return null !== i ? (u += "//", Kf(e) && (u += n + (r ? ":" + r : "") + "@"), u += Wf(i), null !== a && (u += ":" + a)) : "file" == t && (u += "//"), u += e.cannotBeABaseURL ? o[0] : o.length ? "/" + o.join("/") : "", null !== s && (u += "?" + s), null !== c && (u += "#" + c), u;
  },
      np = function np() {
    var e = s_(this),
        t = e.scheme,
        n = e.port;
    if ("blob" == t) try {
      return new URL(t.path[0]).origin;
    } catch (e) {
      return "null";
    }
    return "file" != t && N_(e) ? t + "://" + Wf(e.host) + (null !== n ? ":" + n : "") : "null";
  },
      rp = function rp() {
    return s_(this).scheme + ":";
  },
      ip = function ip() {
    return s_(this).username;
  },
      ap = function ap() {
    return s_(this).password;
  },
      op = function op() {
    var e = s_(this),
        t = e.host,
        e = e.port;
    return null === t ? "" : null === e ? Wf(t) : Wf(t) + ":" + e;
  },
      sp = function sp() {
    var e = s_(this).host;
    return null === e ? "" : Wf(e);
  },
      cp = function cp() {
    var e = s_(this).port;
    return null === e ? "" : String(e);
  },
      up = function up() {
    var e = s_(this),
        t = e.path;
    return e.cannotBeABaseURL ? t[0] : t.length ? "/" + t.join("/") : "";
  },
      lp = function lp() {
    var e = s_(this).query;
    return e ? "?" + e : "";
  },
      dp = function dp() {
    return s_(this).searchParams;
  },
      hp = function hp() {
    var e = s_(this).fragment;
    return e ? "#" + e : "";
  },
      Pt = function Pt(e, t) {
    return {
      get: e,
      set: t,
      configurable: !0,
      enumerable: !0
    };
  };

  v && Ye(a, {
    href: Pt(tp, function (e) {
      var t = s_(this),
          e = String(e),
          e = $f(t, e);
      if (e) throw TypeError(e);
      a_(t.searchParams).updateSearchParams(t.query);
    }),
    origin: Pt(np),
    protocol: Pt(rp, function (e) {
      var t = s_(this);
      $f(t, String(e) + ":", L_);
    }),
    username: Pt(ip, function (e) {
      var t = s_(this),
          n = rf(String(e));

      if (!Yf(t)) {
        t.username = "";

        for (var r = 0; r < n.length; r++) {
          t.username += O_(n[r], b_);
        }
      }
    }),
    password: Pt(ap, function (e) {
      var t = s_(this),
          n = rf(String(e));

      if (!Yf(t)) {
        t.password = "";

        for (var r = 0; r < n.length; r++) {
          t.password += O_(n[r], b_);
        }
      }
    }),
    host: Pt(op, function (e) {
      var t = s_(this);
      t.cannotBeABaseURL || $f(t, String(e), q_);
    }),
    hostname: Pt(sp, function (e) {
      var t = s_(this);
      t.cannotBeABaseURL || $f(t, String(e), H_);
    }),
    port: Pt(cp, function (e) {
      var t = s_(this);
      Yf(t) || ("" == (e = String(e)) ? t.port = null : $f(t, e, z_));
    }),
    pathname: Pt(up, function (e) {
      var t = s_(this);
      t.cannotBeABaseURL || (t.path = [], $f(t, e + "", Z_));
    }),
    search: Pt(lp, function (e) {
      var t = s_(this);
      "" == (e = String(e)) ? t.query = null : ("?" == e.charAt(0) && (e = e.slice(1)), t.query = "", $f(t, e, $_)), a_(t.searchParams).updateSearchParams(t.query);
    }),
    searchParams: Pt(dp),
    hash: Pt(hp, function (e) {
      var t = s_(this);
      "" != (e = String(e)) ? ("#" == e.charAt(0) && (e = e.slice(1)), t.fragment = "", $f(t, e, J_)) : t.fragment = null;
    })
  }), fe(a, "toJSON", function () {
    return tp.call(this);
  }, {
    enumerable: !0
  }), fe(a, "toString", function () {
    return tp.call(this);
  }, {
    enumerable: !0
  }), r_ && (e_ = r_.createObjectURL, t_ = r_.revokeObjectURL, e_ && fe(ep, "createObjectURL", function (e) {
    return e_.apply(r_, arguments);
  }), t_ && fe(ep, "revokeObjectURL", function (e) {
    return t_.apply(r_, arguments);
  })), st(ep, "URL"), ae({
    global: !0,
    forced: !D,
    sham: !v
  }, {
    URL: ep
  });

  var fp,
      _p = null,
      pp = function () {
    function e() {
      Un(this, e);
    }

    return Fn(e, null, [{
      key: "downloadRecordedFile",
      value: function value(e, t) {
        var n = window.URL.createObjectURL(e),
            r = document.createElement("a");
        r.style.display = "none", r.href = n, r.download = t, document.body.appendChild(r), r.click(), setTimeout(function () {
          document.body.removeChild(r), window.URL.revokeObjectURL(n);
        }, 100);
      }
    }, {
      key: "getMergedAudioStream",
      value: function value(e, t) {
        var n = [],
            r = (_p = _p || new (window.AudioContext || window.webkitAudioContext)()).createGain();

        r.gain.value = 1;
        var i = new MediaStream();
        i.addTrack(e), n.push(_p.createMediaStreamSource(i).connect(r));
        i = new MediaStream();
        i.addTrack(t), n.push(_p.createMediaStreamSource(i).connect(r));

        for (var a = _p.createMediaStreamDestination(), o = 0, s = n; o < s.length; o++) {
          s[o].connect(a);
        }

        return a.stream.getAudioTracks()[0];
      }
    }, {
      key: "getVideoStream",
      value: function value(r) {
        var i = document.createElement("canvas"),
            e = mc.value,
            a = e.width,
            o = e.height;
        i.width = a, i.height = o;
        var s = r.videoWidth,
            c = r.videoHeight,
            u = i.getContext("2d"),
            t = setInterval(function () {
          var e,
              t = r.videoWidth,
              n = r.videoHeight;
          (c < n || s < t) && (s = t, c = n, u.fillRect(0, 0, a, o)), n > i.height && (e = r.videoWidth / r.videoHeight, t = (n = i.height) * e), u.drawImage(r, i.width / 2 - t / 2, i.height / 2 - n / 2, t, n);
        }, 10);
        return {
          stream: i.captureStream(),
          cleanup: function cleanup() {
            return clearInterval(t);
          }
        };
      }
    }]), e;
  }(),
      vp = function () {
    function e() {
      Un(this, e);
    }

    return Fn(e, null, [{
      key: "getRecorderMimeType",
      value: function value(e) {
        switch (e) {
          case ka.REMOTE_AUDIO_AND_VIDEO:
          case ka.LOCAL_AUDIO_REMOTE_AUDIO_AND_VIDEO:
          case ka.LOCAL_AUDIO_AND_VIDEO_REMOTE_AUDIO:
            return this.getVideoRecordFileMimeType();

          case ka.REMOTE_AUDIO_ONLY:
          case ka.LOCAL_REMOTE_AUDIOS:
            return this.getAudioRecordFileMimeType();

          default:
            return this.getVideoRecordFileMimeType();
        }
      }
    }, {
      key: "getVideoRecordFileMimeType",
      value: function value() {
        var e = "video/mp4";
        return MediaRecorder.isTypeSupported(e) || (e = "video/webm"), e;
      }
    }, {
      key: "getAudioRecordFileMimeType",
      value: function value() {
        var e = "audio/mp4";
        return MediaRecorder.isTypeSupported(e) || (e = "audio/webm"), e;
      }
    }, {
      key: "createStream",
      value: function value(e, t) {
        var n = {
          mimeType: this.getRecorderMimeType(t)
        },
            r = e.localMediaView.srcObject,
            i = e.remoteMediaView.srcObject;

        switch (t) {
          case ka.REMOTE_AUDIO_AND_VIDEO:
            return {
              stream: i,
              options: n
            };

          case ka.REMOTE_AUDIO_ONLY:
            var a = new MediaStream();
            return a.addTrack(i.getAudioTracks()[0]), {
              stream: a,
              options: n
            };

          case ka.LOCAL_REMOTE_AUDIOS:
            var o = new MediaStream(),
                a = pp.getMergedAudioStream(r.getAudioTracks()[0], i.getAudioTracks()[0]);
            return o.addTrack(a), {
              stream: o,
              options: n
            };

          case ka.LOCAL_AUDIO_REMOTE_AUDIO_AND_VIDEO:
            var s = pp.getVideoStream(e.remoteMediaView),
                c = s.stream,
                u = s.cleanup,
                s = pp.getMergedAudioStream(r.getAudioTracks()[0], i.getAudioTracks()[0]);
            return c.addTrack(s), {
              stream: c,
              options: n,
              cleanup: u
            };

          case ka.LOCAL_AUDIO_AND_VIDEO_REMOTE_AUDIO:
            s = pp.getVideoStream(e.localMediaView), c = s.stream, u = s.cleanup, s = pp.getMergedAudioStream(r.getAudioTracks()[0], i.getAudioTracks()[0]);
            return c.addTrack(s), {
              stream: c,
              options: n,
              cleanup: u
            };

          default:
            return _a.error("Cannot reach here!"), {
              options: n
            };
        }
      }
    }]), e;
  }(),
      yp = function () {
    function n(e, t) {
      Un(this, n), this.call = e, this.stateManager = t, this.timer = null;
    }

    return Fn(n, [{
      key: "dialSent",
      value: function value() {
        _a.verbose("[".concat(this.type, "] dialSent"));
      }
    }, {
      key: "dialFailed",
      value: function value() {
        _a.verbose("[".concat(this.type, "] dialFailed"));
      }
    }, {
      key: "accept",
      value: function value(e) {
        _a.verbose("[".concat(this.type, "] accept"));
      }
    }, {
      key: "acceptSent",
      value: function value(e) {
        _a.verbose("[".concat(this.type, "] acceptSent"));
      }
    }, {
      key: "acceptFailed",
      value: function value() {
        _a.verbose("[".concat(this.type, "] acceptFailed"));
      }
    }, {
      key: "receiveAccept",
      value: function value() {
        _a.verbose("[".concat(this.type, "] receiveAccept"));
      }
    }, {
      key: "receiveAccepted",
      value: function value() {
        _a.verbose("[".concat(this.type, "] receiveAccepted"));
      }
    }, {
      key: "end",
      value: function value() {
        _a.verbose("[".concat(this.type, "] end"));
      }
    }, {
      key: "endSent",
      value: function value(e) {
        _a.verbose("[".concat(this.type, "] endSent"));
      }
    }, {
      key: "receiveOffer",
      value: function value() {
        _a.verbose("[".concat(this.type, "] receiveOffer"));
      }
    }, {
      key: "receiveEnd",
      value: function value(e) {
        _a.verbose("[".concat(this.type, "] receiveEnd"));
      }
    }, {
      key: "timeout",
      value: function value() {
        _a.verbose("[".concat(this.type, "] timeout"));
      }
    }, {
      key: "pcConnected",
      value: function value() {
        _a.verbose("[".concat(this.type, "] pc connected"));
      }
    }, {
      key: "pcReconnecting",
      value: function value() {
        _a.verbose("[".concat(this.type, "] pc reconnecting"));
      }
    }, {
      key: "closed",
      value: function value() {
        _a.verbose("[".concat(this.type, "] closed"));
      }
    }, {
      key: "onStart",
      value: function value() {}
    }, {
      key: "onDestroy",
      value: function value() {}
    }, {
      key: "fireTimeout",
      value: function value() {}
    }, {
      key: "toggleVideo",
      value: function value(e) {
        _a.verbose("[".concat(this.type, "] toggleVideo ").concat(e));
      }
    }, {
      key: "toggleMicrophone",
      value: function value(e) {
        _a.verbose("[".concat(this.type, "] toggleMicrophone ").concat(e));
      }
    }, {
      key: "_createTimer",
      value: function value(e, t) {
        var n = this;
        this.timer ? _a.error("Only one timer allowed") : this.timer = setTimeout(function () {
          n._removeTimer(), e();
        }, t);
      }
    }, {
      key: "_removeTimer",
      value: function value() {
        this.timer && (clearTimeout(this.timer), this.timer = null);
      }
    }]), n;
  }();

  (D = fp = fp || {}).IDLE = "idle", D.DIALING = "dialing", D.RINGING = "ringing", D.ACCEPTING = "accepting", D.ESTABLISHED = "established", D.CONNECTED = "connected", D.RECONNECTING = "reconnecting", D.ICERESTART = "icerestart", D.ENDED = "ended", D.ABORTED = "aborted", D.CLOSING = "closing", D.ENDING = "ending", D.CANCELED = "canceled";

  var mp,
      gp = function () {
    qn(t, yp);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "onStart",
      value: function value() {
        this.call.stopToSendAlive(), this.call.fireOnEnded();
      }
    }, {
      key: "dialSent",
      value: function value() {
        this.call.sendCancelCommand().catch(function (e) {
          return _a.debug(e);
        });
      }
    }, {
      key: "dialFailed",
      value: function value() {
        this.stateManager.toEnded();
      }
    }, {
      key: "endSent",
      value: function value(e) {
        this.call.setEndInfo(e.payload.endedCall), this.stateManager.toEnded();
      }
    }, {
      key: "receiveEnd",
      value: function value(e) {
        this.call.setEndInfo(e.payload.endedCall), this.stateManager.toEnded();
      }
    }, {
      key: "type",
      get: function get() {
        return fp.ABORTED;
      }
    }]), t;
  }();

  (D = mp = mp || {}).ACCEPTING = "accepting_timeout", D.ANSWERING = "answering_timeout", D.OFFERING = "offering_timeout";

  var Ep,
      kp,
      Rp = function () {
    qn(n, yp);
    var e,
        t = Xn(n);

    function n() {
      return Un(this, n), t.apply(this, arguments);
    }

    return Fn(n, [{
      key: "onStart",
      value: function value() {
        this.call.sendAcceptCommand().catch(function (e) {
          return _a.debug(e);
        }), this.call.startCallConnectionTimer();
      }
    }, {
      key: "acceptSent",
      value: function value() {
        this.stateManager.toEstablished();
      }
    }, {
      key: "receiveOffer",
      value: (e = Mn(_regeneratorRuntime.mark(function e() {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                this.stateManager.toEstablished();

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return e.apply(this, arguments);
      })
    }, {
      key: "acceptFailed",
      value: function value() {
        this.call.setEndResult(la.ACCEPT_FAILED), this.stateManager.toClosing();
      }
    }, {
      key: "end",
      value: function value() {
        this.call.sendEndCommand().catch(function (e) {
          return _a.debug(e);
        }), this.call.setEndResult(la.COMPLETED), this.stateManager.toClosing();
      }
    }, {
      key: "fireTimeout",
      value: function value() {
        this.call.sendTimeoutCommand(mp.ACCEPTING).catch(function (e) {
          return _a.debug(e);
        }), this.call.setEndResult(la.TIMED_OUT), this.stateManager.toClosing();
      }
    }, {
      key: "receiveEnd",
      value: function value(e) {
        this.call.setEndResult(e.payload.endedCall.endResult), this.call.setEndInfo(e.payload.endedCall), this.stateManager.toClosing();
      }
    }, {
      key: "toggleMicrophone",
      value: function value(e) {
        this.call.toggleMicrophone(e), this.call.sendAudioCommand().catch(function (e) {
          return _a.debug(e);
        });
      }
    }, {
      key: "toggleVideo",
      value: function value(e) {
        this.call.toggleVideo(e), this.call.sendVideoCommand().catch(function (e) {
          return _a.debug(e);
        });
      }
    }, {
      key: "type",
      get: function get() {
        return fp.ACCEPTING;
      }
    }]), n;
  }(),
      Cp = function () {
    qn(t, yp);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "onStart",
      value: function value() {
        this.call.stopCallConnectionTimer(), this.call.fireOnRinging(), this.stateManager.toClosing();
      }
    }, {
      key: "type",
      get: function get() {
        return fp.CANCELED;
      }
    }]), t;
  }(),
      Ip = function () {
    qn(t, yp);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "onStart",
      value: function value() {
        this.call.stopCallConnectionTimer(), this.call.stopToSendAlive(), this.call.stopCurrentRecording(), this.call.stopScreenShare(), this.call.closeRTCConnection(), this.closed();
      }
    }, {
      key: "endSent",
      value: function value(e) {
        this.call.setEndInfo(e.payload.endedCall);
      }
    }, {
      key: "closed",
      value: function value() {
        this.stateManager.toEnding();
      }
    }, {
      key: "type",
      get: function get() {
        return fp.CLOSING;
      }
    }]), t;
  }(),
      wp = function () {
    qn(i, yp);
    var r = Xn(i);

    function i(e, t, n) {
      return Un(this, i), (t = r.call(this, e, t)).isReconnected = n, t;
    }

    return Fn(i, [{
      key: "onStart",
      value: function value() {
        this.call.stopCallConnectionTimer(), this.call.startGetWebRtcStats(), this.call.sendConnectedInfo(), this.isReconnected ? (this.call.setIsReconnected(!0), this.call.fireOnReconnected(), this.call.playSound(Yc.RECONNECTED)) : (this.call.calcCallSetupTime(), this.call.fireOnConnected());
      }
    }, {
      key: "onDestroy",
      value: function value() {
        this.call.stopGetWebRtcStats(), this.isReconnected && this.call.stopSound(Yc.RECONNECTED);
      }
    }, {
      key: "pcReconnecting",
      value: function value() {
        this.stateManager.toReconnecting();
      }
    }, {
      key: "end",
      value: function value() {
        this.call.sendEndCommand().catch(function (e) {
          return _a.debug(e);
        }), this.call.setEndResult(la.COMPLETED), this.stateManager.toClosing();
      }
    }, {
      key: "receiveEnd",
      value: function value(e) {
        this.call.setEndResult(e.payload.endedCall.endResult), this.call.setEndInfo(e.payload.endedCall), this.stateManager.toClosing();
      }
    }, {
      key: "toggleMicrophone",
      value: function value(e) {
        this.call.toggleMicrophone(e), this.call.sendAudioCommand().catch(function (e) {
          return _a.debug(e);
        });
      }
    }, {
      key: "toggleVideo",
      value: function value(e) {
        this.call.toggleVideo(e), this.call.sendVideoCommand().catch(function (e) {
          return _a.debug(e);
        });
      }
    }, {
      key: "type",
      get: function get() {
        return fp.CONNECTED;
      }
    }]), i;
  }(),
      Ap = function () {
    qn(t, yp);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "onStart",
      value: function value() {
        var e = this;
        this._createTimer(function () {
          e._noAnswer();
        }, this._getTimeoutTime()), this.call.startToSendAlive(), this.call.playSound(Yc.DIALING);
      }
    }, {
      key: "onDestroy",
      value: function value() {
        this._removeTimer(), this.call.stopSound(Yc.DIALING);
      }
    }, {
      key: "receiveAccept",
      value: function value() {
        this.stateManager.toEstablished();
      }
    }, {
      key: "end",
      value: function value() {
        this.call.sendCancelCommand().catch(function (e) {
          return _a.debug(e);
        }), this.call.setEndResult(la.CANCELED), this.stateManager.toClosing();
      }
    }, {
      key: "receiveEnd",
      value: function value(e) {
        this.call.setEndResult(e.payload.endedCall.endResult), this.call.setEndInfo(e.payload.endedCall), this.stateManager.toClosing();
      }
    }, {
      key: "_noAnswer",
      value: function value() {
        this.call.sendNoAnswerCommand().catch(function (e) {
          return _a.debug(e);
        }), this.call.setEndResult(la.NO_ANSWER), this.stateManager.toClosing();
      }
    }, {
      key: "_getTimeoutTime",
      value: function value() {
        return this.call.options.ringingTimeoutValue;
      }
    }, {
      key: "toggleMicrophone",
      value: function value(e) {
        this.call.toggleMicrophone(e), this.call.sendAudioCommand().catch(function (e) {
          return _a.debug(e);
        });
      }
    }, {
      key: "toggleVideo",
      value: function value(e) {
        this.call.toggleVideo(e), this.call.sendVideoCommand().catch(function (e) {
          return _a.debug(e);
        });
      }
    }, {
      key: "type",
      get: function get() {
        return fp.DIALING;
      }
    }]), t;
  }(),
      Tp = function () {
    qn(t, yp);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "onStart",
      value: function value() {
        this.call.stopAllSound();
      }
    }, {
      key: "endSent",
      value: function value(e) {
        this.call.setEndInfo(e.payload.endedCall);
      }
    }, {
      key: "type",
      get: function get() {
        return fp.ENDED;
      }
    }]), t;
  }(),
      Sp = function () {
    qn(t, yp);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "onStart",
      value: function value() {
        this.call.sendCallSummary(), this.call.fireOnEnded(), this.stateManager.toEnded();
      }
    }, {
      key: "type",
      get: function get() {
        return fp.ENDING;
      }
    }]), t;
  }(),
      bp = function () {
    qn(r, yp);
    var n = Xn(r);

    function r(e, t) {
      return Un(this, r), (t = n.call(this, e, t)).isInitiator = e.isCaller, t;
    }

    return Fn(r, [{
      key: "onStart",
      value: function value() {
        this.call.fireOnEstablished(), this.call.sendAudioCommand(), this.call.sendVideoCommand(), this.call.createPeerConnection(), this.isInitiator && this.call.startCallConnectionTimer();
      }
    }, {
      key: "onDestroy",
      value: function value() {}
    }, {
      key: "pcConnected",
      value: function value() {
        this.stateManager.toConnected(!1);
      }
    }, {
      key: "end",
      value: function value() {
        this.call.sendEndCommand().catch(function (e) {
          return _a.debug(e);
        }), this.call.setEndResult(la.COMPLETED), this.stateManager.toClosing();
      }
    }, {
      key: "fireTimeout",
      value: function value() {
        this.call.sendTimeoutCommand(this.isInitiator ? mp.OFFERING : mp.ANSWERING).catch(function (e) {
          return _a.debug(e);
        }), this.call.setEndResult(la.TIMED_OUT), this.stateManager.toClosing();
      }
    }, {
      key: "receiveEnd",
      value: function value(e) {
        this.call.setEndResult(e.payload.endedCall.endResult), this.call.setEndInfo(e.payload.endedCall), this.stateManager.toClosing();
      }
    }, {
      key: "toggleMicrophone",
      value: function value(e) {
        this.call.toggleMicrophone(e), this.call.sendAudioCommand().catch(function (e) {
          return _a.debug(e);
        });
      }
    }, {
      key: "toggleVideo",
      value: function value(e) {
        this.call.toggleVideo(e), this.call.sendVideoCommand().catch(function (e) {
          return _a.debug(e);
        });
      }
    }, {
      key: "type",
      get: function get() {
        return fp.ESTABLISHED;
      }
    }]), r;
  }(),
      Op = function () {
    qn(t, yp);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "dialSent",
      value: function value() {
        this.stateManager.toDialing();
      }
    }, {
      key: "dialFailed",
      value: function value() {
        this.call.setEndResult(la.DIAL_FAILED), this.stateManager.toClosing();
      }
    }, {
      key: "end",
      value: function value() {
        this.call.setEndResult(la.CANCELED), this.stateManager.toAborted();
      }
    }, {
      key: "toggleMicrophone",
      value: function value(e) {
        this.call.toggleMicrophone(e);
      }
    }, {
      key: "toggleVideo",
      value: function value(e) {
        this.call.toggleVideo(e);
      }
    }, {
      key: "type",
      get: function get() {
        return fp.IDLE;
      }
    }]), t;
  }(),
      Dp = function () {
    qn(r, yp);
    var n = Xn(r);

    function r(e, t) {
      return Un(this, r), n.call(this, e, t);
    }

    return Fn(r, [{
      key: "onStart",
      value: function value() {
        var e = this;
        this._createTimer(function () {
          e.call.sendConnectionLostCommand().catch(function (e) {
            return _a.debug(e);
          });
        }, this._getTimeoutTime()), this.call.fireOnReconnecting(), this.call.playSound(Yc.RECONNECTING);
      }
    }, {
      key: "onDestroy",
      value: function value() {
        this._removeTimer(), this.call.stopSound(Yc.RECONNECTING);
      }
    }, {
      key: "pcConnected",
      value: function value() {
        this.stateManager.toConnected(!0);
      }
    }, {
      key: "end",
      value: function value() {
        this.call.sendEndCommand().catch(function (e) {
          return _a.debug(e);
        }), this.call.setEndResult(la.COMPLETED), this.stateManager.toClosing();
      }
    }, {
      key: "endSent",
      value: function value(e) {
        this.call.setEndResult(la.CONNECTION_LOST), this.call.setEndInfo(e.payload.endedCall), this.stateManager.toClosing();
      }
    }, {
      key: "receiveEnd",
      value: function value(e) {
        this.call.setEndResult(e.payload.endedCall.endResult), this.call.setEndInfo(e.payload.endedCall), this.stateManager.toClosing();
      }
    }, {
      key: "_getTimeoutTime",
      value: function value() {
        return 3e4;
      }
    }, {
      key: "toggleMicrophone",
      value: function value(e) {
        this.call.toggleMicrophone(e), this.call.sendAudioCommand().catch(function (e) {
          return _a.debug(e);
        });
      }
    }, {
      key: "toggleVideo",
      value: function value(e) {
        this.call.toggleVideo(e), this.call.sendVideoCommand().catch(function (e) {
          return _a.debug(e);
        });
      }
    }, {
      key: "type",
      get: function get() {
        return fp.RECONNECTING;
      }
    }]), r;
  }(),
      Np = function () {
    qn(t, yp);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return Fn(t, [{
      key: "onStart",
      value: function value() {
        var e = this;
        this._createTimer(function () {
          e._noAnswer();
        }, this._getTimeoutTime()), this.call.startToSendAlive(), this.call.playSound(Yc.RINGING), this.call.fireOnRinging();
      }
    }, {
      key: "onDestroy",
      value: function value() {
        this._removeTimer(), this.call.stopSound(Yc.RINGING);
      }
    }, {
      key: "accept",
      value: function value(e) {
        this.stateManager.toAccepting();
      }
    }, {
      key: "receiveAccepted",
      value: function value() {
        this.call.setEndResult(la.OTHER_DEVICE_ACCEPTED), this.stateManager.toClosing();
      }
    }, {
      key: "end",
      value: function value() {
        this.call.sendDeclineCommand().catch(function (e) {
          return _a.debug(e);
        }), this.call.setEndResult(la.DECLINED), this.stateManager.toClosing();
      }
    }, {
      key: "endSent",
      value: function value(e) {
        this.call.setEndResult(la.DECLINED), this.call.setEndInfo(e.payload.endedCall), this.stateManager.toClosing();
      }
    }, {
      key: "receiveEnd",
      value: function value(e) {
        this.call.setEndResult(e.payload.endedCall.endResult), this.call.setEndInfo(e.payload.endedCall), this.stateManager.toClosing();
      }
    }, {
      key: "toggleMicrophone",
      value: function value(e) {
        this.call.toggleMicrophone(e);
      }
    }, {
      key: "toggleVideo",
      value: function value(e) {
        this.call.toggleVideo(e);
      }
    }, {
      key: "_noAnswer",
      value: function value() {
        this.call.sendNoAnswerCommand().catch(function (e) {
          return _a.debug(e);
        }), this.call.setEndResult(la.NO_ANSWER), this.stateManager.toClosing();
      }
    }, {
      key: "_getTimeoutTime",
      value: function value() {
        return this.call.options.ringingTimeoutValue;
      }
    }, {
      key: "type",
      get: function get() {
        return fp.RINGING;
      }
    }]), t;
  }(),
      Lp = function () {
    function t(e) {
      Un(this, t), this.call = e, this._state = null;
    }

    return Fn(t, [{
      key: "toAborted",
      value: function value() {
        this._changeState(new gp(this.call, this));
      }
    }, {
      key: "toAccepting",
      value: function value() {
        this._changeState(new Rp(this.call, this));
      }
    }, {
      key: "toCanceled",
      value: function value() {
        this._changeState(new Cp(this.call, this));
      }
    }, {
      key: "toClosing",
      value: function value() {
        this._changeState(new Ip(this.call, this));
      }
    }, {
      key: "toConnected",
      value: function value(e) {
        this._changeState(new wp(this.call, this, e));
      }
    }, {
      key: "toDialing",
      value: function value() {
        this._changeState(new Ap(this.call, this));
      }
    }, {
      key: "toEnded",
      value: function value() {
        this._changeState(new Tp(this.call, this));
      }
    }, {
      key: "toEnding",
      value: function value() {
        this._changeState(new Sp(this.call, this));
      }
    }, {
      key: "toEstablished",
      value: function value() {
        this._changeState(new bp(this.call, this));
      }
    }, {
      key: "toIdle",
      value: function value() {
        this._changeState(new Op(this.call, this));
      }
    }, {
      key: "toReconnecting",
      value: function value() {
        this._changeState(new Dp(this.call, this));
      }
    }, {
      key: "toRinging",
      value: function value() {
        this._changeState(new Np(this.call, this));
      }
    }, {
      key: "_changeState",
      value: function value(e) {
        this._state && this._state.type === e.type ? _a.error(new Error("self-transition is not allowed")) : (_a.debug("state: ".concat(this._state ? this._state.type : "null", " -> ").concat(e.type)), this._state && this._state.onDestroy(), this._state = e, this._state.onStart());
      }
    }, {
      key: "state",
      get: function get() {
        return this._state;
      }
    }]), t;
  }(),
      xp = function () {
    function r(e, t, n) {
      Un(this, r), this._ctx = e, this.peerConnectionId = t, this.callId = n;
    }

    return Fn(r, [{
      key: "sendOfferSdp",
      value: function value(e) {
        e = of.createOffer(this.callId, this.peerConnectionId, e.sdp);
        return this._ctx.sender.send(e);
      }
    }, {
      key: "sendAnswerSdp",
      value: function value(e) {
        e = of.createAnswer(this.callId, this.peerConnectionId, e.sdp);
        return this._ctx.sender.send(e);
      }
    }, {
      key: "sendCandidate",
      value: function value(e) {
        e = of.createCandidate(this.callId, this.peerConnectionId, e.candidate, e.sdpMLineIndex, e.sdpMid);
        return this._ctx.sender.send(e);
      }
    }]), r;
  }(),
      Pp = cr(null, function (a, e) {
    var n, t, r, i, o, s, c, u, l, d;
    return {
      F: function () {
        qn(i, e);
        var r = Xn(i);

        function i(e, t) {
          var n;
          return Un(this, i), n = r.call(this), a(Qn(n)), n._ctx = e, n._options = t, n._localMediaView = null, n._remoteMediaView = null, n._caller = null, n._callee = null, n._localConstraints = {
            audio: !0,
            video: !0
          }, n._remoteConstraints = {
            audio: void 0,
            video: void 0
          }, n._endResult = null, n._endInfo = null, n._customItems = null, n._remoteRecordingStatus = $c.NONE, n._sendBirdChatOptions = null, n._holdedBy = [], n._wasRelayed = !1, n._logManager = new If(e, Qn(n)), n._stateManager = new Lp(Qn(n)), n._isReconnected = !1, n._rotatablePeerConnection = new Js(e, {
            audio: "sendrecv",
            video: "sendrecv"
          }), n._rotatablePeerConnection.once("initialized", function () {
            n._onPeerConnectionInitialized();
          }), n._rotatablePeerConnection.on("replaced", function () {
            n._onPeerConnectionReplaced();
          }), n._localStream = new zc(e.deviceManager), n._localStream.on("streamChanged", function () {
            n._onLocalStream();
          }), n._localStream.on("audioOutputChanged", function () {
            n._onAudioOutputChanged();
          }), n._localStream.on("screenShareStreamStopped", function () {
            n.onScreenShareStopped && n.onScreenShareStopped(), n._dispatchEvent("onScreenShareStopped");
          }), n;
        }

        return i;
      }(),
      d: [{
        kind: "field",
        key: "_remoteCapabilities",
        value: function value() {
          return [];
        }
      }, {
        kind: "get",
        key: "_pc",
        value: function value() {
          return this._rotatablePeerConnection.activePeerConnection;
        }
      }, {
        kind: "get",
        key: "callId",
        value: function value() {
          return this._callId;
        }
      }, {
        kind: "get",
        key: "isVideoCall",
        value: function value() {
          return this._isVideoCall;
        }
      }, {
        kind: "get",
        key: "isCaller",
        value: function value() {
          return this._isCaller;
        }
      }, {
        kind: "get",
        key: "caller",
        value: function value() {
          return this._caller;
        }
      }, {
        kind: "get",
        key: "callee",
        value: function value() {
          return this._callee;
        }
      }, {
        kind: "get",
        key: "localUser",
        value: function value() {
          return this._isCaller ? this.caller : this.callee;
        }
      }, {
        kind: "get",
        key: "remoteUser",
        value: function value() {
          return this._isCaller ? this.callee : this.caller;
        }
      }, {
        kind: "get",
        key: "isLocalAudioEnabled",
        value: function value() {
          return this._localConstraints.audio;
        }
      }, {
        kind: "get",
        key: "isRemoteAudioEnabled",
        value: function value() {
          return this._remoteConstraints.audio;
        }
      }, {
        kind: "get",
        key: "isLocalVideoEnabled",
        value: function value() {
          return this._localConstraints.video;
        }
      }, {
        kind: "get",
        key: "isRemoteVideoEnabled",
        value: function value() {
          return this._remoteConstraints.video;
        }
      }, {
        kind: "get",
        key: "localRecordingStatus",
        value: function value() {
          var e;
          return null !== (e = null === (e = this._record) || void 0 === e ? void 0 : e.recordingStatus) && void 0 !== e ? e : $c.NONE;
        }
      }, {
        kind: "get",
        key: "remoteRecordingStatus",
        value: function value() {
          return this._remoteRecordingStatus;
        }
      }, {
        kind: "get",
        key: "localMediaView",
        value: function value() {
          return this._localMediaView;
        }
      }, {
        kind: "get",
        key: "remoteMediaView",
        value: function value() {
          return this._remoteMediaView;
        }
      }, {
        kind: "get",
        key: "myRole",
        value: function value() {
          return this._isCaller ? da.CALLER : da.CALLEE;
        }
      }, {
        kind: "get",
        key: "endedBy",
        value: function value() {
          return this._endInfo ? this._endInfo.endedBy : void 0;
        }
      }, {
        kind: "get",
        key: "options",
        value: function value() {
          return this._options;
        }
      }, {
        kind: "get",
        key: "isOngoing",
        value: function value() {
          return !this.isEnded;
        }
      }, {
        kind: "get",
        key: "isOnHold",
        value: function value() {
          return 0 < this._holdedBy.length;
        }
      }, {
        kind: "get",
        key: "_isLocalOnHold",
        value: function value() {
          return -1 < this._holdedBy.indexOf(this.localUser.userId);
        }
      }, {
        kind: "get",
        key: "isEnded",
        value: function value() {
          return !!this._endResult;
        }
      }, {
        kind: "get",
        key: "endResult",
        value: function value() {
          return this._endResult;
        }
      }, {
        kind: "get",
        key: "_state",
        value: function value() {
          return this._stateManager.state;
        }
      }, {
        kind: "get",
        key: "customItems",
        value: function value() {
          return jn({}, this._customItems);
        }
      }, {
        kind: "get",
        key: "rtcConnection",
        value: function value() {
          var e;
          return null === (e = this._pc) || void 0 === e ? void 0 : e.rtcConnection;
        }
      }, {
        kind: "get",
        key: "callLog",
        value: function value() {
          var e = this._state.type;
          if (e !== fp.ENDING && e !== fp.ENDED) return null;
          e = this._endInfo;
          return new Eh({
            call_id: (e || this).callId,
            is_video_call: (e || this).isVideoCall,
            custom_items: e ? e.customItems : this._customItems,
            user_role: e ? e.userRole : this.myRole,
            started_at: e ? e.startedAt : this._startedAt || Date.now(),
            ended_at: e ? e.endedAt : Date.now(),
            participants: e ? e._participants : [this.caller, this.callee],
            ended_by: this.endedBy,
            duration: e ? e.duration : this.getDuration(),
            end_result: (e || this).endResult,
            call_type: e ? e.callType : "direct"
          }, !1);
        }
      }, {
        kind: "get",
        key: "_record",
        value: function value() {
          return this._ctx.recordingManager.getRecord(this._recordId);
        }
      }, {
        kind: "get",
        key: "_isTurnChangedSupported",
        value: function value() {
          return Sh.includes("turn_changed") && this._remoteCapabilities.includes("turn_changed");
        }
      }, {
        kind: "method",
        key: "setLocalMediaView",
        value: (d = Mn(_regeneratorRuntime.mark(function e(t) {
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, this._updateLocalMediaView(t);

                case 2:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return d.apply(this, arguments);
        })
      }, {
        kind: "method",
        key: "setRemoteMediaView",
        value: (l = Mn(_regeneratorRuntime.mark(function e(t) {
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, this._updateRemoteMediaView(t);

                case 2:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return l.apply(this, arguments);
        })
      }, {
        kind: "method",
        key: "startDuration",
        value: function value() {
          void 0 === this._startedAt && (this._startedAt = Date.now());
        }
      }, {
        kind: "method",
        key: "getDuration",
        value: function value() {
          return this._endInfo ? this._endInfo.duration : void 0 === this._startedAt ? 0 : Date.now() - this._startedAt;
        }
      }, {
        kind: "method",
        key: "_send",
        value: function value(e) {
          return this._ctx.sender.send(e);
        }
      }, {
        kind: "method",
        decorators: [df({
          callOption: va
        })],
        key: "dial",
        value: function value(e) {
          var n = this,
              t = e.userId,
              r = e.isVideoCall,
              i = e.callOption,
              a = e.customItems,
              o = e.sendBirdChatOptions;
          this._isCaller = !0, this._stateManager.toIdle();
          e = new Zs();
          return this._dialDeferred = e, this._isVideoCall = r, this._localStream.mediaConstraints = {
            audio: !0,
            video: r
          }, this._sendBirdChatOptions = o, this._setLocalOption(i), this._getLocalStream(), this._setCustomItems(a), this._logManager.summary.onDial(), this.sendDialCommand(t).then(function () {
            var e;
            null !== (e = n._dialDeferred) && void 0 !== e && e.resolve(), delete n._dialDeferred;
          }).catch(function (e) {
            var t;
            null !== (t = n._dialDeferred) && void 0 !== t && t.reject(e), delete n._dialDeferred;
          }), e.promise;
        }
      }, {
        kind: "method",
        key: "_dialed",
        value: function value(e) {
          this._isCaller = !1;
          e = e.payload;
          this._isVideoCall = e.isVideoCall, this._localStream.mediaConstraints = {
            audio: !0,
            video: e.isVideoCall
          }, this._remoteCapabilities = e.capabilities, this._initTurnCredential = e.turnCredential, this._isTurnChangedSupported && (this._initTurnCredential.turnUrls = [this._initTurnCredential.turnUrls[0]]), this._setCallInfo(e.callId, e.caller, e.callee), this._setCustomItems(e.customItems), this._setRemoteOption(e.constraints), this._stateManager.toRinging();
        }
      }, {
        kind: "method",
        key: "_dialSent",
        value: function value(e) {
          e = e.payload;
          this._setCallInfo(e.callId, e.caller, e.callee), this._logManager.summary.onDialAck(), this._state.dialSent();
        }
      }, {
        kind: "method",
        decorators: [tu(tu.messages.CALL_IS_NOT_SUPPORTED), df({
          callOption: va
        })],
        key: "accept",
        value: function value(e) {
          var t = e.callOption,
              e = e.holdActiveCall;
          _a.info("accept()"), e ? this._ctx.callManager.holdExcept(this) : this._ctx.callManager.endExcept(this), this._setLocalOption(t), this._getLocalStream(), this._logManager.summary.onAccept(), this._state.accept(t);
        }
      }, {
        kind: "method",
        key: "_receiveAccept",
        value: function value(e) {
          e = e.payload;
          this._remoteCapabilities = e.capabilities, this._initTurnCredential = e.turnCredential, this._isTurnChangedSupported && (this._initTurnCredential.turnUrls = [this._initTurnCredential.turnUrls[0]]), this._setRemoteOption(e.constraints), this._logManager.summary.onAcceptAck(), this._state.receiveAccept();
        }
      }, {
        kind: "method",
        key: "_canceled",
        value: function value(e) {
          e = e.payload.endedCall;
          this._setCallInfo(e.callId, e.caller, e.callee), this._setCustomItems(e.customItems), this.setEndResult(e.endResult), this.setEndInfo(e), this._stateManager.toCanceled();
        }
      }, {
        kind: "method",
        key: "end",
        value: function value() {
          _a.info("end()"), this._dialDeferred && (this._dialDeferred.reject(new ou(Tn.DIAL_CANCELED)), delete this._dialDeferred), this._state.end();
        }
      }, {
        kind: "method",
        key: "_setLocalOption",
        value: function value(e) {
          this._updateLocalMediaView(e.localMediaView), this._updateRemoteMediaView(e.remoteMediaView), this._localConstraints.audio = e.audioEnabled, this._localConstraints.video = e.videoEnabled;
        }
      }, {
        kind: "method",
        key: "_setRemoteOption",
        value: function value(e) {
          this._remoteConstraints = e;
        }
      }, {
        kind: "method",
        key: "_setCallInfo",
        value: function value(e, t, n) {
          this._callId = e, this._caller = t, this._callee = n;
        }
      }, {
        kind: "method",
        key: "setEndResult",
        value: function value(e) {
          this._endResult = e;
        }
      }, {
        kind: "method",
        key: "setEndInfo",
        value: function value(e) {
          this._endInfo = e;
        }
      }, {
        kind: "method",
        key: "_setRemoteAudioEnabled",
        value: function value(e) {
          this._remoteConstraints.audio !== (this._remoteConstraints.audio = e) && (this._dispatchEvent("onRemoteAudioSettingsChanged", this), null !== (e = this.onRemoteAudioSettingsChanged) && void 0 !== e && e.call(this, this));
        }
      }, {
        kind: "method",
        key: "_setRemoteVideoEnabled",
        value: function value(e) {
          this._remoteConstraints.video !== (this._remoteConstraints.video = e) && (this._dispatchEvent("onRemoteVideoSettingsChanged", this), null !== (e = this.onRemoteVideoSettingsChanged) && void 0 !== e && e.call(this, this));
        }
      }, {
        kind: "method",
        key: "_setHoldInfo",
        value: function value(e, t, n) {
          var r = t ? this.localUser : this.remoteUser;
          this._wasRelayed ? n ? this._holdedBy.indexOf(r.userId) < 0 && this._holdedBy.push(r.userId) : -1 < (r = this._holdedBy.indexOf(r.userId)) && this._holdedBy.splice(r, 1) : this._holdedBy = e, this._updateStreamByHoldStream(), this._dispatchEvent("onUserHoldStatusChanged", this, t, n), null !== (e = this.onUserHoldStatusChanged) && void 0 !== e && e.call(this, this, t, n);
        }
      }, {
        kind: "method",
        key: "_setCustomItems",
        value: function value(e) {
          this._customItems = e || {};
        }
      }, {
        kind: "method",
        key: "_setRemoteRecordingStatus",
        value: function value(e) {
          var t = this._remoteRecordingStatus;
          (this._remoteRecordingStatus = e) !== t && (this._dispatchEvent("onRemoteRecordingStatusChanged", this), null !== (t = this.onRemoteRecordingStatusChanged) && void 0 !== t && t.call(this, this));
        }
      }, {
        kind: "method",
        key: "closeRTCConnection",
        value: function value() {
          this._releaseLocalStream(), this._rotatablePeerConnection.removeAllEventListeners(), this._rotatablePeerConnection.close();
        }
      }, {
        kind: "method",
        key: "startVideo",
        value: function value() {
          _a.info("startVideo()"), this._state.toggleVideo(!0);
        }
      }, {
        kind: "method",
        key: "stopVideo",
        value: function value() {
          _a.info("stopVideo()"), this._state.toggleVideo(!1);
        }
      }, {
        kind: "method",
        key: "hold",
        value: (u = Mn(_regeneratorRuntime.mark(function e() {
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (_a.info("hold()"), this._isLocalOnHold) throw new ra(Tn.ERR_CALL_ALREADY_ON_HOLD);
                  e.next = 3;
                  break;

                case 3:
                  return e.next = 5, this.sendHoldCommand(!0, this._wasRelayed);

                case 5:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return u.apply(this, arguments);
        })
      }, {
        kind: "method",
        key: "unhold",
        value: (c = Mn(_regeneratorRuntime.mark(function e(t) {
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (_a.info("unhold()"), this._isLocalOnHold) {
                    e.next = 3;
                    break;
                  }

                  throw new ra(Tn.ERR_ACTIVE_CALL_IN_PROGRESS);

                case 3:
                  if (t && this._ctx.callManager.endExcept(this), 0 < this._ctx.callManager.getActiveCallCount()) throw new ra(Tn.ERR_ANOTHER_CALL_IN_PROGRESS);
                  e.next = 6;
                  break;

                case 6:
                  return e.next = 8, this.sendHoldCommand(!1, this._wasRelayed);

                case 8:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return c.apply(this, arguments);
        })
      }, {
        kind: "method",
        key: "_holdSent",
        value: function value(e, t) {
          e = e.payload;
          e.isRelayed && (this._wasRelayed = !0), this._setHoldInfo(e.holdedBy, !0, t);
        }
      }, {
        kind: "method",
        key: "_updateStreamByHoldStream",
        value: function value() {
          var t = this;
          this.stopScreenShare();

          var e = this._getLocalStream();

          e && (e.getAudioTracks().forEach(function (e) {
            e.enabled = t._isMediaEnabled("audio");
          }), e.getVideoTracks().forEach(function (e) {
            e.enabled = t._isMediaEnabled("video");
          })), this._pc.remoteStream && (this._pc.remoteStream.getAudioTracks().forEach(function (e) {
            e.enabled = !t.isOnHold;
          }), this._pc.remoteStream.getVideoTracks().forEach(function (e) {
            e.enabled = !t.isOnHold;
          }));
        }
      }, {
        kind: "method",
        key: "_checkRecordingCondition",
        value: function value(e) {
          return this._state.type !== fp.CONNECTED ? (_a.error(pr.getErrorMessage(Tn.ERR_CALL_NOT_CONNECTED_YET)), !1) : !(!this.isVideoCall && e.isVideo) || (_a.error(pr.getErrorMessage(Tn.ERR_WRONG_RECORDING_TYPE_FOR_AUDIO_CALL)), !1);
        }
      }, {
        kind: "method",
        key: "startRecording",
        value: function value(e) {
          var t = this,
              n = new Ta(e);
          if (!Object.values(ka).includes(n.recordingType)) return _a.error(pr.getErrorMessage(Tn.ERR_INVALID_RECORDING_TYPE)), !1;

          try {
            !function () {
              if (!window.MediaRecorder) {
                var e = pr.getErrorMessage(Tn.ERR_NOT_SUPPORTED_BROWSER_FOR_RECORDING);
                throw _a.error(e), e;
              }
            }();
          } catch (e) {
            return;
          }

          if (this._checkRecordingCondition(n)) if (this._recordId) _a.error(pr.getErrorMessage(Tn.ERR_RECORDING_ALREADY_IN_PROGRESS));else {
            var r = vp.createStream(this, n.recordingType),
                i = r.stream,
                a = r.options,
                o = r.cleanup,
                s = this._ctx.recordingManager.startRecording(i, a, jn(jn({}, n), {}, {
              callId: this.callId
            }));

            if (s) {
              var c = function c() {
                t.sendRecordingCommand(s.recordId, e.recordingType, s.recordingStatus);
              };

              return s.on("start", c), s.on("stop", function () {
                o && o(), c();
              }), s.on("pause", c), s.on("resume", c), s.on("error", c), this._recordId = s.recordId, s.recordId;
            }
          }
        }
      }, {
        kind: "method",
        key: "stopRecording",
        value: function value(e) {
          return e && this._recordId === e ? (this._ctx.recordingManager.stopRecording(e), delete this._recordId, !0) : (_a.error(pr.getErrorMessage(Tn.ERR_FAILED_TO_STOP_RECORDING)), !1);
        }
      }, {
        kind: "method",
        key: "stopCurrentRecording",
        value: function value() {
          return !!this._recordId && this.stopRecording(this._recordId);
        }
      }, {
        kind: "method",
        key: "toggleVideo",
        value: function value(e) {
          var t = this;
          this._localConstraints.video !== e && (this._localConstraints.video = e, (e = this._getLocalStream()) && e.getVideoTracks().forEach(function (e) {
            e.enabled = t._isMediaEnabled("video");
          }));
        }
      }, {
        kind: "method",
        key: "muteMicrophone",
        value: function value() {
          _a.info("muteMicrophone()"), this._state.toggleMicrophone(!1);
        }
      }, {
        kind: "method",
        key: "unmuteMicrophone",
        value: function value() {
          _a.info("unmuteMicrophone()"), this._state.toggleMicrophone(!0);
        }
      }, {
        kind: "method",
        key: "toggleMicrophone",
        value: function value(e) {
          var t = this;
          this._localConstraints.audio !== e && (this._localConstraints.audio = e, (e = this._getLocalStream()) && e.getAudioTracks().forEach(function (e) {
            e.enabled = t._isMediaEnabled("audio");
          }));
        }
      }, {
        kind: "method",
        key: "_validateScreenShareAvailability",
        value: function value() {
          if (this._state.type !== fp.CONNECTED && this._state.type !== fp.RECONNECTING) throw new ra(Tn.ERR_SCREEN_SHARE_REQUEST_BEFORE_CALL_IS_CONNECTED);
          if (!this.isVideoCall) throw new ra(Tn.ERR_SCREEN_SHARE_RESTRICTED_FROM_AUDIO_CALL);
          if (this.isLocalScreenShareEnabled) throw new ra(Tn.ERR_SCREEN_SHARE_ALREADY_IN_PROGRESS);
          if (this.isOnHold) throw new ra(Tn.ERR_MEDIA_STREAM_NOT_ALLOWED_ON_HOLD);
        }
      }, {
        kind: "get",
        key: "isLocalScreenShareEnabled",
        value: function value() {
          return this._localStream.isScreenSharing;
        }
      }, {
        kind: "method",
        key: "startScreenShare",
        value: (s = Mn(_regeneratorRuntime.mark(function e() {
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return this._validateScreenShareAvailability(), e.next = 3, this._localStream.useScreenStream();

                case 3:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return s.apply(this, arguments);
        })
      }, {
        kind: "method",
        key: "stopScreenShare",
        value: function value() {
          this.isLocalScreenShareEnabled && this._localStream.stopScreenShare();
        }
      }, {
        kind: "method",
        key: "_validateCaptureAvailability",
        value: function value(e) {
          if (this._state.type !== fp.CONNECTED) throw new ra(Tn.ERR_VIDEO_CALL_NOT_CONNECTED_YET);
          if (!this.isVideoCall) throw new ra(Tn.ERR_CAPTURE_NOT_ALLOWED_ON_AUDIO_CALL);
          if (e instanceof HTMLAudioElement) throw new ra(Tn.ERR_VIDEO_VIEW_NOT_READY);
          if (null == e || !e.srcObject) throw new ra(Tn.ERR_VIDEO_VIEW_NOT_READY);
          if (this.isOnHold) throw new ra(Tn.ERR_MEDIA_STREAM_NOT_ALLOWED_ON_HOLD);
        }
      }, {
        kind: "method",
        key: "captureLocalVideoView",
        value: function value(e) {
          var n = this,
              t = new Promise(function (e, t) {
            n._validateCaptureAvailability(n._localMediaView), e(n._captureVideoView(n._localMediaView));
          });
          return e && ia(t)(e), t;
        }
      }, {
        kind: "method",
        key: "captureRemoteVideoView",
        value: function value(e) {
          var n = this,
              t = new Promise(function (e, t) {
            n._validateCaptureAvailability(n.remoteMediaView), e(n._captureVideoView(n._remoteMediaView));
          });
          return e && ia(t)(e), t;
        }
      }, {
        kind: "method",
        key: "_captureVideoView",
        value: function value(e) {
          try {
            var t,
                n = document.createElement("canvas"),
                r = n.getContext("2d"),
                i = e;
            n.width = null !== (t = i.videoWidth) && void 0 !== t ? t : 640, n.height = null !== (t = i.videoHeight) && void 0 !== t ? t : 360, r.drawImage(i, 0, 0);
            i = {
              width: n.width,
              height: n.height,
              data: n.toDataURL("image/jpeg", 1)
            };
            return n.remove(), i;
          } catch (e) {
            throw _a.error(e), new ra(Tn.ERR_FAILED_TO_GET_IMAGE_FROM_VIDEO_STREAM);
          }
        }
      }, {
        kind: "method",
        key: "updateCustomItems",
        value: function value(e, t) {
          var n = this,
              r = Jn(aa(e, t), 2)[1];
          if (r) return r;
          e = of.createUpdateCustomItems(this.callId, e), e = this._send(e).then(function (e) {
            return n._setCustomItems(e.custom_items), {
              customItems: e.custom_items,
              affectedKeys: e.updated
            };
          }).catch(function (e) {
            throw _a.error("failed to update customItems"), e;
          });
          return t && ia(e)(t), e;
        }
      }, {
        kind: "method",
        key: "deleteCustomItems",
        value: function value(e, t) {
          var n = this,
              r = Jn(oa(e, t), 2)[1];
          if (r) return r;
          e = of.createDeleteCustomItems(this.callId, e), e = this._send(e).then(function (e) {
            return n._setCustomItems(e.custom_items), {
              customItems: e.custom_items,
              affectedKeys: e.deleted
            };
          }).catch(function (e) {
            throw _a.error("failed to delete customItems"), e;
          });
          return t && ia(e)(t), e;
        }
      }, {
        kind: "method",
        key: "deleteAllCustomItems",
        value: function value(e) {
          var t = this,
              n = of.createDeleteAllCustomItems(this.callId),
              n = this._send(n).then(function (e) {
            return t._setCustomItems(e.custom_items), {
              customItems: e.custom_items,
              affectedKeys: e.deleted
            };
          }).catch(function (e) {
            throw _a.error("failed to delete all customItems"), e;
          });

          return e && ia(n)(e), n;
        }
      }, {
        kind: "method",
        key: "fireOnRinging",
        value: function value() {
          _a.info("onRinging"), this.onRinging && this.onRinging();
        }
      }, {
        kind: "method",
        key: "fireOnEstablished",
        value: function value() {
          var e;
          _a.info("onEstablished"), this._dispatchEvent("onEstablished", this), null !== (e = this.onEstablished) && void 0 !== e && e.call(this, this);
        }
      }, {
        kind: "method",
        key: "fireOnEnded",
        value: function value() {
          var e;

          switch (this.endResult) {
            case la.NO_ANSWER:
            case la.CANCELED:
            case la.DECLINED:
            case la.OTHER_DEVICE_ACCEPTED:
            case la.COMPLETED:
              _a.info("onEnded");

              break;

            case la.TIMED_OUT:
              _a.warning("onEnded");

              break;

            case la.CONNECTION_LOST:
            case la.DIAL_FAILED:
            case la.ACCEPT_FAILED:
            case la.UNKNOWN:
              _a.error("onEnded");

              break;

            default:
              _a.info("onEnded");

          }

          this._dispatchEvent("onEnded", this), null !== (e = this.onEnded) && void 0 !== e && e.call(this, this);
        }
      }, {
        kind: "method",
        key: "fireOnConnected",
        value: function value() {
          var e;
          _a.info("onConnected"), this._dispatchEvent("onConnected", this), null !== (e = this.onConnected) && void 0 !== e && e.call(this, this);
        }
      }, {
        kind: "method",
        key: "fireOnReconnecting",
        value: function value() {
          var e;
          _a.info("onReconnecting"), this._dispatchEvent("onReconnecting", this), null !== (e = this.onReconnecting) && void 0 !== e && e.call(this, this);
        }
      }, {
        kind: "method",
        key: "fireOnReconnected",
        value: function value() {
          var e;
          _a.info("onReconnected"), this._dispatchEvent("onReconnected", this), null !== (e = this.onReconnected) && void 0 !== e && e.call(this, this);
        }
      }, {
        kind: "method",
        key: "sendDialCommand",
        value: function value(e) {
          var t = this,
              e = of.createDial(e, this._isVideoCall, this._customItems, this._sendBirdChatOptions, this._localConstraints);
          return this._send(e).then(function (e) {
            t.onEvent(e);
          }).catch(function (e) {
            throw t._state.dialFailed(), e;
          });
        }
      }, {
        kind: "method",
        key: "sendAcceptCommand",
        value: function value() {
          var t = this,
              e = of.createAccept(this.callId, this._localConstraints);
          return this._send(e).then(function (e) {
            t.onEvent(e);
          }).catch(function (e) {
            throw t._state.acceptFailed(), e;
          });
        }
      }, {
        kind: "method",
        key: "sendCancelCommand",
        value: function value() {
          var t = this,
              e = of.createCancel(this.callId);
          return this._send(e).then(function (e) {
            t.onEvent(e);
          });
        }
      }, {
        kind: "method",
        key: "sendDeclineCommand",
        value: function value() {
          var t = this,
              e = of.createDecline(this.callId);
          return this._send(e).then(function (e) {
            t.onEvent(e);
          });
        }
      }, {
        kind: "method",
        key: "sendEndCommand",
        value: function value() {
          var t = this,
              e = of.createEnd(this.callId);
          return this._send(e).then(function (e) {
            t.onEvent(e);
          });
        }
      }, {
        kind: "method",
        key: "sendTimeoutCommand",
        value: function value(e) {
          var t = this,
              e = of.createTimeout(this.callId, e);
          return this._send(e).then(function (e) {
            t.onEvent(e);
          });
        }
      }, {
        kind: "method",
        key: "sendConnectionLostCommand",
        value: function value() {
          var t = this,
              e = of.createConnectionLost(this.callId);
          return this._send(e).then(function (e) {
            t.onEvent(e);
          });
        }
      }, {
        kind: "method",
        key: "sendNoAnswerCommand",
        value: function value() {
          var t = this,
              e = of.createNoAnswer(this.callId);
          return this._send(e).then(function (e) {
            t.onEvent(e);
          });
        }
      }, {
        kind: "method",
        key: "sendAliveCommand",
        value: function value() {
          var e = of.createAlive(this.callId);
          return this._send(e);
        }
      }, {
        kind: "method",
        key: "sendAudioCommand",
        value: function value() {
          var e = of.createAudio(this.callId, this._localConstraints.audio);
          return this._send(e);
        }
      }, {
        kind: "method",
        key: "sendVideoCommand",
        value: function value() {
          var e = of.createVideo(this.callId, this._localConstraints.video);
          return this._send(e);
        }
      }, {
        kind: "method",
        key: "sendCallSummaryCommand",
        value: function value(e) {
          e = of.createCallSummaryCommand(this._callId, this.myRole, e);
          return this._send(e);
        }
      }, {
        kind: "method",
        key: "sendConnectedCommand",
        value: function value(e, t, n) {
          n = of.createConnected(e, t, n);
          return this._send(n);
        }
      }, {
        kind: "method",
        key: "sendRecordingCommand",
        value: function value(e, t, n) {
          n = of.createRecording(this.callId, e, t, n);
          return this._send(n);
        }
      }, {
        kind: "method",
        key: "sendHoldCommand",
        value: function value(t, e) {
          var n = this,
              e = of.createHoldCommand(this.callId, t, e);
          return this._send(e).then(function (e) {
            n._holdSent(e, t);
          });
        }
      }, {
        kind: "method",
        key: "startToSendAlive",
        value: function value() {
          var e = this;
          this._aliveIntervalId = setInterval(function () {
            e.sendAliveCommand().catch(function (e) {
              return _a.debug(e);
            });
          }, 3e4);
        }
      }, {
        kind: "method",
        key: "stopToSendAlive",
        value: function value() {
          this._aliveIntervalId && (clearInterval(this._aliveIntervalId), delete this._aliveIntervalId);
        }
      }, {
        kind: "method",
        key: "startGetWebRtcStats",
        value: function value() {
          this._logManager.startGetWebRtcStats(this._rotatablePeerConnection);
        }
      }, {
        kind: "method",
        key: "stopGetWebRtcStats",
        value: function value() {
          this._logManager.stopGetWebRtcStats();
        }
      }, {
        kind: "method",
        key: "sendConnectedInfo",
        value: function value() {
          var t = this;

          this._pc.getCandidateInfo().then(function (e) {
            e && t.sendConnectedCommand(t.callId, e, t._isReconnected);
          });
        }
      }, {
        kind: "method",
        key: "sendCallSummary",
        value: function value() {
          var e;
          this.callId && this.endResult !== la.OTHER_DEVICE_ACCEPTED && (e = this._logManager.getCallSummary(), this.sendCallSummaryCommand(e));
        }
      }, {
        kind: "method",
        key: "startCallConnectionTimer",
        value: function value() {
          var e = this;
          this._callConnectionTimer = setTimeout(function () {
            e._state.fireTimeout();
          }, this._options.callConnectionTimeoutValue);
        }
      }, {
        kind: "method",
        key: "stopCallConnectionTimer",
        value: function value() {
          this._callConnectionTimer && (clearTimeout(this._callConnectionTimer), delete this._callConnectionTimer);
        }
      }, {
        kind: "method",
        key: "playSound",
        value: (o = Mn(_regeneratorRuntime.mark(function e(t) {
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", this._ctx.soundManager.playSound(t));

                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return o.apply(this, arguments);
        })
      }, {
        kind: "method",
        key: "stopSound",
        value: function value(e) {
          return this._ctx.soundManager.stopSound(e);
        }
      }, {
        kind: "method",
        key: "stopAllSound",
        value: function value() {
          return this._ctx.soundManager.stopAllSound();
        }
      }, {
        kind: "method",
        key: "_receiveAudio",
        value: function value(e) {
          this._setRemoteAudioEnabled(e.payload.isEnabled);
        }
      }, {
        kind: "method",
        key: "_receiveVideo",
        value: function value(e) {
          this._setRemoteVideoEnabled(e.payload.isEnabled);
        }
      }, {
        kind: "method",
        key: "_receiveHold",
        value: function value(e) {
          e.payload.isRelayed && (this._wasRelayed = !0), this._setHoldInfo(e.payload.holdedBy, !1, e.payload.isPeerOnHold);
        }
      }, {
        kind: "method",
        key: "_receiveCustomItemsUpdate",
        value: function value(e) {
          var t;
          this._setCustomItems(e.payload.customItems), this._dispatchEvent("onCustomItemsUpdated", this, e.payload.updated), null !== (t = this.onCustomItemsUpdated) && void 0 !== t && t.call(this, this, e.payload.updated);
        }
      }, {
        kind: "method",
        key: "_receiveCustomItemsDelete",
        value: function value(e) {
          var t;
          this._setCustomItems(e.payload.customItems), this._dispatchEvent("onCustomItemsDeleted", this, e.payload.deleted), null !== (t = this.onCustomItemsDeleted) && void 0 !== t && t.call(this, this, e.payload.deleted);
        }
      }, {
        kind: "method",
        key: "_receiveRecording",
        value: function value(e) {
          this._setRemoteRecordingStatus(e.payload.recordingStatus);
        }
      }, {
        kind: "method",
        key: "_receiveTurnChanged",
        value: function value(e) {
          var t;
          this._isTurnChangedSupported && (e = (t = e.payload).turnCredential, t = t.eventId, this.createPeerConnection(t, e));
        }
      }, {
        kind: "method",
        key: "_registerPCListeners",
        value: function value() {
          var e = this,
              t = this._pc;
          t.on("connected", function () {
            e._onPeerConnectionConnected();
          }), t.on("reconnecting", function () {
            e._onPeerConnectionReconnecting();
          }), t.on("remoteStream", function () {
            e._onRemoteStream();
          });
        }
      }, {
        kind: "method",
        key: "createPeerConnection",
        value: function value(e, t) {
          var n = new xp(this._ctx, e, this.callId),
              t = this._rotatablePeerConnection.createPeerConnection(e, n, this._localStream, this._isCaller, e ? t : this._initTurnCredential);

          return this.isCaller && t.createOffer(), t;
        }
      }, {
        kind: "method",
        key: "_onPeerConnectionConnected",
        value: function value() {
          this._state.pcConnected();
        }
      }, {
        kind: "method",
        key: "_onPeerConnectionReconnecting",
        value: function value() {
          this._state.pcReconnecting();
        }
      }, {
        kind: "method",
        key: "_onPeerConnectionInitialized",
        value: function value() {
          this._registerPCListeners(), this._onRemoteStream();
        }
      }, {
        kind: "method",
        key: "_onPeerConnectionReplaced",
        value: function value() {
          this._onPeerConnectionInitialized(), this._onPeerConnectionConnected();
        }
      }, {
        kind: "method",
        key: "_receiveSnapshot",
        value: function value(e) {
          _a.verbose("snapshot is received");

          var t,
              n,
              r,
              i,
              a = e.payload,
              o = a.audioEnabled,
              s = a.videoEnabled,
              e = a.customItems,
              a = a.recording;
          "boolean" == typeof o && this._setRemoteAudioEnabled(o), "boolean" == typeof s && this._setRemoteVideoEnabled(s), a ? this._setRemoteRecordingStatus($c.RECORDING) : this._setRemoteRecordingStatus($c.NONE), e && (t = e, n = Object.keys(t), r = this._customItems, i = Object.keys(r), s = n.filter(function (e) {
            return !i.includes(e) || t[e] !== r[e];
          }), a = i.filter(function (e) {
            return !n.includes(e);
          }), this._setCustomItems(e), 0 < s.length && (this._dispatchEvent("onCustomItemsUpdated", this, s), null !== (e = this.onCustomItemsUpdated) && void 0 !== e && e.call(this, this, s)), 0 < a.length && (this._dispatchEvent("onCustomItemsDeleted", this, a), null !== (s = this.onCustomItemsDeleted) && void 0 !== s && s.call(this, this, a)));
        }
      }, {
        kind: "method",
        key: "_passToPeerConnection",
        value: function value(e) {
          switch (e.type) {
            case vu.CANDIDATE:
              var t = Ls.createCandidate(e.payload.peerConnectionId, e.payload.candidate);

              this._rotatablePeerConnection.onEvent(t);

              break;

            case vu.OFFER:
              var n = Ls.createOffer(e.payload.peerConnectionId, e.payload.sdp);

              this._rotatablePeerConnection.onEvent(n);

              break;

            case vu.ANSWER:
              n = Ls.createAnswer(e.payload.peerConnectionId, e.payload.sdp);

              this._rotatablePeerConnection.onEvent(n);

          }
        }
      }, {
        kind: "method",
        key: "onEvent",
        value: function value(e) {
          switch (_a.verbose("'onEvent' on ".concat(e.constructor.name)), e.type) {
            case vu.DIAL:
              this._dialed(e);

              break;

            case vu.DIAL_ACK:
              this._dialSent(e);

              break;

            case vu.DIAL_RCV:
              break;

            case vu.ACCEPT:
              this._receiveAccept(e);

              break;

            case vu.ACCEPT_ACK:
              this._state.acceptSent(e);

              break;

            case vu.OTHER_DEVICE_ACCEPTED:
              this._state.receiveAccepted();

              break;

            case vu.CANCEL:
              this._canceled(e);

              break;

            case vu.DECLINE:
            case vu.END:
            case vu.TIME_OUT:
            case vu.NO_ANSWER:
            case vu.CONNECTION_LOST:
            case vu.UNKNOWN_END:
              this._state.receiveEnd(e);

              break;

            case vu.CANCEL_ACK:
            case vu.DECLINE_ACK:
            case vu.END_ACK:
            case vu.TIMEOUT_ACK:
            case vu.NO_ANSWER_ACK:
            case vu.CONNECTION_LOST_ACK:
            case vu.UNKNOWN_END_ACK:
              this._state.endSent(e);

              break;

            case vu.REMOVE_CANDIDATES:
              break;

            case vu.AUDIO:
              this._receiveAudio(e);

              break;

            case vu.VIDEO:
              this._receiveVideo(e);

              break;

            case vu.HOLD:
              this._receiveHold(e);

              break;

            case vu.CUSTOM_ITEMS_UPDATE:
              this._receiveCustomItemsUpdate(e);

              break;

            case vu.CUSTOM_ITEMS_DELETE:
              this._receiveCustomItemsDelete(e);

              break;

            case vu.RECORDING:
              this._receiveRecording(e);

              break;

            case vu.TURN_CHANGED:
              this._receiveTurnChanged(e);

              break;

            case vu.SNAPSHOT:
              this._receiveSnapshot(e);

              break;

            case vu.CANDIDATE:
              this._passToPeerConnection(e);

              break;

            case vu.OFFER:
              this._passToPeerConnection(e), "accepting" === this._state.type && this._state.receiveOffer(), this._startedAt || this.startDuration();
              break;

            case vu.ANSWER:
              this._passToPeerConnection(e), this._startedAt || this.startDuration();
              break;

            default:
              _a.error(new Error("unhandled call event ".concat(e.type)));

          }
        }
      }, {
        kind: "method",
        key: "_onAudioOutputChanged",
        value: (i = Mn(_regeneratorRuntime.mark(function e() {
          var t, n, r, i;
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return i = this._ctx.deviceManager.getCurrentAudioOutputDevice(), e.next = 3, null === (n = this._localMediaView) || void 0 === n || null === (t = n.setSinkId) || void 0 === t ? void 0 : t.call(n, i.deviceId);

                case 3:
                  return e.next = 5, null === (n = this._remoteMediaView) || void 0 === n || null === (r = n.setSinkId) || void 0 === r ? void 0 : r.call(n, i.deviceId);

                case 5:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return i.apply(this, arguments);
        })
      }, {
        kind: "method",
        key: "_onLocalStream",
        value: function value() {
          var e = this._getLocalStream();

          this._localMediaView && (this._localMediaView.srcObject = e);
          var t = or(e.getTracks());

          try {
            for (t.s(); !(n = t.n()).done;) {
              var n,
                  r = n.value;
              r.enabled = null === (n = this._isMediaEnabled) || void 0 === n ? void 0 : n.call(this, r.kind);
            }
          } catch (e) {
            t.e(e);
          } finally {
            t.f();
          }
        }
      }, {
        kind: "method",
        key: "_onRemoteStream",
        value: function value() {
          this._remoteMediaView && (this._remoteMediaView.srcObject = this._pc.remoteStream);
        }
      }, {
        kind: "method",
        key: "calcCallSetupTime",
        value: function value() {
          this._logManager.summary.onConnected();
        }
      }, {
        kind: "method",
        key: "setIsReconnected",
        value: function value(e) {
          this._isReconnected = e, this._logManager.summary.increaseReconnectedCount();
        }
      }, {
        kind: "method",
        key: "_isMediaEnabled",
        value: function value(e) {
          switch (e) {
            case "audio":
              return this._localConstraints.audio && !this.isOnHold;

            case "video":
              return this._localConstraints.video && !this.isOnHold;

            default:
              return _a.error(new Error("unrecognized media type ".concat(e))), !1;
          }
        }
      }, {
        kind: "method",
        key: "_updateLocalMediaView",
        value: (r = Mn(_regeneratorRuntime.mark(function e(t) {
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this._localMediaView === t) return e.abrupt("return");
                  e.next = 2;
                  break;

                case 2:
                  if (this._localMediaView && (this._localMediaView.srcObject = null), t) {
                    e.next = 6;
                    break;
                  }

                  return this._localMediaView = null, e.abrupt("return");

                case 6:
                  return e.next = 8, this._updateMediaView(t, this._getLocalStream());

                case 8:
                  this._localMediaView = e.sent;

                case 9:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return r.apply(this, arguments);
        })
      }, {
        kind: "method",
        key: "_updateRemoteMediaView",
        value: (t = Mn(_regeneratorRuntime.mark(function e(t) {
          var n;
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this._remoteMediaView === t) return e.abrupt("return");
                  e.next = 2;
                  break;

                case 2:
                  if (this._remoteMediaView && (this._remoteMediaView.srcObject = null), t) {
                    e.next = 6;
                    break;
                  }

                  return this._remoteMediaView = null, e.abrupt("return");

                case 6:
                  return e.next = 8, this._updateMediaView(t, null === (n = this._pc) || void 0 === n ? void 0 : n.remoteStream);

                case 8:
                  this._remoteMediaView = e.sent;

                case 9:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return t.apply(this, arguments);
        })
      }, {
        kind: "method",
        key: "_updateMediaView",
        value: (n = Mn(_regeneratorRuntime.mark(function e(t, n) {
          var r, i;
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (r = this._ctx.deviceManager.getCurrentAudioOutputDevice()) return e.next = 4, null === (i = t.setSinkId) || void 0 === i ? void 0 : i.call(t, r.deviceId);
                  e.next = 4;
                  break;

                case 4:
                  return n && (t.srcObject = n), e.abrupt("return", t);

                case 6:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e, t) {
          return n.apply(this, arguments);
        })
      }, {
        kind: "method",
        key: "_getLocalStream",
        value: function value() {
          return this._localStream.localStream;
        }
      }, {
        kind: "method",
        key: "_releaseLocalStream",
        value: function value() {
          this._localStream && (this._localStream.removeAllEventListeners(), this._localStream.release());
        }
      }]
    };
  }, e),
      Mp = function () {
    function r(e) {
      var t = e.ringingTimeout,
          n = e.callConnectionTimeout,
          e = e.statsInterval;
      Un(this, r), this._ringingTimeout = t, this._callConnectionTimeout = n, this._statsInterval = e;
    }

    return Fn(r, [{
      key: "ringingTimeoutValue",
      get: function get() {
        return this._ringingTimeout;
      }
    }, {
      key: "callConnectionTimeoutValue",
      get: function get() {
        return this._callConnectionTimeout;
      }
    }, {
      key: "statsIntervalValue",
      get: function get() {
        return this._statsInterval;
      }
    }]), r;
  }(),
      Up = function () {
    function t(e) {
      Un(this, t), this._ctx = e, this.options = {
        ringingTimeout: 6e4,
        callConnectionTimeout: 6e4,
        statsInterval: 3e3
      };
    }

    return Fn(t, [{
      key: "createDirectCall",
      value: function value() {
        return new Pp(this._ctx, new Mp(this.options));
      }
    }, {
      key: "setRingingTimeout",
      value: function value(e) {
        "number" == typeof e && 0 < e && (this.options.ringingTimeout = 1e3 * e);
      }
    }, {
      key: "setStatsInterval",
      value: function value(e) {
        "number" == typeof e && ((e = e) < 1 && (e = 1), 60 < e && (e = 60), this.options.statsInterval = 1e3 * e);
      }
    }, {
      key: "setCallConnectionTimeout",
      value: function value(e) {
        "number" == typeof e && 0 < e && (this.options.callConnectionTimeout = 1e3 * e);
      }
    }]), t;
  }(),
      Vp = function e(t) {
    Un(this, e), this.audioEnabled = t.is_audio_enabled, this.videoEnabled = t.is_video_enabled, this.customItems = null === (t = t.custom_items) || void 0 === t ? void 0 : t.custom_items;
  },
      Fp = function () {
    function t(e) {
      Un(this, t), this.callId = e.call_id, this.callType = e.call_type, this.userRole = e.user_role, this.callerClientId = e.caller_client_id, this.calleeClientId = e.callee_client_id, this.signalSeq = e.signal_seq.map(of.parse).filter(function (e) {
        return !!e;
      }), this.signalSnapshot = new Vp(e.signal_snapshot);
    }

    return Fn(t, [{
      key: "getAcceptResponse",
      value: function value() {
        return this.signalSeq.find(function (e) {
          return e.type === vu.ACCEPT_ACK;
        });
      }
    }, {
      key: "getDeclineResponse",
      value: function value() {
        return this.signalSeq.find(function (e) {
          return e.type === vu.DECLINE_ACK;
        });
      }
    }, {
      key: "commands",
      get: function get() {
        return this.signalSeq;
      }
    }, {
      key: "snapshot",
      get: function get() {
        return this.signalSnapshot;
      }
    }]), t;
  }(),
      Gp = function () {
    function t(e) {
      Un(this, t), this._ctx = e, this._callFactory = new Up(e), this._calls = new Map(), this.dialListeners = new Map();
    }

    return Fn(t, [{
      key: "setRingingTimeout",
      value: function value(e) {
        this._callFactory.setRingingTimeout(e);
      }
    }, {
      key: "setStatsInterval",
      value: function value(e) {
        this._callFactory.setStatsInterval(e);
      }
    }, {
      key: "setCallConnectionTimeout",
      value: function value(e) {
        this._callFactory.setCallConnectionTimeout(e);
      }
    }, {
      key: "getCall",
      value: function value(e) {
        return this._calls.get(e);
      }
    }, {
      key: "_hasCall",
      value: function value(e) {
        return this._calls.has(e);
      }
    }, {
      key: "getOngoingCalls",
      value: function value() {
        return er(this._calls.values());
      }
    }, {
      key: "getOngoingCallCount",
      value: function value() {
        return er(this._calls.values()).reduce(function (e, t) {
          return t.isOngoing ? e + 1 : e;
        }, 0);
      }
    }, {
      key: "getActiveCallCount",
      value: function value() {
        return er(this._calls.values()).reduce(function (e, t) {
          return t.isOnHold ? e : e + 1;
        }, 0);
      }
    }, {
      key: "dial",
      value: function value(e, t) {
        var n = this,
            r = this._callFactory.createDirectCall();

        e.holdActiveCall ? this.holdExcept(r) : this.endExcept(r);
        e = r.dial(e).then(function () {
          return n._register(r.callId, r), r;
        }).catch(function (e) {
          throw _a.error(e), e;
        });
        return t && ia(e)(t), r;
      }
    }, {
      key: "holdExcept",
      value: function value(e) {
        var t = or(this._calls.values());

        try {
          for (t.s(); !(n = t.n()).done;) {
            var n = n.value;
            n.callId === e.callId || n.isOnHold || n.hold();
          }
        } catch (e) {
          t.e(e);
        } finally {
          t.f();
        }
      }
    }, {
      key: "endExcept",
      value: function value(e) {
        var t = or(this._calls.values());

        try {
          for (t.s(); !(n = t.n()).done;) {
            var n = n.value;
            n.callId !== e.callId && n.end();
          }
        } catch (e) {
          t.e(e);
        } finally {
          t.f();
        }
      }
    }, {
      key: "onEvent",
      value: function value(e) {
        switch (e.type) {
          case vu.DIAL:
            this._onCallDialed(e);

            break;

          case vu.CANCEL:
            this._hasCall(e.getCallId()) ? this._passToCall(e) : this._onCallCanceled(e);
            break;

          case ef.CONNECTED:
            this._requestCommandLists();

            break;

          default:
            this._passToCall(e);

        }
      }
    }, {
      key: "addListener",
      value: function value(e, t) {
        this.dialListeners.set(e, t);
      }
    }, {
      key: "removeListener",
      value: function value(e) {
        this.dialListeners.delete(e);
      }
    }, {
      key: "removeAllListeners",
      value: function value() {
        this.dialListeners.clear();
      }
    }, {
      key: "clear",
      value: function value() {
        var e,
            t = or(this._calls.values());

        try {
          for (t.s(); !(e = t.n()).done;) {
            var n = e.value;

            try {
              n.end();
            } catch (e) {
              _a.error("failed to clear call.");
            }
          }
        } catch (e) {
          t.e(e);
        } finally {
          t.f();
        }

        this._calls.clear();
      }
    }, {
      key: "_register",
      value: function value(e, t) {
        if (!e) throw new Error("call id is not set in call");
        if (!t) throw new Error("call is null");

        this._calls.set(e, t);
      }
    }, {
      key: "_sendDialReceiveCommand",
      value: function value(e) {
        e = of.createDialReceive(e.getCallId(), e.deliveryInfo, e.receivedType, e.payload.shortLivedToken);
        return this._ctx.sender.send(e).catch(function () {});
      }
    }, {
      key: "_onCallDialed",
      value: function value(e) {
        var t = this,
            n = this._callFactory.createDirectCall();

        this._sendDialReceiveCommand(e), this._register(e.getCallId(), n), n.onRinging = function () {
          return t._onCallRinging(n);
        }, this._passToCall(e);
      }
    }, {
      key: "_onCallCanceled",
      value: function value(e) {
        var t = this,
            n = this._callFactory.createDirectCall();

        this._register(e.getCallId(), n), n.onRinging = function () {
          return t._onCallRinging(n);
        }, this._passToCall(e);
      }
    }, {
      key: "_onCallRinging",
      value: function value(e) {
        var t = or(this.dialListeners.values());

        try {
          for (t.s(); !(n = t.n()).done;) {
            var n = n.value;
            n.onRinging && n.onRinging(e);
          }
        } catch (e) {
          t.e(e);
        } finally {
          t.f();
        }
      }
    }, {
      key: "_requestCommandLists",
      value: function value() {
        var t = this;

        _a.verbose("request command list");

        var e = Array.from(this._calls.keys()).filter(function (e) {
          return !t._calls.get(e).isEnded;
        }),
            e = of.createCommandList(e);

        this._retrieveCommands(e);
      }
    }, {
      key: "_retrieveCommands",
      value: function value(e) {
        var t = this;
        return this._ctx.sender.send(e).then(function (e) {
          _a.verbose("commandLists is received.");

          e = e.call_signal.map(function (e) {
            return new Fp(e);
          });

          t._ctx.sender.processCommandLists(e);
        }).catch(function (e) {
          _a.debug("failed to get commandLists", e);
        });
      }
    }, {
      key: "_passToCall",
      value: function value(e) {
        this._hasCall(e.getCallId()) ? this._calls.get(e.getCallId()).onEvent(e) : _a.debug("received command ".concat(e.type, " for non-existing call ").concat(e.getCallId()));
      }
    }]), t;
  }(),
      Bp = "undefined" != typeof globalThis && globalThis || "undefined" != typeof self && self || void 0 !== Bp && Bp,
      jp = ("URLSearchParams" in Bp),
      qp = "Symbol" in Bp && "iterator" in Symbol,
      Hp = "FileReader" in Bp && "Blob" in Bp && function () {
    try {
      return new Blob(), !0;
    } catch (e) {
      return !1;
    }
  }(),
      zp = ("FormData" in Bp),
      Wp = ("ArrayBuffer" in Bp);

  function Kp(e) {
    if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e) || "" === e) throw new TypeError("Invalid character in header field name");
    return e.toLowerCase();
  }

  function Yp(e) {
    return "string" != typeof e && (e = String(e)), e;
  }

  function Zp(t) {
    var e = {
      next: function next() {
        var e = t.shift();
        return {
          done: void 0 === e,
          value: e
        };
      }
    };
    return qp && (e[Symbol.iterator] = function () {
      return e;
    }), e;
  }

  function Qp(t) {
    this.map = {}, t instanceof Qp ? t.forEach(function (e, t) {
      this.append(t, e);
    }, this) : Array.isArray(t) ? t.forEach(function (e) {
      this.append(e[0], e[1]);
    }, this) : t && Object.getOwnPropertyNames(t).forEach(function (e) {
      this.append(e, t[e]);
    }, this);
  }

  function Xp(e) {
    if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
    e.bodyUsed = !0;
  }

  function $p(n) {
    return new Promise(function (e, t) {
      n.onload = function () {
        e(n.result);
      }, n.onerror = function () {
        t(n.error);
      };
    });
  }

  function Jp(e) {
    var t = new FileReader(),
        n = $p(t);
    return t.readAsArrayBuffer(e), n;
  }

  function ev(e) {
    if (e.slice) return e.slice(0);
    var t = new Uint8Array(e.byteLength);
    return t.set(new Uint8Array(e)), t.buffer;
  }

  function tv() {
    return this.bodyUsed = !1, this._initBody = function (e) {
      var t;
      this.bodyUsed = this.bodyUsed, (this._bodyInit = e) ? "string" == typeof e ? this._bodyText = e : Hp && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : zp && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : jp && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : Wp && Hp && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = ev(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : Wp && (ArrayBuffer.prototype.isPrototypeOf(e) || kp(e)) ? this._bodyArrayBuffer = ev(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : jp && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
    }, Hp && (this.blob = function () {
      var e = Xp(this);
      if (e) return e;
      if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
      if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
      if (this._bodyFormData) throw new Error("could not read FormData body as blob");
      return Promise.resolve(new Blob([this._bodyText]));
    }, this.arrayBuffer = function () {
      if (this._bodyArrayBuffer) {
        var e = Xp(this);
        return e ? e : ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer);
      }

      return this.blob().then(Jp);
    }), this.text = function () {
      var e,
          t,
          n = Xp(this);
      if (n) return n;
      if (this._bodyBlob) return e = this._bodyBlob, t = new FileReader(), n = $p(t), t.readAsText(e), n;
      if (this._bodyArrayBuffer) return Promise.resolve(function (e) {
        for (var t = new Uint8Array(e), n = new Array(t.length), r = 0; r < t.length; r++) {
          n[r] = String.fromCharCode(t[r]);
        }

        return n.join("");
      }(this._bodyArrayBuffer));
      if (this._bodyFormData) throw new Error("could not read FormData body as text");
      return Promise.resolve(this._bodyText);
    }, zp && (this.formData = function () {
      return this.text().then(iv);
    }), this.json = function () {
      return this.text().then(JSON.parse);
    }, this;
  }

  Wp && (Ep = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"], kp = ArrayBuffer.isView || function (e) {
    return e && -1 < Ep.indexOf(Object.prototype.toString.call(e));
  }), Qp.prototype.append = function (e, t) {
    e = Kp(e), t = Yp(t);
    var n = this.map[e];
    this.map[e] = n ? n + ", " + t : t;
  }, Qp.prototype.delete = function (e) {
    delete this.map[Kp(e)];
  }, Qp.prototype.get = function (e) {
    return e = Kp(e), this.has(e) ? this.map[e] : null;
  }, Qp.prototype.has = function (e) {
    return this.map.hasOwnProperty(Kp(e));
  }, Qp.prototype.set = function (e, t) {
    this.map[Kp(e)] = Yp(t);
  }, Qp.prototype.forEach = function (e, t) {
    for (var n in this.map) {
      this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
    }
  }, Qp.prototype.keys = function () {
    var n = [];
    return this.forEach(function (e, t) {
      n.push(t);
    }), Zp(n);
  }, Qp.prototype.values = function () {
    var t = [];
    return this.forEach(function (e) {
      t.push(e);
    }), Zp(t);
  }, Qp.prototype.entries = function () {
    var n = [];
    return this.forEach(function (e, t) {
      n.push([t, e]);
    }), Zp(n);
  }, qp && (Qp.prototype[Symbol.iterator] = Qp.prototype.entries);
  var nv = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];

  function rv(e, t) {
    if (!(this instanceof rv)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    var n,
        r = (t = t || {}).body;

    if (e instanceof rv) {
      if (e.bodyUsed) throw new TypeError("Already read");
      this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new Qp(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, r || null == e._bodyInit || (r = e._bodyInit, e.bodyUsed = !0);
    } else this.url = String(e);

    if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new Qp(t.headers)), this.method = (n = t.method || this.method || "GET", e = n.toUpperCase(), -1 < nv.indexOf(e) ? e : n), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && r) throw new TypeError("Body not allowed for GET or HEAD requests");
    this._initBody(r), "GET" !== this.method && "HEAD" !== this.method || "no-store" !== t.cache && "no-cache" !== t.cache || ((t = /([?&])_=[^&]*/).test(this.url) ? this.url = this.url.replace(t, "$1_=" + new Date().getTime()) : this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + new Date().getTime());
  }

  function iv(e) {
    var n = new FormData();
    return e.trim().split("&").forEach(function (e) {
      var t;
      e && (e = (t = e.split("=")).shift().replace(/\+/g, " "), t = t.join("=").replace(/\+/g, " "), n.append(decodeURIComponent(e), decodeURIComponent(t)));
    }), n;
  }

  function av(e, t) {
    if (!(this instanceof av)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    t = t || {}, this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = 200 <= this.status && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "", this.headers = new Qp(t.headers), this.url = t.url || "", this._initBody(e);
  }

  rv.prototype.clone = function () {
    return new rv(this, {
      body: this._bodyInit
    });
  }, tv.call(rv.prototype), tv.call(av.prototype), av.prototype.clone = function () {
    return new av(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Qp(this.headers),
      url: this.url
    });
  }, av.error = function () {
    var e = new av(null, {
      status: 0,
      statusText: ""
    });
    return e.type = "error", e;
  };
  var ov = [301, 302, 303, 307, 308];

  av.redirect = function (e, t) {
    if (-1 === ov.indexOf(t)) throw new RangeError("Invalid status code");
    return new av(null, {
      status: t,
      headers: {
        location: e
      }
    });
  };

  var sv = Bp.DOMException;

  try {
    new sv();
  } catch (rd) {
    (sv = function sv(e, t) {
      this.message = e, this.name = t;
      e = Error(e);
      this.stack = e.stack;
    }).prototype = Object.create(Error.prototype), sv.prototype.constructor = sv;
  }

  function cv(r, o) {
    return new Promise(function (i, e) {
      var t = new rv(r, o);
      if (t.signal && t.signal.aborted) return e(new sv("Aborted", "AbortError"));
      var a = new XMLHttpRequest();

      function n() {
        a.abort();
      }

      a.onload = function () {
        var e,
            n,
            t = {
          status: a.status,
          statusText: a.statusText,
          headers: (e = a.getAllResponseHeaders() || "", n = new Qp(), e.replace(/\r?\n[\t ]+/g, " ").split("\r").map(function (e) {
            return 0 === e.indexOf("\n") ? e.substr(1, e.length) : e;
          }).forEach(function (e) {
            var t = e.split(":"),
                e = t.shift().trim();
            e && (t = t.join(":").trim(), n.append(e, t));
          }), n)
        };
        t.url = "responseURL" in a ? a.responseURL : t.headers.get("X-Request-URL");
        var r = "response" in a ? a.response : a.responseText;
        setTimeout(function () {
          i(new av(r, t));
        }, 0);
      }, a.onerror = function () {
        setTimeout(function () {
          e(new TypeError("Network request failed"));
        }, 0);
      }, a.ontimeout = function () {
        setTimeout(function () {
          e(new TypeError("Network request failed"));
        }, 0);
      }, a.onabort = function () {
        setTimeout(function () {
          e(new sv("Aborted", "AbortError"));
        }, 0);
      }, a.open(t.method, function (t) {
        try {
          return "" === t && Bp.location.href ? Bp.location.href : t;
        } catch (e) {
          return t;
        }
      }(t.url), !0), "include" === t.credentials ? a.withCredentials = !0 : "omit" === t.credentials && (a.withCredentials = !1), "responseType" in a && (Hp ? a.responseType = "blob" : Wp && t.headers.get("Content-Type") && -1 !== t.headers.get("Content-Type").indexOf("application/octet-stream") && (a.responseType = "arraybuffer")), !o || "object" != typeof o.headers || o.headers instanceof Qp ? t.headers.forEach(function (e, t) {
        a.setRequestHeader(t, e);
      }) : Object.getOwnPropertyNames(o.headers).forEach(function (e) {
        a.setRequestHeader(e, Yp(o.headers[e]));
      }), t.signal && (t.signal.addEventListener("abort", n), a.onreadystatechange = function () {
        4 === a.readyState && t.signal.removeEventListener("abort", n);
      }), a.send(void 0 === t._bodyInit ? null : t._bodyInit);
    });
  }

  cv.polyfill = !0, Bp.fetch || (Bp.fetch = cv, Bp.Headers = Qp, Bp.Request = rv, Bp.Response = av);

  var uv = function uv() {
    var e;
    return null !== (e = window) && void 0 !== e && e.fetch ? (e = window).fetch.apply(e, arguments) : cv.apply(void 0, arguments);
  },
      lv = function () {
    function e() {
      Un(this, e);
    }

    return Fn(e, null, [{
      key: "getOsVersion",
      value: function value() {
        return "undefined" != typeof navigator && navigator.userAgent ? navigator.userAgent.replace(/,/g, ".") : "undefined";
      }
    }]), e;
  }(),
      dv = function () {
    qn(t, na);
    var e = Xn(t);

    function t() {
      return Un(this, t), e.apply(this, arguments);
    }

    return t;
  }(),
      hv = function () {
    function t(e) {
      Un(this, t), this._ctx = e, this._fetch = uv, this._sessionKey = null, this._hostUrl = null !== (e = this._ctx.apiHost) && void 0 !== e ? e : "https://api-IDENTIFIER.calls.sendbird.com".replace("IDENTIFIER", this._ctx.appId);
    }

    var n;
    return Fn(t, [{
      key: "setSessionKey",
      value: function value(e) {
        this._sessionKey = e;
      }
    }, {
      key: "clearSessionKey",
      value: function value() {
        this._sessionKey = null;
      }
    }, {
      key: "send",
      value: (n = Mn(_regeneratorRuntime.mark(function e(t) {
        var n, r, i, a, o;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (t.getApiOption) {
                  e.next = 2;
                  break;
                }

                throw new Error("invalid api request ".concat(JSON.stringify(t)));

              case 2:
                if ((n = t.getApiOption()).auth && !this._sessionKey) throw new Error("tried to call private api without auth");
                e.next = 5;
                break;

              case 5:
                return (i = jn({
                  "Content-Type": "application/json"
                }, n.headers)).SendBird = "JS,".concat(lv.getOsVersion(), ",").concat(au), i["SBCall-Client-Id"] = this._ctx.clientId, this._sessionKey && (i["SBCall-Session-Token"] = this._sessionKey), e.next = 11, this._fetch("".concat(this._getHost()).concat(n.path), {
                  method: n.method,
                  body: JSON.stringify(n.body),
                  headers: i
                });

              case 11:
                return r = e.sent, e.next = 14, r.text();

              case 14:
                i = e.sent, a = null, e.prev = 16, a = JSON.parse(i), e.next = 23;
                break;

              case 20:
                throw e.prev = 20, e.t0 = e.catch(16), new ra(Tn.ERR_MALFORMED_DATA);

              case 23:
                if (r.ok) {
                  e.next = 33;
                  break;
                }

                if (a.error) throw new dv(a.code, {
                  message: a.message
                });
                e.next = 28;
                break;

              case 28:
                if (500 === r.status) throw new ra(Tn.INTERNAL_SERVER_ERROR);
                e.next = 30;
                break;

              case 30:
                if (300 <= r.status && r.status < 400) throw new ra(Tn.ERR_MALFORMED_DATA);
                e.next = 32;
                break;

              case 32:
                throw new ra(Tn.ERR_REQUEST_FAILED);

              case 33:
                if (t instanceof Wa) return o = Ko.parseResponse(t.type, a), e.abrupt("return", o);
                e.next = 36;
                break;

              case 36:
                if (a.cmd) return o = of.parse(a), e.abrupt("return", o);
                e.next = 39;
                break;

              case 39:
                return e.abrupt("return", a);

              case 40:
              case "end":
                return e.stop();
            }
          }
        }, e, this, [[16, 20]]);
      })), function (e) {
        return n.apply(this, arguments);
      })
    }, {
      key: "_getHost",
      value: function value() {
        return this._hostUrl;
      }
    }]), t;
  }(),
      fv = function () {
    function e() {
      Un(this, e);
    }

    return Fn(e, [{
      key: "parseToJson",
      value: function value(e) {
        try {
          return JSON.parse(e);
        } catch (e) {
          return _a.error("failed to parse JSON message", e), {};
        }
      }
    }, {
      key: "validate",
      value: function value(e) {
        var t = e.cmd,
            n = e.request_id,
            e = e.call_type;
        return !!(n || t || e);
      }
    }, {
      key: "parseCommand",
      value: function value(e) {
        return e.error ? {
          isValid: !0,
          error: {
            requestId: e.request_id,
            message: e.message,
            code: e.code
          }
        } : "room" === e.call_type ? {
          isValid: !0,
          command: Ko.parse(e)
        } : {
          isValid: !0,
          command: of.parse(e)
        };
      }
    }, {
      key: "parse",
      value: function value(e) {
        e = this.parseToJson(e);
        return this.validate(e) ? this.parseCommand(e) : {
          isValid: !1
        };
      }
    }]), e;
  }(),
      _v = function () {
    function t(e) {
      Un(this, t), this._ctx = e, this._ws = null, this._retryTimer = null, this._closed = !0, this._sessionKey = null, this._requestMap = new rc(this._getTimeoutTime()), this._messageParser = new fv(), this._hostUrl = null !== (e = this._ctx.websocketHost) && void 0 !== e ? e : "wss://ws-IDENTIFIER.calls.sendbird.com".replace("IDENTIFIER", this._ctx.appId);
    }

    return Fn(t, [{
      key: "connect",
      value: function value() {
        var r = this;
        return new Promise(function (e, t) {
          r._sessionKey || t(new Error("tried to connect to websocket server without auth")), r._ws = r._createWebSocket(), r._closed = !1, r._ws.onopen = function () {
            r._onOpen(), e(null);
          }, r._ws.onmessage = function (e) {
            var t = r._messageParser.parse(e.data),
                n = t.isValid,
                e = t.error,
                t = t.command;

            n && (e ? r._processError(e) : r.processCommand(t));
          }, r._ws.onerror = function (e) {
            return r._onError(e);
          }, r._ws.onclose = function () {
            r._onClose(), t(new ra(Tn.ERR_WEBSOCKET_CONNECTION_FAILED));
          };
        });
      }
    }, {
      key: "_processError",
      value: function value(e) {
        var t = e.requestId,
            n = e.code,
            r = e.message,
            i = this._requestMap.unregister(t);

        i && (_a.debug(t, e.message), i.reject(new dv(n, {
          message: r
        })));
      }
    }, {
      key: "processCommand",
      value: function value(e) {
        var t,
            n = this._ctx.router;
        e instanceof Eu ? n.routeDirectCallPeerCommand(e, iu.WS) : e instanceof ku ? (t = this._requestMap.unregister(e.requestId)) && n.routeDirectCallResponseCommand(e, t) : e instanceof Cu ? n.routeDirectCallServerCommand(e, iu.WS) : e instanceof Jh ? n.routeLogServerCommand(e) : e instanceof za ? n.routeServerCommand(e) : e instanceof qa && n.routePeerCommand(e);
      }
    }, {
      key: "setSessionKey",
      value: function value(e) {
        this._sessionKey = e;
      }
    }, {
      key: "clearSessionKey",
      value: function value() {
        this._disconnect(), this._sessionKey = null;
      }
    }, {
      key: "_disconnect",
      value: function value() {
        this._ws && (this._closed = !0, this._removeRetryTimer(), this._ws.onopen = null, this._ws.onmessage = null, this._ws.onerror = null, this._ws.onclose = null, this._ws.close(), this._requestMap.rejectAll(new ra(Tn.ERR_REQUEST_FAILED_DUE_TO_WEBSOCKET_CONNECTION_LOST)), this._ws = null);
      }
    }, {
      key: "send",
      value: function value(e) {
        var t = e.requireResponse() ? this._requestMap.register(e.requestId).promise : Promise.resolve(),
            e = e.serialize();
        return this._ws.send("".concat(e, "\n")), t;
      }
    }, {
      key: "_onOpen",
      value: function value() {
        this._ctx.router.routeWebSocketInternalCommand(of.createWebSocketConnectedCommand());
      }
    }, {
      key: "_onError",
      value: function value(e) {
        _a.error(e);
      }
    }, {
      key: "_onClose",
      value: function value() {
        this._startToReconnect();
      }
    }, {
      key: "_createWebSocket",
      value: function value() {
        var e = "/?sbcall_session_token=".concat(encodeURIComponent(this._sessionKey), "&sbcall_client_id=").concat(encodeURIComponent(this._ctx.clientId), "&sendbird=").concat(encodeURIComponent(this._getVersion()));
        return new WebSocket(this._getHost() + e);
      }
    }, {
      key: "_getVersion",
      value: function value() {
        return "JS,".concat(lv.getOsVersion(), ",").concat(au);
      }
    }, {
      key: "_getHost",
      value: function value() {
        return this._hostUrl;
      }
    }, {
      key: "_startToReconnect",
      value: function value() {
        this._closed || this._retryTimer || (this._retryTimer = setTimeout(this._reconnect.bind(this), this._getRetryTime()));
      }
    }, {
      key: "_reconnect",
      value: function value() {
        this._removeRetryTimer(), this.connect().catch(function () {
          _a.error("websocket reconnection is failed.");
        });
      }
    }, {
      key: "_removeRetryTimer",
      value: function value() {
        this._retryTimer && (clearTimeout(this._retryTimer), this._retryTimer = null);
      }
    }, {
      key: "_getTimeoutTime",
      value: function value() {
        return 6e4;
      }
    }, {
      key: "_getRetryTime",
      value: function value() {
        return 2e3;
      }
    }, {
      key: "isConnected",
      get: function get() {
        return !!this._ws && 1 === this._ws.readyState;
      }
    }]), t;
  }(),
      pv = function () {
    function t(e) {
      Un(this, t), this._ctx = e, this.wsClient = new _v(e), this.apiClient = new hv(e);
    }

    var n, r;
    return Fn(t, [{
      key: "connectWs",
      value: function value() {
        return this.wsClient.connect();
      }
    }, {
      key: "sendAPI",
      value: function value(e) {
        return this.apiClient.send(e);
      }
    }, {
      key: "sendWs",
      value: function value(e) {
        return this.wsClient.send(e);
      }
    }, {
      key: "send",
      value: (r = Mn(_regeneratorRuntime.mark(function e(t) {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (!(t instanceof yu)) {
                  e.next = 11;
                  break;
                }

                if (t.sendStrategy === ru.API) return e.abrupt("return", this.sendAPI(t));
                e.next = 3;
                break;

              case 3:
                if (t.sendStrategy !== ru.WS) {
                  e.next = 7;
                  break;
                }

                if (this.wsClient.isConnected) return e.abrupt("return", this.sendWs(t));
                e.next = 6;
                break;

              case 6:
                throw new ra(Tn.ERR_WEBSOCKET_CONNECTION_NOT_OPENED);

              case 7:
                if (t.sendStrategy !== ru.BOTH) {
                  e.next = 11;
                  break;
                }

                if (this.wsClient.isConnected) return e.abrupt("return", this.sendWs(t));
                e.next = 10;
                break;

              case 10:
              case 11:
                return e.abrupt("return", this.sendAPI(t));

              case 12:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return r.apply(this, arguments);
      })
    }, {
      key: "sendWithRetry",
      value: (n = Mn(_regeneratorRuntime.mark(function e(t) {
        var n,
            r,
            i,
            a,
            o,
            s = this,
            c = arguments;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = 1 < c.length && void 0 !== c[1] ? c[1] : new tc(), r = 2 < c.length && void 0 !== c[2] ? c[2] : {
                  count: 0,
                  deferred: new Zs()
                }, i = r.deferred, a = r.count, e.prev = 3, e.next = 6, this.send(t);

              case 6:
                o = e.sent, i.resolve(o), e.next = 14;
                break;

              case 10:
                e.prev = 10, e.t0 = e.catch(3), 0 < (o = n.calcTimeout(a)) ? setTimeout(function () {
                  s.sendWithRetry(t, n, {
                    count: a + 1,
                    deferred: i
                  });
                }, o) : i.reject(e.t0);

              case 14:
                return e.abrupt("return", i.promise);

              case 15:
              case "end":
                return e.stop();
            }
          }
        }, e, this, [[3, 10]]);
      })), function (e) {
        return n.apply(this, arguments);
      })
    }, {
      key: "_setSessionKey",
      value: function value(e) {
        this.apiClient.setSessionKey(e), this.wsClient.setSessionKey(e);
      }
    }, {
      key: "authenticate",
      value: function value(e) {
        var n = this,
            t = e.userId,
            e = e.accessToken,
            e = of.createAuthRequest(this._ctx.appId, t, e);
        return this.send(e).then(function (e) {
          n._setSessionKey(e.sbcall_session_token);

          var t = ua(e.user);
          return {
            user: new fo(t),
            statsInterval: e.stats_interval
          };
        }).catch(function (e) {
          throw _a.error("failed to authenticate user ".concat(t)), e;
        });
      }
    }, {
      key: "deauthenticate",
      value: function value() {
        this.apiClient.clearSessionKey(), this.wsClient.clearSessionKey();
      }
    }, {
      key: "processCommandLists",
      value: function value(e) {
        var t = or(e);

        try {
          for (t.s(); !(r = t.n()).done;) {
            var n = r.value;

            if (n.userRole !== da.CALLER || this._ctx.clientId === n.callerClientId) {
              if (n.userRole === da.CALLEE && this._ctx.clientId !== n.calleeClientId) {
                var r = n.getAcceptResponse();

                if (r) {
                  var i = r.payload.callId,
                      i = of.createAccepted(i);

                  this._ctx.router.routeDirectCallPeerCommand(i, iu.WS);

                  continue;
                }

                i = n.getDeclineResponse();
                i && (o = (a = i.payload).callId, a = a.endedCall, o = of.createDeclined(o, a), this._ctx.router.routeDirectCallInternalCommand(o));
              }

              var a = n.commands,
                  o = n.snapshot;

              _a.verbose("process commandList. length: ".concat(a.length));

              var s = or(a);

              try {
                for (s.s(); !(c = s.n()).done;) {
                  var c = c.value;
                  this.wsClient.processCommand(c);
                }
              } catch (e) {
                s.e(e);
              } finally {
                s.f();
              }

              o = of.createSnapshot(n.callId, o);

              this._ctx.router.routeDirectCallInternalCommand(o);
            }
          }
        } catch (e) {
          t.e(e);
        } finally {
          t.f();
        }
      }
    }]), t;
  }(),
      vv = function () {
    qn(i, Pa);
    var r = Xn(i);

    function i(e, t) {
      var n;
      return Un(this, i), (n = r.call(this))._recordId = Jo(), n._blobs = [], n._mediaRecorder = new MediaRecorder(e, t), n._mediaRecorder.ondataavailable = function (e) {
        e.data && 0 < e.data.size && n._blobs.push(e.data);
      }, n._mediaRecorder.onstart = function () {
        return n._onStart();
      }, n._mediaRecorder.onstop = function () {
        return n._onStop();
      }, n._mediaRecorder.onpause = function () {
        return n._onPause();
      }, n._mediaRecorder.onresume = function () {
        return n._onResume();
      }, n._mediaRecorder.onerror = function () {
        return n._onError();
      }, n;
    }

    return Fn(i, [{
      key: "startRecording",
      value: function value() {
        try {
          this._mediaRecorder.start();
        } catch (e) {
          return _a.error("start recording failed with error : ", e), !1;
        }

        return !0;
      }
    }, {
      key: "stopRecording",
      value: function value() {
        try {
          this._mediaRecorder.stop();
        } catch (e) {
          return _a.error("stop recording failed with error : ", e), !1;
        }

        return !0;
      }
    }, {
      key: "_onStart",
      value: function value() {
        this._dispatchEvent("start");
      }
    }, {
      key: "_onStop",
      value: function value() {
        this._dispatchEvent("stop"), this._onRecordingSucceeded(new Blob(this._blobs));
      }
    }, {
      key: "_onPause",
      value: function value() {
        this._dispatchEvent("pause");
      }
    }, {
      key: "_onResume",
      value: function value() {
        this._dispatchEvent("resume");
      }
    }, {
      key: "_onError",
      value: function value() {
        this._dispatchEvent("error"), this._onRecordingFailed(new ra(Tn.ERR_FAILED_TO_STOP_RECORDING));
      }
    }, {
      key: "_onRecordingSucceeded",
      value: function value(e) {
        this._dispatchEvent("succeeded", e);
      }
    }, {
      key: "_onRecordingFailed",
      value: function value(e) {
        this._dispatchEvent("failed", e);
      }
    }, {
      key: "recordId",
      get: function get() {
        return this._recordId;
      }
    }, {
      key: "recordingStatus",
      get: function get() {
        switch (this._mediaRecorder.state) {
          case "recording":
            return $c.RECORDING;

          case "inactive":
          case "paused":
          default:
            return $c.NONE;
        }
      }
    }]), i;
  }(),
      yv = function () {
    function e() {
      Un(this, e), this._listeners = new Map(), this._recorders = new Map();
    }

    return Fn(e, [{
      key: "getRecord",
      value: function value(e) {
        return this._recorders.get(e);
      }
    }, {
      key: "addListener",
      value: function value(e, t) {
        this._listeners.set(e, t);
      }
    }, {
      key: "removeListener",
      value: function value(e) {
        this._listeners.delete(e);
      }
    }, {
      key: "removeAllListeners",
      value: function value() {
        this._listeners.clear();
      }
    }, {
      key: "_fireOnSucceeded",
      value: function value(t, n) {
        this._listeners.forEach(function (e) {
          e.onRecordingSucceeded && e.onRecordingSucceeded(n.callId, t, n.recordingOptions, n.fileName);
        });
      }
    }, {
      key: "_fireOnFailed",
      value: function value(t, n, r) {
        this._listeners.forEach(function (e) {
          e.onRecordingFailed && e.onRecordingFailed(n.callId, t, r);
        });
      }
    }, {
      key: "startRecording",
      value: function value(e, t, n) {
        var r = this,
            i = new vv(e, t);
        if (i.startRecording()) return this._recorders.set(i.recordId, i), i.on("succeeded", function (e) {
          pp.downloadRecordedFile(e, n.fileName), r._fireOnSucceeded(i.recordId, n);
        }), i.on("failed", function (e) {
          r._fireOnFailed(i.recordId, n, e);
        }), i;
      }
    }, {
      key: "stopRecording",
      value: function value(e) {
        if (0 < this._recorders.size) {
          e = this._recorders.get(e);
          return e ? e.stopRecording() : !1;
        }

        return !1;
      }
    }, {
      key: "listeners",
      get: function get() {
        return this._listeners;
      }
    }]), e;
  }(),
      mv = function () {
    function e() {
      Un(this, e), this.processed = new Map();
    }

    return Fn(e, [{
      key: "process",
      value: function value(e) {
        return !e.messageId || (this._isProcessed(e) ? (this.processed.delete(e.messageId), !1) : (this._setProcessed(e), !0));
      }
    }, {
      key: "_isProcessed",
      value: function value(e) {
        return this.processed.has(e.messageId);
      }
    }, {
      key: "_setProcessed",
      value: function value(e) {
        this.processed.set(e.messageId, !0);
      }
    }]), e;
  }(),
      gv = function () {
    function e() {
      Un(this, e), this.lastSeqNumber = -1, this.queue = new Map();
    }

    var t, n;
    return Fn(e, [{
      key: "insert",
      value: (n = Mn(_regeneratorRuntime.mark(function e(t, n) {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.lastSeqNumber >= t.sequenceNumber) return e.abrupt("return");
                e.next = 2;
                break;

              case 2:
                return this.queue.set(t.sequenceNumber, {
                  command: t,
                  handler: n
                }), _a.verbose("".concat(t.constructor.name, " is inserted")), e.next = 6, this.flush();

              case 6:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, t) {
        return n.apply(this, arguments);
      })
    }, {
      key: "flush",
      value: (t = Mn(_regeneratorRuntime.mark(function e() {
        var t, n, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                _a.verbose("try flushing sequence queue"), t = this.next();

              case 2:
                if (t) return n = t.command, r = t.handler, _a.verbose("flush ".concat(n.constructor.name)), e.next = 7, r(n);
                e.next = 10;
                break;

              case 7:
                t = this.next(), e.next = 2;
                break;

              case 10:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "next",
      value: function value() {
        var e = this.lastSeqNumber + 1;

        if (this.queue.has(e)) {
          var t = this.queue.get(e),
              n = t.command,
              t = t.handler;
          return this.queue.delete(e), this.lastSeqNumber = e, {
            command: n,
            handler: t
          };
        }

        return null;
      }
    }]), e;
  }(),
      Ev = function () {
    function e() {
      Un(this, e), this.sequences = new Map(), this.lock = new Ga();
    }

    var n;
    return Fn(e, [{
      key: "insert",
      value: (n = Mn(_regeneratorRuntime.mark(function e(t, n) {
        var r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this.lock.acquire();

              case 2:
                if (e.prev = 2, _a.verbose("try to insert in SequenceManager with ".concat(t.constructor.name)), r = t.getCallId(), t.isSequential() && r) {
                  e.next = 10;
                  break;
                }

                return _a.verbose("not sequential; immediately flush ".concat(t.constructor.name)), this.lock.release(), n(t), e.abrupt("return");

              case 10:
                if (this.sequences.has(r)) return i = this.sequences.get(r), e.next = 14, i.insert(t, n);
                e.next = 16;
                break;

              case 14:
                e.next = 20;
                break;

              case 16:
                return i = new gv(), this.sequences.set(r, i), e.next = 20, i.insert(t, n);

              case 20:
                e.next = 25;
                break;

              case 22:
                e.prev = 22, e.t0 = e.catch(2), _a.warning("failed to SequenceManager.insert()", e.t0);

              case 25:
                return e.prev = 25, this.lock.release(), e.finish(25);

              case 28:
              case "end":
                return e.stop();
            }
          }
        }, e, this, [[2, 22, 25, 28]]);
      })), function (e, t) {
        return n.apply(this, arguments);
      })
    }]), e;
  }(),
      kv = function () {
    qn(n, Pa);
    var t = Xn(n);

    function n() {
      var e;
      return Un(this, n), (e = t.call(this))._sequenceManager = new Ev(), e._eventDeduplicator = new mv(), e;
    }

    return Fn(n, [{
      key: "routeWebSocketInternalCommand",
      value: function value(e) {
        this._dispatchEvent("webSocketInternal", e);
      }
    }, {
      key: "routeLogServerCommand",
      value: function value(e) {
        this._dispatchEvent("logServer", e);
      }
    }, {
      key: "routeDirectCallInternalCommand",
      value: function value(e) {
        this._dispatchEvent("directCallInternal", e);
      }
    }, {
      key: "routeDirectCallPeerCommand",
      value: function value(e, t) {
        var n = this;
        this._eventDeduplicator.process(e) && (e.receivedType = t, this._sequenceManager.insert(e, function (e) {
          n._dispatchEvent("directCallPeer", e);
        }));
      }
    }, {
      key: "routeDirectCallResponseCommand",
      value: function value(e, n) {
        this._sequenceManager.insert(e, function () {
          var t = Mn(_regeneratorRuntime.mark(function e(t) {
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return n.resolve(t), e.abrupt("return", n.promise);

                  case 2:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }));
          return function (e) {
            return t.apply(this, arguments);
          };
        }());
      }
    }, {
      key: "routeDirectCallServerCommand",
      value: function value(e, t) {
        var n = this;
        this._eventDeduplicator.process(e) && (e.receivedType = t, this._sequenceManager.insert(e, function (e) {
          n._dispatchEvent("directCallServer", e);
        }));
      }
    }, {
      key: "routeServerCommand",
      value: function value(e) {
        e instanceof Za && this._dispatchEvent("roomServer", e);
      }
    }, {
      key: "routePeerCommand",
      value: function value(e) {
        e instanceof Ka && this._dispatchEvent("roomPeer", e);
      }
    }]), n;
  }(),
      Rv = function () {
    function r(e, t, n) {
      Un(this, r), this.isLoading = !1, this.hasNext = !0, this.userId = e, this.params = t, this.sender = n, this.nextToken = null;
    }

    var t;
    return Fn(r, [{
      key: "next",
      value: (t = Mn(_regeneratorRuntime.mark(function e(t) {
        var n,
            r = this;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.isLoading) throw new ra(Tn.ERR_QUERY_IN_PROGRESS);
                e.next = 2;
                break;

              case 2:
                if (this.hasNext) {
                  e.next = 4;
                  break;
                }

                return e.abrupt("return", []);

              case 4:
                return this.isLoading = !0, n = this.sender.send(this._createCommand()).then(function (e) {
                  return r.nextToken = e.next, r.hasNext = e.has_next, r.isLoading = !1, e.calls.map(function (e) {
                    return new Eh(e, !0);
                  });
                }), t && ia(n)(t), e.abrupt("return", n);

              case 8:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "_createCommand",
      value: function value() {
        return new du(this.userId, this.params, this.nextToken);
      }
    }]), r;
  }(),
      Cv = function () {
    function n(e, t) {
      Un(this, n), this.isLoading = !1, this.params = e, this.sender = t, this.prevToken = null, this.nextToken = null;
    }

    var r, e, t;
    return Fn(n, [{
      key: "next",
      value: (t = Mn(_regeneratorRuntime.mark(function e() {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.isLoading) throw new ra(Tn.ERR_QUERY_IN_PROGRESS);
                e.next = 2;
                break;

              case 2:
                if (this.hasNext) {
                  e.next = 4;
                  break;
                }

                return e.abrupt("return", []);

              case 4:
                return e.abrupt("return", this._sendQueryCommand(null, this.nextToken));

              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return t.apply(this, arguments);
      })
    }, {
      key: "prev",
      value: (e = Mn(_regeneratorRuntime.mark(function e() {
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (this.isLoading) throw new ra(Tn.ERR_QUERY_IN_PROGRESS);
                e.next = 2;
                break;

              case 2:
                if (this.hasPrev) {
                  e.next = 4;
                  break;
                }

                return e.abrupt("return", []);

              case 4:
                return e.abrupt("return", this._sendQueryCommand(this.prevToken, null));

              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function () {
        return e.apply(this, arguments);
      })
    }, {
      key: "_sendQueryCommand",
      value: (r = Mn(_regeneratorRuntime.mark(function e(t, n) {
        var r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (t && n) throw new Error("internal error while creating RoomListQueryCommand");
                e.next = 2;
                break;

              case 2:
                return r = Ko.createRoomListQuery(this.params, t, n), e.next = 5, this.sender.send(r);

              case 5:
                return r = e.sent, r = r.payload, this.isLoading = !0, this.prevToken = r.prev, this.nextToken = r.next, this.isLoading = !1, e.abrupt("return", r.rooms);

              case 12:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })), function (e, t) {
        return r.apply(this, arguments);
      })
    }, {
      key: "hasPrev",
      get: function get() {
        return !!this.prevToken;
      }
    }, {
      key: "hasNext",
      get: function get() {
        return !this.prevToken && !this.nextToken || !!this.nextToken;
      }
    }]), n;
  }(),
      Iv = function () {
    function r(e, t, n) {
      if (Un(this, r), Gn(this, "_ctx", {}), this._appId = e, this._apiHost = t, this._websocketHost = n, !e) throw new pa(Tn.INVALID_PARAMETER_VALUE, {
        invalidParameter: "appId"
      });
      this._ctx.appId = e, this._ctx.apiHost = t, this._ctx.websocketHost = n, this._user = null, this.init();
    }

    return Fn(r, [{
      key: "init",
      value: function value() {
        this._ctx.clientId = Jo();
        var e = new kv();
        this._ctx.router = e, this._ctx.sender = new pv(this._ctx), this._ctx.deviceManager = new Mc(), this._ctx.recordingManager = new yv(), this._ctx.soundManager = new eu();
        var t = new Gp(this._ctx);
        this._ctx.callManager = t, this._callManager = t;
        var n = new Qc(this._ctx);
        this._roomManager = n, e.on("directCallInternal", function (e) {
          return t.onEvent(e);
        }), e.on("directCallPeer", function (e) {
          return t.onEvent(e);
        }), e.on("directCallServer", function (e) {
          return t.onEvent(e);
        }), e.on("webSocketInternal", function (e) {
          return t.onEvent(e);
        }), e.on("roomServer", function (e) {
          return n.onEvent(e);
        }), e.on("roomPeer", function (e) {
          return n.onEvent(e);
        });
        var r = new sf(this._ctx);
        _a.logCollector = r, e.on("logServer", function (e) {
          return r.onEvent(e);
        });
      }
    }, {
      key: "_checkAuthed",
      value: function value() {
        if (!this.currentUser) throw new pa(Tn.USER_NOT_AUTHENTICATED);
      }
    }, {
      key: "authenticate",
      value: function value(e, t) {
        var n = this,
            r = e.userId,
            e = e.accessToken;
        if (_a.info("authenticate()"), !r) throw new pa(Tn.INVALID_PARAMETER_VALUE, {
          invalidParameter: "userId"
        });
        e = this._ctx.sender.authenticate({
          userId: r,
          accessToken: e
        }).then(function (e) {
          return n._user = e.user, n._callManager.setStatsInterval(e.statsInterval), n._user;
        });
        return t && ia(e)(t), e;
      }
    }, {
      key: "deauthenticate",
      value: function value() {
        _a.info("deauthenticate()"), this._callManager && this._callManager.clear(), this._roomManager && this._roomManager.clear(), this._ctx.sender.deauthenticate(), this._user = null;
      }
    }, {
      key: "connectWebSocket",
      value: function value() {
        return this._ctx.sender.connectWs();
      }
    }, {
      key: "handleWebhookData",
      value: function value(e) {
        e = e.sendbird_call;
        if (!e) throw new ra(Tn.ERR_MALFORMED_DATA);
        if (!e.cmd) throw new ra(Tn.ERR_MALFORMED_DATA);
        e = of.parse(e);
        e instanceof Eu && this._ctx.router.routeDirectCallPeerCommand(e, iu.WEBHOOK);
      }
    }, {
      key: "addListener",
      value: function value(e, t) {
        if (!t) throw new pa(Tn.INVALID_PARAMETER_VALUE, {
          invalidParameter: "listener"
        });
        this._callManager.addListener(e, t), this._ctx.deviceManager.addSendBirdCallListener(e, t);
      }
    }, {
      key: "removeListener",
      value: function value(e) {
        this._callManager.removeListener(e), this._ctx.deviceManager.removeSendBirdCallListener(e);
      }
    }, {
      key: "removeAllListeners",
      value: function value() {
        this._callManager.removeAllListeners(), this._ctx.deviceManager.removeAllSendBirdCallListener();
      }
    }, {
      key: "addRecordingListener",
      value: function value(e, t) {
        this._ctx.recordingManager.addListener(e, t);
      }
    }, {
      key: "removeRecordingListener",
      value: function value(e) {
        this._ctx.recordingManager.removeListener(e);
      }
    }, {
      key: "removeAllRecordingListeners",
      value: function value() {
        this._ctx.recordingManager.removeAllListeners();
      }
    }, {
      key: "useMedia",
      value: function value(e) {
        return this._ctx.deviceManager.useMedia(e);
      }
    }, {
      key: "updateMediaDevices",
      value: function value(e) {
        return this._ctx.deviceManager.refreshMediaDevices(e);
      }
    }, {
      key: "getCurrentAudioInputDevice",
      value: function value() {
        return this._ctx.deviceManager.getCurrentAudioInputDevice();
      }
    }, {
      key: "getAvailableAudioInputDevices",
      value: function value() {
        return this._ctx.deviceManager.getAvailableAudioInputDevices();
      }
    }, {
      key: "selectAudioInputDevice",
      value: function value(e) {
        return this._ctx.deviceManager.selectDevice("audioinput", e);
      }
    }, {
      key: "getCurrentAudioOutputDevice",
      value: function value() {
        return this._ctx.deviceManager.getCurrentAudioOutputDevice();
      }
    }, {
      key: "getAvailableAudioOutputDevices",
      value: function value() {
        return this._ctx.deviceManager.getAvailableAudioOutputDevices();
      }
    }, {
      key: "selectAudioOutputDevice",
      value: function value(e) {
        return this._ctx.deviceManager.selectDevice("audiooutput", e);
      }
    }, {
      key: "getCurrentVideoInputDevice",
      value: function value() {
        return this._ctx.deviceManager.getCurrentVideoInputDevice();
      }
    }, {
      key: "getAvailableVideoInputDevices",
      value: function value() {
        return this._ctx.deviceManager.getAvailableVideoInputDevices();
      }
    }, {
      key: "selectVideoInputDevice",
      value: function value(e) {
        return this._ctx.deviceManager.selectDevice("videoinput", e);
      }
    }, {
      key: "getCall",
      value: function value(e) {
        return this._callManager.getCall(e);
      }
    }, {
      key: "getOngoingCalls",
      value: function value() {
        return this._callManager.getOngoingCalls();
      }
    }, {
      key: "getOngoingCallCount",
      value: function value() {
        return this._callManager.getOngoingCallCount();
      }
    }, {
      key: "setRingingTimeout",
      value: function value(e) {
        this._callManager.setRingingTimeout(e);
      }
    }, {
      key: "setCallConnectionTimeout",
      value: function value(e) {
        this._callManager.setCallConnectionTimeout(e);
      }
    }, {
      key: "isPlaying",
      value: function value(e) {
        return this._ctx.soundManager.isPlaying(e);
      }
    }, {
      key: "addDirectCallSound",
      value: function value(e, t) {
        return this._ctx.soundManager.loadSound(e, t);
      }
    }, {
      key: "removeDirectCallSound",
      value: function value(e) {
        return this._ctx.soundManager.unloadSound(e);
      }
    }, {
      key: "dial",
      value: function value(e, t) {
        _a.info("dial()"), this._checkAuthed();
        var n = e.userId;
        if (this._user.userId === n) throw new ou(Tn.MY_USER_ID_NOT_ALLOWED);
        return this._callManager.dial(e, t);
      }
    }, {
      key: "updateCustomItems",
      value: function value(e, t, n) {
        var r = Jn(aa(t, n), 2)[1];
        if (r) return r;
        r = this._callManager.getCall(e);
        if (r) return r.updateCustomItems(t, n);
        t = of.createUpdateCustomItems(e, t), t = this._ctx.sender.send(t).then(function (e) {
          return {
            customItems: e.custom_items,
            affectedKeys: e.updated
          };
        }).catch(function (e) {
          throw _a.error("failed to update customItems"), e;
        });
        return n && ia(t)(n), t;
      }
    }, {
      key: "deleteCustomItems",
      value: function value(e, t, n) {
        var r = Jn(oa(t, n), 2)[1];
        if (r) return r;
        r = this._callManager.getCall(e);
        if (r) return r.deleteCustomItems(t, n);
        t = of.createDeleteCustomItems(e, t), t = this._ctx.sender.send(t).then(function (e) {
          return {
            customItems: e.custom_items,
            affectedKeys: e.deleted
          };
        }).catch(function (e) {
          throw _a.error("failed to delete customItems"), e;
        });
        return n && ia(t)(n), t;
      }
    }, {
      key: "deleteAllCustomItems",
      value: function value(e, t) {
        var n = this._callManager.getCall(e);

        if (n) return n.deleteAllCustomItems(t);
        e = of.createDeleteAllCustomItems(e), e = this._ctx.sender.send(e).then(function (e) {
          return {
            customItems: e.custom_items,
            affectedKeys: e.deleted
          };
        }).catch(function (e) {
          throw _a.error("failed to delete all customItems"), e;
        });
        return t && ia(e)(t), e;
      }
    }, {
      key: "createDirectCallLogListQuery",
      value: function value(e) {
        return new Rv(this._user.userId, e, this._ctx.sender);
      }
    }, {
      key: "createRoom",
      value: function value(e) {
        return this._roomManager.createRoom(e);
      }
    }, {
      key: "getCachedRoomById",
      value: function value(e) {
        return this._roomManager.getCachedRoomById(e);
      }
    }, {
      key: "fetchRoomById",
      value: function value(e) {
        return this._roomManager.fetchRoomById(e);
      }
    }, {
      key: "createRoomListQuery",
      value: function value(e) {
        return new Cv(e, this._ctx.sender);
      }
    }, {
      key: "registerPushToken",
      value: function value(e, t) {
        if (!e) throw new pa(Tn.INVALID_PARAMETER_VALUE, {
          invalidParameter: "pushToken"
        });
        if (!t) throw new pa(Tn.INVALID_PARAMETER_VALUE, {
          invalidParameter: "tokenType"
        });
        t = of.createRegisterPushToken(this._user.userId, e, t);
        return this._ctx.sender.send(t).catch(function (e) {
          throw _a.error("failed to register the user's push token"), e;
        });
      }
    }, {
      key: "unregisterPushToken",
      value: function value(e, t) {
        if (!e) throw new pa(Tn.INVALID_PARAMETER_VALUE, {
          invalidParameter: "pushToken"
        });
        if (!t) throw new pa(Tn.INVALID_PARAMETER_VALUE, {
          invalidParameter: "tokenType"
        });
        t = of.createUnregisterPushToken(this._user.userId, e, t);
        return this._ctx.sender.send(t).catch(function (e) {
          throw _a.error("failed to unregister the user's push token"), e;
        });
      }
    }, {
      key: "unregisterAllPushTokens",
      value: function value(e) {
        if (!e) throw new pa(Tn.INVALID_PARAMETER_VALUE, {
          invalidParameter: "tokenType"
        });
        e = of.createUnregisterAllPushTokens(this._user.userId, e);
        return this._ctx.sender.send(e).catch(function (e) {
          throw _a.error("failed to unregister the user's all push token"), e;
        });
      }
    }, {
      key: "appId",
      get: function get() {
        return this._appId;
      }
    }, {
      key: "currentUser",
      get: function get() {
        return this._user;
      }
    }, {
      key: "dialListeners",
      get: function get() {
        return this._callManager.dialListeners;
      }
    }, {
      key: "recordingListeners",
      get: function get() {
        return this._ctx.recordingManager.listeners;
      }
    }]), r;
  }(),
      wv = null;

  function Av() {
    if (!wv) throw new pa(Tn.INSTANCE_NOT_INITIALIZED);
  }

  return cr(null, function (e) {
    function r() {
      Un(this, r), e(this);
    }

    return {
      F: r,
      d: [{
        kind: "get",
        static: !0,
        key: "sdkVersion",
        value: function value() {
          return au;
        }
      }, {
        kind: "get",
        static: !0,
        key: "LoggerLevel",
        value: function value() {
          return Xc;
        }
      }, {
        kind: "method",
        static: !0,
        key: "setLoggerLevel",
        value: function value(e) {
          return _a.setLoggerLevel(Tr[e]);
        }
      }, {
        kind: "get",
        static: !0,
        key: "SoundType",
        value: function value() {
          return Yc;
        }
      }, {
        kind: "get",
        static: !0,
        key: "RoomType",
        value: function value() {
          return Gc;
        }
      }, {
        kind: "get",
        static: !0,
        key: "DirectCallUserRole",
        value: function value() {
          return da;
        }
      }, {
        kind: "get",
        static: !0,
        key: "DirectCallEndResult",
        value: function value() {
          return la;
        }
      }, {
        kind: "get",
        static: !0,
        key: "DirectCallOption",
        value: function value() {
          return va;
        }
      }, {
        kind: "get",
        static: !0,
        key: "DirectCallRecordOption",
        value: function value() {
          return Ta;
        }
      }, {
        kind: "get",
        static: !0,
        key: "RecordingType",
        value: function value() {
          return ka;
        }
      }, {
        kind: "get",
        static: !0,
        key: "ErrorCode",
        value: function value() {
          return Tn;
        }
      }, {
        kind: "get",
        static: !0,
        key: "TokenType",
        value: function value() {
          return Jc;
        }
      }, {
        kind: "method",
        static: !0,
        key: "init",
        value: function value(e, t, n) {
          if (!e) throw new pa(Tn.INVALID_PARAMETER_VALUE, {
            invalidParameter: "appId"
          });
          if (!function () {
            if ("undefined" == typeof window) {
              var e = "SendBirdCall needs 'window' in global";
              throw _a.error(e), e;
            }

            if (void 0 === window.RTCPeerConnection) {
              var t = "SendBirdCall needs 'RTCPeerConnection' in global";
              throw _a.error(t), t;
            }

            if (t = (e = window.location).protocol, e = e.hostname, "file:" !== t && "https:" !== t && "127.0.0.1" !== e && "localhost" !== e) {
              var n = "SendBirdCall needs https connection, except for 'localhost' or '127.0.0.1'";
              throw _a.error(n), n;
            }

            if (void 0 === window.RTCPeerConnection.prototype.addTrack || void 0 === window.RTCPeerConnection.prototype.getSenders) {
              n = "SendBirdCall can't support the browser using legacy WebRTC module";
              throw _a.error(n), n;
            }
          }(), wv && wv.appId === e) return !1;
          var r = null,
              i = null,
              a = null;
          return wv && (wv.deauthenticate(), i = new Map(wv.dialListeners), a = new Map(wv.recordingListeners), wv.removeAllListeners(), wv.removeAllRecordingListeners(), r = wv), wv = new Iv(e, t, n), r && (i.forEach(function (e, t) {
            wv.addListener(t, e);
          }), a.forEach(function (e, t) {
            wv.addRecordingListener(t, e);
          })), !0;
        }
      }, {
        kind: "get",
        static: !0,
        key: "appId",
        value: function value() {
          return null === wv || void 0 === wv ? void 0 : wv.appId;
        }
      }, {
        kind: "get",
        static: !0,
        key: "currentUser",
        value: function value() {
          return null === wv || void 0 === wv ? void 0 : wv.currentUser;
        }
      }, {
        kind: "method",
        static: !0,
        key: "authenticate",
        value: function value(e, t) {
          Av();
          var n = e.userId,
              e = e.accessToken;
          return wv && wv.currentUser && wv.currentUser.userId !== n && r.deauthenticate(), wv.authenticate({
            userId: n,
            accessToken: e
          }, t);
        }
      }, {
        kind: "method",
        static: !0,
        key: "deauthenticate",
        value: function value() {
          Av(), wv.deauthenticate();
        }
      }, {
        kind: "method",
        static: !0,
        key: "connectWebSocket",
        value: function value() {
          return Av(), wv.connectWebSocket();
        }
      }, {
        kind: "method",
        static: !0,
        key: "handleWebhookData",
        value: function value(e) {
          Av(), wv.handleWebhookData(e);
        }
      }, {
        kind: "method",
        static: !0,
        key: "addListener",
        value: function value(e, t) {
          Av(), wv.addListener(e, t);
        }
      }, {
        kind: "method",
        static: !0,
        key: "removeListener",
        value: function value(e) {
          Av(), wv.removeListener(e);
        }
      }, {
        kind: "method",
        static: !0,
        key: "removeAllListeners",
        value: function value() {
          Av(), wv.removeAllListeners();
        }
      }, {
        kind: "method",
        static: !0,
        key: "addRecordingListener",
        value: function value(e, t) {
          Av(), wv.addRecordingListener(e, t);
        }
      }, {
        kind: "method",
        static: !0,
        key: "removeRecordingListener",
        value: function value(e) {
          Av(), wv.removeRecordingListener(e);
        }
      }, {
        kind: "method",
        static: !0,
        key: "removeAllRecordingListeners",
        value: function value() {
          Av(), wv.removeAllRecordingListeners();
        }
      }, {
        kind: "method",
        static: !0,
        key: "useMedia",
        value: function value(e) {
          return Av(), wv.useMedia(e);
        }
      }, {
        kind: "method",
        static: !0,
        key: "updateMediaDevices",
        value: function value(e) {
          return Av(), wv.updateMediaDevices(e);
        }
      }, {
        kind: "method",
        static: !0,
        key: "getCurrentAudioInputDevice",
        value: function value() {
          return Av(), wv.getCurrentAudioInputDevice();
        }
      }, {
        kind: "method",
        static: !0,
        key: "getAvailableAudioInputDevices",
        value: function value() {
          return Av(), wv.getAvailableAudioInputDevices();
        }
      }, {
        kind: "method",
        static: !0,
        key: "selectAudioInputDevice",
        value: function value(e) {
          return Av(), wv.selectAudioInputDevice(e);
        }
      }, {
        kind: "method",
        static: !0,
        key: "getCurrentAudioOutputDevice",
        value: function value() {
          return Av(), wv.getCurrentAudioOutputDevice();
        }
      }, {
        kind: "method",
        static: !0,
        key: "getAvailableAudioOutputDevices",
        value: function value() {
          return Av(), wv.getAvailableAudioOutputDevices();
        }
      }, {
        kind: "method",
        static: !0,
        key: "selectAudioOutputDevice",
        value: function value(e) {
          return Av(), wv.selectAudioOutputDevice(e);
        }
      }, {
        kind: "method",
        static: !0,
        key: "getCurrentVideoInputDevice",
        value: function value() {
          return Av(), wv.getCurrentVideoInputDevice();
        }
      }, {
        kind: "method",
        static: !0,
        key: "getAvailableVideoInputDevices",
        value: function value() {
          return Av(), wv.getAvailableVideoInputDevices();
        }
      }, {
        kind: "method",
        static: !0,
        key: "selectVideoInputDevice",
        value: function value(e) {
          return Av(), wv.selectVideoInputDevice(e);
        }
      }, {
        kind: "method",
        static: !0,
        key: "getCall",
        value: function value(e) {
          return Av(), wv.getCall(e);
        }
      }, {
        kind: "method",
        static: !0,
        key: "getOngoingCalls",
        value: function value() {
          return Av(), wv.getOngoingCalls();
        }
      }, {
        kind: "method",
        static: !0,
        key: "getOngoingCallCount",
        value: function value() {
          return Av(), wv.getOngoingCallCount();
        }
      }, {
        kind: "method",
        static: !0,
        key: "setRingingTimeout",
        value: function value(e) {
          Av(), wv.setRingingTimeout(e);
        }
      }, {
        kind: "method",
        static: !0,
        key: "setCallConnectionTimeout",
        value: function value(e) {
          Av(), wv.setCallConnectionTimeout(e);
        }
      }, {
        kind: "method",
        static: !0,
        key: "isPlaying",
        value: function value(e) {
          return Av(), wv.isPlaying(e);
        }
      }, {
        kind: "method",
        static: !0,
        key: "addDirectCallSound",
        value: function value(e, t) {
          return Av(), wv.addDirectCallSound(e, t);
        }
      }, {
        kind: "method",
        static: !0,
        key: "removeDirectCallSound",
        value: function value(e) {
          return Av(), wv.removeDirectCallSound(e);
        }
      }, {
        kind: "method",
        decorators: [tu(tu.messages.CALL_IS_NOT_SUPPORTED)],
        static: !0,
        key: "dial",
        value: function value(e, t) {
          return Av(), wv.dial(e, t);
        }
      }, {
        kind: "method",
        static: !0,
        key: "updateCustomItems",
        value: function value(e, t, n) {
          return Av(), wv.updateCustomItems(e, t, n);
        }
      }, {
        kind: "method",
        static: !0,
        key: "deleteCustomItems",
        value: function value(e, t, n) {
          return Av(), wv.deleteCustomItems(e, t, n);
        }
      }, {
        kind: "method",
        static: !0,
        key: "deleteAllCustomItems",
        value: function value(e, t) {
          return Av(), wv.deleteAllCustomItems(e, t);
        }
      }, {
        kind: "method",
        static: !0,
        key: "createDirectCallLogListQuery",
        value: function value(e) {
          return Av(), wv.createDirectCallLogListQuery(e);
        }
      }, {
        kind: "method",
        static: !0,
        key: "createRoom",
        value: function value(e) {
          return Av(), wv.createRoom(e);
        }
      }, {
        kind: "method",
        static: !0,
        key: "getCachedRoomById",
        value: function value(e) {
          return Av(), wv.getCachedRoomById(e);
        }
      }, {
        kind: "method",
        static: !0,
        key: "fetchRoomById",
        value: function value(e) {
          return Av(), wv.fetchRoomById(e);
        }
      }, {
        kind: "method",
        static: !0,
        key: "createRoomListQuery",
        value: function value(e) {
          return Av(), wv.createRoomListQuery(e);
        }
      }, {
        kind: "method",
        static: !0,
        key: "registerPushToken",
        value: function value(e, t) {
          return Av(), wv.registerPushToken(e, t);
        }
      }, {
        kind: "method",
        static: !0,
        key: "unregisterPushToken",
        value: function value(e, t) {
          return Av(), wv.unregisterPushToken(e, t);
        }
      }, {
        kind: "method",
        static: !0,
        key: "unregisterAllPushTokens",
        value: function value(e) {
          return Av(), wv.unregisterAllPushTokens(e);
        }
      }]
    };
  });
});